(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d166a5a387251cdc$var$t = window, $d166a5a387251cdc$export$b4d10f6001c083c2 = $d166a5a387251cdc$var$t.ShadowRoot && (void 0 === $d166a5a387251cdc$var$t.ShadyCSS || $d166a5a387251cdc$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $d166a5a387251cdc$var$s = Symbol(), $d166a5a387251cdc$var$n = new WeakMap;
class $d166a5a387251cdc$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $d166a5a387251cdc$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($d166a5a387251cdc$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $d166a5a387251cdc$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $d166a5a387251cdc$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $d166a5a387251cdc$export$8d80f9cac07cdb3 = (t)=>new $d166a5a387251cdc$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $d166a5a387251cdc$var$s), $d166a5a387251cdc$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $d166a5a387251cdc$export$505d1e8739bad805(n, t, $d166a5a387251cdc$var$s);
}, $d166a5a387251cdc$export$2ca4a66ec4cecb90 = (s, n)=>{
    $d166a5a387251cdc$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $d166a5a387251cdc$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $d166a5a387251cdc$export$ee69dfd951e24778 = $d166a5a387251cdc$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $d166a5a387251cdc$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $7ece5e2ccb4fd0d9$var$s;
const $7ece5e2ccb4fd0d9$var$e = window, $7ece5e2ccb4fd0d9$var$r = $7ece5e2ccb4fd0d9$var$e.trustedTypes, $7ece5e2ccb4fd0d9$var$h = $7ece5e2ccb4fd0d9$var$r ? $7ece5e2ccb4fd0d9$var$r.emptyScript : "", $7ece5e2ccb4fd0d9$var$o = $7ece5e2ccb4fd0d9$var$e.reactiveElementPolyfillSupport, $7ece5e2ccb4fd0d9$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $7ece5e2ccb4fd0d9$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $7ece5e2ccb4fd0d9$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $7ece5e2ccb4fd0d9$var$l = {
    attribute: !0,
    type: String,
    converter: $7ece5e2ccb4fd0d9$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $7ece5e2ccb4fd0d9$export$53a6892c50694894
}, $7ece5e2ccb4fd0d9$var$d = "finalized";
class $7ece5e2ccb4fd0d9$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $7ece5e2ccb4fd0d9$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $7ece5e2ccb4fd0d9$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($7ece5e2ccb4fd0d9$var$d)) return !1;
        this[$7ece5e2ccb4fd0d9$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $d166a5a387251cdc$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $d166a5a387251cdc$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $d166a5a387251cdc$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $7ece5e2ccb4fd0d9$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $7ece5e2ccb4fd0d9$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $7ece5e2ccb4fd0d9$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $7ece5e2ccb4fd0d9$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$7ece5e2ccb4fd0d9$export$c7c07a37856565d[$7ece5e2ccb4fd0d9$var$d] = !0, $7ece5e2ccb4fd0d9$export$c7c07a37856565d.elementProperties = new Map, $7ece5e2ccb4fd0d9$export$c7c07a37856565d.elementStyles = [], $7ece5e2ccb4fd0d9$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $7ece5e2ccb4fd0d9$var$o || $7ece5e2ccb4fd0d9$var$o({
    ReactiveElement: $7ece5e2ccb4fd0d9$export$c7c07a37856565d
}), (null !== ($7ece5e2ccb4fd0d9$var$s = $7ece5e2ccb4fd0d9$var$e.reactiveElementVersions) && void 0 !== $7ece5e2ccb4fd0d9$var$s ? $7ece5e2ccb4fd0d9$var$s : $7ece5e2ccb4fd0d9$var$e.reactiveElementVersions = []).push("1.6.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $e0373a6519ee54ad$var$t;
const $e0373a6519ee54ad$var$i = window, $e0373a6519ee54ad$var$s = $e0373a6519ee54ad$var$i.trustedTypes, $e0373a6519ee54ad$var$e = $e0373a6519ee54ad$var$s ? $e0373a6519ee54ad$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e0373a6519ee54ad$var$o = "$lit$", $e0373a6519ee54ad$var$n = `lit$${(Math.random() + "").slice(9)}$`, $e0373a6519ee54ad$var$l = "?" + $e0373a6519ee54ad$var$n, $e0373a6519ee54ad$var$h = `<${$e0373a6519ee54ad$var$l}>`, $e0373a6519ee54ad$var$r = document, $e0373a6519ee54ad$var$u = ()=>$e0373a6519ee54ad$var$r.createComment(""), $e0373a6519ee54ad$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e0373a6519ee54ad$var$c = Array.isArray, $e0373a6519ee54ad$var$v = (t)=>$e0373a6519ee54ad$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $e0373a6519ee54ad$var$a = "[ \t\n\f\r]", $e0373a6519ee54ad$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e0373a6519ee54ad$var$_ = /-->/g, $e0373a6519ee54ad$var$m = />/g, $e0373a6519ee54ad$var$p = RegExp(`>|${$e0373a6519ee54ad$var$a}(?:([^\\s"'>=/]+)(${$e0373a6519ee54ad$var$a}*=${$e0373a6519ee54ad$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e0373a6519ee54ad$var$g = /'/g, $e0373a6519ee54ad$var$$ = /"/g, $e0373a6519ee54ad$var$y = /^(?:script|style|textarea|title)$/i, $e0373a6519ee54ad$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e0373a6519ee54ad$export$c0bb0b647f701bb5 = $e0373a6519ee54ad$var$w(1), $e0373a6519ee54ad$export$7ed1367e7fa1ad68 = $e0373a6519ee54ad$var$w(2), $e0373a6519ee54ad$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e0373a6519ee54ad$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e0373a6519ee54ad$var$E = new WeakMap, $e0373a6519ee54ad$var$C = $e0373a6519ee54ad$var$r.createTreeWalker($e0373a6519ee54ad$var$r, 129, null, !1);
function $e0373a6519ee54ad$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e0373a6519ee54ad$var$e ? $e0373a6519ee54ad$var$e.createHTML(i) : i;
}
const $e0373a6519ee54ad$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $e0373a6519ee54ad$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $e0373a6519ee54ad$var$f ? "!--" === c[1] ? u = $e0373a6519ee54ad$var$_ : void 0 !== c[1] ? u = $e0373a6519ee54ad$var$m : void 0 !== c[2] ? ($e0373a6519ee54ad$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $e0373a6519ee54ad$var$p) : void 0 !== c[3] && (u = $e0373a6519ee54ad$var$p) : u === $e0373a6519ee54ad$var$p ? ">" === c[0] ? (u = null != l ? l : $e0373a6519ee54ad$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $e0373a6519ee54ad$var$p : '"' === c[3] ? $e0373a6519ee54ad$var$$ : $e0373a6519ee54ad$var$g) : u === $e0373a6519ee54ad$var$$ || u === $e0373a6519ee54ad$var$g ? u = $e0373a6519ee54ad$var$p : u === $e0373a6519ee54ad$var$_ || u === $e0373a6519ee54ad$var$m ? u = $e0373a6519ee54ad$var$f : (u = $e0373a6519ee54ad$var$p, l = void 0);
        const w = u === $e0373a6519ee54ad$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $e0373a6519ee54ad$var$f ? s + $e0373a6519ee54ad$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $e0373a6519ee54ad$var$o + s.slice(v) + $e0373a6519ee54ad$var$n + w) : s + $e0373a6519ee54ad$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $e0373a6519ee54ad$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $e0373a6519ee54ad$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $e0373a6519ee54ad$var$V(t, i);
        if (this.el = $e0373a6519ee54ad$var$N.createElement(a, e), $e0373a6519ee54ad$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $e0373a6519ee54ad$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($e0373a6519ee54ad$var$o) || i.startsWith($e0373a6519ee54ad$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $e0373a6519ee54ad$var$o).split($e0373a6519ee54ad$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $e0373a6519ee54ad$var$H : "?" === i[1] ? $e0373a6519ee54ad$var$L : "@" === i[1] ? $e0373a6519ee54ad$var$z : $e0373a6519ee54ad$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($e0373a6519ee54ad$var$y.test(h.tagName)) {
                    const t = h.textContent.split($e0373a6519ee54ad$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $e0373a6519ee54ad$var$s ? $e0373a6519ee54ad$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $e0373a6519ee54ad$var$u()), $e0373a6519ee54ad$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $e0373a6519ee54ad$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $e0373a6519ee54ad$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($e0373a6519ee54ad$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $e0373a6519ee54ad$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $e0373a6519ee54ad$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e0373a6519ee54ad$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $e0373a6519ee54ad$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $e0373a6519ee54ad$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $e0373a6519ee54ad$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $e0373a6519ee54ad$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $e0373a6519ee54ad$var$r).importNode(s, !0);
        $e0373a6519ee54ad$var$C.currentNode = o;
        let n = $e0373a6519ee54ad$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $e0373a6519ee54ad$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $e0373a6519ee54ad$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $e0373a6519ee54ad$var$C.nextNode(), l++);
        }
        return $e0373a6519ee54ad$var$C.currentNode = $e0373a6519ee54ad$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e0373a6519ee54ad$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $e0373a6519ee54ad$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e0373a6519ee54ad$var$S(this, t, i), $e0373a6519ee54ad$var$d(t) ? t === $e0373a6519ee54ad$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e0373a6519ee54ad$export$45b790e32b2810ee && this._$AR(), this._$AH = $e0373a6519ee54ad$export$45b790e32b2810ee) : t !== this._$AH && t !== $e0373a6519ee54ad$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $e0373a6519ee54ad$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $e0373a6519ee54ad$export$45b790e32b2810ee && $e0373a6519ee54ad$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($e0373a6519ee54ad$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $e0373a6519ee54ad$var$N.createElement($e0373a6519ee54ad$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $e0373a6519ee54ad$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e0373a6519ee54ad$var$E.get(t.strings);
        return void 0 === i && $e0373a6519ee54ad$var$E.set(t.strings, i = new $e0373a6519ee54ad$var$N(t)), i;
    }
    T(t) {
        $e0373a6519ee54ad$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $e0373a6519ee54ad$var$R(this.k($e0373a6519ee54ad$var$u()), this.k($e0373a6519ee54ad$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $e0373a6519ee54ad$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $e0373a6519ee54ad$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e0373a6519ee54ad$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $e0373a6519ee54ad$var$S(this, t, i, 0), n = !$e0373a6519ee54ad$var$d(t) || t !== this._$AH && t !== $e0373a6519ee54ad$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $e0373a6519ee54ad$var$S(this, e[s + l], i, l), h === $e0373a6519ee54ad$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$e0373a6519ee54ad$var$d(h) || h !== this._$AH[l]), h === $e0373a6519ee54ad$export$45b790e32b2810ee ? t = $e0373a6519ee54ad$export$45b790e32b2810ee : t !== $e0373a6519ee54ad$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $e0373a6519ee54ad$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $e0373a6519ee54ad$var$H extends $e0373a6519ee54ad$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e0373a6519ee54ad$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $e0373a6519ee54ad$var$I = $e0373a6519ee54ad$var$s ? $e0373a6519ee54ad$var$s.emptyScript : "";
class $e0373a6519ee54ad$var$L extends $e0373a6519ee54ad$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $e0373a6519ee54ad$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $e0373a6519ee54ad$var$I) : this.element.removeAttribute(this.name);
    }
}
class $e0373a6519ee54ad$var$z extends $e0373a6519ee54ad$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $e0373a6519ee54ad$var$S(this, t, i, 0)) && void 0 !== s ? s : $e0373a6519ee54ad$export$45b790e32b2810ee) === $e0373a6519ee54ad$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $e0373a6519ee54ad$export$45b790e32b2810ee && e !== $e0373a6519ee54ad$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $e0373a6519ee54ad$export$45b790e32b2810ee && (e === $e0373a6519ee54ad$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e0373a6519ee54ad$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e0373a6519ee54ad$var$S(this, t);
    }
}
const $e0373a6519ee54ad$export$8613d1ca9052b22e = {
    O: $e0373a6519ee54ad$var$o,
    P: $e0373a6519ee54ad$var$n,
    A: $e0373a6519ee54ad$var$l,
    C: 1,
    M: $e0373a6519ee54ad$var$V,
    L: $e0373a6519ee54ad$var$M,
    R: $e0373a6519ee54ad$var$v,
    D: $e0373a6519ee54ad$var$S,
    I: $e0373a6519ee54ad$var$R,
    V: $e0373a6519ee54ad$var$k,
    H: $e0373a6519ee54ad$var$L,
    N: $e0373a6519ee54ad$var$z,
    U: $e0373a6519ee54ad$var$H,
    F: $e0373a6519ee54ad$var$Z
}, $e0373a6519ee54ad$var$B = $e0373a6519ee54ad$var$i.litHtmlPolyfillSupport;
null == $e0373a6519ee54ad$var$B || $e0373a6519ee54ad$var$B($e0373a6519ee54ad$var$N, $e0373a6519ee54ad$var$R), (null !== ($e0373a6519ee54ad$var$t = $e0373a6519ee54ad$var$i.litHtmlVersions) && void 0 !== $e0373a6519ee54ad$var$t ? $e0373a6519ee54ad$var$t : $e0373a6519ee54ad$var$i.litHtmlVersions = []).push("2.8.0");
const $e0373a6519ee54ad$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $e0373a6519ee54ad$var$R(i.insertBefore($e0373a6519ee54ad$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $79945edb0549afcc$var$t;
const $79945edb0549afcc$var$i = window, $79945edb0549afcc$var$s = $79945edb0549afcc$var$i.trustedTypes, $79945edb0549afcc$var$e = $79945edb0549afcc$var$s ? $79945edb0549afcc$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $79945edb0549afcc$var$o = "$lit$", $79945edb0549afcc$var$n = `lit$${(Math.random() + "").slice(9)}$`, $79945edb0549afcc$var$l = "?" + $79945edb0549afcc$var$n, $79945edb0549afcc$var$h = `<${$79945edb0549afcc$var$l}>`, $79945edb0549afcc$var$r = document, $79945edb0549afcc$var$u = ()=>$79945edb0549afcc$var$r.createComment(""), $79945edb0549afcc$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $79945edb0549afcc$var$c = Array.isArray, $79945edb0549afcc$var$v = (t)=>$79945edb0549afcc$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $79945edb0549afcc$var$a = "[ \t\n\f\r]", $79945edb0549afcc$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $79945edb0549afcc$var$_ = /-->/g, $79945edb0549afcc$var$m = />/g, $79945edb0549afcc$var$p = RegExp(`>|${$79945edb0549afcc$var$a}(?:([^\\s"'>=/]+)(${$79945edb0549afcc$var$a}*=${$79945edb0549afcc$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $79945edb0549afcc$var$g = /'/g, $79945edb0549afcc$var$$ = /"/g, $79945edb0549afcc$var$y = /^(?:script|style|textarea|title)$/i, $79945edb0549afcc$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $79945edb0549afcc$export$c0bb0b647f701bb5 = $79945edb0549afcc$var$w(1), $79945edb0549afcc$export$7ed1367e7fa1ad68 = $79945edb0549afcc$var$w(2), $79945edb0549afcc$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $79945edb0549afcc$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $79945edb0549afcc$var$E = new WeakMap, $79945edb0549afcc$var$C = $79945edb0549afcc$var$r.createTreeWalker($79945edb0549afcc$var$r, 129, null, !1);
function $79945edb0549afcc$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $79945edb0549afcc$var$e ? $79945edb0549afcc$var$e.createHTML(i) : i;
}
const $79945edb0549afcc$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $79945edb0549afcc$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $79945edb0549afcc$var$f ? "!--" === c[1] ? u = $79945edb0549afcc$var$_ : void 0 !== c[1] ? u = $79945edb0549afcc$var$m : void 0 !== c[2] ? ($79945edb0549afcc$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $79945edb0549afcc$var$p) : void 0 !== c[3] && (u = $79945edb0549afcc$var$p) : u === $79945edb0549afcc$var$p ? ">" === c[0] ? (u = null != l ? l : $79945edb0549afcc$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $79945edb0549afcc$var$p : '"' === c[3] ? $79945edb0549afcc$var$$ : $79945edb0549afcc$var$g) : u === $79945edb0549afcc$var$$ || u === $79945edb0549afcc$var$g ? u = $79945edb0549afcc$var$p : u === $79945edb0549afcc$var$_ || u === $79945edb0549afcc$var$m ? u = $79945edb0549afcc$var$f : (u = $79945edb0549afcc$var$p, l = void 0);
        const w = u === $79945edb0549afcc$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $79945edb0549afcc$var$f ? s + $79945edb0549afcc$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $79945edb0549afcc$var$o + s.slice(v) + $79945edb0549afcc$var$n + w) : s + $79945edb0549afcc$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $79945edb0549afcc$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $79945edb0549afcc$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $79945edb0549afcc$var$V(t, i);
        if (this.el = $79945edb0549afcc$var$N.createElement(a, e), $79945edb0549afcc$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $79945edb0549afcc$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($79945edb0549afcc$var$o) || i.startsWith($79945edb0549afcc$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $79945edb0549afcc$var$o).split($79945edb0549afcc$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $79945edb0549afcc$var$H : "?" === i[1] ? $79945edb0549afcc$var$L : "@" === i[1] ? $79945edb0549afcc$var$z : $79945edb0549afcc$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($79945edb0549afcc$var$y.test(h.tagName)) {
                    const t = h.textContent.split($79945edb0549afcc$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $79945edb0549afcc$var$s ? $79945edb0549afcc$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $79945edb0549afcc$var$u()), $79945edb0549afcc$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $79945edb0549afcc$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $79945edb0549afcc$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($79945edb0549afcc$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $79945edb0549afcc$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $79945edb0549afcc$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $79945edb0549afcc$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $79945edb0549afcc$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $79945edb0549afcc$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $79945edb0549afcc$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $79945edb0549afcc$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $79945edb0549afcc$var$r).importNode(s, !0);
        $79945edb0549afcc$var$C.currentNode = o;
        let n = $79945edb0549afcc$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $79945edb0549afcc$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $79945edb0549afcc$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $79945edb0549afcc$var$C.nextNode(), l++);
        }
        return $79945edb0549afcc$var$C.currentNode = $79945edb0549afcc$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $79945edb0549afcc$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $79945edb0549afcc$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $79945edb0549afcc$var$S(this, t, i), $79945edb0549afcc$var$d(t) ? t === $79945edb0549afcc$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $79945edb0549afcc$export$45b790e32b2810ee && this._$AR(), this._$AH = $79945edb0549afcc$export$45b790e32b2810ee) : t !== this._$AH && t !== $79945edb0549afcc$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $79945edb0549afcc$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $79945edb0549afcc$export$45b790e32b2810ee && $79945edb0549afcc$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($79945edb0549afcc$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $79945edb0549afcc$var$N.createElement($79945edb0549afcc$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $79945edb0549afcc$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $79945edb0549afcc$var$E.get(t.strings);
        return void 0 === i && $79945edb0549afcc$var$E.set(t.strings, i = new $79945edb0549afcc$var$N(t)), i;
    }
    T(t) {
        $79945edb0549afcc$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $79945edb0549afcc$var$R(this.k($79945edb0549afcc$var$u()), this.k($79945edb0549afcc$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $79945edb0549afcc$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $79945edb0549afcc$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $79945edb0549afcc$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $79945edb0549afcc$var$S(this, t, i, 0), n = !$79945edb0549afcc$var$d(t) || t !== this._$AH && t !== $79945edb0549afcc$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $79945edb0549afcc$var$S(this, e[s + l], i, l), h === $79945edb0549afcc$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$79945edb0549afcc$var$d(h) || h !== this._$AH[l]), h === $79945edb0549afcc$export$45b790e32b2810ee ? t = $79945edb0549afcc$export$45b790e32b2810ee : t !== $79945edb0549afcc$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $79945edb0549afcc$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $79945edb0549afcc$var$H extends $79945edb0549afcc$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $79945edb0549afcc$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $79945edb0549afcc$var$I = $79945edb0549afcc$var$s ? $79945edb0549afcc$var$s.emptyScript : "";
class $79945edb0549afcc$var$L extends $79945edb0549afcc$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $79945edb0549afcc$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $79945edb0549afcc$var$I) : this.element.removeAttribute(this.name);
    }
}
class $79945edb0549afcc$var$z extends $79945edb0549afcc$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $79945edb0549afcc$var$S(this, t, i, 0)) && void 0 !== s ? s : $79945edb0549afcc$export$45b790e32b2810ee) === $79945edb0549afcc$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $79945edb0549afcc$export$45b790e32b2810ee && e !== $79945edb0549afcc$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $79945edb0549afcc$export$45b790e32b2810ee && (e === $79945edb0549afcc$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $79945edb0549afcc$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $79945edb0549afcc$var$S(this, t);
    }
}
const $79945edb0549afcc$export$8613d1ca9052b22e = {
    O: $79945edb0549afcc$var$o,
    P: $79945edb0549afcc$var$n,
    A: $79945edb0549afcc$var$l,
    C: 1,
    M: $79945edb0549afcc$var$V,
    L: $79945edb0549afcc$var$M,
    R: $79945edb0549afcc$var$v,
    D: $79945edb0549afcc$var$S,
    I: $79945edb0549afcc$var$R,
    V: $79945edb0549afcc$var$k,
    H: $79945edb0549afcc$var$L,
    N: $79945edb0549afcc$var$z,
    U: $79945edb0549afcc$var$H,
    F: $79945edb0549afcc$var$Z
}, $79945edb0549afcc$var$B = $79945edb0549afcc$var$i.litHtmlPolyfillSupport;
null == $79945edb0549afcc$var$B || $79945edb0549afcc$var$B($79945edb0549afcc$var$N, $79945edb0549afcc$var$R), (null !== ($79945edb0549afcc$var$t = $79945edb0549afcc$var$i.litHtmlVersions) && void 0 !== $79945edb0549afcc$var$t ? $79945edb0549afcc$var$t : $79945edb0549afcc$var$i.litHtmlVersions = []).push("2.8.0");
const $79945edb0549afcc$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $79945edb0549afcc$var$R(i.insertBefore($79945edb0549afcc$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $70334511cd44bfe1$var$l, $70334511cd44bfe1$var$o;
const $70334511cd44bfe1$export$8bf27daf9e8907c9 = (0, $7ece5e2ccb4fd0d9$export$c7c07a37856565d);
class $70334511cd44bfe1$export$3f2f9f5909897157 extends (0, $7ece5e2ccb4fd0d9$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $79945edb0549afcc$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $79945edb0549afcc$export$9c068ae9cc5db4e8;
    }
}
$70334511cd44bfe1$export$3f2f9f5909897157.finalized = !0, $70334511cd44bfe1$export$3f2f9f5909897157._$litElement$ = !0, null === ($70334511cd44bfe1$var$l = globalThis.litElementHydrateSupport) || void 0 === $70334511cd44bfe1$var$l || $70334511cd44bfe1$var$l.call(globalThis, {
    LitElement: $70334511cd44bfe1$export$3f2f9f5909897157
});
const $70334511cd44bfe1$var$n = globalThis.litElementPolyfillSupport;
null == $70334511cd44bfe1$var$n || $70334511cd44bfe1$var$n({
    LitElement: $70334511cd44bfe1$export$3f2f9f5909897157
});
const $70334511cd44bfe1$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($70334511cd44bfe1$var$o = globalThis.litElementVersions) && void 0 !== $70334511cd44bfe1$var$o ? $70334511cd44bfe1$var$o : globalThis.litElementVersions = []).push("3.3.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ec75afab15bedb3c$export$6acf61af03e62db = !1;






var $35cd9a7e2c9cfa6e$export$2e2bcd8739ae039 = [
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
    .hidden {
      display: none;
    }

    .line {
      line-height: var(--tenable-line-height, 1.1);
    }

    .d-flex {
      display: flex;
    }

    .d-flow-root {
      display: flow-root;
    }

    .flex-wrap {
      flex-wrap: wrap;
    }

    .flex-fill {
      flex: 1;
    }

    .justify-content-start {
      justify-content: flex-start;
    }

    .justify-content-end {
      justify-content: flex-end;
    }

    .justify-content-center {
      justify-content: center;
    }

    .justify-content-between {
      justify-content: space-between;
    }

    .justify-content-around {
      justify-content: space-around;
    }

    .w-25 {
      width: 25% !important;
    }

    .w-50 {
      width: 50% !important;
    }

    .w-66 {
      width: 66.66666% !important;
    }

    .w-75 {
      width: 75% !important;
    }

    .w-100 {
      width: 100% !important;
    }

    .w-auto {
      width: auto !important;
    }

    .h-25 {
      height: 25% !important;
    }

    .h-50 {
      height: 50% !important;
    }

    .h-75 {
      height: 75% !important;
    }

    .h-100 {
      height: 100% !important;
    }

    .h-auto {
      height: auto !important;
    }

    .m-0 {
      margin: 0 !important;
    }

    .m-1 {
      margin: 0.25rem !important;
    }

    .m-2 {
      margin: 0.5rem !important;
    }

    .m-3 {
      margin: 1rem !important;
    }

    .m-4 {
      margin: 1.5rem !important;
    }

    .m-5 {
      margin: 3rem !important;
    }

    .mt-0 {
      margin-top: 0 !important;
    }

    .mt-1 {
      margin-top: 0.25rem !important;
    }

    .mt-2 {
      margin-top: 0.5rem !important;
    }

    .mt-3 {
      margin-top: 1rem !important;
    }

    .mt-4 {
      margin-top: 1.5rem !important;
    }

    .mt-5 {
      margin-top: 3rem !important;
    }

    .mr-0 {
      margin-right: 0 !important;
    }

    .mr-1 {
      margin-right: 0.25rem !important;
    }

    .mr-2 {
      margin-right: 0.5rem !important;
    }

    .mr-3 {
      margin-right: 1rem !important;
    }

    .mr-4 {
      margin-right: 1.5rem !important;
    }

    .mr-5 {
      margin-right: 3rem !important;
    }

    .mb-0 {
      margin-bottom: 0 !important;
    }

    .mb-1 {
      margin-bottom: 0.25rem !important;
    }

    .mb-2 {
      margin-bottom: 0.5rem !important;
    }

    .mb-3 {
      margin-bottom: 1rem !important;
    }

    .mb-4 {
      margin-bottom: 1.5rem !important;
    }

    .mb-5 {
      margin-bottom: 3rem !important;
    }

    .ml-0 {
      margin-left: 0 !important;
    }

    .ml-1 {
      margin-left: 0.25rem !important;
    }

    .ml-2 {
      margin-left: 0.5rem !important;
    }

    .ml-3 {
      margin-left: 1rem !important;
    }

    .ml-4 {
      margin-left: 1.5rem !important;
    }

    .ml-5 {
      margin-left: 3rem !important;
    }

    .mx-0 {
      margin-right: 0 !important;
      margin-left: 0 !important;
    }

    .mx-1 {
      margin-right: 0.25rem !important;
      margin-left: 0.25rem !important;
    }

    .mx-2 {
      margin-right: 0.5rem !important;
      margin-left: 0.5rem !important;
    }

    .mx-3 {
      margin-right: 1rem !important;
      margin-left: 1rem !important;
    }

    .mx-4 {
      margin-right: 1.5rem !important;
      margin-left: 1.5rem !important;
    }

    .mx-5 {
      margin-right: 3rem !important;
      margin-left: 3rem !important;
    }

    .my-0 {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

    .my-1 {
      margin-top: 0.25rem !important;
      margin-bottom: 0.25rem !important;
    }

    .my-2 {
      margin-top: 0.5rem !important;
      margin-bottom: 0.5rem !important;
    }

    .my-3 {
      margin-top: 1rem !important;
      margin-bottom: 1rem !important;
    }

    .my-4 {
      margin-top: 1.5rem !important;
      margin-bottom: 1.5rem !important;
    }

    .my-5 {
      margin-top: 3rem !important;
      margin-bottom: 3rem !important;
    }

    .p-0 {
      padding: 0 !important;
    }

    .p-1 {
      padding: 0.25rem !important;
    }

    .p-2 {
      padding: 0.5rem !important;
    }

    .p-3 {
      padding: 1rem !important;
    }

    .p-4 {
      padding: 1.5rem !important;
    }

    .p-5 {
      padding: 3rem !important;
    }

    .pt-0 {
      padding-top: 0 !important;
    }

    .pt-1 {
      padding-top: 0.25rem !important;
    }

    .pt-2 {
      padding-top: 0.5rem !important;
    }

    .pt-3 {
      padding-top: 1rem !important;
    }

    .pt-4 {
      padding-top: 1.5rem !important;
    }

    .pt-5 {
      padding-top: 3rem !important;
    }

    .pr-0 {
      padding-right: 0 !important;
    }

    .pr-1 {
      padding-right: 0.25rem !important;
    }

    .pr-2 {
      padding-right: 0.5rem !important;
    }

    .pr-3 {
      padding-right: 1rem !important;
    }

    .pr-4 {
      padding-right: 1.5rem !important;
    }

    .pr-5 {
      padding-right: 3rem !important;
    }

    .pb-0 {
      padding-bottom: 0 !important;
    }

    .pb-1 {
      padding-bottom: 0.25rem !important;
    }

    .pb-2 {
      padding-bottom: 0.5rem !important;
    }

    .pb-3 {
      padding-bottom: 1rem !important;
    }

    .pb-4 {
      padding-bottom: 1.5rem !important;
    }

    .pb-5 {
      padding-bottom: 3rem !important;
    }

    .pl-0 {
      padding-left: 0 !important;
    }

    .pl-1 {
      padding-left: 0.25rem !important;
    }

    .pl-2 {
      padding-left: 0.5rem !important;
    }

    .pl-3 {
      padding-left: 1rem !important;
    }

    .pl-4 {
      padding-left: 1.5rem !important;
    }

    .pl-5 {
      padding-left: 3rem !important;
    }

    .px-0 {
      padding-right: 0 !important;
      padding-left: 0 !important;
    }

    .px-1 {
      padding-right: 0.25rem !important;
      padding-left: 0.25rem !important;
    }

    .px-2 {
      padding-right: 0.5rem !important;
      padding-left: 0.5rem !important;
    }

    .px-3 {
      padding-right: 1rem !important;
      padding-left: 1rem !important;
    }

    .px-4 {
      padding-right: 1.5rem !important;
      padding-left: 1.5rem !important;
    }

    .px-5 {
      padding-right: 3rem !important;
      padding-left: 3rem !important;
    }

    .py-0 {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    .py-1 {
      padding-top: 0.25rem !important;
      padding-bottom: 0.25rem !important;
    }

    .py-2 {
      padding-top: 0.5rem !important;
      padding-bottom: 0.5rem !important;
    }

    .py-3 {
      padding-top: 1rem !important;
      padding-bottom: 1rem !important;
    }

    .py-4 {
      padding-top: 1.5rem !important;
      padding-bottom: 1.5rem !important;
    }

    .py-5 {
      padding-top: 3rem !important;
      padding-bottom: 3rem !important;
    }

    .border-bottom {
      border-bottom: 1px solid #dee2e6 !important;
    }

    .text-center {
      text-align: center !important;
    }

    .font-weight-bold {
      font-weight: 700 !important;
    }

    .text-white {
      color: #ffffff !important;
    }
  `
];


var $00b2a1180faf264c$export$2e2bcd8739ae039 = [
    (0, $35cd9a7e2c9cfa6e$export$2e2bcd8739ae039),
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
    :host {
      font-size: 100%;
      line-height: 1.5;
      color: var(--tenable-text-color, #5B6062);
    }

    h1, .h1 {
      font-size: var(--tenable-heading-1-font-size, 2.625rem);
      font-weight: var(--tenable-heading-1-font-weight, bold);
      line-height: var(--tenable-heading-1-line-height, 1.2);
      margin: var(--tenable-heading-1-margin, 0 0 .5rem);
    }

    h2, .h2 {
      color: var(--tenable-heading-color, #1E2426);
      margin: var(--tenable-heading-2-margin, 0 0 .25rem);
      font-size: var(--tenable-heading-2-font-size, 1.6rem);
      font-weight: var(--tenable-heading-2-font-weight, 600);
      line-height: var(--tenable-heading-2-line-height, 1.2);
    }

    p {
      color: var(--tenable-text-color, #5B6062);
      margin: 0 0 1rem;
    }

    small {
      font-size: var(--tenable-font-small, .75rem);
    }

    a,
    a:visited {
      color: var(--tenable-link-color, #5B6062);
      text-decoration: var(--tenable-link-decoration, underline);
    }

    a:hover {
      text-decoration: underline;
    }

    input[type="checkbox"],
    input[type="radio"] {
      accent-color: var(--tenable-input-accent-color, #1E2426);
    }
  `
];


var $c8f06188fc3ad916$exports = {};

$parcel$export($c8f06188fc3ad916$exports, "countryNames", () => $c8f06188fc3ad916$export$6abcfcee8c2e5863);
$parcel$export($c8f06188fc3ad916$exports, "countryShortCodes", () => $c8f06188fc3ad916$export$d53ac25eb93ed16f);
$parcel$export($c8f06188fc3ad916$exports, "AF", () => $c8f06188fc3ad916$export$515692adc069839f);
$parcel$export($c8f06188fc3ad916$exports, "AX", () => $c8f06188fc3ad916$export$f5cd1d288a5591fb);
$parcel$export($c8f06188fc3ad916$exports, "AL", () => $c8f06188fc3ad916$export$1bb1140fe1358b00);
$parcel$export($c8f06188fc3ad916$exports, "DZ", () => $c8f06188fc3ad916$export$d2309a4fc782a0d1);
$parcel$export($c8f06188fc3ad916$exports, "AS", () => $c8f06188fc3ad916$export$33f07343a4b8be1f);
$parcel$export($c8f06188fc3ad916$exports, "AD", () => $c8f06188fc3ad916$export$132ea4ffd82bf2b2);
$parcel$export($c8f06188fc3ad916$exports, "AO", () => $c8f06188fc3ad916$export$98cc8105f49bb278);
$parcel$export($c8f06188fc3ad916$exports, "AI", () => $c8f06188fc3ad916$export$d710c5f50fc7496a);
$parcel$export($c8f06188fc3ad916$exports, "AQ", () => $c8f06188fc3ad916$export$123513653fa883e4);
$parcel$export($c8f06188fc3ad916$exports, "AG", () => $c8f06188fc3ad916$export$9b1a14e161c718eb);
$parcel$export($c8f06188fc3ad916$exports, "AR", () => $c8f06188fc3ad916$export$1cd25c0dace0921a);
$parcel$export($c8f06188fc3ad916$exports, "AM", () => $c8f06188fc3ad916$export$1507e1869e034170);
$parcel$export($c8f06188fc3ad916$exports, "AW", () => $c8f06188fc3ad916$export$d170d5872abbd45);
$parcel$export($c8f06188fc3ad916$exports, "AU", () => $c8f06188fc3ad916$export$24f205cbfb89b8fc);
$parcel$export($c8f06188fc3ad916$exports, "AT", () => $c8f06188fc3ad916$export$537de78b98ba1ef0);
$parcel$export($c8f06188fc3ad916$exports, "AZ", () => $c8f06188fc3ad916$export$16cde7da05f651a);
$parcel$export($c8f06188fc3ad916$exports, "BS", () => $c8f06188fc3ad916$export$66ea4a98fa009686);
$parcel$export($c8f06188fc3ad916$exports, "BH", () => $c8f06188fc3ad916$export$873be2d0c4c0f90f);
$parcel$export($c8f06188fc3ad916$exports, "BD", () => $c8f06188fc3ad916$export$2672079d1ac1dedf);
$parcel$export($c8f06188fc3ad916$exports, "BB", () => $c8f06188fc3ad916$export$921068d8846a1559);
$parcel$export($c8f06188fc3ad916$exports, "BY", () => $c8f06188fc3ad916$export$558af6901b7fc79a);
$parcel$export($c8f06188fc3ad916$exports, "BE", () => $c8f06188fc3ad916$export$69784246352913ed);
$parcel$export($c8f06188fc3ad916$exports, "BZ", () => $c8f06188fc3ad916$export$8af59566cb38fe85);
$parcel$export($c8f06188fc3ad916$exports, "BJ", () => $c8f06188fc3ad916$export$289e628e47fc68d4);
$parcel$export($c8f06188fc3ad916$exports, "BM", () => $c8f06188fc3ad916$export$f063c90a7fd94f53);
$parcel$export($c8f06188fc3ad916$exports, "BT", () => $c8f06188fc3ad916$export$433b53d451a98e6d);
$parcel$export($c8f06188fc3ad916$exports, "BO", () => $c8f06188fc3ad916$export$cd6527c992e4b6fe);
$parcel$export($c8f06188fc3ad916$exports, "BQ", () => $c8f06188fc3ad916$export$2ca204c58a1fc922);
$parcel$export($c8f06188fc3ad916$exports, "BA", () => $c8f06188fc3ad916$export$a73c4d14459b698d);
$parcel$export($c8f06188fc3ad916$exports, "BW", () => $c8f06188fc3ad916$export$cd7b90d76addb66a);
$parcel$export($c8f06188fc3ad916$exports, "BV", () => $c8f06188fc3ad916$export$8ba1594c72a88684);
$parcel$export($c8f06188fc3ad916$exports, "BR", () => $c8f06188fc3ad916$export$b3e0c086157e0a90);
$parcel$export($c8f06188fc3ad916$exports, "IO", () => $c8f06188fc3ad916$export$8f8422ac5947a789);
$parcel$export($c8f06188fc3ad916$exports, "BN", () => $c8f06188fc3ad916$export$ed16643e9b9e3dfe);
$parcel$export($c8f06188fc3ad916$exports, "BG", () => $c8f06188fc3ad916$export$7ecc97c3ec9172d0);
$parcel$export($c8f06188fc3ad916$exports, "BF", () => $c8f06188fc3ad916$export$5d7d56d6166de861);
$parcel$export($c8f06188fc3ad916$exports, "BI", () => $c8f06188fc3ad916$export$2601bd2ab73f6dbe);
$parcel$export($c8f06188fc3ad916$exports, "KH", () => $c8f06188fc3ad916$export$96381358fb12b492);
$parcel$export($c8f06188fc3ad916$exports, "CM", () => $c8f06188fc3ad916$export$dcd191669c0a595f);
$parcel$export($c8f06188fc3ad916$exports, "CA", () => $c8f06188fc3ad916$export$8de6180416dff1fc);
$parcel$export($c8f06188fc3ad916$exports, "CV", () => $c8f06188fc3ad916$export$9c7a4b602f1ee953);
$parcel$export($c8f06188fc3ad916$exports, "KY", () => $c8f06188fc3ad916$export$ea257f329676e0aa);
$parcel$export($c8f06188fc3ad916$exports, "CF", () => $c8f06188fc3ad916$export$ba26f2d80491fb47);
$parcel$export($c8f06188fc3ad916$exports, "TD", () => $c8f06188fc3ad916$export$9cf5b401f969f5e3);
$parcel$export($c8f06188fc3ad916$exports, "CL", () => $c8f06188fc3ad916$export$9bf3043cb7503aa1);
$parcel$export($c8f06188fc3ad916$exports, "CN", () => $c8f06188fc3ad916$export$f175668af5171efd);
$parcel$export($c8f06188fc3ad916$exports, "CX", () => $c8f06188fc3ad916$export$ef748afa94c5c5f9);
$parcel$export($c8f06188fc3ad916$exports, "CC", () => $c8f06188fc3ad916$export$183b2a0874e6e919);
$parcel$export($c8f06188fc3ad916$exports, "CO", () => $c8f06188fc3ad916$export$423e5ab65bdedcb8);
$parcel$export($c8f06188fc3ad916$exports, "KM", () => $c8f06188fc3ad916$export$7ca86d88f982585b);
$parcel$export($c8f06188fc3ad916$exports, "CG", () => $c8f06188fc3ad916$export$9e8da9070f3c2e68);
$parcel$export($c8f06188fc3ad916$exports, "CD", () => $c8f06188fc3ad916$export$6ede307faf7aaec4);
$parcel$export($c8f06188fc3ad916$exports, "CK", () => $c8f06188fc3ad916$export$2779adff9720d9c9);
$parcel$export($c8f06188fc3ad916$exports, "CR", () => $c8f06188fc3ad916$export$de92be486109a1df);
$parcel$export($c8f06188fc3ad916$exports, "CI", () => $c8f06188fc3ad916$export$ddcf9efc80efb978);
$parcel$export($c8f06188fc3ad916$exports, "HR", () => $c8f06188fc3ad916$export$41dbabafe943a3bc);
$parcel$export($c8f06188fc3ad916$exports, "CU", () => $c8f06188fc3ad916$export$6f478fc577ffffe3);
$parcel$export($c8f06188fc3ad916$exports, "CW", () => $c8f06188fc3ad916$export$640171019d58eb6d);
$parcel$export($c8f06188fc3ad916$exports, "CY", () => $c8f06188fc3ad916$export$e5e7583d5d9c5f7b);
$parcel$export($c8f06188fc3ad916$exports, "CZ", () => $c8f06188fc3ad916$export$3aa7db55ae20a642);
$parcel$export($c8f06188fc3ad916$exports, "DK", () => $c8f06188fc3ad916$export$861a3271cad515fc);
$parcel$export($c8f06188fc3ad916$exports, "DJ", () => $c8f06188fc3ad916$export$b116121769fff50f);
$parcel$export($c8f06188fc3ad916$exports, "DM", () => $c8f06188fc3ad916$export$c63caaa7a05b64da);
$parcel$export($c8f06188fc3ad916$exports, "DO", () => $c8f06188fc3ad916$export$fe81c0b6cf107daf);
$parcel$export($c8f06188fc3ad916$exports, "EC", () => $c8f06188fc3ad916$export$129fe12d32abc311);
$parcel$export($c8f06188fc3ad916$exports, "EG", () => $c8f06188fc3ad916$export$e107e11ec3489258);
$parcel$export($c8f06188fc3ad916$exports, "SV", () => $c8f06188fc3ad916$export$8fc936c6ebd916b3);
$parcel$export($c8f06188fc3ad916$exports, "GQ", () => $c8f06188fc3ad916$export$64532cc081f88b3a);
$parcel$export($c8f06188fc3ad916$exports, "ER", () => $c8f06188fc3ad916$export$20e28a5cfb7c13df);
$parcel$export($c8f06188fc3ad916$exports, "EE", () => $c8f06188fc3ad916$export$3f443bcc5237c742);
$parcel$export($c8f06188fc3ad916$exports, "ET", () => $c8f06188fc3ad916$export$404386694049c788);
$parcel$export($c8f06188fc3ad916$exports, "FK", () => $c8f06188fc3ad916$export$58f4e3559034e3ed);
$parcel$export($c8f06188fc3ad916$exports, "FO", () => $c8f06188fc3ad916$export$3117889032a11ab0);
$parcel$export($c8f06188fc3ad916$exports, "FJ", () => $c8f06188fc3ad916$export$4cd493ed69e3bc18);
$parcel$export($c8f06188fc3ad916$exports, "FI", () => $c8f06188fc3ad916$export$b742dc37108d5cac);
$parcel$export($c8f06188fc3ad916$exports, "FR", () => $c8f06188fc3ad916$export$b0bfe88d8be86eef);
$parcel$export($c8f06188fc3ad916$exports, "GF", () => $c8f06188fc3ad916$export$a1c692af90f0ad93);
$parcel$export($c8f06188fc3ad916$exports, "PF", () => $c8f06188fc3ad916$export$7d19ebf018caa9aa);
$parcel$export($c8f06188fc3ad916$exports, "TF", () => $c8f06188fc3ad916$export$4014e91f2965d3df);
$parcel$export($c8f06188fc3ad916$exports, "GA", () => $c8f06188fc3ad916$export$2c816677949efbbf);
$parcel$export($c8f06188fc3ad916$exports, "GM", () => $c8f06188fc3ad916$export$af02b8e3ecf08df4);
$parcel$export($c8f06188fc3ad916$exports, "GE", () => $c8f06188fc3ad916$export$64f1adb8dced2c27);
$parcel$export($c8f06188fc3ad916$exports, "DE", () => $c8f06188fc3ad916$export$b2bfc53cef5629f5);
$parcel$export($c8f06188fc3ad916$exports, "GH", () => $c8f06188fc3ad916$export$2063236980199869);
$parcel$export($c8f06188fc3ad916$exports, "GI", () => $c8f06188fc3ad916$export$b3b059666b470a4);
$parcel$export($c8f06188fc3ad916$exports, "GR", () => $c8f06188fc3ad916$export$be3bb2d6fb94aa6);
$parcel$export($c8f06188fc3ad916$exports, "GL", () => $c8f06188fc3ad916$export$bad2a840ccda93b6);
$parcel$export($c8f06188fc3ad916$exports, "GD", () => $c8f06188fc3ad916$export$44132903afebf574);
$parcel$export($c8f06188fc3ad916$exports, "GP", () => $c8f06188fc3ad916$export$a1e9daa76fd80d91);
$parcel$export($c8f06188fc3ad916$exports, "GU", () => $c8f06188fc3ad916$export$875a05f1afdc3a63);
$parcel$export($c8f06188fc3ad916$exports, "GT", () => $c8f06188fc3ad916$export$b023c82b48e70453);
$parcel$export($c8f06188fc3ad916$exports, "GG", () => $c8f06188fc3ad916$export$ffd553dab4f92f72);
$parcel$export($c8f06188fc3ad916$exports, "GN", () => $c8f06188fc3ad916$export$49b768d2cda4fc68);
$parcel$export($c8f06188fc3ad916$exports, "GW", () => $c8f06188fc3ad916$export$4f7b2a18b14c6e6);
$parcel$export($c8f06188fc3ad916$exports, "GY", () => $c8f06188fc3ad916$export$f433acc20da515b9);
$parcel$export($c8f06188fc3ad916$exports, "HT", () => $c8f06188fc3ad916$export$3927bce5ead7457e);
$parcel$export($c8f06188fc3ad916$exports, "HM", () => $c8f06188fc3ad916$export$e8ae668e70e7a813);
$parcel$export($c8f06188fc3ad916$exports, "VA", () => $c8f06188fc3ad916$export$8f976c058e984810);
$parcel$export($c8f06188fc3ad916$exports, "HN", () => $c8f06188fc3ad916$export$d654914ee99e1b51);
$parcel$export($c8f06188fc3ad916$exports, "HK", () => $c8f06188fc3ad916$export$7bf8e436292b0d9);
$parcel$export($c8f06188fc3ad916$exports, "HU", () => $c8f06188fc3ad916$export$2cba20fb7b4c6fda);
$parcel$export($c8f06188fc3ad916$exports, "IS", () => $c8f06188fc3ad916$export$bfe27467c1de9413);
$parcel$export($c8f06188fc3ad916$exports, "IN", () => $c8f06188fc3ad916$export$70824c8942178d60);
$parcel$export($c8f06188fc3ad916$exports, "ID", () => $c8f06188fc3ad916$export$8be180ec26319f9f);
$parcel$export($c8f06188fc3ad916$exports, "IR", () => $c8f06188fc3ad916$export$35f3e3f7e3ce71e0);
$parcel$export($c8f06188fc3ad916$exports, "IQ", () => $c8f06188fc3ad916$export$776a9becd139230f);
$parcel$export($c8f06188fc3ad916$exports, "IE", () => $c8f06188fc3ad916$export$5056f4df3c1a040a);
$parcel$export($c8f06188fc3ad916$exports, "IM", () => $c8f06188fc3ad916$export$5e0fd3f816252990);
$parcel$export($c8f06188fc3ad916$exports, "IL", () => $c8f06188fc3ad916$export$747f5b589ac90db);
$parcel$export($c8f06188fc3ad916$exports, "IT", () => $c8f06188fc3ad916$export$c8c4756768edc1be);
$parcel$export($c8f06188fc3ad916$exports, "JM", () => $c8f06188fc3ad916$export$62925b2b1d8826f);
$parcel$export($c8f06188fc3ad916$exports, "JP", () => $c8f06188fc3ad916$export$4165087edc6149ea);
$parcel$export($c8f06188fc3ad916$exports, "JE", () => $c8f06188fc3ad916$export$7300d7e65520d9c0);
$parcel$export($c8f06188fc3ad916$exports, "JO", () => $c8f06188fc3ad916$export$4ff8ba3b6e78910e);
$parcel$export($c8f06188fc3ad916$exports, "KZ", () => $c8f06188fc3ad916$export$45edc2c6b51c02b3);
$parcel$export($c8f06188fc3ad916$exports, "KE", () => $c8f06188fc3ad916$export$ebf06250eda1662e);
$parcel$export($c8f06188fc3ad916$exports, "KI", () => $c8f06188fc3ad916$export$8aa7bcd4299a59b9);
$parcel$export($c8f06188fc3ad916$exports, "KP", () => $c8f06188fc3ad916$export$171643e72dc5e91);
$parcel$export($c8f06188fc3ad916$exports, "KR", () => $c8f06188fc3ad916$export$ced591d2396bbc3f);
$parcel$export($c8f06188fc3ad916$exports, "XK", () => $c8f06188fc3ad916$export$ba5d28d969e41cd5);
$parcel$export($c8f06188fc3ad916$exports, "KW", () => $c8f06188fc3ad916$export$867391011d376267);
$parcel$export($c8f06188fc3ad916$exports, "KG", () => $c8f06188fc3ad916$export$32f37961c13d8178);
$parcel$export($c8f06188fc3ad916$exports, "LA", () => $c8f06188fc3ad916$export$64f943d6c6d62030);
$parcel$export($c8f06188fc3ad916$exports, "LV", () => $c8f06188fc3ad916$export$feea9fafc15a0118);
$parcel$export($c8f06188fc3ad916$exports, "LB", () => $c8f06188fc3ad916$export$1dd3e96947fb44fc);
$parcel$export($c8f06188fc3ad916$exports, "LS", () => $c8f06188fc3ad916$export$c6944423ed371873);
$parcel$export($c8f06188fc3ad916$exports, "LR", () => $c8f06188fc3ad916$export$9e0d336de5ae0eb3);
$parcel$export($c8f06188fc3ad916$exports, "LY", () => $c8f06188fc3ad916$export$4eb7334fca20385f);
$parcel$export($c8f06188fc3ad916$exports, "LI", () => $c8f06188fc3ad916$export$2e3013aac067a692);
$parcel$export($c8f06188fc3ad916$exports, "LT", () => $c8f06188fc3ad916$export$7158f0ceb70f54c7);
$parcel$export($c8f06188fc3ad916$exports, "LU", () => $c8f06188fc3ad916$export$b6a2dd8a7c2d6cd5);
$parcel$export($c8f06188fc3ad916$exports, "MO", () => $c8f06188fc3ad916$export$511fbc18fa6ca984);
$parcel$export($c8f06188fc3ad916$exports, "MK", () => $c8f06188fc3ad916$export$9391ff7d7f7d79ce);
$parcel$export($c8f06188fc3ad916$exports, "MG", () => $c8f06188fc3ad916$export$d7c1ae0cf4ef5274);
$parcel$export($c8f06188fc3ad916$exports, "MW", () => $c8f06188fc3ad916$export$a3772f6eb527275b);
$parcel$export($c8f06188fc3ad916$exports, "MY", () => $c8f06188fc3ad916$export$655dc88003efaac0);
$parcel$export($c8f06188fc3ad916$exports, "MV", () => $c8f06188fc3ad916$export$20138591ba7d4d60);
$parcel$export($c8f06188fc3ad916$exports, "ML", () => $c8f06188fc3ad916$export$670dad092b145ea);
$parcel$export($c8f06188fc3ad916$exports, "MT", () => $c8f06188fc3ad916$export$b900a375df2ae552);
$parcel$export($c8f06188fc3ad916$exports, "MH", () => $c8f06188fc3ad916$export$61a81a4b59098e0c);
$parcel$export($c8f06188fc3ad916$exports, "MQ", () => $c8f06188fc3ad916$export$451b471c9c9066b);
$parcel$export($c8f06188fc3ad916$exports, "MR", () => $c8f06188fc3ad916$export$c4e38e98e3fb5f60);
$parcel$export($c8f06188fc3ad916$exports, "MU", () => $c8f06188fc3ad916$export$c5764e4399dad848);
$parcel$export($c8f06188fc3ad916$exports, "YT", () => $c8f06188fc3ad916$export$8c2e794969bbe829);
$parcel$export($c8f06188fc3ad916$exports, "MX", () => $c8f06188fc3ad916$export$80b36494c451f15f);
$parcel$export($c8f06188fc3ad916$exports, "FM", () => $c8f06188fc3ad916$export$ae39d226e90e08ef);
$parcel$export($c8f06188fc3ad916$exports, "MD", () => $c8f06188fc3ad916$export$3c37c3bdb860ae1e);
$parcel$export($c8f06188fc3ad916$exports, "MC", () => $c8f06188fc3ad916$export$cd68417dc2ec295d);
$parcel$export($c8f06188fc3ad916$exports, "MN", () => $c8f06188fc3ad916$export$30e7c6589c527eef);
$parcel$export($c8f06188fc3ad916$exports, "ME", () => $c8f06188fc3ad916$export$4898541b722d275d);
$parcel$export($c8f06188fc3ad916$exports, "MS", () => $c8f06188fc3ad916$export$71ad59f2e432cfe8);
$parcel$export($c8f06188fc3ad916$exports, "MA", () => $c8f06188fc3ad916$export$d88940c21edc1e8e);
$parcel$export($c8f06188fc3ad916$exports, "MZ", () => $c8f06188fc3ad916$export$b5030f3cedb7f384);
$parcel$export($c8f06188fc3ad916$exports, "MM", () => $c8f06188fc3ad916$export$eefdfd8a735ff143);
$parcel$export($c8f06188fc3ad916$exports, "NA", () => $c8f06188fc3ad916$export$dbd1925f4fe9ec65);
$parcel$export($c8f06188fc3ad916$exports, "NR", () => $c8f06188fc3ad916$export$8885480fb36cb8cc);
$parcel$export($c8f06188fc3ad916$exports, "NP", () => $c8f06188fc3ad916$export$575bf2af220888ee);
$parcel$export($c8f06188fc3ad916$exports, "NL", () => $c8f06188fc3ad916$export$e51d3c675bb0140d);
$parcel$export($c8f06188fc3ad916$exports, "NC", () => $c8f06188fc3ad916$export$fbcebdb931d67ac9);
$parcel$export($c8f06188fc3ad916$exports, "NZ", () => $c8f06188fc3ad916$export$b6db8d689596ccb0);
$parcel$export($c8f06188fc3ad916$exports, "NI", () => $c8f06188fc3ad916$export$2128ddd8b6e5cc05);
$parcel$export($c8f06188fc3ad916$exports, "NE", () => $c8f06188fc3ad916$export$8719acbfb72c829);
$parcel$export($c8f06188fc3ad916$exports, "NG", () => $c8f06188fc3ad916$export$d9501190a8cd7a46);
$parcel$export($c8f06188fc3ad916$exports, "NU", () => $c8f06188fc3ad916$export$8227ca023eb0daaa);
$parcel$export($c8f06188fc3ad916$exports, "NF", () => $c8f06188fc3ad916$export$ebe65a9e9fde641f);
$parcel$export($c8f06188fc3ad916$exports, "MP", () => $c8f06188fc3ad916$export$15b7d6cdd29b06a0);
$parcel$export($c8f06188fc3ad916$exports, "NO", () => $c8f06188fc3ad916$export$c01351c0af048e39);
$parcel$export($c8f06188fc3ad916$exports, "OM", () => $c8f06188fc3ad916$export$1ed389bd9cb529);
$parcel$export($c8f06188fc3ad916$exports, "PK", () => $c8f06188fc3ad916$export$73910688e185534c);
$parcel$export($c8f06188fc3ad916$exports, "PW", () => $c8f06188fc3ad916$export$5f5211c171c1b47a);
$parcel$export($c8f06188fc3ad916$exports, "PS", () => $c8f06188fc3ad916$export$5adddb0645f34b2);
$parcel$export($c8f06188fc3ad916$exports, "PA", () => $c8f06188fc3ad916$export$ff7e3d480d313da2);
$parcel$export($c8f06188fc3ad916$exports, "PG", () => $c8f06188fc3ad916$export$c56943b7b8ffea21);
$parcel$export($c8f06188fc3ad916$exports, "PY", () => $c8f06188fc3ad916$export$21b6e0fb60b525ae);
$parcel$export($c8f06188fc3ad916$exports, "PE", () => $c8f06188fc3ad916$export$d5e55eb9565ea8d5);
$parcel$export($c8f06188fc3ad916$exports, "PH", () => $c8f06188fc3ad916$export$38ea63fabb2c685f);
$parcel$export($c8f06188fc3ad916$exports, "PN", () => $c8f06188fc3ad916$export$6bc8c38c416ebf89);
$parcel$export($c8f06188fc3ad916$exports, "PL", () => $c8f06188fc3ad916$export$9e95f02561f2d9f9);
$parcel$export($c8f06188fc3ad916$exports, "PT", () => $c8f06188fc3ad916$export$3961bdb9130b90e7);
$parcel$export($c8f06188fc3ad916$exports, "PR", () => $c8f06188fc3ad916$export$af5f8d68aad3cd3a);
$parcel$export($c8f06188fc3ad916$exports, "QA", () => $c8f06188fc3ad916$export$a7078eadaecd4b6f);
$parcel$export($c8f06188fc3ad916$exports, "RE", () => $c8f06188fc3ad916$export$ded96516917cab2a);
$parcel$export($c8f06188fc3ad916$exports, "RO", () => $c8f06188fc3ad916$export$993ec495e78d530d);
$parcel$export($c8f06188fc3ad916$exports, "RU", () => $c8f06188fc3ad916$export$6c2517b5e52f01cc);
$parcel$export($c8f06188fc3ad916$exports, "RW", () => $c8f06188fc3ad916$export$ef5ca6a08aac8ca5);
$parcel$export($c8f06188fc3ad916$exports, "BL", () => $c8f06188fc3ad916$export$b54e584898971a5);
$parcel$export($c8f06188fc3ad916$exports, "SH", () => $c8f06188fc3ad916$export$c713cf928ffb5e8e);
$parcel$export($c8f06188fc3ad916$exports, "KN", () => $c8f06188fc3ad916$export$fd8f06eb7ce62883);
$parcel$export($c8f06188fc3ad916$exports, "LC", () => $c8f06188fc3ad916$export$3cb73e0e841fe17f);
$parcel$export($c8f06188fc3ad916$exports, "MF", () => $c8f06188fc3ad916$export$33916af50bbab5f5);
$parcel$export($c8f06188fc3ad916$exports, "PM", () => $c8f06188fc3ad916$export$164607a37e7daeba);
$parcel$export($c8f06188fc3ad916$exports, "VC", () => $c8f06188fc3ad916$export$c3ea4fdfa4d8ecb7);
$parcel$export($c8f06188fc3ad916$exports, "WS", () => $c8f06188fc3ad916$export$911baa0677ac404c);
$parcel$export($c8f06188fc3ad916$exports, "SM", () => $c8f06188fc3ad916$export$59096964bd9627ef);
$parcel$export($c8f06188fc3ad916$exports, "ST", () => $c8f06188fc3ad916$export$80980ed6b6f31397);
$parcel$export($c8f06188fc3ad916$exports, "SA", () => $c8f06188fc3ad916$export$da51c6332ad11d7b);
$parcel$export($c8f06188fc3ad916$exports, "SN", () => $c8f06188fc3ad916$export$b70f9dd36a734be4);
$parcel$export($c8f06188fc3ad916$exports, "RS", () => $c8f06188fc3ad916$export$e9d8d46fbf5f29f6);
$parcel$export($c8f06188fc3ad916$exports, "SC", () => $c8f06188fc3ad916$export$f49cccbff6374af4);
$parcel$export($c8f06188fc3ad916$exports, "SL", () => $c8f06188fc3ad916$export$b49d6918df199090);
$parcel$export($c8f06188fc3ad916$exports, "SG", () => $c8f06188fc3ad916$export$bea437c40441867d);
$parcel$export($c8f06188fc3ad916$exports, "SX", () => $c8f06188fc3ad916$export$b4f896bb97547f66);
$parcel$export($c8f06188fc3ad916$exports, "SK", () => $c8f06188fc3ad916$export$5f584391ee0d99b4);
$parcel$export($c8f06188fc3ad916$exports, "SI", () => $c8f06188fc3ad916$export$e6702cab675b095);
$parcel$export($c8f06188fc3ad916$exports, "SB", () => $c8f06188fc3ad916$export$279f8048cbf05e80);
$parcel$export($c8f06188fc3ad916$exports, "SO", () => $c8f06188fc3ad916$export$f6311706676f39f2);
$parcel$export($c8f06188fc3ad916$exports, "ZA", () => $c8f06188fc3ad916$export$b2eccbdcd109dde0);
$parcel$export($c8f06188fc3ad916$exports, "GS", () => $c8f06188fc3ad916$export$f7fbe7cb90eabcb4);
$parcel$export($c8f06188fc3ad916$exports, "SS", () => $c8f06188fc3ad916$export$8cda4cf3f4deb8c2);
$parcel$export($c8f06188fc3ad916$exports, "ES", () => $c8f06188fc3ad916$export$a723e6e41cced9bd);
$parcel$export($c8f06188fc3ad916$exports, "LK", () => $c8f06188fc3ad916$export$782aca1f2c103f6b);
$parcel$export($c8f06188fc3ad916$exports, "SD", () => $c8f06188fc3ad916$export$5b088def975a652b);
$parcel$export($c8f06188fc3ad916$exports, "SR", () => $c8f06188fc3ad916$export$13acf42283a26926);
$parcel$export($c8f06188fc3ad916$exports, "SZ", () => $c8f06188fc3ad916$export$988c8b3cfeed3531);
$parcel$export($c8f06188fc3ad916$exports, "SE", () => $c8f06188fc3ad916$export$88d2e60d4be28663);
$parcel$export($c8f06188fc3ad916$exports, "CH", () => $c8f06188fc3ad916$export$31ff2235b44019b8);
$parcel$export($c8f06188fc3ad916$exports, "SY", () => $c8f06188fc3ad916$export$2e8caadc521d7cbb);
$parcel$export($c8f06188fc3ad916$exports, "TW", () => $c8f06188fc3ad916$export$1d1fd77441e66de6);
$parcel$export($c8f06188fc3ad916$exports, "TJ", () => $c8f06188fc3ad916$export$f5448d52a2727e70);
$parcel$export($c8f06188fc3ad916$exports, "TZ", () => $c8f06188fc3ad916$export$786aa6dc686c7fa2);
$parcel$export($c8f06188fc3ad916$exports, "TH", () => $c8f06188fc3ad916$export$2b39a3648955dd09);
$parcel$export($c8f06188fc3ad916$exports, "TL", () => $c8f06188fc3ad916$export$28666a74ae2b9cff);
$parcel$export($c8f06188fc3ad916$exports, "TG", () => $c8f06188fc3ad916$export$3909ee2d70cce411);
$parcel$export($c8f06188fc3ad916$exports, "TK", () => $c8f06188fc3ad916$export$73184284939cbbe8);
$parcel$export($c8f06188fc3ad916$exports, "TO", () => $c8f06188fc3ad916$export$ee525e60afffec7b);
$parcel$export($c8f06188fc3ad916$exports, "TT", () => $c8f06188fc3ad916$export$c506431d6b27243b);
$parcel$export($c8f06188fc3ad916$exports, "TN", () => $c8f06188fc3ad916$export$82039c5ab5b44a72);
$parcel$export($c8f06188fc3ad916$exports, "TR", () => $c8f06188fc3ad916$export$5582bd7183a5e873);
$parcel$export($c8f06188fc3ad916$exports, "TM", () => $c8f06188fc3ad916$export$e3227e6e5fca8775);
$parcel$export($c8f06188fc3ad916$exports, "TC", () => $c8f06188fc3ad916$export$bf91931db7b40921);
$parcel$export($c8f06188fc3ad916$exports, "TV", () => $c8f06188fc3ad916$export$9e799ed47e538f9d);
$parcel$export($c8f06188fc3ad916$exports, "UG", () => $c8f06188fc3ad916$export$c5b3cc9fdc52ea1d);
$parcel$export($c8f06188fc3ad916$exports, "UA", () => $c8f06188fc3ad916$export$4b88e746e0f81154);
$parcel$export($c8f06188fc3ad916$exports, "AE", () => $c8f06188fc3ad916$export$2b2c8e343c91a153);
$parcel$export($c8f06188fc3ad916$exports, "GB", () => $c8f06188fc3ad916$export$5c1daad85ece4f0d);
$parcel$export($c8f06188fc3ad916$exports, "US", () => $c8f06188fc3ad916$export$6137fb82cd5996e9);
$parcel$export($c8f06188fc3ad916$exports, "UM", () => $c8f06188fc3ad916$export$a0e1852ae1fae17b);
$parcel$export($c8f06188fc3ad916$exports, "UY", () => $c8f06188fc3ad916$export$3f448fbd9cc8b25f);
$parcel$export($c8f06188fc3ad916$exports, "UZ", () => $c8f06188fc3ad916$export$6553e0f362fae356);
$parcel$export($c8f06188fc3ad916$exports, "VU", () => $c8f06188fc3ad916$export$e4fcd53a919210fd);
$parcel$export($c8f06188fc3ad916$exports, "VE", () => $c8f06188fc3ad916$export$d7d2699f2b01bb80);
$parcel$export($c8f06188fc3ad916$exports, "VN", () => $c8f06188fc3ad916$export$4ef9166b5b9f8bef);
$parcel$export($c8f06188fc3ad916$exports, "VG", () => $c8f06188fc3ad916$export$42769a1039364fc6);
$parcel$export($c8f06188fc3ad916$exports, "VI", () => $c8f06188fc3ad916$export$ae144c30ed7463e6);
$parcel$export($c8f06188fc3ad916$exports, "WF", () => $c8f06188fc3ad916$export$2791da67db7afdb6);
$parcel$export($c8f06188fc3ad916$exports, "EH", () => $c8f06188fc3ad916$export$8e048a19e03780a2);
$parcel$export($c8f06188fc3ad916$exports, "YE", () => $c8f06188fc3ad916$export$5c4a0ca5352789e5);
$parcel$export($c8f06188fc3ad916$exports, "ZM", () => $c8f06188fc3ad916$export$8b0f08115411339f);
$parcel$export($c8f06188fc3ad916$exports, "ZW", () => $c8f06188fc3ad916$export$b2fd9c01d360241f);
$parcel$export($c8f06188fc3ad916$exports, "allCountries", () => $c8f06188fc3ad916$export$234e4f7526f79ef2);
$parcel$export($c8f06188fc3ad916$exports, "countryTuples", () => $c8f06188fc3ad916$export$7a8c3fa4a24a2370);
const $c8f06188fc3ad916$export$6abcfcee8c2e5863 = [
    "Afghanistan",
    "\xc5land Islands",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo, Republic of the (Brazzaville)",
    "Congo, the Democratic Republic of the (Kinshasa)",
    "Cook Islands",
    "Costa Rica",
    "C\xf4te d'Ivoire, Republic of",
    "Croatia",
    "Cuba",
    "Cura\xe7ao",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands (Islas Malvinas)",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern and Antarctic Lands",
    "Gabon",
    "Gambia, The",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard Island and McDonald Islands",
    "Holy See (Vatican City)",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran, Islamic Republic of",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, Democratic People's Republic of",
    "Korea, Republic of",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Macedonia, Republic of",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia, Federated States of",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "R\xe9union",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "Saint Barth\xe9lemy",
    "Saint Helena, Ascension and Tristan da Cunha",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten (Dutch part)",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia and South Sandwich Islands",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Eswatini",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Taiwan",
    "Tajikistan",
    "Tanzania, United Republic of",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "United States Minor Outlying Islands",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela, Bolivarian Republic of",
    "Vietnam",
    "Virgin Islands, British",
    "Virgin Islands, U.S.",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe"
];
const $c8f06188fc3ad916$export$d53ac25eb93ed16f = [
    "AF",
    "AX",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AQ",
    "AG",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BQ",
    "BA",
    "BW",
    "BV",
    "BR",
    "IO",
    "BN",
    "BG",
    "BF",
    "BI",
    "KH",
    "CM",
    "CA",
    "CV",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CG",
    "CD",
    "CK",
    "CR",
    "CI",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "DK",
    "DJ",
    "DM",
    "DO",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "ET",
    "FK",
    "FO",
    "FJ",
    "FI",
    "FR",
    "GF",
    "PF",
    "TF",
    "GA",
    "GM",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GG",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "VA",
    "HN",
    "HK",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IM",
    "IL",
    "IT",
    "JM",
    "JP",
    "JE",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KP",
    "KR",
    "XK",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MO",
    "MK",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MQ",
    "MR",
    "MU",
    "YT",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "NC",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "MP",
    "NO",
    "OM",
    "PK",
    "PW",
    "PS",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "RE",
    "RO",
    "RU",
    "RW",
    "BL",
    "SH",
    "KN",
    "LC",
    "MF",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SX",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "GS",
    "SS",
    "ES",
    "LK",
    "SD",
    "SR",
    "SZ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TL",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "UG",
    "UA",
    "AE",
    "GB",
    "US",
    "UM",
    "UY",
    "UZ",
    "VU",
    "VE",
    "VN",
    "VG",
    "VI",
    "WF",
    "EH",
    "YE",
    "ZM",
    "ZW"
];
const $c8f06188fc3ad916$export$515692adc069839f = [
    "Afghanistan",
    "AF",
    [
        [
            "Badakhshan",
            "BDS"
        ],
        [
            "Badghis",
            "BDG"
        ],
        [
            "Baghlan",
            "BGL"
        ],
        [
            "Balkh",
            "BAL"
        ],
        [
            "Bamyan",
            "BAM"
        ],
        [
            "Daykundi",
            "DAY"
        ],
        [
            "Farah",
            "FRA"
        ],
        [
            "Faryab",
            "FYB"
        ],
        [
            "Ghazni",
            "GHA"
        ],
        [
            "Ghor",
            "GHO"
        ],
        [
            "Helmand",
            "HEL"
        ],
        [
            "Herat",
            "HER"
        ],
        [
            "Jowzjan",
            "JOW"
        ],
        [
            "Kabul",
            "KAB"
        ],
        [
            "Kandahar",
            "KAN"
        ],
        [
            "Kapisa",
            "KAP"
        ],
        [
            "Khost",
            "KHO"
        ],
        [
            "Kunar",
            "KNR"
        ],
        [
            "Kunduz",
            "KDZ"
        ],
        [
            "Laghman",
            "LAG"
        ],
        [
            "Logar",
            "LOW"
        ],
        [
            "Maidan Wardak",
            "WAR"
        ],
        [
            "Nangarhar",
            "NAN"
        ],
        [
            "Nimruz",
            "NIM"
        ],
        [
            "Nuristan",
            "NUR"
        ],
        [
            "Paktia",
            "PIA"
        ],
        [
            "Paktika",
            "PKA"
        ],
        [
            "Panjshir",
            "PAN"
        ],
        [
            "Parwan",
            "PAR"
        ],
        [
            "Samangan",
            "SAM"
        ],
        [
            "Sar-e Pol",
            "SAR"
        ],
        [
            "Takhar",
            "TAK"
        ],
        [
            "Urozgan",
            "ORU"
        ],
        [
            "Zabul",
            "ZAB"
        ]
    ]
];
const $c8f06188fc3ad916$export$f5cd1d288a5591fb = [
    "\xc5land Islands",
    "AX",
    [
        [
            "Br\xe4nd\xf6",
            "BR"
        ],
        [
            "Ecker\xf6",
            "EC"
        ],
        [
            "Finstr\xf6m",
            "FN"
        ],
        [
            "F\xf6gl\xf6",
            "FG"
        ],
        [
            "Geta",
            "GT"
        ],
        [
            "Hammarland",
            "HM"
        ],
        [
            "Jomala",
            "JM"
        ],
        [
            "Kumlinge",
            "KM"
        ],
        [
            "K\xf6kar",
            "KK"
        ],
        [
            "Lemland",
            "LE"
        ],
        [
            "Lumparland",
            "LU"
        ],
        [
            "Mariehamn",
            "MH"
        ],
        [
            "Saltvik",
            "SV"
        ],
        [
            "Sottunga",
            "ST"
        ],
        [
            "Sund",
            "SD"
        ],
        [
            "V\xe5rd\xf6",
            "VR"
        ]
    ]
];
const $c8f06188fc3ad916$export$1bb1140fe1358b00 = [
    "Albania",
    "AL",
    [
        [
            "Berat",
            "01"
        ],
        [
            "Dib\xebr",
            "09"
        ],
        [
            "Durr\xebs",
            "02"
        ],
        [
            "Elbasan",
            "03"
        ],
        [
            "Fier",
            "04"
        ],
        [
            "Gjirokast\xebr",
            "05"
        ],
        [
            "Kor\xe7\xeb",
            "06"
        ],
        [
            "Kuk\xebs",
            "07"
        ],
        [
            "Lezh\xeb",
            "08"
        ],
        [
            "Shkod\xebr",
            "10"
        ],
        [
            "Tirana",
            "11"
        ],
        [
            "Vlor\xeb",
            "12"
        ]
    ]
];
const $c8f06188fc3ad916$export$d2309a4fc782a0d1 = [
    "Algeria",
    "DZ",
    [
        [
            "Adrar",
            "01"
        ],
        [
            "A\xefn Defla",
            "44"
        ],
        [
            "A\xefn T\xe9mouchent",
            "46"
        ],
        [
            "Algiers",
            "16"
        ],
        [
            "Annaba",
            "23"
        ],
        [
            "Batna",
            "05"
        ],
        [
            "B\xe9char",
            "08"
        ],
        [
            "B\xe9ja\xefa",
            "06"
        ],
        [
            "Biskra",
            "07"
        ],
        [
            "Blida",
            "09"
        ],
        [
            "Bordj Bou Arr\xe9ridj",
            "34"
        ],
        [
            "Bou\xefra",
            "10"
        ],
        [
            "Boumerd\xe8s",
            "35"
        ],
        [
            "Chlef",
            "02"
        ],
        [
            "Constantine",
            "25"
        ],
        [
            "Djelfa",
            "17"
        ],
        [
            "El Bayadh",
            "32"
        ],
        [
            "El Oued",
            "39"
        ],
        [
            "El Tarf",
            "36"
        ],
        [
            "Gharda\xefa",
            "47"
        ],
        [
            "Guelma",
            "24"
        ],
        [
            "Illizi",
            "33"
        ],
        [
            "Jijel",
            "18"
        ],
        [
            "Khenchela",
            "40"
        ],
        [
            "Laghouat",
            "03"
        ],
        [
            "Mascara",
            "29"
        ],
        [
            "M\xe9d\xe9a",
            "26"
        ],
        [
            "Mila",
            "43"
        ],
        [
            "Mostaganem",
            "27"
        ],
        [
            "Msila",
            "28"
        ],
        [
            "Na\xe2ma",
            "45"
        ],
        [
            "Oran",
            "31"
        ],
        [
            "Ouargla",
            "30"
        ],
        [
            "Oum el Bouaghi",
            "04"
        ],
        [
            "Relizane",
            "48"
        ],
        [
            "Sa\xefda",
            "20"
        ],
        [
            "S\xe9tif",
            "19"
        ],
        [
            "Sidi Bel Abb\xe8s",
            "22"
        ],
        [
            "Skikda",
            "21"
        ],
        [
            "Souk Ahras",
            "41"
        ],
        [
            "Tamanghasset",
            "11"
        ],
        [
            "T\xe9bessa",
            "12"
        ],
        [
            "Tiaret",
            "14"
        ],
        [
            "Tindouf",
            "37"
        ],
        [
            "Tipaza",
            "42"
        ],
        [
            "Tissemsilt",
            "38"
        ],
        [
            "Tizi Ouzou",
            "15"
        ],
        [
            "Tlemcen",
            "13"
        ]
    ]
];
const $c8f06188fc3ad916$export$33f07343a4b8be1f = [
    "American Samoa",
    "AS",
    [
        [
            "Tutuila",
            "01"
        ],
        [
            "Aunu'u",
            "02"
        ],
        [
            "Ta'\u016B",
            "03"
        ],
        [
            "Ofu\u2011Olosega",
            "04"
        ],
        [
            "Rose Atoll",
            "21"
        ],
        [
            "Swains Island",
            "22"
        ]
    ]
];
const $c8f06188fc3ad916$export$132ea4ffd82bf2b2 = [
    "Andorra",
    "AD",
    [
        [
            "Andorra la Vella",
            "07"
        ],
        [
            "Canillo",
            "02"
        ],
        [
            "Encamp",
            "03"
        ],
        [
            "Escaldes-Engordany",
            "08"
        ],
        [
            "La Massana",
            "04"
        ],
        [
            "Ordino",
            "05"
        ],
        [
            "Sant Juli\xe0 de L\xf2ria",
            "06"
        ]
    ]
];
const $c8f06188fc3ad916$export$98cc8105f49bb278 = [
    "Angola",
    "AO",
    [
        [
            "Bengo",
            "BGO"
        ],
        [
            "Benguela",
            "BGU"
        ],
        [
            "Bi\xe9",
            "BIE"
        ],
        [
            "Cabinda",
            "CAB"
        ],
        [
            "Cuando Cubango",
            "CCU"
        ],
        [
            "Cuanza Norte",
            "CNO"
        ],
        [
            "Cuanza Sul",
            "CUS"
        ],
        [
            "Cunene",
            "CNN"
        ],
        [
            "Huambo",
            "HUA"
        ],
        [
            "Hu\xedla",
            "HUI"
        ],
        [
            "Luanda",
            "LUA"
        ],
        [
            "Lunda Norte",
            "LNO"
        ],
        [
            "Lunda Sul",
            "LSU"
        ],
        [
            "Malanje",
            "MAL"
        ],
        [
            "Moxico",
            "MOX"
        ],
        [
            "Namibe",
            "NAM"
        ],
        [
            "U\xedge",
            "UIG"
        ],
        [
            "Zaire",
            "ZAI"
        ]
    ]
];
const $c8f06188fc3ad916$export$d710c5f50fc7496a = [
    "Anguilla",
    "AI",
    [
        [
            "Anguilla",
            "01"
        ],
        [
            "Anguillita Island",
            "02"
        ],
        [
            "Blowing Rock",
            "03"
        ],
        [
            "Cove Cay",
            "04"
        ],
        [
            "Crocus Cay",
            "05"
        ],
        [
            "Deadman's Cay",
            "06"
        ],
        [
            "Dog Island",
            "07"
        ],
        [
            "East Cay",
            "08"
        ],
        [
            "Little Island",
            "09"
        ],
        [
            "Little Scrub Island",
            "10"
        ],
        [
            "Mid Cay",
            "11"
        ],
        [
            "North Cay",
            "12"
        ],
        [
            "Prickly Pear Cays",
            "13"
        ],
        [
            "Rabbit Island",
            "14"
        ],
        [
            "Sandy Island/Sand Island",
            "15"
        ],
        [
            "Scilly Cay",
            "16"
        ],
        [
            "Scrub Island",
            "17"
        ],
        [
            "Seal Island",
            "18"
        ],
        [
            "Sombrero/Hat Island",
            "19"
        ],
        [
            "South Cay",
            "20"
        ],
        [
            "South Wager Island",
            "21"
        ],
        [
            "West Cay",
            "22"
        ]
    ]
];
const $c8f06188fc3ad916$export$123513653fa883e4 = [
    "Antarctica",
    "AQ",
    [
        [
            "Antarctica",
            "AQ"
        ]
    ]
];
const $c8f06188fc3ad916$export$9b1a14e161c718eb = [
    "Antigua and Barbuda",
    "AG",
    [
        [
            "Antigua Island",
            "01"
        ],
        [
            "Barbuda Island",
            "02"
        ],
        [
            "Bird Island",
            "04"
        ],
        [
            "Bishop Island",
            "05"
        ],
        [
            "Blake Island",
            "06"
        ],
        [
            "Crump Island",
            "09"
        ],
        [
            "Dulcina Island",
            "10"
        ],
        [
            "Exchange Island",
            "11"
        ],
        [
            "Five Islands",
            "12"
        ],
        [
            "Great Bird Island",
            "13"
        ],
        [
            "Green Island",
            "14"
        ],
        [
            "Guiana Island",
            "15"
        ],
        [
            "Hawes Island",
            "17"
        ],
        [
            "Hells Gate Island",
            "16"
        ],
        [
            "Henry Island",
            "18"
        ],
        [
            "Johnson Island",
            "19"
        ],
        [
            "Kid Island",
            "20"
        ],
        [
            "Lobster Island",
            "22"
        ],
        [
            "Maiden Island",
            "24"
        ],
        [
            "Moor Island",
            "25"
        ],
        [
            "Nanny Island",
            "26"
        ],
        [
            "Pelican Island",
            "27"
        ],
        [
            "Prickly Pear Island",
            "28"
        ],
        [
            "Rabbit Island",
            "29"
        ],
        [
            "Red Head Island",
            "31"
        ],
        [
            "Redonda Island",
            "03"
        ],
        [
            "Sandy Island",
            "32"
        ],
        [
            "Smith Island",
            "33"
        ],
        [
            "The Sisters",
            "34"
        ],
        [
            "Vernon Island",
            "35"
        ],
        [
            "Wicked Will Island",
            "36"
        ],
        [
            "York Island",
            "37"
        ]
    ]
];
const $c8f06188fc3ad916$export$1cd25c0dace0921a = [
    "Argentina",
    "AR",
    [
        [
            "Buenos Aires",
            "B"
        ],
        [
            "Capital Federal",
            "C"
        ],
        [
            "Catamarca",
            "K"
        ],
        [
            "Chaco",
            "H"
        ],
        [
            "Chubut",
            "U"
        ],
        [
            "C\xf3rdoba",
            "X"
        ],
        [
            "Corrientes",
            "W"
        ],
        [
            "Entre R\xedos",
            "E"
        ],
        [
            "Formosa",
            "P"
        ],
        [
            "Jujuy",
            "Y"
        ],
        [
            "La Pampa",
            "L"
        ],
        [
            "La Rioja",
            "F"
        ],
        [
            "Mendoza",
            "M"
        ],
        [
            "Misiones",
            "N"
        ],
        [
            "Neuqu\xe9n",
            "Q"
        ],
        [
            "R\xedo Negro",
            "R"
        ],
        [
            "Salta",
            "A"
        ],
        [
            "San Juan",
            "J"
        ],
        [
            "San Luis",
            "D"
        ],
        [
            "Santa Cruz",
            "Z"
        ],
        [
            "Santa Fe",
            "S"
        ],
        [
            "Santiago del Estero",
            "G"
        ],
        [
            "Tierra del Fuego",
            "V"
        ],
        [
            "Tucum\xe1n",
            "T"
        ]
    ]
];
const $c8f06188fc3ad916$export$1507e1869e034170 = [
    "Armenia",
    "AM",
    [
        [
            "Aragatsotn",
            "AG"
        ],
        [
            "Ararat",
            "AR"
        ],
        [
            "Armavir",
            "AV"
        ],
        [
            "Gegharkunik",
            "GR"
        ],
        [
            "Kotayk",
            "KT"
        ],
        [
            "Lori",
            "LO"
        ],
        [
            "Shirak",
            "SH"
        ],
        [
            "Syunik",
            "SU"
        ],
        [
            "Tavush",
            "TV"
        ],
        [
            "Vayots Dzor",
            "VD"
        ],
        [
            "Yerevan",
            "ER"
        ]
    ]
];
const $c8f06188fc3ad916$export$d170d5872abbd45 = [
    "Aruba",
    "AW",
    [
        [
            "Aruba",
            "AW"
        ]
    ]
];
const $c8f06188fc3ad916$export$24f205cbfb89b8fc = [
    "Australia",
    "AU",
    [
        [
            "Australian Capital Territory",
            "ACT"
        ],
        [
            "New South Wales",
            "NSW"
        ],
        [
            "Northern Territory",
            "NT"
        ],
        [
            "Queensland",
            "QLD"
        ],
        [
            "South Australia",
            "SA"
        ],
        [
            "Tasmania",
            "TAS"
        ],
        [
            "Victoria",
            "VIC"
        ],
        [
            "Western Australia",
            "WA"
        ]
    ]
];
const $c8f06188fc3ad916$export$537de78b98ba1ef0 = [
    "Austria",
    "AT",
    [
        [
            "Burgenland",
            "1"
        ],
        [
            "K\xe4rnten",
            "2"
        ],
        [
            "Nieder\xf6sterreich",
            "3"
        ],
        [
            "Ober\xf6sterreich",
            "4"
        ],
        [
            "Salzburg",
            "5"
        ],
        [
            "Steiermark",
            "6"
        ],
        [
            "Tirol",
            "7"
        ],
        [
            "Vorarlberg",
            "8"
        ],
        [
            "Wien",
            "9"
        ]
    ]
];
const $c8f06188fc3ad916$export$16cde7da05f651a = [
    "Azerbaijan",
    "AZ",
    [
        [
            "Ab\u015Feron",
            "ABS"
        ],
        [
            "A\u011Fcab\u0259di",
            "AGC"
        ],
        [
            "A\u011Fdam",
            "AGM"
        ],
        [
            "A\u011Fda\u015F",
            "AGS"
        ],
        [
            "A\u011Fstafa",
            "AGA"
        ],
        [
            "A\u011Fsu",
            "AGU"
        ],
        [
            "Astara",
            "AST"
        ],
        [
            "Bak\u0131",
            "BAK"
        ],
        [
            "Bab\u0259k",
            "BAB"
        ],
        [
            "Balak\u0259n",
            "BAL"
        ],
        [
            "B\u0259rd\u0259",
            "BAR"
        ],
        [
            "Beyl\u0259qan",
            "BEY"
        ],
        [
            "Bil\u0259suvar",
            "BIL"
        ],
        [
            "C\u0259bray\u0131l",
            "CAB"
        ],
        [
            "C\u0259lilabad",
            "CAL"
        ],
        [
            "Culfa",
            "CUL"
        ],
        [
            "Da\u015Fk\u0259s\u0259n",
            "DAS"
        ],
        [
            "F\xfczuli",
            "FUZ"
        ],
        [
            "G\u0259d\u0259b\u0259y",
            "GAD"
        ],
        [
            "Goranboy",
            "GOR"
        ],
        [
            "G\xf6y\xe7ay",
            "GOY"
        ],
        [
            "G\xf6yg\xf6l",
            "GYG"
        ],
        [
            "Hac\u0131qabul",
            "HAC"
        ],
        [
            "\u0130mi\u015Fli",
            "IMI"
        ],
        [
            "\u0130smay\u0131ll\u0131",
            "ISM"
        ],
        [
            "K\u0259lb\u0259c\u0259r",
            "KAL"
        ],
        [
            "K\u01DDng\u01DDrli",
            "KAN"
        ],
        [
            "K\xfcrd\u0259mir",
            "KUR"
        ],
        [
            "La\xe7\u0131n",
            "LAC"
        ],
        [
            "L\u0259nk\u0259ran",
            "LAN"
        ],
        [
            "Lerik",
            "LER"
        ],
        [
            "Masall\u0131",
            "MAS"
        ],
        [
            "Neft\xe7ala",
            "NEF"
        ],
        [
            "O\u011Fuz",
            "OGU"
        ],
        [
            "Ordubad",
            "ORD"
        ],
        [
            "Q\u0259b\u0259l\u0259",
            "QAB"
        ],
        [
            "Qax",
            "QAX"
        ],
        [
            "Qazax",
            "QAZ"
        ],
        [
            "Qobustan",
            "QOB"
        ],
        [
            "Quba",
            "QBA"
        ],
        [
            "Qubadli",
            "QBI"
        ],
        [
            "Qusar",
            "QUS"
        ],
        [
            "Saatl\u0131",
            "SAT"
        ],
        [
            "Sabirabad",
            "SAB"
        ],
        [
            "\u015Eabran",
            "SBN"
        ],
        [
            "S\u0259d\u0259r\u0259k",
            "SAD"
        ],
        [
            "\u015Eahbuz",
            "SAH"
        ],
        [
            "\u015E\u0259ki",
            "SAK"
        ],
        [
            "Salyan",
            "SAL"
        ],
        [
            "\u015Eamax\u0131",
            "SMI"
        ],
        [
            "\u015E\u0259mkir",
            "SKR"
        ],
        [
            "Samux",
            "SMX"
        ],
        [
            "\u015E\u0259rur",
            "SAR"
        ],
        [
            "Siy\u0259z\u0259n",
            "SIY"
        ],
        [
            "\u015Eu\u015Fa",
            "SUS"
        ],
        [
            "T\u0259rt\u0259r",
            "TAR"
        ],
        [
            "Tovuz",
            "TOV"
        ],
        [
            "Ucar",
            "UCA"
        ],
        [
            "Xa\xe7maz",
            "XAC"
        ],
        [
            "X\u0131z\u0131",
            "XIZ"
        ],
        [
            "Xocal\u0131",
            "XCI"
        ],
        [
            "Xocav\u0259nd",
            "XVD"
        ],
        [
            "Yard\u0131ml\u0131",
            "YAR"
        ],
        [
            "Yevlax",
            "YEV"
        ],
        [
            "Z\u0259ngilan",
            "ZAN"
        ],
        [
            "Zaqatala",
            "ZAQ"
        ],
        [
            "Z\u0259rdab",
            "ZAR"
        ]
    ]
];
const $c8f06188fc3ad916$export$66ea4a98fa009686 = [
    "Bahamas",
    "BS",
    [
        [
            "Acklins Island",
            "01"
        ],
        [
            "Berry Islands",
            "22"
        ],
        [
            "Bimini",
            "02"
        ],
        [
            "Black Point",
            "23"
        ],
        [
            "Cat Island",
            "03"
        ],
        [
            "Central Abaco",
            "24"
        ],
        [
            "Crooked Island and Long Cay",
            "28"
        ],
        [
            "East Grand Bahama",
            "29"
        ],
        [
            "Exuma",
            "04"
        ],
        [
            "Freeport",
            "05"
        ],
        [
            "Fresh Creek",
            "06"
        ],
        [
            "Governor's Harbour",
            "07"
        ],
        [
            "Green Turtle Cay",
            "08"
        ],
        [
            "Harbour Island",
            "09"
        ],
        [
            "High Rock",
            "10"
        ],
        [
            "Inagua",
            "11"
        ],
        [
            "Kemps Bay",
            "12"
        ],
        [
            "Long Island",
            "13"
        ],
        [
            "Marsh Harbour",
            "14"
        ],
        [
            "Mayaguana",
            "15"
        ],
        [
            "Moore\u2019s Island",
            "40"
        ],
        [
            "New Providence",
            "16"
        ],
        [
            "Nichollstown and Berry Islands",
            "17"
        ],
        [
            "North Abaco",
            "42"
        ],
        [
            "North Andros",
            "41"
        ],
        [
            "North Eleuthera",
            "33"
        ],
        [
            "Ragged Island",
            "18"
        ],
        [
            "Rock Sound",
            "19"
        ],
        [
            "San Salvador and Rum Cay",
            "20"
        ],
        [
            "Sandy Point",
            "21"
        ],
        [
            "South Abaco",
            "35"
        ],
        [
            "South Andros",
            "36"
        ],
        [
            "South Eleuthera",
            "37"
        ],
        [
            "West Grand Bahama",
            "39"
        ],
        [
            "Central Andros",
            "43"
        ],
        [
            "Central Eleuthera",
            "44"
        ],
        [
            "Grand Cay",
            "45"
        ],
        [
            "Hope Town",
            "46"
        ],
        [
            "Mangrove Cay",
            "47"
        ],
        [
            "Spanish Wells",
            "48"
        ]
    ]
];
const $c8f06188fc3ad916$export$873be2d0c4c0f90f = [
    "Bahrain",
    "BH",
    [
        [
            "Al Jan\u016Bb\u012Byah",
            "14"
        ],
        [
            "Al Man\u0101mah",
            "13"
        ],
        [
            "Al Mu\u1E29arraq",
            "15"
        ],
        [
            "Al Wus\u0163\xe1",
            "16"
        ],
        [
            "Ash Sham\u0101l\u012Byah",
            "17"
        ]
    ]
];
const $c8f06188fc3ad916$export$2672079d1ac1dedf = [
    "Bangladesh",
    "BD",
    [
        [
            "Barisal",
            "A"
        ],
        [
            "Chittagong",
            "B"
        ],
        [
            "Dhaka",
            "C"
        ],
        [
            "Khulna",
            "D"
        ],
        [
            "Mymensingh",
            "M"
        ],
        [
            "Rajshahi",
            "E"
        ],
        [
            "Rangpur",
            "F"
        ],
        [
            "Sylhet",
            "G"
        ]
    ]
];
const $c8f06188fc3ad916$export$921068d8846a1559 = [
    "Barbados",
    "BB",
    [
        [
            "Christ Church",
            "01"
        ],
        [
            "Saint Andrew",
            "02"
        ],
        [
            "Saint George",
            "03"
        ],
        [
            "Saint James",
            "04"
        ],
        [
            "Saint John",
            "05"
        ],
        [
            "Saint Joseph",
            "06"
        ],
        [
            "Saint Lucy",
            "07"
        ],
        [
            "Saint Michael",
            "08"
        ],
        [
            "Saint Peter",
            "09"
        ],
        [
            "Saint Philip",
            "10"
        ],
        [
            "Saint Thomas",
            "11"
        ]
    ]
];
const $c8f06188fc3ad916$export$558af6901b7fc79a = [
    "Belarus",
    "BY",
    [
        [
            "Brest voblast",
            "BR"
        ],
        [
            "Gorod Minsk",
            "HM"
        ],
        [
            "Homiel voblast",
            "HO"
        ],
        [
            "Hrodna voblast",
            "HR"
        ],
        [
            "Mahilyow voblast",
            "MA"
        ],
        [
            "Minsk voblast",
            "MI"
        ],
        [
            "Vitsebsk voblast",
            "VI"
        ]
    ]
];
const $c8f06188fc3ad916$export$69784246352913ed = [
    "Belgium",
    "BE",
    [
        [
            "Brussels",
            "BRU"
        ],
        [
            "Flanders",
            "VLG"
        ],
        [
            "Wallonia",
            "WAL"
        ]
    ]
];
const $c8f06188fc3ad916$export$8af59566cb38fe85 = [
    "Belize",
    "BZ",
    [
        [
            "Belize District",
            "BZ"
        ],
        [
            "Cayo District",
            "CY"
        ],
        [
            "Corozal District",
            "CZL"
        ],
        [
            "Orange Walk District",
            "OW"
        ],
        [
            "Stann Creek District",
            "SC"
        ],
        [
            "Toledo District",
            "TOL"
        ]
    ]
];
const $c8f06188fc3ad916$export$289e628e47fc68d4 = [
    "Benin",
    "BJ",
    [
        [
            "Alibori",
            "AL"
        ],
        [
            "Atakora",
            "AK"
        ],
        [
            "Atlantique",
            "AQ"
        ],
        [
            "Borgou",
            "BO"
        ],
        [
            "Collines Department",
            "CO"
        ],
        [
            "Donga",
            "DO"
        ],
        [
            "Kouffo",
            "KO"
        ],
        [
            "Littoral Department",
            "LI"
        ],
        [
            "Mono Department",
            "MO"
        ],
        [
            "Ou\xe9m\xe9",
            "OU"
        ],
        [
            "Plateau",
            "PL"
        ],
        [
            "Zou",
            "ZO"
        ]
    ]
];
const $c8f06188fc3ad916$export$f063c90a7fd94f53 = [
    "Bermuda",
    "BM",
    [
        [
            "City of Hamilton",
            "03"
        ],
        [
            "Devonshire Parish",
            "01"
        ],
        [
            "Hamilton Parish",
            "02"
        ],
        [
            "Paget Parish",
            "04"
        ],
        [
            "Pembroke Parish",
            "05"
        ],
        [
            "Sandys Parish",
            "08"
        ],
        [
            "Smith's Parish",
            "09"
        ],
        [
            "Southampton Parish",
            "10"
        ],
        [
            "St. George's Parish",
            "07"
        ],
        [
            "Town of St. George",
            "06"
        ],
        [
            "Warwick Parish",
            "11"
        ]
    ]
];
const $c8f06188fc3ad916$export$433b53d451a98e6d = [
    "Bhutan",
    "BT",
    [
        [
            "Bumthang",
            "33"
        ],
        [
            "Chhukha",
            "12"
        ],
        [
            "Dagana",
            "22"
        ],
        [
            "Gasa",
            "GA"
        ],
        [
            "Haa",
            "13"
        ],
        [
            "Lhuntse",
            "44"
        ],
        [
            "Mongar",
            "42"
        ],
        [
            "Paro",
            "11"
        ],
        [
            "Pemagatshel",
            "43"
        ],
        [
            "Punakha",
            "23"
        ],
        [
            "Samdrup Jongkhar",
            "45"
        ],
        [
            "Samtse",
            "14"
        ],
        [
            "Sarpang",
            "31"
        ],
        [
            "Thimphu",
            "15"
        ],
        [
            "Trashigang",
            "41"
        ],
        [
            "Trashiyangtse",
            "TY"
        ],
        [
            "Trongsa",
            "32"
        ],
        [
            "Tsirang",
            "21"
        ],
        [
            "Wangdue Phodrang",
            "24"
        ],
        [
            "Zhemgang",
            "34"
        ]
    ]
];
const $c8f06188fc3ad916$export$cd6527c992e4b6fe = [
    "Bolivia",
    "BO",
    [
        [
            "Beni",
            "BE"
        ],
        [
            "Chuquisaca",
            "CH"
        ],
        [
            "Cochabamba",
            "CB"
        ],
        [
            "La Paz",
            "LP"
        ],
        [
            "Oruro",
            "OR"
        ],
        [
            "Pando",
            "PD"
        ],
        [
            "Potos\xed",
            "PT"
        ],
        [
            "Santa Cruz",
            "SC"
        ],
        [
            "Tarija",
            "TJ"
        ]
    ]
];
const $c8f06188fc3ad916$export$2ca204c58a1fc922 = [
    "Bonaire, Sint Eustatius and Saba",
    "BQ",
    [
        [
            "Bonaire",
            "BO"
        ],
        [
            "Saba Isand",
            "SA"
        ],
        [
            "Sint Eustatius",
            "SE"
        ]
    ]
];
const $c8f06188fc3ad916$export$a73c4d14459b698d = [
    "Bosnia and Herzegovina",
    "BA",
    [
        [
            "Br\u010Dko Distrikt",
            "BRC"
        ],
        [
            "Federacija Bosne i Hercegovine",
            "BIH"
        ],
        [
            "Republika Srpska",
            "SRP"
        ]
    ]
];
const $c8f06188fc3ad916$export$cd7b90d76addb66a = [
    "Botswana",
    "BW",
    [
        [
            "Central",
            "CE"
        ],
        [
            "Ghanzi",
            "GH"
        ],
        [
            "Kgalagadi",
            "KG"
        ],
        [
            "Kgatleng",
            "KL"
        ],
        [
            "Kweneng",
            "KW"
        ],
        [
            "North West",
            "NW"
        ],
        [
            "North-East",
            "NE"
        ],
        [
            "South East",
            "SE"
        ],
        [
            "Southern",
            "SO"
        ]
    ]
];
const $c8f06188fc3ad916$export$8ba1594c72a88684 = [
    "Bouvet Island",
    "BV",
    [
        [
            "Bouvet Island",
            "BV"
        ]
    ]
];
const $c8f06188fc3ad916$export$b3e0c086157e0a90 = [
    "Brazil",
    "BR",
    [
        [
            "Acre",
            "AC"
        ],
        [
            "Alagoas",
            "AL"
        ],
        [
            "Amap\xe1",
            "AP"
        ],
        [
            "Amazonas",
            "AM"
        ],
        [
            "Bahia",
            "BA"
        ],
        [
            "Cear\xe1",
            "CE"
        ],
        [
            "Distrito Federal",
            "DF"
        ],
        [
            "Esp\xedrito Santo",
            "ES"
        ],
        [
            "Goi\xe1s",
            "GO"
        ],
        [
            "Maranh\xe3o",
            "MA"
        ],
        [
            "Mato Grosso",
            "MT"
        ],
        [
            "Mato Grosso do Sul",
            "MS"
        ],
        [
            "Minas Gerais",
            "MG"
        ],
        [
            "Par\xe1",
            "PA"
        ],
        [
            "Para\xedba",
            "PB"
        ],
        [
            "Paran\xe1",
            "PR"
        ],
        [
            "Pernambuco",
            "PE"
        ],
        [
            "Piau\xed",
            "PI"
        ],
        [
            "Rio de Janeiro",
            "RJ"
        ],
        [
            "Rio Grande do Norte",
            "RN"
        ],
        [
            "Rio Grande do Sul",
            "RS"
        ],
        [
            "Rond\xf4nia",
            "RO"
        ],
        [
            "Roraima",
            "RR"
        ],
        [
            "Santa Catarina",
            "SC"
        ],
        [
            "S\xe3o Paulo",
            "SP"
        ],
        [
            "Sergipe",
            "SE"
        ],
        [
            "Tocantins",
            "TO"
        ]
    ]
];
const $c8f06188fc3ad916$export$8f8422ac5947a789 = [
    "British Indian Ocean Territory",
    "IO",
    [
        [
            "British Indian Ocean Territory",
            "IO"
        ]
    ]
];
const $c8f06188fc3ad916$export$ed16643e9b9e3dfe = [
    "Brunei Darussalam",
    "BN",
    [
        [
            "Belait",
            "BE"
        ],
        [
            "Brunei Muara",
            "BM"
        ],
        [
            "Temburong",
            "TE"
        ],
        [
            "Tutong",
            "TU"
        ]
    ]
];
const $c8f06188fc3ad916$export$7ecc97c3ec9172d0 = [
    "Bulgaria",
    "BG",
    [
        [
            "Blagoevgrad",
            "01"
        ],
        [
            "Burgas",
            "02"
        ],
        [
            "Dobrich",
            "08"
        ],
        [
            "Gabrovo",
            "07"
        ],
        [
            "Jambol",
            "28"
        ],
        [
            "Khaskovo",
            "26"
        ],
        [
            "Kjustendil",
            "10"
        ],
        [
            "Kurdzhali",
            "09"
        ],
        [
            "Lovech",
            "11"
        ],
        [
            "Montana",
            "12"
        ],
        [
            "Pazardzhik",
            "13"
        ],
        [
            "Pernik",
            "14"
        ],
        [
            "Pleven",
            "15"
        ],
        [
            "Plovdiv",
            "16"
        ],
        [
            "Razgrad",
            "17"
        ],
        [
            "Ruse",
            "18"
        ],
        [
            "Shumen",
            "27"
        ],
        [
            "Silistra",
            "19"
        ],
        [
            "Sliven",
            "20"
        ],
        [
            "Smoljan",
            "21"
        ],
        [
            "Sofija",
            "23"
        ],
        [
            "Sofija-Grad",
            "22"
        ],
        [
            "Stara Zagora",
            "24"
        ],
        [
            "Turgovishhe",
            "25"
        ],
        [
            "Varna",
            "03"
        ],
        [
            "Veliko Turnovo",
            "04"
        ],
        [
            "Vidin",
            "05"
        ],
        [
            "Vraca",
            "06"
        ]
    ]
];
const $c8f06188fc3ad916$export$5d7d56d6166de861 = [
    "Burkina Faso",
    "BF",
    [
        [
            "Bal\xe9",
            "BAL"
        ],
        [
            "Bam/Lake Bam",
            "BAM"
        ],
        [
            "Banwa Province",
            "BAN"
        ],
        [
            "Baz\xe8ga",
            "BAZ"
        ],
        [
            "Bougouriba",
            "BGR"
        ],
        [
            "Boulgou Province",
            "BLG"
        ],
        [
            "Boulkiemd\xe9",
            "BLK"
        ],
        [
            "Como\xe9/Komoe",
            "COM"
        ],
        [
            "Ganzourgou Province",
            "GAN"
        ],
        [
            "Gnagna",
            "GNA"
        ],
        [
            "Gourma Province",
            "GOU"
        ],
        [
            "Houet",
            "HOU"
        ],
        [
            "Ioba",
            "IOB"
        ],
        [
            "Kadiogo",
            "KAD"
        ],
        [
            "K\xe9n\xe9dougou",
            "KEN"
        ],
        [
            "Komondjari",
            "KMD"
        ],
        [
            "Kompienga",
            "KMP"
        ],
        [
            "Kossi Province",
            "KOS"
        ],
        [
            "Koulp\xe9logo",
            "KOP"
        ],
        [
            "Kouritenga",
            "KOT"
        ],
        [
            "Kourw\xe9ogo",
            "KOW"
        ],
        [
            "L\xe9raba",
            "LER"
        ],
        [
            "Loroum",
            "LOR"
        ],
        [
            "Mouhoun",
            "MOU"
        ],
        [
            "Namentenga",
            "NAM"
        ],
        [
            "Naouri/Nahouri",
            "NAO"
        ],
        [
            "Nayala",
            "NAY"
        ],
        [
            "Noumbiel",
            "NOU"
        ],
        [
            "Oubritenga",
            "OUB"
        ],
        [
            "Oudalan",
            "OUD"
        ],
        [
            "Passor\xe9",
            "PAS"
        ],
        [
            "Poni",
            "PON"
        ],
        [
            "Sangui\xe9",
            "SNG"
        ],
        [
            "Sanmatenga",
            "SMT"
        ],
        [
            "S\xe9no",
            "SEN"
        ],
        [
            "Sissili",
            "SIS"
        ],
        [
            "Soum",
            "SOM"
        ],
        [
            "Sourou",
            "SOR"
        ],
        [
            "Tapoa",
            "TAP"
        ],
        [
            "Tui/Tuy",
            "TUI"
        ],
        [
            "Yagha",
            "YAG"
        ],
        [
            "Yatenga",
            "YAT"
        ],
        [
            "Ziro",
            "ZIR"
        ],
        [
            "Zondoma",
            "ZON"
        ],
        [
            "Zoundw\xe9ogo",
            "ZOU"
        ]
    ]
];
const $c8f06188fc3ad916$export$2601bd2ab73f6dbe = [
    "Burundi",
    "BI",
    [
        [
            "Bubanza",
            "BB"
        ],
        [
            "Bujumbura Mairie",
            "BM"
        ],
        [
            "Bujumbura Rural",
            "BL"
        ],
        [
            "Bururi",
            "BR"
        ],
        [
            "Cankuzo",
            "CA"
        ],
        [
            "Cibitoke",
            "CI"
        ],
        [
            "Gitega",
            "GI"
        ],
        [
            "Karuzi",
            "KR"
        ],
        [
            "Kayanza",
            "KY"
        ],
        [
            "Kirundo",
            "KI"
        ],
        [
            "Makamba",
            "MA"
        ],
        [
            "Muramvya",
            "MU"
        ],
        [
            "Muyinga",
            "MY"
        ],
        [
            "Mwaro",
            "MW"
        ],
        [
            "Ngozi",
            "NG"
        ],
        [
            "Rutana",
            "RT"
        ],
        [
            "Ruyigi",
            "RY"
        ]
    ]
];
const $c8f06188fc3ad916$export$96381358fb12b492 = [
    "Cambodia",
    "KH",
    [
        [
            "Baat Dambang",
            "2"
        ],
        [
            "Banteay Mean Chey",
            "1"
        ],
        [
            "Kampong Chaam",
            "3"
        ],
        [
            "Kampong Chhnang",
            "4"
        ],
        [
            "Kampong Spueu",
            "5"
        ],
        [
            "Kampong Thum",
            "6"
        ],
        [
            "Kampot",
            "7"
        ],
        [
            "Kandaal",
            "8"
        ],
        [
            "Kaoh Kong",
            "9"
        ],
        [
            "Kracheh",
            "10"
        ],
        [
            "Krong Kaeb",
            "23"
        ],
        [
            "Krong Pailin",
            "24"
        ],
        [
            "Krong Preah Sihanouk",
            "18"
        ],
        [
            "Mondol Kiri",
            "11"
        ],
        [
            "Otdar Mean Chey",
            "22"
        ],
        [
            "Phnom Penh",
            "12"
        ],
        [
            "Pousaat",
            "15"
        ],
        [
            "Preah Vihear",
            "13"
        ],
        [
            "Prey Veaeng",
            "14"
        ],
        [
            "Rotanah Kiri",
            "16"
        ],
        [
            "Siem Reab",
            "17"
        ],
        [
            "Stueng Treng",
            "19"
        ],
        [
            "Svaay Rieng",
            "20"
        ],
        [
            "Taakaev",
            "21"
        ],
        [
            "Tbong Khmum",
            "25"
        ]
    ]
];
const $c8f06188fc3ad916$export$dcd191669c0a595f = [
    "Cameroon",
    "CM",
    [
        [
            "Adamaoua",
            "AD"
        ],
        [
            "Centre",
            "CE"
        ],
        [
            "Est",
            "ES"
        ],
        [
            "Extr\xeame-Nord",
            "EN"
        ],
        [
            "Littoral",
            "LT"
        ],
        [
            "Nord",
            "NO"
        ],
        [
            "Nord-Ouest",
            "NW"
        ],
        [
            "Ouest",
            "OU"
        ],
        [
            "Sud",
            "SU"
        ],
        [
            "Sud-Ouest",
            "SW"
        ]
    ]
];
const $c8f06188fc3ad916$export$8de6180416dff1fc = [
    "Canada",
    "CA",
    [
        [
            "Alberta",
            "AB"
        ],
        [
            "British Columbia",
            "BC"
        ],
        [
            "Manitoba",
            "MB"
        ],
        [
            "New Brunswick",
            "NB"
        ],
        [
            "Newfoundland and Labrador",
            "NL"
        ],
        [
            "Northwest Territories",
            "NT"
        ],
        [
            "Nova Scotia",
            "NS"
        ],
        [
            "Nunavut",
            "NU"
        ],
        [
            "Ontario",
            "ON"
        ],
        [
            "Prince Edward Island",
            "PE"
        ],
        [
            "Quebec",
            "QC"
        ],
        [
            "Saskatchewan",
            "SK"
        ],
        [
            "Yukon",
            "YT"
        ]
    ]
];
const $c8f06188fc3ad916$export$9c7a4b602f1ee953 = [
    "Cape Verde",
    "CV",
    [
        [
            "Boa Vista",
            "BV"
        ],
        [
            "Brava",
            "BR"
        ],
        [
            "Calheta de S\xe3o Miguel",
            "CS"
        ],
        [
            "Maio",
            "MA"
        ],
        [
            "Mosteiros",
            "MO"
        ],
        [
            "Pa\xfal",
            "PA"
        ],
        [
            "Porto Novo",
            "PN"
        ],
        [
            "Praia",
            "PR"
        ],
        [
            "Ribeira Brava",
            "RB"
        ],
        [
            "Ribeira Grande",
            "RG"
        ],
        [
            "Sal",
            "SL"
        ],
        [
            "Santa Catarina",
            "CA"
        ],
        [
            "Santa Cruz",
            "CR"
        ],
        [
            "S\xe3o Domingos",
            "SD"
        ],
        [
            "S\xe3o Filipe",
            "SF"
        ],
        [
            "S\xe3o Nicolau",
            "SN"
        ],
        [
            "S\xe3o Vicente",
            "SV"
        ],
        [
            "Tarrafal",
            "TA"
        ],
        [
            "Tarrafal de S\xe3o Nicolau",
            "TS"
        ]
    ]
];
const $c8f06188fc3ad916$export$ea257f329676e0aa = [
    "Cayman Islands",
    "KY",
    [
        [
            "Bodden Town",
            "BT"
        ],
        [
            "East End",
            "EE"
        ],
        [
            "George Town",
            "GT"
        ],
        [
            "North Side",
            "NS"
        ],
        [
            "Sister Islands",
            "SI"
        ],
        [
            "West Bay",
            "WB"
        ]
    ]
];
const $c8f06188fc3ad916$export$ba26f2d80491fb47 = [
    "Central African Republic",
    "CF",
    [
        [
            "Bamingui-Bangoran",
            "BB"
        ],
        [
            "Bangui",
            "BGF"
        ],
        [
            "Basse-Kotto",
            "BK"
        ],
        [
            "Haute-Kotto",
            "HK"
        ],
        [
            "Haut-Mbomou",
            "HM"
        ],
        [
            "K\xe9mo",
            "KG"
        ],
        [
            "Lobaye",
            "LB"
        ],
        [
            "Mamb\xe9r\xe9-Kad\xe9\xef",
            "HS"
        ],
        [
            "Mbomou",
            "MB"
        ],
        [
            "Nana-Grebizi",
            "10"
        ],
        [
            "Nana-Mamb\xe9r\xe9",
            "NM"
        ],
        [
            "Ombella-M'Poko",
            "MP"
        ],
        [
            "Ouaka",
            "UK"
        ],
        [
            "Ouham",
            "AC"
        ],
        [
            "Ouham P\xe9nd\xe9",
            "OP"
        ],
        [
            "Sangha-Mba\xe9r\xe9",
            "SE"
        ],
        [
            "Vakaga",
            "VK"
        ]
    ]
];
const $c8f06188fc3ad916$export$9cf5b401f969f5e3 = [
    "Chad",
    "TD",
    [
        [
            "Bahr el Ghazal",
            "BG"
        ],
        [
            "Batha",
            "BA"
        ],
        [
            "Borkou",
            "BO"
        ],
        [
            "Chari-Baguirmi",
            "CB"
        ],
        [
            "Ennedi-Est",
            "EE"
        ],
        [
            "Ennedi-Ouest",
            "EO"
        ],
        [
            "Gu\xe9ra",
            "GR"
        ],
        [
            "Hadjer Lamis",
            "HL"
        ],
        [
            "Kanem",
            "KA"
        ],
        [
            "Lac",
            "LC"
        ],
        [
            "Logone Occidental",
            "LO"
        ],
        [
            "Logone Oriental",
            "LR"
        ],
        [
            "Mondoul",
            "MA"
        ],
        [
            "Mayo-K\xe9bbi-Est",
            "ME"
        ],
        [
            "Moyen-Chari",
            "MC"
        ],
        [
            "Ouaddai",
            "OD"
        ],
        [
            "Salamat",
            "SA"
        ],
        [
            "Sila",
            "SI"
        ],
        [
            "Tandjil\xe9",
            "TA"
        ],
        [
            "Tibesti",
            "TI"
        ],
        [
            "Ville de Ndjamena",
            "ND"
        ],
        [
            "Wadi Fira",
            "WF"
        ]
    ]
];
const $c8f06188fc3ad916$export$9bf3043cb7503aa1 = [
    "Chile",
    "CL",
    [
        [
            "Ais\xe9n del General Carlos Ib\xe1\xf1ez del Campo",
            "AI"
        ],
        [
            "Antofagasta",
            "AN"
        ],
        [
            "Araucan\xeda",
            "AR"
        ],
        [
            "Arica y Parinacota",
            "AP"
        ],
        [
            "Atacama",
            "AT"
        ],
        [
            "B\xedo-B\xedo",
            "BI"
        ],
        [
            "Coquimbo",
            "CO"
        ],
        [
            "Libertador General Bernardo O'Higgins",
            "LI"
        ],
        [
            "Los Lagos",
            "LL"
        ],
        [
            "Los R\xedos",
            "LR"
        ],
        [
            "Magallanes y Antartica Chilena",
            "MA"
        ],
        [
            "Maule",
            "ML"
        ],
        [
            "\xd1uble",
            "NB"
        ],
        [
            "Regi\xf3n Metropolitana de Santiago",
            "RM"
        ],
        [
            "Tarapac\xe1",
            "TA"
        ],
        [
            "Valpara\xedso",
            "VS"
        ]
    ]
];
const $c8f06188fc3ad916$export$f175668af5171efd = [
    "China",
    "CN",
    [
        [
            "Anhui",
            "AH"
        ],
        [
            "Beijing",
            "BJ"
        ],
        [
            "Chongqing",
            "CQ"
        ],
        [
            "Fujian",
            "FJ"
        ],
        [
            "Gansu",
            "GS"
        ],
        [
            "Guangdong",
            "GD"
        ],
        [
            "Guangxi",
            "GX"
        ],
        [
            "Guizhou",
            "GZ"
        ],
        [
            "Hainan",
            "HI"
        ],
        [
            "Hebei",
            "HE"
        ],
        [
            "Heilongjiang",
            "HL"
        ],
        [
            "Henan",
            "HA"
        ],
        [
            "Hong Kong",
            "HK"
        ],
        [
            "Hubei",
            "HB"
        ],
        [
            "Hunan",
            "HN"
        ],
        [
            "Inner Mongolia",
            "NM"
        ],
        [
            "Jiangsu",
            "JS"
        ],
        [
            "Jiangxi",
            "JX"
        ],
        [
            "Jilin",
            "JL"
        ],
        [
            "Liaoning",
            "LN"
        ],
        [
            "Macau",
            "MO"
        ],
        [
            "Ningxia",
            "NX"
        ],
        [
            "Qinghai",
            "QH"
        ],
        [
            "Shaanxi",
            "SN"
        ],
        [
            "Shandong",
            "SD"
        ],
        [
            "Shanghai",
            "SH"
        ],
        [
            "Shanxi",
            "SX"
        ],
        [
            "Sichuan",
            "SC"
        ],
        [
            "Tianjin",
            "TJ"
        ],
        [
            "Tibet",
            "XZ"
        ],
        [
            "Xinjiang",
            "XJ"
        ],
        [
            "Yunnan",
            "YN"
        ],
        [
            "Zhejiang",
            "ZJ"
        ]
    ]
];
const $c8f06188fc3ad916$export$ef748afa94c5c5f9 = [
    "Christmas Island",
    "CX",
    [
        [
            "Christmas Island",
            "CX"
        ]
    ]
];
const $c8f06188fc3ad916$export$183b2a0874e6e919 = [
    "Cocos (Keeling) Islands",
    "CC",
    [
        [
            "Direction Island",
            "DI"
        ],
        [
            "Home Island",
            "HM"
        ],
        [
            "Horsburgh Island",
            "HR"
        ],
        [
            "North Keeling Island",
            "NK"
        ],
        [
            "South Island",
            "SI"
        ],
        [
            "West Island",
            "WI"
        ]
    ]
];
const $c8f06188fc3ad916$export$423e5ab65bdedcb8 = [
    "Colombia",
    "CO",
    [
        [
            "Amazonas",
            "AMA"
        ],
        [
            "Antioquia",
            "ANT"
        ],
        [
            "Arauca",
            "ARA"
        ],
        [
            "Archipi\xe9lago de San Andr\xe9s",
            "SAP"
        ],
        [
            "Atl\xe1ntico",
            "ATL"
        ],
        [
            "Bogot\xe1 D.C.",
            "DC"
        ],
        [
            "Bol\xedvar",
            "BOL"
        ],
        [
            "Boyac\xe1",
            "BOY"
        ],
        [
            "Caldas",
            "CAL"
        ],
        [
            "Caquet\xe1",
            "CAQ"
        ],
        [
            "Casanare",
            "CAS"
        ],
        [
            "Cauca",
            "CAU"
        ],
        [
            "Cesar",
            "CES"
        ],
        [
            "Choc\xf3",
            "CHO"
        ],
        [
            "C\xf3rdoba",
            "COR"
        ],
        [
            "Cundinamarca",
            "CUN"
        ],
        [
            "Guain\xeda",
            "GUA"
        ],
        [
            "Guaviare",
            "GUV"
        ],
        [
            "Huila",
            "HUI"
        ],
        [
            "La Guajira",
            "LAG"
        ],
        [
            "Magdalena",
            "MAG"
        ],
        [
            "Meta",
            "MET"
        ],
        [
            "Nari\xf1o",
            "NAR"
        ],
        [
            "Norte de Santander",
            "NSA"
        ],
        [
            "Putumayo",
            "PUT"
        ],
        [
            "Quind\xedo",
            "QUI"
        ],
        [
            "Risaralda",
            "RIS"
        ],
        [
            "Santander",
            "SAN"
        ],
        [
            "Sucre",
            "SUC"
        ],
        [
            "Tolima",
            "TOL"
        ],
        [
            "Valle del Cauca",
            "VAC"
        ],
        [
            "Vaup\xe9s",
            "VAU"
        ],
        [
            "Vichada",
            "VID"
        ]
    ]
];
const $c8f06188fc3ad916$export$7ca86d88f982585b = [
    "Comoros",
    "KM",
    [
        [
            "Andjaz\xeedja",
            "G"
        ],
        [
            "Andjou\xe2n",
            "A"
        ],
        [
            "Mo\xfbh\xeel\xee",
            "M"
        ]
    ]
];
const $c8f06188fc3ad916$export$9e8da9070f3c2e68 = [
    "Congo, Republic of the (Brazzaville)",
    "CG",
    [
        [
            "Bouenza",
            "11"
        ],
        [
            "Brazzaville",
            "BZV"
        ],
        [
            "Cuvette",
            "8"
        ],
        [
            "Cuvette-Ouest",
            "15"
        ],
        [
            "Kouilou",
            "5"
        ],
        [
            "L\xe9koumou",
            "2"
        ],
        [
            "Likouala",
            "7"
        ],
        [
            "Niari",
            "9"
        ],
        [
            "Plateaux",
            "14"
        ],
        [
            "Pointe-Noire",
            "16"
        ],
        [
            "Pool",
            "12"
        ],
        [
            "Sangha",
            "13"
        ]
    ]
];
const $c8f06188fc3ad916$export$6ede307faf7aaec4 = [
    "Congo, the Democratic Republic of the (Kinshasa)",
    "CD",
    [
        [
            "Bandundu",
            "BN"
        ],
        [
            "Bas-Congo",
            "BC"
        ],
        [
            "\xc9quateur",
            "EQ"
        ],
        [
            "Kasa\xef-Occidental",
            "KE"
        ],
        [
            "Kasa\xef-Oriental",
            "KW"
        ],
        [
            "Katanga",
            "KA"
        ],
        [
            "Kinshasa",
            "KN"
        ],
        [
            "Maniema",
            "MA"
        ],
        [
            "Nord-Kivu",
            "NK"
        ],
        [
            "Orientale",
            "OR"
        ],
        [
            "Sud-Kivu",
            "SK"
        ]
    ]
];
const $c8f06188fc3ad916$export$2779adff9720d9c9 = [
    "Cook Islands",
    "CK",
    [
        [
            "Aitutaki",
            "undefined"
        ],
        [
            "Atiu",
            "undefined"
        ],
        [
            "Avarua",
            "undefined"
        ],
        [
            "Mangaia",
            "undefined"
        ],
        [
            "Manihiki",
            "undefined"
        ],
        [
            "Ma'uke",
            "undefined"
        ],
        [
            "Mitiaro",
            "undefined"
        ],
        [
            "Nassau",
            "undefined"
        ],
        [
            "Palmerston",
            "undefined"
        ],
        [
            "Penrhyn",
            "undefined"
        ],
        [
            "Pukapuka",
            "undefined"
        ],
        [
            "Rakahanga",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$de92be486109a1df = [
    "Costa Rica",
    "CR",
    [
        [
            "Alajuela",
            "2"
        ],
        [
            "Cartago",
            "3"
        ],
        [
            "Guanacaste",
            "5"
        ],
        [
            "Heredia",
            "4"
        ],
        [
            "Lim\xf3n",
            "7"
        ],
        [
            "Puntarenas",
            "6"
        ],
        [
            "San Jos\xe9",
            "1"
        ]
    ]
];
const $c8f06188fc3ad916$export$ddcf9efc80efb978 = [
    "C\xf4te d'Ivoire, Republic of",
    "CI",
    [
        [
            "Agn\xe9by",
            "16"
        ],
        [
            "Bafing",
            "17"
        ],
        [
            "Bas-Sassandra",
            "09"
        ],
        [
            "Dengu\xe9l\xe9",
            "10"
        ],
        [
            "Dix-Huit Montagnes",
            "06"
        ],
        [
            "Fromager",
            "18"
        ],
        [
            "Haut-Sassandra",
            "02"
        ],
        [
            "Lacs",
            "07"
        ],
        [
            "Lagunes",
            "01"
        ],
        [
            "Marahou\xe9",
            "12"
        ],
        [
            "Moyen-Cavally",
            "19"
        ],
        [
            "Moyen-Como\xe9",
            "05"
        ],
        [
            "N'zi-Como\xe9",
            "11"
        ],
        [
            "Savanes",
            "03"
        ],
        [
            "Sud-Bandama",
            "15"
        ],
        [
            "Sud-Como\xe9",
            "13"
        ],
        [
            "Vall\xe9e du Bandama",
            "04"
        ],
        [
            "Worodougou",
            "14"
        ],
        [
            "Zanzan",
            "08"
        ]
    ]
];
const $c8f06188fc3ad916$export$41dbabafe943a3bc = [
    "Croatia",
    "HR",
    [
        [
            "Bjelovarsko-bilogorska \u017Eupanija",
            "07"
        ],
        [
            "Brodsko-posavska \u017Eupanija",
            "12"
        ],
        [
            "Dubrova\u010Dko-neretvanska \u017Eupanija",
            "19"
        ],
        [
            "Grad Zagreb",
            "21"
        ],
        [
            "Istarska \u017Eupanija",
            "18"
        ],
        [
            "Karlova\u010Dka \u017Eupanija",
            "04"
        ],
        [
            "Koprivni\u010Dko-kri\u017Eeva\u010Dka \u017Eupanija",
            "06"
        ],
        [
            "Krapinsko-zagorska \u017Eupanija",
            "02"
        ],
        [
            "Li\u010Dko-senjska \u017Eupanija",
            "09"
        ],
        [
            "Me\u0111imurska \u017Eupanija",
            "20"
        ],
        [
            "Osje\u010Dko-baranjska \u017Eupanija",
            "14"
        ],
        [
            "Po\u017Ee\u0161ko-slavonska \u017Eupanija",
            "11"
        ],
        [
            "Primorsko-goranska \u017Eupanija",
            "08"
        ],
        [
            "Sisa\u010Dko-moslava\u010Dka \u017Eupanija",
            "03"
        ],
        [
            "Splitsko-dalmatinska \u017Eupanija",
            "17"
        ],
        [
            "\u0160ibensko-kninska \u017Eupanija",
            "15"
        ],
        [
            "Vara\u017Edinska \u017Eupanija",
            "05"
        ],
        [
            "Viroviti\u010Dko-podravska \u017Eupanija",
            "10"
        ],
        [
            "Vukovarsko-srijemska \u017Eupanija",
            "16"
        ],
        [
            "Zadarska \u017Eupanija",
            "13"
        ],
        [
            "Zagreba\u010Dka \u017Eupanija",
            "01"
        ]
    ]
];
const $c8f06188fc3ad916$export$6f478fc577ffffe3 = [
    "Cuba",
    "CU",
    [
        [
            "Artemisa",
            "15"
        ],
        [
            "Camag\xfcey",
            "09"
        ],
        [
            "Ciego de \xc1vila",
            "08"
        ],
        [
            "Cienfuegos",
            "06"
        ],
        [
            "Granma",
            "12"
        ],
        [
            "Guant\xe1namo",
            "14"
        ],
        [
            "Holgu\xedn",
            "11"
        ],
        [
            "Isla de la Juventud",
            "99"
        ],
        [
            "La Habana",
            "03"
        ],
        [
            "Las Tunas",
            "10"
        ],
        [
            "Matanzas",
            "04"
        ],
        [
            "Mayabeque",
            "16"
        ],
        [
            "Pinar del R\xedo",
            "01"
        ],
        [
            "Sancti Sp\xedritus",
            "07"
        ],
        [
            "Santiago de Cuba",
            "13"
        ],
        [
            "Villa Clara",
            "05"
        ]
    ]
];
const $c8f06188fc3ad916$export$640171019d58eb6d = [
    "Cura\xe7ao",
    "CW",
    [
        [
            "Cura\xe7ao",
            "CW"
        ]
    ]
];
const $c8f06188fc3ad916$export$e5e7583d5d9c5f7b = [
    "Cyprus",
    "CY",
    [
        [
            "Ammochostos",
            "04"
        ],
        [
            "Keryneia",
            "06"
        ],
        [
            "Larnaka",
            "03"
        ],
        [
            "Lefkosia",
            "01"
        ],
        [
            "Lemesos",
            "02"
        ],
        [
            "Pafos",
            "05"
        ]
    ]
];
const $c8f06188fc3ad916$export$3aa7db55ae20a642 = [
    "Czech Republic",
    "CZ",
    [
        [
            "Hlavn\xed m\u011Bsto Praha",
            "10"
        ],
        [
            "Jiho\u010Desk\xfd kraj",
            "31"
        ],
        [
            "Jihomoravsk\xfd kraj",
            "64"
        ],
        [
            "Karlovarsk\xfd kraj",
            "41"
        ],
        [
            "Kr\xe1lov\xe9hradeck\xfd kraj",
            "52"
        ],
        [
            "Libereck\xfd kraj",
            "51"
        ],
        [
            "Moravskoslezsk\xfd kraj",
            "80"
        ],
        [
            "Olomouck\xfd kraj",
            "71"
        ],
        [
            "Pardubick\xfd kraj",
            "53"
        ],
        [
            "Plze\u0148sk\xfd kraj",
            "32"
        ],
        [
            "St\u0159edo\u010Desk\xfd kraj",
            "20"
        ],
        [
            "\xdasteck\xfd kraj",
            "42"
        ],
        [
            "Vyso\u010Dina",
            "63"
        ],
        [
            "Zl\xednsk\xfd kraj",
            "72"
        ]
    ]
];
const $c8f06188fc3ad916$export$861a3271cad515fc = [
    "Denmark",
    "DK",
    [
        [
            "Hovedstaden",
            "DK-84"
        ],
        [
            "Midtjylland",
            "DK-82"
        ],
        [
            "Nordjylland",
            "DK-81"
        ],
        [
            "Sj\xe6lland",
            "DK-85"
        ],
        [
            "Syddanmark",
            "DK-83"
        ]
    ]
];
const $c8f06188fc3ad916$export$b116121769fff50f = [
    "Djibouti",
    "DJ",
    [
        [
            "Ali Sabieh",
            "AS"
        ],
        [
            "Arta",
            "AR"
        ],
        [
            "Dikhil",
            "DI"
        ],
        [
            "Obock",
            "OB"
        ],
        [
            "Tadjourah",
            "TA"
        ]
    ]
];
const $c8f06188fc3ad916$export$c63caaa7a05b64da = [
    "Dominica",
    "DM",
    [
        [
            "Saint Andrew Parish",
            "02"
        ],
        [
            "Saint David Parish",
            "03"
        ],
        [
            "Saint George Parish",
            "04"
        ],
        [
            "Saint John Parish",
            "05"
        ],
        [
            "Saint Joseph Parish",
            "06"
        ],
        [
            "Saint Luke Parish",
            "07"
        ],
        [
            "Saint Mark Parish",
            "08"
        ],
        [
            "Saint Patrick Parish",
            "09"
        ],
        [
            "Saint Paul Parish",
            "10"
        ],
        [
            "Saint Peter Parish",
            "11"
        ]
    ]
];
const $c8f06188fc3ad916$export$fe81c0b6cf107daf = [
    "Dominican Republic",
    "DO",
    [
        [
            "Cibao Central",
            "02"
        ],
        [
            "Del Valle",
            "37"
        ],
        [
            "Distrito Nacional",
            "01"
        ],
        [
            "Enriquillo",
            "38"
        ],
        [
            "Norcentral",
            "04"
        ],
        [
            "Nordeste",
            "33"
        ],
        [
            "Noroeste",
            "34"
        ],
        [
            "Norte",
            "35"
        ],
        [
            "Valdesia",
            "42"
        ]
    ]
];
const $c8f06188fc3ad916$export$129fe12d32abc311 = [
    "Ecuador",
    "EC",
    [
        [
            "Azuay",
            "A"
        ],
        [
            "Bol\xedvar",
            "B"
        ],
        [
            "Ca\xf1ar",
            "F"
        ],
        [
            "Carchi",
            "C"
        ],
        [
            "Chimborazo",
            "H"
        ],
        [
            "Cotopaxi",
            "X"
        ],
        [
            "El Oro",
            "O"
        ],
        [
            "Esmeraldas",
            "E"
        ],
        [
            "Gal\xe1pagos",
            "W"
        ],
        [
            "Guayas",
            "G"
        ],
        [
            "Imbabura",
            "I"
        ],
        [
            "Loja",
            "L"
        ],
        [
            "Los R\xedos",
            "R"
        ],
        [
            "Manab\xed",
            "M"
        ],
        [
            "Morona-Santiago",
            "S"
        ],
        [
            "Napo",
            "N"
        ],
        [
            "Orellana",
            "D"
        ],
        [
            "Pastaza",
            "Y"
        ],
        [
            "Pichincha",
            "P"
        ],
        [
            "Santa Elena",
            "SE"
        ],
        [
            "Santo Domingo de los Ts\xe1chilas",
            "SD"
        ],
        [
            "Sucumb\xedos",
            "U"
        ],
        [
            "Tungurahua",
            "T"
        ],
        [
            "Zamora-Chinchipe",
            "Z"
        ]
    ]
];
const $c8f06188fc3ad916$export$e107e11ec3489258 = [
    "Egypt",
    "EG",
    [
        [
            "Alexandria",
            "ALX"
        ],
        [
            "Aswan",
            "ASN"
        ],
        [
            "Asyout",
            "AST"
        ],
        [
            "Bani Sueif",
            "BNS"
        ],
        [
            "Beheira",
            "BH"
        ],
        [
            "Cairo",
            "C"
        ],
        [
            "Daqahlia",
            "DK"
        ],
        [
            "Dumiat",
            "DT"
        ],
        [
            "El Bahr El Ahmar",
            "BA"
        ],
        [
            "El Ismailia",
            "IS"
        ],
        [
            "El Suez",
            "SUZ"
        ],
        [
            "El Wadi El Gedeed",
            "WAD"
        ],
        [
            "Fayoum",
            "FYM"
        ],
        [
            "Gharbia",
            "GH"
        ],
        [
            "Giza",
            "GZ"
        ],
        [
            "Helwan",
            "HU"
        ],
        [
            "Kafr El Sheikh",
            "KFS"
        ],
        [
            "Luxor",
            "LX"
        ],
        [
            "Matrouh",
            "MT"
        ],
        [
            "Menia",
            "MN"
        ],
        [
            "Menofia",
            "MNF"
        ],
        [
            "North Sinai",
            "SIN"
        ],
        [
            "Port Said",
            "PTS"
        ],
        [
            "Qalubia",
            "KB"
        ],
        [
            "Qena",
            "KN"
        ],
        [
            "Sharqia",
            "SHR"
        ],
        [
            "Sixth of October",
            "SU"
        ],
        [
            "Sohag",
            "SHG"
        ],
        [
            "South Sinai",
            "JS"
        ]
    ]
];
const $c8f06188fc3ad916$export$8fc936c6ebd916b3 = [
    "El Salvador",
    "SV",
    [
        [
            "Ahuachap\xe1n",
            "AH"
        ],
        [
            "Caba\xf1as",
            "CA"
        ],
        [
            "Cuscatl\xe1n",
            "CU"
        ],
        [
            "Chalatenango",
            "CH"
        ],
        [
            "La Libertad",
            "LI"
        ],
        [
            "La Paz",
            "PA"
        ],
        [
            "La Uni\xf3n",
            "UN"
        ],
        [
            "Moraz\xe1n",
            "MO"
        ],
        [
            "San Miguel",
            "SM"
        ],
        [
            "San Salvador",
            "SS"
        ],
        [
            "Santa Ana",
            "SA"
        ],
        [
            "San Vicente",
            "SV"
        ],
        [
            "Sonsonate",
            "SO"
        ],
        [
            "Usulut\xe1n",
            "US"
        ]
    ]
];
const $c8f06188fc3ad916$export$64532cc081f88b3a = [
    "Equatorial Guinea",
    "GQ",
    [
        [
            "Annob\xf3n",
            "AN"
        ],
        [
            "Bioko Norte",
            "BN"
        ],
        [
            "Bioko Sur",
            "BS"
        ],
        [
            "Centro Sur",
            "CS"
        ],
        [
            "Ki\xe9-Ntem",
            "KN"
        ],
        [
            "Litoral",
            "LI"
        ],
        [
            "Wele-Nzas",
            "WN"
        ]
    ]
];
const $c8f06188fc3ad916$export$20e28a5cfb7c13df = [
    "Eritrea",
    "ER",
    [
        [
            "Anseba",
            "AN"
        ],
        [
            "Debub",
            "DU"
        ],
        [
            "Debub-Keih-Bahri",
            "DK"
        ],
        [
            "Gash-Barka",
            "GB"
        ],
        [
            "Maekel",
            "MA"
        ],
        [
            "Semien-Keih-Bahri",
            "SK"
        ]
    ]
];
const $c8f06188fc3ad916$export$3f443bcc5237c742 = [
    "Estonia",
    "EE",
    [
        [
            "Harjumaa (Tallinn)",
            "37"
        ],
        [
            "Hiiumaa (Kardla)",
            "39"
        ],
        [
            "Ida-Virumaa (Johvi)",
            "44"
        ],
        [
            "J\xe4rvamaa (Paide)",
            "41"
        ],
        [
            "J\xf5gevamaa (Jogeva)",
            "49"
        ],
        [
            "L\xe4\xe4nemaa",
            "57"
        ],
        [
            "L\xe4\xe4ne-Virumaa (Rakvere)",
            "59"
        ],
        [
            "P\xe4rnumaa (Parnu)",
            "67"
        ],
        [
            "P\xf5lvamaa (Polva)",
            "65"
        ],
        [
            "Raplamaa (Rapla)",
            "70"
        ],
        [
            "Saaremaa (Kuessaare)",
            "74"
        ],
        [
            "Tartumaa (Tartu)",
            "78"
        ],
        [
            "Valgamaa (Valga)",
            "82"
        ],
        [
            "Viljandimaa (Viljandi)",
            "84"
        ],
        [
            "V\xf5rumaa (Voru)",
            "86"
        ]
    ]
];
const $c8f06188fc3ad916$export$404386694049c788 = [
    "Ethiopia",
    "ET",
    [
        [
            "Addis Ababa",
            "AA"
        ],
        [
            "Afar",
            "AF"
        ],
        [
            "Amhara",
            "AM"
        ],
        [
            "Benshangul-Gumaz",
            "BE"
        ],
        [
            "Dire Dawa",
            "DD"
        ],
        [
            "Gambela",
            "GA"
        ],
        [
            "Harari",
            "HA"
        ],
        [
            "Oromia",
            "OR"
        ],
        [
            "Somali",
            "SO"
        ],
        [
            "Southern Nations Nationalities and People's Region",
            "SN"
        ],
        [
            "Tigray",
            "TI"
        ]
    ]
];
const $c8f06188fc3ad916$export$58f4e3559034e3ed = [
    "Falkland Islands (Islas Malvinas)",
    "FK",
    [
        [
            "Falkland Islands (Islas Malvinas)",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$3117889032a11ab0 = [
    "Faroe Islands",
    "FO",
    [
        [
            "Bordoy",
            "undefined"
        ],
        [
            "Eysturoy",
            "undefined"
        ],
        [
            "Mykines",
            "undefined"
        ],
        [
            "Sandoy",
            "undefined"
        ],
        [
            "Skuvoy",
            "undefined"
        ],
        [
            "Streymoy",
            "undefined"
        ],
        [
            "Suduroy",
            "undefined"
        ],
        [
            "Tvoroyri",
            "undefined"
        ],
        [
            "Vagar",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$4cd493ed69e3bc18 = [
    "Fiji",
    "FJ",
    [
        [
            "Ba",
            "01"
        ],
        [
            "Bua",
            "02"
        ],
        [
            "Cakaudrove",
            "03"
        ],
        [
            "Kadavu",
            "04"
        ],
        [
            "Lau",
            "05"
        ],
        [
            "Lomaiviti",
            "06"
        ],
        [
            "Macuata",
            "07"
        ],
        [
            "Nadroga and Navosa",
            "08"
        ],
        [
            "Naitasiri",
            "09"
        ],
        [
            "Namosi",
            "10"
        ],
        [
            "Ra",
            "11"
        ],
        [
            "Rewa",
            "12"
        ],
        [
            "Rotuma",
            "R"
        ],
        [
            "Serua",
            "13"
        ],
        [
            "Tailevu",
            "14"
        ]
    ]
];
const $c8f06188fc3ad916$export$b742dc37108d5cac = [
    "Finland",
    "FI",
    [
        [
            "Ahvenanmaan maakunta",
            "FI-01"
        ],
        [
            "Etel\xe4-Karjala",
            "FI-02"
        ],
        [
            "Etel\xe4-Pohjanmaa",
            "FI-03"
        ],
        [
            "Etel\xe4-Savo",
            "FI-04"
        ],
        [
            "Kainuu",
            "FI-05"
        ],
        [
            "Kanta-H\xe4me",
            "FI-06"
        ],
        [
            "Keski-Pohjanmaa",
            "FI-07"
        ],
        [
            "Keski-Suomi",
            "FI-08"
        ],
        [
            "Kymenlaakso",
            "FI-09"
        ],
        [
            "Lappi",
            "FI-10"
        ],
        [
            "Pirkanmaa",
            "FI-11"
        ],
        [
            "Pohjanmaa",
            "FI-12"
        ],
        [
            "Pohjois-Karjala",
            "FI-13"
        ],
        [
            "Pohjois-Pohjanmaa",
            "FI-14"
        ],
        [
            "Pohjois-Savo",
            "FI-15"
        ],
        [
            "P\xe4ij\xe4t-H\xe4me",
            "FI-16"
        ],
        [
            "Satakunta",
            "FI-17"
        ],
        [
            "Uusimaa",
            "FI-18"
        ],
        [
            "Varsinais-Suomi",
            "FI-19"
        ]
    ]
];
const $c8f06188fc3ad916$export$b0bfe88d8be86eef = [
    "France",
    "FR",
    [
        [
            "Auvergne-Rh\xf4ne-Alpes",
            "ARA"
        ],
        [
            "Bourgogne-Franche-Comt\xe9",
            "BFC"
        ],
        [
            "Bretagne",
            "BRE"
        ],
        [
            "Centre-Val de Loire",
            "CVL"
        ],
        [
            "Corse",
            "COR"
        ],
        [
            "Grand Est",
            "GES"
        ],
        [
            "Hauts-de-France",
            "HDF"
        ],
        [
            "\xcele-de-France",
            "IDF"
        ],
        [
            "Normandie",
            "NOR"
        ],
        [
            "Nouvelle-Aquitaine",
            "NAQ"
        ],
        [
            "Occitanie",
            "OCC"
        ],
        [
            "Pays de la Loire",
            "PDL"
        ],
        [
            "Provence-Alpes-C\xf4te d'Azur",
            "PAC"
        ],
        [
            "Clipperton",
            "CP"
        ],
        [
            "Guadeloupe",
            "GP"
        ],
        [
            "Guyane",
            "GF"
        ],
        [
            "Martinique",
            "MQ"
        ],
        [
            "Mayotte",
            "YT"
        ],
        [
            "Nouvelle-Cal\xe9donie",
            "NC"
        ],
        [
            "Polyn\xe9sie",
            "PF"
        ],
        [
            "Saint-Pierre-et-Miquelon",
            "PM"
        ],
        [
            "Saint Barth\xe9lemy",
            "BL"
        ],
        [
            "Saint Martin",
            "MF"
        ],
        [
            "R\xe9union",
            "RE"
        ],
        [
            "Terres Australes Fran\xe7aises",
            "TF"
        ],
        [
            "Wallis-et-Futuna",
            "WF"
        ]
    ]
];
const $c8f06188fc3ad916$export$a1c692af90f0ad93 = [
    "French Guiana",
    "GF",
    [
        [
            "French Guiana",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$7d19ebf018caa9aa = [
    "French Polynesia",
    "PF",
    [
        [
            "Archipel des Marquises",
            "undefined"
        ],
        [
            "Archipel des Tuamotu",
            "undefined"
        ],
        [
            "Archipel des Tubuai",
            "undefined"
        ],
        [
            "Iles du Vent",
            "undefined"
        ],
        [
            "Iles Sous-le-Vent",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$4014e91f2965d3df = [
    "French Southern and Antarctic Lands",
    "TF",
    [
        [
            "Adelie Land",
            "undefined"
        ],
        [
            "Ile Crozet",
            "undefined"
        ],
        [
            "Iles Kerguelen",
            "undefined"
        ],
        [
            "Iles Saint-Paul et Amsterdam",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$2c816677949efbbf = [
    "Gabon",
    "GA",
    [
        [
            "Estuaire",
            "1"
        ],
        [
            "Haut-Ogoou\xe9",
            "2"
        ],
        [
            "Moyen-Ogoou\xe9",
            "3"
        ],
        [
            "Ngouni\xe9",
            "4"
        ],
        [
            "Nyanga",
            "5"
        ],
        [
            "Ogoou\xe9-Ivindo",
            "6"
        ],
        [
            "Ogoou\xe9-Lolo",
            "7"
        ],
        [
            "Ogoou\xe9-Maritime",
            "8"
        ],
        [
            "Woleu-Ntem",
            "9"
        ]
    ]
];
const $c8f06188fc3ad916$export$af02b8e3ecf08df4 = [
    "Gambia, The",
    "GM",
    [
        [
            "Banjul",
            "B"
        ],
        [
            "Central River",
            "M"
        ],
        [
            "Lower River",
            "L"
        ],
        [
            "North Bank",
            "N"
        ],
        [
            "Upper River",
            "U"
        ],
        [
            "Western",
            "W"
        ]
    ]
];
const $c8f06188fc3ad916$export$64f1adb8dced2c27 = [
    "Georgia",
    "GE",
    [
        [
            "Abkhazia (Sokhumi)",
            "AB"
        ],
        [
            "Ajaria (Bat'umi)",
            "AJ"
        ],
        [
            "Guria",
            "GU"
        ],
        [
            "Imereti",
            "IM"
        ],
        [
            "K'akheti",
            "KA"
        ],
        [
            "Kvemo Kartli",
            "KK"
        ],
        [
            "Mtshkheta-Mtianeti",
            "MM"
        ],
        [
            "Rach'a-Lexhkumi-KvemoSvaneti",
            "RL"
        ],
        [
            "Samegrelo-Zemo Svaneti",
            "SZ"
        ],
        [
            "Samtskhe-Javakheti",
            "SJ"
        ],
        [
            "Shida Kartli",
            "SK"
        ],
        [
            "Tbilisi",
            "TB"
        ]
    ]
];
const $c8f06188fc3ad916$export$b2bfc53cef5629f5 = [
    "Germany",
    "DE",
    [
        [
            "Baden-W\xfcrttemberg",
            "BW"
        ],
        [
            "Bayern",
            "BY"
        ],
        [
            "Berlin",
            "BE"
        ],
        [
            "Brandenburg",
            "BB"
        ],
        [
            "Bremen",
            "HB"
        ],
        [
            "Hamburg",
            "HH"
        ],
        [
            "Hessen",
            "HE"
        ],
        [
            "Mecklenburg-Vorpommern",
            "MV"
        ],
        [
            "Niedersachsen",
            "NI"
        ],
        [
            "Nordrhein-Westfalen",
            "NW"
        ],
        [
            "Rheinland-Pfalz",
            "RP"
        ],
        [
            "Saarland",
            "SL"
        ],
        [
            "Sachsen",
            "SN"
        ],
        [
            "Sachsen-Anhalt",
            "ST"
        ],
        [
            "Schleswig-Holstein",
            "SH"
        ],
        [
            "Th\xfcringen",
            "TH"
        ]
    ]
];
const $c8f06188fc3ad916$export$2063236980199869 = [
    "Ghana",
    "GH",
    [
        [
            "Ahafo",
            "AF"
        ],
        [
            "Ashanti",
            "AH"
        ],
        [
            "Bono",
            "BO"
        ],
        [
            "Bono East",
            "BE"
        ],
        [
            "Central",
            "CP"
        ],
        [
            "Eastern",
            "EP"
        ],
        [
            "Greater Accra",
            "AA"
        ],
        [
            "Northern",
            "NP"
        ],
        [
            "North East",
            "NE"
        ],
        [
            "Oti",
            "OT"
        ],
        [
            "Savannah",
            "SV"
        ],
        [
            "Upper East",
            "UE"
        ],
        [
            "Upper West",
            "UW"
        ],
        [
            "Volta",
            "TV"
        ],
        [
            "Western",
            "WP"
        ],
        [
            "Western North",
            "WN"
        ]
    ]
];
const $c8f06188fc3ad916$export$b3b059666b470a4 = [
    "Gibraltar",
    "GI",
    [
        [
            "Gibraltar",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$be3bb2d6fb94aa6 = [
    "Greece",
    "GR",
    [
        [
            "Anatolik\xed Makedon\xeda kai Thr\xe1ki",
            "A"
        ],
        [
            "Attik\u1E2F",
            "I"
        ],
        [
            "Dytik\xed Ell\xe1da",
            "G"
        ],
        [
            "Dytik\xed Makedon\xeda",
            "C"
        ],
        [
            "Ion\xeda N\xedsia",
            "F"
        ],
        [
            "Kentrik\xed Makedon\xeda",
            "B"
        ],
        [
            "Kr\xedt\xed",
            "M"
        ],
        [
            "Not\xedo Aiga\xedo",
            "L"
        ],
        [
            "Peloponn\xedsos",
            "J"
        ],
        [
            "Stere\xe1 Ell\xe1da",
            "H"
        ],
        [
            "Thessal\xeda",
            "E"
        ],
        [
            "Vore\xedo Aiga\xedo",
            "K"
        ],
        [
            "\xcdpeiros",
            "D"
        ],
        [
            "\xc1gion \xd3ros",
            "69"
        ]
    ]
];
const $c8f06188fc3ad916$export$bad2a840ccda93b6 = [
    "Greenland",
    "GL",
    [
        [
            "Kommune Kujalleq",
            "KU"
        ],
        [
            "Kommuneqarfik Sermersooq",
            "SM"
        ],
        [
            "Qaasuitsup Kommunia",
            "QA"
        ],
        [
            "Qeqqata Kommunia",
            "QE"
        ]
    ]
];
const $c8f06188fc3ad916$export$44132903afebf574 = [
    "Grenada",
    "GD",
    [
        [
            "Saint Andrew",
            "01"
        ],
        [
            "Saint David",
            "02"
        ],
        [
            "Saint George",
            "03"
        ],
        [
            "Saint John",
            "04"
        ],
        [
            "Saint Mark",
            "05"
        ],
        [
            "Saint Patrick",
            "06"
        ],
        [
            "Southern Grenadine Islands",
            "10"
        ]
    ]
];
const $c8f06188fc3ad916$export$a1e9daa76fd80d91 = [
    "Guadeloupe",
    "GP",
    [
        [
            "Guadeloupe",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$875a05f1afdc3a63 = [
    "Guam",
    "GU",
    [
        [
            "Guam",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$b023c82b48e70453 = [
    "Guatemala",
    "GT",
    [
        [
            "Alta Verapaz",
            "AV"
        ],
        [
            "Baja Verapaz",
            "BV"
        ],
        [
            "Chimaltenango",
            "CM"
        ],
        [
            "Chiquimula",
            "CQ"
        ],
        [
            "El Progreso",
            "PR"
        ],
        [
            "Escuintla",
            "ES"
        ],
        [
            "Guatemala",
            "GU"
        ],
        [
            "Huehuetenango",
            "HU"
        ],
        [
            "Izabal",
            "IZ"
        ],
        [
            "Jalapa",
            "JA"
        ],
        [
            "Jutiapa",
            "JU"
        ],
        [
            "Pet\xe9n",
            "PE"
        ],
        [
            "Quetzaltenango",
            "QZ"
        ],
        [
            "Quich\xe9",
            "QC"
        ],
        [
            "Retalhuleu",
            "Re"
        ],
        [
            "Sacatep\xe9quez",
            "SA"
        ],
        [
            "San Marcos",
            "SM"
        ],
        [
            "Santa Rosa",
            "SR"
        ],
        [
            "Solol\xe1",
            "SO"
        ],
        [
            "Suchitep\xe9quez",
            "SU"
        ],
        [
            "Totonicap\xe1n",
            "TO"
        ],
        [
            "Zacapa",
            "ZA"
        ]
    ]
];
const $c8f06188fc3ad916$export$ffd553dab4f92f72 = [
    "Guernsey",
    "GG",
    [
        [
            "Castel",
            "undefined"
        ],
        [
            "Forest",
            "undefined"
        ],
        [
            "St. Andrew",
            "undefined"
        ],
        [
            "St. Martin",
            "undefined"
        ],
        [
            "St. Peter Port",
            "undefined"
        ],
        [
            "St. Pierre du Bois",
            "undefined"
        ],
        [
            "St. Sampson",
            "undefined"
        ],
        [
            "St. Saviour",
            "undefined"
        ],
        [
            "Torteval",
            "undefined"
        ],
        [
            "Vale",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$49b768d2cda4fc68 = [
    "Guinea",
    "GN",
    [
        [
            "Bok\xe9",
            "B"
        ],
        [
            "Conakry",
            "C"
        ],
        [
            "Faranah",
            "F"
        ],
        [
            "Kankan",
            "K"
        ],
        [
            "Kindia",
            "D"
        ],
        [
            "Lab\xe9",
            "L"
        ],
        [
            "Mamou",
            "M"
        ],
        [
            "Nz\xe9r\xe9kor\xe9",
            "N"
        ]
    ]
];
const $c8f06188fc3ad916$export$4f7b2a18b14c6e6 = [
    "Guinea-Bissau",
    "GW",
    [
        [
            "Bafat\xe1",
            "BA"
        ],
        [
            "Biombo",
            "BM"
        ],
        [
            "Bissau",
            "BS"
        ],
        [
            "Bolama-Bijagos",
            "BL"
        ],
        [
            "Cacheu",
            "CA"
        ],
        [
            "Gab\xfa",
            "GA"
        ],
        [
            "Oio",
            "OI"
        ],
        [
            "Quinara",
            "QU"
        ],
        [
            "Tombali",
            "TO"
        ]
    ]
];
const $c8f06188fc3ad916$export$f433acc20da515b9 = [
    "Guyana",
    "GY",
    [
        [
            "Barima-Waini",
            "BA"
        ],
        [
            "Cuyuni-Mazaruni",
            "CU"
        ],
        [
            "Demerara-Mahaica",
            "DE"
        ],
        [
            "East Berbice-Corentyne",
            "EB"
        ],
        [
            "Essequibo Islands-West Demerara",
            "ES"
        ],
        [
            "Mahaica-Berbice",
            "MA"
        ],
        [
            "Pomeroon-Supenaam",
            "PM"
        ],
        [
            "Potaro-Siparuni",
            "PT"
        ],
        [
            "Upper Demerara-Berbice",
            "UD"
        ],
        [
            "Upper Takutu-Upper Essequibo",
            "UT"
        ]
    ]
];
const $c8f06188fc3ad916$export$3927bce5ead7457e = [
    "Haiti",
    "HT",
    [
        [
            "Artibonite",
            "AR"
        ],
        [
            "Centre",
            "CE"
        ],
        [
            "Grand'Anse",
            "GA"
        ],
        [
            "Nippes",
            "NI"
        ],
        [
            "Nord",
            "ND"
        ],
        [
            "Nord-Est",
            "NE"
        ],
        [
            "Nord-Ouest",
            "NO"
        ],
        [
            "Ouest",
            "OU"
        ],
        [
            "Sud",
            "SD"
        ],
        [
            "Sud-Est",
            "SE"
        ]
    ]
];
const $c8f06188fc3ad916$export$e8ae668e70e7a813 = [
    "Heard Island and McDonald Islands",
    "HM",
    [
        [
            "Heard Island and McDonald Islands",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$8f976c058e984810 = [
    "Holy See (Vatican City)",
    "VA",
    [
        [
            "Holy See (Vatican City)",
            "01"
        ]
    ]
];
const $c8f06188fc3ad916$export$d654914ee99e1b51 = [
    "Honduras",
    "HN",
    [
        [
            "Atl\xe1ntida",
            "AT"
        ],
        [
            "Choluteca",
            "CH"
        ],
        [
            "Col\xf3n",
            "CL"
        ],
        [
            "Comayagua",
            "CM"
        ],
        [
            "Cop\xe1n",
            "CP"
        ],
        [
            "Cort\xe9s",
            "CR"
        ],
        [
            "El Para\xedso",
            "EP"
        ],
        [
            "Francisco Moraz\xe1n",
            "FM"
        ],
        [
            "Gracias a Dios",
            "GD"
        ],
        [
            "Intibuc\xe1",
            "IN"
        ],
        [
            "Islas de la Bah\xeda",
            "IB"
        ],
        [
            "La Paz",
            "LP"
        ],
        [
            "Lempira",
            "LE"
        ],
        [
            "Ocotepeque",
            "OC"
        ],
        [
            "Olancho",
            "OL"
        ],
        [
            "Santa B\xe1rbara",
            "SB"
        ],
        [
            "Valle",
            "VA"
        ],
        [
            "Yoro",
            "YO"
        ]
    ]
];
const $c8f06188fc3ad916$export$7bf8e436292b0d9 = [
    "Hong Kong",
    "HK",
    [
        [
            "Hong Kong",
            "HK"
        ]
    ]
];
const $c8f06188fc3ad916$export$2cba20fb7b4c6fda = [
    "Hungary",
    "HU",
    [
        [
            "B\xe1cs-Kiskun",
            "BK"
        ],
        [
            "Baranya",
            "BA"
        ],
        [
            "B\xe9k\xe9s",
            "BE"
        ],
        [
            "Borsod-Aba\xfaj-Zempl\xe9n",
            "BZ"
        ],
        [
            "Budapest",
            "BU"
        ],
        [
            "Csongr\xe1d-Csan\xe1d",
            "CS"
        ],
        [
            "Fej\xe9r",
            "FE"
        ],
        [
            "Gy\u0151r-Moson-Sopron",
            "GS"
        ],
        [
            "Hajd\xfa-Bihar",
            "HB"
        ],
        [
            "Heves",
            "HE"
        ],
        [
            "J\xe1sz-Nagykun-Szolnok",
            "JN"
        ],
        [
            "Kom\xe1rom-Esztergom",
            "KE"
        ],
        [
            "Pest",
            "PE"
        ],
        [
            "Somogy",
            "SO"
        ],
        [
            "Szabolcs-Szatm\xe1r-Bereg",
            "SZ"
        ],
        [
            "Tolna",
            "TO"
        ],
        [
            "Vas",
            "VA"
        ],
        [
            "Veszpr\xe9m",
            "VE"
        ],
        [
            "Zala",
            "ZA"
        ]
    ]
];
const $c8f06188fc3ad916$export$bfe27467c1de9413 = [
    "Iceland",
    "IS",
    [
        [
            "Austurland",
            "7"
        ],
        [
            "H\xf6fu\xf0borgarsv\xe6\xf0i",
            "1"
        ],
        [
            "Nor\xf0urland eystra",
            "6"
        ],
        [
            "Nor\xf0urland vestra",
            "5"
        ],
        [
            "Su\xf0urland",
            "8"
        ],
        [
            "Su\xf0urnes",
            "2"
        ],
        [
            "Vestfir\xf0ir",
            "4"
        ],
        [
            "Vesturland",
            "3"
        ]
    ]
];
const $c8f06188fc3ad916$export$70824c8942178d60 = [
    "India",
    "IN",
    [
        [
            "Andaman and Nicobar Islands",
            "AN"
        ],
        [
            "Andhra Pradesh",
            "AP"
        ],
        [
            "Arunachal Pradesh",
            "AR"
        ],
        [
            "Assam",
            "AS"
        ],
        [
            "Bihar",
            "BR"
        ],
        [
            "Chandigarh",
            "CH"
        ],
        [
            "Chhattisgarh",
            "CT"
        ],
        [
            "Dadra and Nagar Haveli and Daman and Diu",
            "DH"
        ],
        [
            "Delhi",
            "DL"
        ],
        [
            "Goa",
            "GA"
        ],
        [
            "Gujarat",
            "GJ"
        ],
        [
            "Haryana",
            "HR"
        ],
        [
            "Himachal Pradesh",
            "HP"
        ],
        [
            "Jammu and Kashmir",
            "JK"
        ],
        [
            "Jharkhand",
            "JH"
        ],
        [
            "Karnataka",
            "KA"
        ],
        [
            "Kerala",
            "KL"
        ],
        [
            "Ladakh",
            "LA"
        ],
        [
            "Lakshadweep",
            "LD"
        ],
        [
            "Madhya Pradesh",
            "MP"
        ],
        [
            "Maharashtra",
            "MH"
        ],
        [
            "Manipur",
            "MN"
        ],
        [
            "Meghalaya",
            "ML"
        ],
        [
            "Mizoram",
            "MZ"
        ],
        [
            "Nagaland",
            "NL"
        ],
        [
            "Odisha",
            "OR"
        ],
        [
            "Puducherry",
            "PY"
        ],
        [
            "Punjab",
            "PB"
        ],
        [
            "Rajasthan",
            "RJ"
        ],
        [
            "Sikkim",
            "SK"
        ],
        [
            "Tamil Nadu",
            "TN"
        ],
        [
            "Telangana",
            "TG"
        ],
        [
            "Tripura",
            "TR"
        ],
        [
            "Uttarakhand",
            "UT"
        ],
        [
            "Uttar Pradesh",
            "UP"
        ],
        [
            "West Bengal",
            "WB"
        ]
    ]
];
const $c8f06188fc3ad916$export$8be180ec26319f9f = [
    "Indonesia",
    "ID",
    [
        [
            "Aceh",
            "AC"
        ],
        [
            "Bali",
            "BA"
        ],
        [
            "Bangka Belitung",
            "BB"
        ],
        [
            "Banten",
            "BT"
        ],
        [
            "Bengkulu",
            "BE"
        ],
        [
            "Gorontalo",
            "GO"
        ],
        [
            "Jakarta Raya",
            "JK"
        ],
        [
            "Jambi",
            "JA"
        ],
        [
            "Jawa Barat",
            "JB"
        ],
        [
            "Jawa Tengah",
            "JT"
        ],
        [
            "Jawa Timur",
            "JI"
        ],
        [
            "Kalimantan Barat",
            "KB"
        ],
        [
            "Kalimantan Selatan",
            "KS"
        ],
        [
            "Kalimantan Tengah",
            "KT"
        ],
        [
            "Kalimantan Timur",
            "KI"
        ],
        [
            "Kalimantan Utara",
            "KU"
        ],
        [
            "Kepulauan Riau",
            "KR"
        ],
        [
            "Lampung",
            "LA"
        ],
        [
            "Maluku",
            "MA"
        ],
        [
            "Maluku Utara",
            "MU"
        ],
        [
            "Nusa Tenggara Barat",
            "NB"
        ],
        [
            "Nusa Tenggara Timur",
            "NT"
        ],
        [
            "Papua",
            "PA"
        ],
        [
            "Papua Barat",
            "PB"
        ],
        [
            "Riau",
            "RI"
        ],
        [
            "Sulawesi Selatan",
            "SR"
        ],
        [
            "Sulawesi Tengah",
            "ST"
        ],
        [
            "Sulawesi Tenggara",
            "SG"
        ],
        [
            "Sulawesi Utara",
            "SA"
        ],
        [
            "Sumatera Barat",
            "SB"
        ],
        [
            "Sumatera Selatan",
            "SS"
        ],
        [
            "Sumatera Utara",
            "SU"
        ],
        [
            "Yogyakarta",
            "YO"
        ]
    ]
];
const $c8f06188fc3ad916$export$35f3e3f7e3ce71e0 = [
    "Iran, Islamic Republic of",
    "IR",
    [
        [
            "Alborz",
            "32"
        ],
        [
            "Ardab\u012Bl",
            "03"
        ],
        [
            "\u0100z\u0304arb\u0101yj\u0101n-e Gharb\u012B",
            "02"
        ],
        [
            "\u0100z\u0304arb\u0101yj\u0101n-e Sharq\u012B",
            "01"
        ],
        [
            "B\u016Bshehr",
            "06"
        ],
        [
            "Chah\u0101r Ma\u1E29\u0101l va Bakht\u012B\u0101r\u012B",
            "08"
        ],
        [
            "E\u015Ffah\u0101n",
            "04"
        ],
        [
            "F\u0101rs",
            "14"
        ],
        [
            "G\u012Bl\u0101n",
            "19"
        ],
        [
            "Golest\u0101n",
            "27"
        ],
        [
            "Hamad\u0101n",
            "24"
        ],
        [
            "Hormozg\u0101n",
            "23"
        ],
        [
            "\u012Al\u0101m",
            "05"
        ],
        [
            "Kerm\u0101n",
            "15"
        ],
        [
            "Kerm\u0101nsh\u0101h",
            "17"
        ],
        [
            "Khor\u0101s\u0101n-e Jon\u016Bb\u012B",
            "29"
        ],
        [
            "Khor\u0101s\u0101n-e Ra\u1E95av\u012B",
            "30"
        ],
        [
            "Khor\u0101s\u0101n-e Shom\u0101l\u012B",
            "61"
        ],
        [
            "Kh\u016Bzest\u0101n",
            "10"
        ],
        [
            "Kohg\u012Bl\u016Byeh va Bowyer A\u1E29mad",
            "18"
        ],
        [
            "Kordest\u0101n",
            "16"
        ],
        [
            "Lorest\u0101n",
            "20"
        ],
        [
            "Markazi",
            "22"
        ],
        [
            "M\u0101zandar\u0101n",
            "21"
        ],
        [
            "Qazv\u012Bn",
            "28"
        ],
        [
            "Qom",
            "26"
        ],
        [
            "Semn\u0101n",
            "12"
        ],
        [
            "S\u012Bst\u0101n va Bal\u016Bchest\u0101n",
            "13"
        ],
        [
            "Tehr\u0101n",
            "07"
        ],
        [
            "Yazd",
            "25"
        ],
        [
            "Zanj\u0101n",
            "11"
        ]
    ]
];
const $c8f06188fc3ad916$export$776a9becd139230f = [
    "Iraq",
    "IQ",
    [
        [
            "Al Anb\u0101r",
            "AN"
        ],
        [
            "Al Ba\u015Frah",
            "BA"
        ],
        [
            "Al Muthann\xe1",
            "MU"
        ],
        [
            "Al Q\u0101dis\u012Byah",
            "QA"
        ],
        [
            "An Najaf",
            "NA"
        ],
        [
            "Arb\u012Bl",
            "AR"
        ],
        [
            "As Sulaym\u0101n\u012Byah",
            "SU"
        ],
        [
            "B\u0101bil",
            "BB"
        ],
        [
            "Baghd\u0101d",
            "BG"
        ],
        [
            "Dohuk",
            "DA"
        ],
        [
            "Dh\u012B Q\u0101r",
            "DQ"
        ],
        [
            "Diy\u0101l\xe1",
            "DI"
        ],
        [
            "Karbal\u0101'",
            "KA"
        ],
        [
            "Kirkuk",
            "KI"
        ],
        [
            "Mays\u0101n",
            "MA"
        ],
        [
            "N\u012Bnaw\xe1",
            "NI"
        ],
        [
            "\u015Eal\u0101\u1E29 ad D\u012Bn",
            "SD"
        ],
        [
            "W\u0101si\u0163",
            "WA"
        ]
    ]
];
const $c8f06188fc3ad916$export$5056f4df3c1a040a = [
    "Ireland",
    "IE",
    [
        [
            "Carlow",
            "CW"
        ],
        [
            "Cavan",
            "CN"
        ],
        [
            "Clare",
            "CE"
        ],
        [
            "Cork",
            "CO"
        ],
        [
            "Donegal",
            "DL"
        ],
        [
            "Dublin",
            "D"
        ],
        [
            "Galway",
            "G"
        ],
        [
            "Kerry",
            "KY"
        ],
        [
            "Kildare",
            "KE"
        ],
        [
            "Kilkenny",
            "KK"
        ],
        [
            "Laois",
            "LS"
        ],
        [
            "Leitrim",
            "LM"
        ],
        [
            "Limerick",
            "LK"
        ],
        [
            "Longford",
            "LD"
        ],
        [
            "Louth",
            "LH"
        ],
        [
            "Mayo",
            "MO"
        ],
        [
            "Meath",
            "MH"
        ],
        [
            "Monaghan",
            "MN"
        ],
        [
            "Offaly",
            "OY"
        ],
        [
            "Roscommon",
            "RN"
        ],
        [
            "Sligo",
            "SO"
        ],
        [
            "Tipperary",
            "TA"
        ],
        [
            "Waterford",
            "WD"
        ],
        [
            "Westmeath",
            "WH"
        ],
        [
            "Wexford",
            "WX"
        ],
        [
            "Wicklow",
            "WW"
        ]
    ]
];
const $c8f06188fc3ad916$export$5e0fd3f816252990 = [
    "Isle of Man",
    "IM",
    [
        [
            "Isle of Man",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$747f5b589ac90db = [
    "Israel",
    "IL",
    [
        [
            "HaDarom",
            "D"
        ],
        [
            "HaMerkaz",
            "M"
        ],
        [
            "HaTsafon",
            "Z"
        ],
        [
            "H\u0331efa",
            "HA"
        ],
        [
            "Tel-Aviv",
            "TA"
        ],
        [
            "Yerushalayim",
            "JM"
        ]
    ]
];
const $c8f06188fc3ad916$export$c8c4756768edc1be = [
    "Italy",
    "IT",
    [
        [
            "Abruzzo",
            "65"
        ],
        [
            "Basilicata",
            "77"
        ],
        [
            "Calabria",
            "78"
        ],
        [
            "Campania",
            "72"
        ],
        [
            "Emilia-Romagna",
            "45"
        ],
        [
            "Friuli-Venezia Giulia",
            "36"
        ],
        [
            "Lazio",
            "62"
        ],
        [
            "Liguria",
            "42"
        ],
        [
            "Lombardia",
            "25"
        ],
        [
            "Marche",
            "57"
        ],
        [
            "Molise",
            "67"
        ],
        [
            "Piemonte",
            "21"
        ],
        [
            "Puglia",
            "75"
        ],
        [
            "Sardegna",
            "88"
        ],
        [
            "Sicilia",
            "82"
        ],
        [
            "Toscana",
            "52"
        ],
        [
            "Trentino-Alto Adige",
            "32"
        ],
        [
            "Umbria",
            "55"
        ],
        [
            "Valle d'Aosta",
            "23"
        ],
        [
            "Veneto",
            "34"
        ]
    ]
];
const $c8f06188fc3ad916$export$62925b2b1d8826f = [
    "Jamaica",
    "JM",
    [
        [
            "Clarendon",
            "13"
        ],
        [
            "Hanover",
            "09"
        ],
        [
            "Kingston",
            "01"
        ],
        [
            "Manchester",
            "12"
        ],
        [
            "Portland",
            "04"
        ],
        [
            "Saint Andrew",
            "02"
        ],
        [
            "Saint Ann",
            "06"
        ],
        [
            "Saint Catherine",
            "14"
        ],
        [
            "Saint Elizabeth",
            "11"
        ],
        [
            "Saint James",
            "08"
        ],
        [
            "Saint Mary",
            "05"
        ],
        [
            "Saint Thomas",
            "03"
        ],
        [
            "Trelawny",
            "07"
        ],
        [
            "Westmoreland",
            "10"
        ]
    ]
];
const $c8f06188fc3ad916$export$4165087edc6149ea = [
    "Japan",
    "JP",
    [
        [
            "Aichi",
            "23"
        ],
        [
            "Akita",
            "05"
        ],
        [
            "Aomori",
            "02"
        ],
        [
            "Chiba",
            "12"
        ],
        [
            "Ehime",
            "38"
        ],
        [
            "Fukui",
            "18"
        ],
        [
            "Fukuoka",
            "40"
        ],
        [
            "Fukushima",
            "07"
        ],
        [
            "Gifu",
            "21"
        ],
        [
            "Gunma",
            "10"
        ],
        [
            "Hiroshima",
            "34"
        ],
        [
            "Hokkaido",
            "01"
        ],
        [
            "Hyogo",
            "28"
        ],
        [
            "Ibaraki",
            "08"
        ],
        [
            "Ishikawa",
            "17"
        ],
        [
            "Iwate",
            "03"
        ],
        [
            "Kagawa",
            "37"
        ],
        [
            "Kagoshima",
            "46"
        ],
        [
            "Kanagawa",
            "14"
        ],
        [
            "Kochi",
            "39"
        ],
        [
            "Kumamoto",
            "43"
        ],
        [
            "Kyoto",
            "26"
        ],
        [
            "Mie",
            "24"
        ],
        [
            "Miyagi",
            "04"
        ],
        [
            "Miyazaki",
            "45"
        ],
        [
            "Nagano",
            "20"
        ],
        [
            "Nagasaki",
            "42"
        ],
        [
            "Nara",
            "29"
        ],
        [
            "Niigata",
            "15"
        ],
        [
            "Oita",
            "44"
        ],
        [
            "Okayama",
            "33"
        ],
        [
            "Okinawa",
            "47"
        ],
        [
            "Osaka",
            "27"
        ],
        [
            "Saga",
            "41"
        ],
        [
            "Saitama",
            "11"
        ],
        [
            "Shiga",
            "25"
        ],
        [
            "Shimane",
            "32"
        ],
        [
            "Shizuoka",
            "22"
        ],
        [
            "Tochigi",
            "09"
        ],
        [
            "Tokushima",
            "36"
        ],
        [
            "Tokyo",
            "13"
        ],
        [
            "Tottori",
            "31"
        ],
        [
            "Toyama",
            "16"
        ],
        [
            "Wakayama",
            "30"
        ],
        [
            "Yamagata",
            "06"
        ],
        [
            "Yamaguchi",
            "35"
        ],
        [
            "Yamanashi",
            "19"
        ]
    ]
];
const $c8f06188fc3ad916$export$7300d7e65520d9c0 = [
    "Jersey",
    "JE",
    [
        [
            "Jersey",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$4ff8ba3b6e78910e = [
    "Jordan",
    "JO",
    [
        [
            "\u2018Ajl\u016Bn",
            "AJ"
        ],
        [
            "Al 'Aqabah",
            "AQ"
        ],
        [
            "Al Balq\u0101\u2019",
            "BA"
        ],
        [
            "Al Karak",
            "KA"
        ],
        [
            "Al Mafraq",
            "MA"
        ],
        [
            "Al \u2018A\u0305\u015Fimah",
            "AM"
        ],
        [
            "A\u0163 \u0162af\u012Blah",
            "AT"
        ],
        [
            "Az Zarq\u0101\u2019",
            "AZ"
        ],
        [
            "Irbid",
            "IR"
        ],
        [
            "Jarash",
            "JA"
        ],
        [
            "Ma\u2018\u0101n",
            "MN"
        ],
        [
            "M\u0101dab\u0101",
            "MD"
        ]
    ]
];
const $c8f06188fc3ad916$export$45edc2c6b51c02b3 = [
    "Kazakhstan",
    "KZ",
    [
        [
            "Almaty",
            "ALA"
        ],
        [
            "Aqmola",
            "AKM"
        ],
        [
            "Aqtobe",
            "AKT"
        ],
        [
            "Astana",
            "AST"
        ],
        [
            "Atyrau",
            "ATY"
        ],
        [
            "Batys Qazaqstan",
            "ZAP"
        ],
        [
            "Bayqongyr",
            "undefined"
        ],
        [
            "Mangghystau",
            "MAN"
        ],
        [
            "Ongtustik Qazaqstan",
            "YUZ"
        ],
        [
            "Pavlodar",
            "PAV"
        ],
        [
            "Qaraghandy",
            "KAR"
        ],
        [
            "Qostanay",
            "KUS"
        ],
        [
            "Qyzylorda",
            "KZY"
        ],
        [
            "Shyghys Qazaqstan",
            "VOS"
        ],
        [
            "Soltustik Qazaqstan",
            "SEV"
        ],
        [
            "Zhambyl",
            "ZHA"
        ]
    ]
];
const $c8f06188fc3ad916$export$ebf06250eda1662e = [
    "Kenya",
    "KE",
    [
        [
            "Baringo",
            "01"
        ],
        [
            "Bomet",
            "02"
        ],
        [
            "Bungoma",
            "03"
        ],
        [
            "Busia",
            "04"
        ],
        [
            "Eleyo/Marakwet",
            "05"
        ],
        [
            "Embu",
            "06"
        ],
        [
            "Garissa",
            "07"
        ],
        [
            "Homa Bay",
            "08"
        ],
        [
            "Isiolo",
            "09"
        ],
        [
            "Kajiado",
            "10"
        ],
        [
            "Kakamega",
            "11"
        ],
        [
            "Kericho",
            "12"
        ],
        [
            "Kiambu",
            "13"
        ],
        [
            "Kilifi",
            "14"
        ],
        [
            "Kirinyaga",
            "15"
        ],
        [
            "Kisii",
            "16"
        ],
        [
            "Kisumu",
            "17"
        ],
        [
            "Kitui",
            "18"
        ],
        [
            "Kwale",
            "19"
        ],
        [
            "Laikipia",
            "20"
        ],
        [
            "Lamu",
            "21"
        ],
        [
            "Machakos",
            "22"
        ],
        [
            "Makueni",
            "23"
        ],
        [
            "Mandera",
            "24"
        ],
        [
            "Marsabit",
            "25"
        ],
        [
            "Meru",
            "26"
        ],
        [
            "Migori",
            "27"
        ],
        [
            "Mombasa",
            "28"
        ],
        [
            "Murang'a",
            "29"
        ],
        [
            "Nairobi City",
            "30"
        ],
        [
            "Nakuru",
            "31"
        ],
        [
            "Nandi",
            "32"
        ],
        [
            "Narok",
            "33"
        ],
        [
            "Nyamira",
            "34"
        ],
        [
            "Nyandarua",
            "35"
        ],
        [
            "Nyeri",
            "36"
        ],
        [
            "Samburu",
            "37"
        ],
        [
            "Siaya",
            "38"
        ],
        [
            "Taita/Taveta",
            "39"
        ],
        [
            "Tana River",
            "40"
        ],
        [
            "Tharaka-Nithi",
            "41"
        ],
        [
            "Trans Nzoia",
            "42"
        ],
        [
            "Turkana",
            "43"
        ],
        [
            "Uasin Gishu",
            "44"
        ],
        [
            "Vihiga",
            "45"
        ],
        [
            "Wajir",
            "46"
        ],
        [
            "West Pokot",
            "47"
        ]
    ]
];
const $c8f06188fc3ad916$export$8aa7bcd4299a59b9 = [
    "Kiribati",
    "KI",
    [
        [
            "Abaiang",
            "undefined"
        ],
        [
            "Abemama",
            "undefined"
        ],
        [
            "Aranuka",
            "undefined"
        ],
        [
            "Arorae",
            "undefined"
        ],
        [
            "Banaba",
            "undefined"
        ],
        [
            "Beru",
            "undefined"
        ],
        [
            "Butaritari",
            "undefined"
        ],
        [
            "Central Gilberts",
            "undefined"
        ],
        [
            "Gilbert Islands",
            "G"
        ],
        [
            "Kanton",
            "undefined"
        ],
        [
            "Kiritimati",
            "undefined"
        ],
        [
            "Kuria",
            "undefined"
        ],
        [
            "Line Islands",
            "L"
        ],
        [
            "Maiana",
            "undefined"
        ],
        [
            "Makin",
            "undefined"
        ],
        [
            "Marakei",
            "undefined"
        ],
        [
            "Nikunau",
            "undefined"
        ],
        [
            "Nonouti",
            "undefined"
        ],
        [
            "Northern Gilberts",
            "undefined"
        ],
        [
            "Onotoa",
            "undefined"
        ],
        [
            "Phoenix Islands",
            "P"
        ],
        [
            "Southern Gilberts",
            "undefined"
        ],
        [
            "Tabiteuea",
            "undefined"
        ],
        [
            "Tabuaeran",
            "undefined"
        ],
        [
            "Tamana",
            "undefined"
        ],
        [
            "Tarawa",
            "undefined"
        ],
        [
            "Teraina",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$171643e72dc5e91 = [
    "Korea, Democratic People's Republic of",
    "KP",
    [
        [
            "Chagang-do (Chagang Province)",
            "04"
        ],
        [
            "Hamgyong-bukto (North Hamgyong Province)",
            "09"
        ],
        [
            "Hamgyong-namdo (South Hamgyong Province)",
            "08"
        ],
        [
            "Hwanghae-bukto (North Hwanghae Province)",
            "06"
        ],
        [
            "Hwanghae-namdo (South Hwanghae Province)",
            "05"
        ],
        [
            "Kangwon-do (Kangwon Province)",
            "07"
        ],
        [
            "Nas\u014Fn (Najin-S\u014Fnbong)",
            "13"
        ],
        [
            "P'yongan-bukto (North P'yongan Province)",
            "03"
        ],
        [
            "P'yongan-namdo (South P'yongan Province)",
            "02"
        ],
        [
            "P'yongyang-si (P'yongyang City)",
            "01"
        ],
        [
            "Yanggang-do (Yanggang Province)",
            "10"
        ]
    ]
];
const $c8f06188fc3ad916$export$ced591d2396bbc3f = [
    "Korea, Republic of",
    "KR",
    [
        [
            "Chungcheongbuk-do",
            "43"
        ],
        [
            "Chungcheongnam-do",
            "44"
        ],
        [
            "Jeju-teukbyeoljachido",
            "49"
        ],
        [
            "Jeollabuk-do",
            "45"
        ],
        [
            "Jeollanam-do",
            "46"
        ],
        [
            "Incheon-gwangyeoksi",
            "28"
        ],
        [
            "Gangwon-do",
            "42"
        ],
        [
            "Gwangju-gwangyeoksi",
            "29"
        ],
        [
            "Gyeonggi-do",
            "41"
        ],
        [
            "Gyeongsangbuk-do",
            "47"
        ],
        [
            "Gyeongsangnam-do",
            "48"
        ],
        [
            "Busan-gwangyeoksi",
            "26"
        ],
        [
            "Seoul-teukbyeolsi",
            "11"
        ],
        [
            "Sejong-teukbyeoljachisi",
            "50"
        ],
        [
            "Daegu-gwangyeoksi",
            "27"
        ],
        [
            "Daejeon-gwangyeoksi",
            "30"
        ],
        [
            "Ulsan-gwangyeoksi",
            "31"
        ]
    ]
];
const $c8f06188fc3ad916$export$ba5d28d969e41cd5 = [
    "Kosovo",
    "XK",
    [
        [
            "Farizaj",
            "FZ"
        ],
        [
            "Gjakova",
            "GK"
        ],
        [
            "Gjilan",
            "GL"
        ],
        [
            "Mitrovica",
            "MI"
        ],
        [
            "Peja/Pe\u0107",
            "PE"
        ],
        [
            "Pristina",
            "PR"
        ],
        [
            "Prizren",
            "PZ"
        ]
    ]
];
const $c8f06188fc3ad916$export$867391011d376267 = [
    "Kuwait",
    "KW",
    [
        [
            "Al A\u1E29madi",
            "AH"
        ],
        [
            "Al Farw\u0101n\u012Byah",
            "FA"
        ],
        [
            "Al Jahr\u0101\u2019",
            "JA"
        ],
        [
            "Al \u2018\u0100\u015Fimah",
            "KU"
        ],
        [
            "\u1E28awall\u012B",
            "HA"
        ],
        [
            "Mub\u0101rak al Kabir",
            "MU"
        ]
    ]
];
const $c8f06188fc3ad916$export$32f37961c13d8178 = [
    "Kyrgyzstan",
    "KG",
    [
        [
            "Batken Oblasty",
            "B"
        ],
        [
            "Bishkek Shaary",
            "GB"
        ],
        [
            "Chuy Oblasty (Bishkek)",
            "C"
        ],
        [
            "Jalal-Abad Oblasty",
            "J"
        ],
        [
            "Naryn Oblasty",
            "N"
        ],
        [
            "Osh Oblasty",
            "O"
        ],
        [
            "Talas Oblasty",
            "T"
        ],
        [
            "Ysyk-Kol Oblasty (Karakol)",
            "Y"
        ]
    ]
];
const $c8f06188fc3ad916$export$64f943d6c6d62030 = [
    "Laos",
    "LA",
    [
        [
            "Attapu",
            "AT"
        ],
        [
            "Bok\xe8o",
            "BK"
        ],
        [
            "Bolikhamxai",
            "BL"
        ],
        [
            "Champasak",
            "CH"
        ],
        [
            "Houaphan",
            "HO"
        ],
        [
            "Khammouan",
            "KH"
        ],
        [
            "Louang Namtha",
            "LM"
        ],
        [
            "Louangphabang",
            "LP"
        ],
        [
            "Oud\xf4mxai",
            "OU"
        ],
        [
            "Ph\xf4ngsali",
            "PH"
        ],
        [
            "Salavan",
            "SL"
        ],
        [
            "Savannakh\xe9t",
            "SV"
        ],
        [
            "Vientiane",
            "VI"
        ],
        [
            "Xaignabouli",
            "XA"
        ],
        [
            "X\xe9kong",
            "XE"
        ],
        [
            "Xaisomboun",
            "XS"
        ],
        [
            "Xiangkhouang",
            "XI"
        ]
    ]
];
const $c8f06188fc3ad916$export$feea9fafc15a0118 = [
    "Latvia",
    "LV",
    [
        [
            "Aglona",
            "001"
        ],
        [
            "Aizkraukle",
            "002"
        ],
        [
            "Aizpute",
            "003"
        ],
        [
            "Akn\u012Bste",
            "004"
        ],
        [
            "Aloja",
            "005"
        ],
        [
            "Alsunga",
            "06"
        ],
        [
            "Al\u016Bksne",
            "007"
        ],
        [
            "Amata",
            "008"
        ],
        [
            "Ape",
            "009"
        ],
        [
            "Auce",
            "010"
        ],
        [
            "\u0100da\u017Ei",
            "011"
        ],
        [
            "Bab\u012Bte",
            "012"
        ],
        [
            "Baldone",
            "013"
        ],
        [
            "Baltinava",
            "014"
        ],
        [
            "Balvi",
            "015"
        ],
        [
            "Bauska",
            "016"
        ],
        [
            "Bever\u012Bna",
            "017"
        ],
        [
            "Broc\u0113ni",
            "018"
        ],
        [
            "Burtnieki",
            "019"
        ],
        [
            "Carnikava",
            "020"
        ],
        [
            "Cesvaine",
            "021"
        ],
        [
            "C\u0113sis",
            "022"
        ],
        [
            "Cibla",
            "023"
        ],
        [
            "Dagda",
            "024"
        ],
        [
            "Daugavpils",
            "025"
        ],
        [
            "Daugavpils (City)",
            "DGV"
        ],
        [
            "Dobele",
            "026"
        ],
        [
            "Dundaga",
            "027"
        ],
        [
            "Durbe",
            "028"
        ],
        [
            "Engure",
            "029"
        ],
        [
            "\u0112rg\u013Ci",
            "030"
        ],
        [
            "Garkalne",
            "031"
        ],
        [
            "Grobi\u0146a",
            "032"
        ],
        [
            "Gulbene",
            "033"
        ],
        [
            "Iecava",
            "034"
        ],
        [
            "Ik\u0161\u0137ile",
            "035"
        ],
        [
            "Il\u016Bkste",
            "036"
        ],
        [
            "In\u010Dukalns",
            "037"
        ],
        [
            "Jaunjelgava",
            "038"
        ],
        [
            "Jaunpiebalga",
            "039"
        ],
        [
            "Jaunpils",
            "040"
        ],
        [
            "Jelgava",
            "041"
        ],
        [
            "Jelgava (City)",
            "JEL"
        ],
        [
            "J\u0113kabpils",
            "042"
        ],
        [
            "J\u0113kabpils (City)",
            "JKB"
        ],
        [
            "J\u016Brmala (City)",
            "JUR"
        ],
        [
            "Kandava",
            "043"
        ],
        [
            "K\u0101rsava",
            "044"
        ],
        [
            "Koc\u0113ni",
            "045"
        ],
        [
            "Koknese",
            "046"
        ],
        [
            "Kr\u0101slava",
            "047"
        ],
        [
            "Krimulda",
            "048"
        ],
        [
            "Krustpils",
            "049"
        ],
        [
            "Kuld\u012Bga",
            "050"
        ],
        [
            "\u0136egums",
            "051"
        ],
        [
            "\u0136ekava",
            "052"
        ],
        [
            "Lielv\u0101rde",
            "053"
        ],
        [
            "Liep\u0101ja",
            "LPX"
        ],
        [
            "Limba\u017Ei",
            "054"
        ],
        [
            "L\u012Bgatne",
            "055"
        ],
        [
            "L\u012Bv\u0101ni",
            "056"
        ],
        [
            "Lub\u0101na",
            "057"
        ],
        [
            "Ludza",
            "058"
        ],
        [
            "Madona",
            "059"
        ],
        [
            "Mazsalaca",
            "060"
        ],
        [
            "M\u0101lpils",
            "061"
        ],
        [
            "M\u0101rupe",
            "062"
        ],
        [
            "M\u0113rsrags",
            "063"
        ],
        [
            "Nauk\u0161\u0113ni",
            "064"
        ],
        [
            "Nereta",
            "065"
        ],
        [
            "N\u012Bca",
            "066"
        ],
        [
            "Ogre",
            "067"
        ],
        [
            "Olaine",
            "068"
        ],
        [
            "Ozolnieki",
            "069"
        ],
        [
            "P\u0101rgauja",
            "070"
        ],
        [
            "P\u0101vilosta",
            "071"
        ],
        [
            "P\u013Cavi\u0146as",
            "072"
        ],
        [
            "Prei\u013Ci",
            "073"
        ],
        [
            "Priekule",
            "074"
        ],
        [
            "Prieku\u013Ci",
            "075"
        ],
        [
            "Rauna",
            "076"
        ],
        [
            "R\u0113zekne",
            "077"
        ],
        [
            "R\u0113zekne (City)",
            "REZ"
        ],
        [
            "Riebi\u0146i",
            "078"
        ],
        [
            "R\u012Bga",
            "RIX"
        ],
        [
            "Roja",
            "079"
        ],
        [
            "Ropa\u017Ei",
            "080"
        ],
        [
            "Rucava",
            "081"
        ],
        [
            "Rug\u0101ji",
            "082"
        ],
        [
            "Rund\u0101le",
            "083"
        ],
        [
            "R\u016Bjiena",
            "084"
        ],
        [
            "Sala",
            "085"
        ],
        [
            "Salacgr\u012Bva",
            "086"
        ],
        [
            "Salaspils",
            "087"
        ],
        [
            "Saldus",
            "088"
        ],
        [
            "Saulkrasti",
            "089"
        ],
        [
            "S\u0113ja",
            "090"
        ],
        [
            "Sigulda",
            "091"
        ],
        [
            "Skr\u012Bveri",
            "092"
        ],
        [
            "Skrunda",
            "093"
        ],
        [
            "Smiltene",
            "094"
        ],
        [
            "Stopi\u0146i",
            "095"
        ],
        [
            "Stren\u010Di",
            "096"
        ],
        [
            "Talsi",
            "097"
        ],
        [
            "T\u0113rvete",
            "098"
        ],
        [
            "Tukums",
            "099"
        ],
        [
            "Vai\u0146ode",
            "100"
        ],
        [
            "Valka",
            "101"
        ],
        [
            "Valmiera",
            "VMR"
        ],
        [
            "Varak\u013C\u0101ni",
            "102"
        ],
        [
            "V\u0101rkava",
            "103"
        ],
        [
            "Vecpiebalga",
            "104"
        ],
        [
            "Vecumnieki",
            "105"
        ],
        [
            "Ventspils",
            "106"
        ],
        [
            "Ventspils (City)",
            "VEN"
        ],
        [
            "Vies\u012Bte",
            "107"
        ],
        [
            "Vi\u013Caka",
            "108"
        ],
        [
            "Vi\u013C\u0101ni",
            "109"
        ],
        [
            "Zilupe",
            "110"
        ]
    ]
];
const $c8f06188fc3ad916$export$1dd3e96947fb44fc = [
    "Lebanon",
    "LB",
    [
        [
            "Aakk\xe2r",
            "AK"
        ],
        [
            "Baalbelk-Hermel",
            "BH"
        ],
        [
            "B\xe9qaa",
            "BI"
        ],
        [
            "Beyrouth",
            "BA"
        ],
        [
            "Liban-Nord",
            "AS"
        ],
        [
            "Liban-Sud",
            "JA"
        ],
        [
            "Mont-Liban",
            "JL"
        ],
        [
            "Nabat\xeey\xe9",
            "NA"
        ]
    ]
];
const $c8f06188fc3ad916$export$c6944423ed371873 = [
    "Lesotho",
    "LS",
    [
        [
            "Berea",
            "D"
        ],
        [
            "Butha-Buthe",
            "B"
        ],
        [
            "Leribe",
            "C"
        ],
        [
            "Mafeteng",
            "E"
        ],
        [
            "Maseru",
            "A"
        ],
        [
            "Mohales Hoek",
            "F"
        ],
        [
            "Mokhotlong",
            "J"
        ],
        [
            "Qacha's Nek",
            "H"
        ],
        [
            "Quthing",
            "G"
        ],
        [
            "Thaba-Tseka",
            "K"
        ]
    ]
];
const $c8f06188fc3ad916$export$9e0d336de5ae0eb3 = [
    "Liberia",
    "LR",
    [
        [
            "Bomi",
            "BM"
        ],
        [
            "Bong",
            "BG"
        ],
        [
            "Gbarpolu",
            "GP"
        ],
        [
            "Grand Bassa",
            "GB"
        ],
        [
            "Grand Cape Mount",
            "CM"
        ],
        [
            "Grand Gedeh",
            "GG"
        ],
        [
            "Grand Kru",
            "GK"
        ],
        [
            "Lofa",
            "LO"
        ],
        [
            "Margibi",
            "MG"
        ],
        [
            "Maryland",
            "MY"
        ],
        [
            "Montserrado",
            "MO"
        ],
        [
            "Nimba",
            "NI"
        ],
        [
            "River Cess",
            "RI"
        ],
        [
            "River Geee",
            "RG"
        ],
        [
            "Sinoe",
            "SI"
        ]
    ]
];
const $c8f06188fc3ad916$export$4eb7334fca20385f = [
    "Libya",
    "LY",
    [
        [
            "Al Bu\u0163n\u0101n",
            "BU"
        ],
        [
            "Al Jabal al Akh\u1E11ar",
            "JA"
        ],
        [
            "Al Jabal al Gharb\u012B",
            "JG"
        ],
        [
            "Al Jaf\u0101rah",
            "JI"
        ],
        [
            "Al Jufrah",
            "JU"
        ],
        [
            "Al Kufrah",
            "FK"
        ],
        [
            "Al Marj",
            "MJ"
        ],
        [
            "Al Marquab",
            "MB"
        ],
        [
            "Al W\u0101\u1E29\u0101t",
            "WA"
        ],
        [
            "An Nuqa\u0163 al Khams",
            "NQ"
        ],
        [
            "Az Z\u0101wiyah",
            "ZA"
        ],
        [
            "Bangh\u0101z\u012B",
            "BA"
        ],
        [
            "Darnah",
            "DR"
        ],
        [
            "Gh\u0101t",
            "GH"
        ],
        [
            "Mi\u015Fr\u0101tah",
            "MI"
        ],
        [
            "Murzuq",
            "MQ"
        ],
        [
            "N\u0101l\u016Bt",
            "NL"
        ],
        [
            "Sabh\u0101",
            "SB"
        ],
        [
            "Surt",
            "SR"
        ],
        [
            "\u0162ar\u0101bulus",
            "TB"
        ],
        [
            "Yafran",
            "WD"
        ],
        [
            "W\u0101d\u012B ash Sh\u0101\u0163i\u02BE",
            "WS"
        ]
    ]
];
const $c8f06188fc3ad916$export$2e3013aac067a692 = [
    "Liechtenstein",
    "LI",
    [
        [
            "Balzers",
            "01"
        ],
        [
            "Eschen",
            "02"
        ],
        [
            "Gamprin",
            "03"
        ],
        [
            "Mauren",
            "04"
        ],
        [
            "Planken",
            "05"
        ],
        [
            "Ruggell",
            "06"
        ],
        [
            "Schaan",
            "07"
        ],
        [
            "Schellenberg",
            "08"
        ],
        [
            "Triesen",
            "09"
        ],
        [
            "Triesenberg",
            "10"
        ],
        [
            "Vaduz",
            "11"
        ]
    ]
];
const $c8f06188fc3ad916$export$7158f0ceb70f54c7 = [
    "Lithuania",
    "LT",
    [
        [
            "Alytaus",
            "AL"
        ],
        [
            "Kauno",
            "KU"
        ],
        [
            "Klaip\u0117dos",
            "KL"
        ],
        [
            "Marijampol\u0117s",
            "MR"
        ],
        [
            "Panev\u0117\u017Eio",
            "PN"
        ],
        [
            "\u0160iauli\u0173",
            "SA"
        ],
        [
            "Taurag\u0117s",
            "TA"
        ],
        [
            "Tel\u0161i\u0173",
            "TE"
        ],
        [
            "Utenos",
            "UT"
        ],
        [
            "Vilniaus",
            "VL"
        ]
    ]
];
const $c8f06188fc3ad916$export$b6a2dd8a7c2d6cd5 = [
    "Luxembourg",
    "LU",
    [
        [
            "Capellen",
            "CA"
        ],
        [
            "Clevaux",
            "CL"
        ],
        [
            "Diekirch",
            "DI"
        ],
        [
            "Echternach",
            "EC"
        ],
        [
            "Esch-sur-Alzette",
            "ES"
        ],
        [
            "Grevenmacher",
            "GR"
        ],
        [
            "Luxembourg",
            "LU"
        ],
        [
            "Mersch",
            "ME"
        ],
        [
            "Redange",
            "RD"
        ],
        [
            "Remich",
            "RM"
        ],
        [
            "Vianden",
            "VD"
        ],
        [
            "Wiltz",
            "WI"
        ]
    ]
];
const $c8f06188fc3ad916$export$511fbc18fa6ca984 = [
    "Macao",
    "MO",
    [
        [
            "Macao",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$9391ff7d7f7d79ce = [
    "Macedonia, Republic of",
    "MK",
    [
        [
            "Ara\u010Dinovo",
            "02"
        ],
        [
            "Berovo",
            "03"
        ],
        [
            "Bitola",
            "04"
        ],
        [
            "Bogdanci",
            "05"
        ],
        [
            "Bogovinje",
            "06"
        ],
        [
            "Bosilovo",
            "07"
        ],
        [
            "Brvenica",
            "08"
        ],
        [
            "Centar \u017Dupa",
            "78"
        ],
        [
            "\u010Ca\u0161ka",
            "80"
        ],
        [
            "\u010Ce\u0161inovo-Oble\u0161evo",
            "81"
        ],
        [
            "\u010Cu\u010Der Sandevo",
            "82"
        ],
        [
            "Debar",
            "21"
        ],
        [
            "Debarca",
            "22"
        ],
        [
            "Del\u010Devo",
            "23"
        ],
        [
            "Demir Hisar",
            "25"
        ],
        [
            "Demir Kapija",
            "24"
        ],
        [
            "Doran",
            "26"
        ],
        [
            "Dolneni",
            "27"
        ],
        [
            "Gevgelija",
            "18"
        ],
        [
            "Gostivar",
            "19"
        ],
        [
            "Gradsko",
            "20"
        ],
        [
            "Ilinden",
            "34"
        ],
        [
            "Jegunovce",
            "35"
        ],
        [
            "Karbinci",
            "37"
        ],
        [
            "Kavadarci",
            "36"
        ],
        [
            "Ki\u010Devo",
            "40"
        ],
        [
            "Ko\u010Dani",
            "42"
        ],
        [
            "Kon\u010De",
            "41"
        ],
        [
            "Kratovo",
            "43"
        ],
        [
            "Kriva Palanka",
            "44"
        ],
        [
            "Krivoga\u0161tani",
            "45"
        ],
        [
            "Kru\u0161evo",
            "46"
        ],
        [
            "Kumanovo",
            "47"
        ],
        [
            "Lipkovo",
            "48"
        ],
        [
            "Lozovo",
            "49"
        ],
        [
            "Makedonska Kamenica",
            "51"
        ],
        [
            "Makedonski Brod",
            "52"
        ],
        [
            "Mavrovo i Rostu\u0161a",
            "50"
        ],
        [
            "Mogila",
            "53"
        ],
        [
            "Negotino",
            "54"
        ],
        [
            "Novaci",
            "55"
        ],
        [
            "Novo Selo",
            "56"
        ],
        [
            "Ohrid",
            "58"
        ],
        [
            "Peh\u010Devo",
            "60"
        ],
        [
            "Petrovec",
            "59"
        ],
        [
            "Plasnica",
            "61"
        ],
        [
            "Prilep",
            "62"
        ],
        [
            "Probi\u0161tip",
            "63"
        ],
        [
            "Radovi\u0161",
            ""
        ],
        [
            "Rankovce",
            "65"
        ],
        [
            "Resen",
            "66"
        ],
        [
            "Rosoman",
            "67"
        ],
        [
            "Skopje",
            "85"
        ],
        [
            "Sopi\u0161te",
            "70"
        ],
        [
            "Staro Nagori\u010Dane",
            "71"
        ],
        [
            "Struga",
            "72"
        ],
        [
            "Strumica",
            "73"
        ],
        [
            "Studeni\u010Dani",
            "74"
        ],
        [
            "Sveti Nikole",
            "69"
        ],
        [
            "\u0160tip",
            "83"
        ],
        [
            "Tearce",
            "75"
        ],
        [
            "Tetovo",
            "76"
        ],
        [
            "Valandovo",
            "10"
        ],
        [
            "Vasilevo",
            "11"
        ],
        [
            "Veles",
            "13"
        ],
        [
            "Vev\u010Dani",
            "12"
        ],
        [
            "Vinica",
            "14"
        ],
        [
            "Vrap\u010Di\u0161te",
            "16"
        ],
        [
            "Zelenikovo",
            "32"
        ],
        [
            "Zrnovci",
            "33"
        ],
        [
            "\u017Delino",
            "30"
        ]
    ]
];
const $c8f06188fc3ad916$export$d7c1ae0cf4ef5274 = [
    "Madagascar",
    "MG",
    [
        [
            "Antananarivo",
            "T"
        ],
        [
            "Antsiranana",
            "D"
        ],
        [
            "Fianarantsoa",
            "F"
        ],
        [
            "Mahajanga",
            "M"
        ],
        [
            "Toamasina",
            "A"
        ],
        [
            "Toliara",
            "U"
        ]
    ]
];
const $c8f06188fc3ad916$export$a3772f6eb527275b = [
    "Malawi",
    "MW",
    [
        [
            "Balaka",
            "BA"
        ],
        [
            "Blantyre",
            "BL"
        ],
        [
            "Chikwawa",
            "CK"
        ],
        [
            "Chiradzulu",
            "CR"
        ],
        [
            "Chitipa",
            "CT"
        ],
        [
            "Dedza",
            "DE"
        ],
        [
            "Dowa",
            "DO"
        ],
        [
            "Karonga",
            "KR"
        ],
        [
            "Kasungu",
            "KS"
        ],
        [
            "Likoma",
            "LK"
        ],
        [
            "Lilongwe",
            "LI"
        ],
        [
            "Machinga",
            "MH"
        ],
        [
            "Mangochi",
            "MG"
        ],
        [
            "Mchinji",
            "MC"
        ],
        [
            "Mulanje",
            "MU"
        ],
        [
            "Mwanza",
            "MW"
        ],
        [
            "Mzimba",
            "MZ"
        ],
        [
            "Nkhata Bay",
            "NE"
        ],
        [
            "Nkhotakota",
            "NB"
        ],
        [
            "Nsanje",
            "NS"
        ],
        [
            "Ntcheu",
            "NU"
        ],
        [
            "Ntchisi",
            "NI"
        ],
        [
            "Phalombe",
            "PH"
        ],
        [
            "Rumphi",
            "RU"
        ],
        [
            "Salima",
            "SA"
        ],
        [
            "Thyolo",
            "TH"
        ],
        [
            "Zomba",
            "ZO"
        ]
    ]
];
const $c8f06188fc3ad916$export$655dc88003efaac0 = [
    "Malaysia",
    "MY",
    [
        [
            "Johor",
            "01"
        ],
        [
            "Kedah",
            "02"
        ],
        [
            "Kelantan",
            "03"
        ],
        [
            "Melaka",
            "04"
        ],
        [
            "Negeri Sembilan",
            "05"
        ],
        [
            "Pahang",
            "06"
        ],
        [
            "Perak",
            "08"
        ],
        [
            "Perlis",
            "09"
        ],
        [
            "Pulau Pinang",
            "07"
        ],
        [
            "Sabah",
            "12"
        ],
        [
            "Sarawak",
            "13"
        ],
        [
            "Selangor",
            "10"
        ],
        [
            "Terengganu",
            "11"
        ],
        [
            "Wilayah Persekutuan (Kuala Lumpur)",
            "14"
        ],
        [
            "Wilayah Persekutuan (Labuan)",
            "15"
        ],
        [
            "Wilayah Persekutuan (Putrajaya)",
            "16"
        ]
    ]
];
const $c8f06188fc3ad916$export$20138591ba7d4d60 = [
    "Maldives",
    "MV",
    [
        [
            "Alifu Alifu",
            "02"
        ],
        [
            "Alifu Dhaalu",
            "00"
        ],
        [
            "Baa",
            "20"
        ],
        [
            "Dhaalu",
            "17"
        ],
        [
            "Faafu",
            "14"
        ],
        [
            "Gaafu Alifu",
            "27"
        ],
        [
            "Gaafu Dhaalu",
            "28"
        ],
        [
            "Gnaviyani",
            "29"
        ],
        [
            "Haa Alifu",
            "07"
        ],
        [
            "Haa Dhaalu",
            "23"
        ],
        [
            "Kaafu",
            "26"
        ],
        [
            "Laamu",
            "05"
        ],
        [
            "Lhaviyani",
            "03"
        ],
        [
            "Mal\xe9",
            "MLE"
        ],
        [
            "Meemu",
            "12"
        ],
        [
            "Noonu",
            "25"
        ],
        [
            "Raa",
            "13"
        ],
        [
            "Seenu",
            "01"
        ],
        [
            "Shaviyani",
            "24"
        ],
        [
            "Thaa",
            "08"
        ],
        [
            "Vaavu",
            "04"
        ]
    ]
];
const $c8f06188fc3ad916$export$670dad092b145ea = [
    "Mali",
    "ML",
    [
        [
            "Bamako",
            "BKO"
        ],
        [
            "Gao",
            "7"
        ],
        [
            "Kayes",
            "1"
        ],
        [
            "Kidal",
            "8"
        ],
        [
            "Koulikoro",
            "2"
        ],
        [
            "Mopti",
            "5"
        ],
        [
            "Segou",
            "4"
        ],
        [
            "Sikasso",
            "3"
        ],
        [
            "Tombouctou",
            "6"
        ],
        [
            "Taoud\xe9nit",
            "9"
        ],
        [
            "M\xe9naka",
            "10"
        ]
    ]
];
const $c8f06188fc3ad916$export$b900a375df2ae552 = [
    "Malta",
    "MT",
    [
        [
            "Attard",
            "01"
        ],
        [
            "Balzan",
            "02"
        ],
        [
            "Birgu",
            "03"
        ],
        [
            "Birkirkara",
            "04"
        ],
        [
            "Bir\u017Cebbu\u0121a",
            "05"
        ],
        [
            "Bormla",
            "06"
        ],
        [
            "Dingli",
            "07"
        ],
        [
            "Fgura",
            "08"
        ],
        [
            "Floriana",
            "09"
        ],
        [
            "Fontana",
            "10"
        ],
        [
            "Guda",
            "11"
        ],
        [
            "G\u017Cira",
            "12"
        ],
        [
            "G\u0127ajnsielem",
            "13"
        ],
        [
            "G\u0127arb",
            "14"
        ],
        [
            "G\u0127arg\u0127ur",
            "15"
        ],
        [
            "G\u0127asri",
            "16"
        ],
        [
            "G\u0127axaq",
            "17"
        ],
        [
            "\u0126amrun",
            "18"
        ],
        [
            "Iklin",
            "19"
        ],
        [
            "Isla",
            "20"
        ],
        [
            "Kalkara",
            "21"
        ],
        [
            "Ker\u010Bem",
            "22"
        ],
        [
            "Kirkop",
            "23"
        ],
        [
            "Lija",
            "24"
        ],
        [
            "Luqa",
            "25"
        ],
        [
            "Marsa",
            "26"
        ],
        [
            "Marsaskala",
            "27"
        ],
        [
            "Marsaxlokk",
            "28"
        ],
        [
            "Mdina",
            "29"
        ],
        [
            "Mellie\u0127a",
            "30"
        ],
        [
            "M\u0121arr",
            "31"
        ],
        [
            "Mosta",
            "32"
        ],
        [
            "Mqabba",
            "33"
        ],
        [
            "Msida",
            "34"
        ],
        [
            "Mtarfa",
            "35"
        ],
        [
            "Munxar",
            "36"
        ],
        [
            "Nadur",
            "37"
        ],
        [
            "Naxxar",
            "38"
        ],
        [
            "Paola",
            "39"
        ],
        [
            "Pembroke",
            "40"
        ],
        [
            "Piet\xe0",
            "41"
        ],
        [
            "Qala",
            "42"
        ],
        [
            "Qormi",
            "43"
        ],
        [
            "Qrendi",
            "44"
        ],
        [
            "Rabat G\u0127awdex",
            "45"
        ],
        [
            "Rabat Malta",
            "46"
        ],
        [
            "Safi",
            "47"
        ],
        [
            "San \u0120iljan",
            "48"
        ],
        [
            "San \u0120wann",
            "49"
        ],
        [
            "San Lawrenz",
            "50"
        ],
        [
            "San Pawl il-Ba\u0127ar",
            "51"
        ],
        [
            "Sannat",
            "52"
        ],
        [
            "Santa Lu\u010Bija",
            "53"
        ],
        [
            "Santa Venera",
            "54"
        ],
        [
            "Si\u0121\u0121iewi",
            "55"
        ],
        [
            "Sliema",
            "56"
        ],
        [
            "Swieqi",
            "57"
        ],
        [
            "Tai Xbiex",
            "58"
        ],
        [
            "Tarzien",
            "59"
        ],
        [
            "Valletta",
            "60"
        ],
        [
            "Xag\u0127ra",
            "61"
        ],
        [
            "Xewkija",
            "62"
        ],
        [
            "Xg\u0127ajra",
            "63"
        ],
        [
            "\u017Babbar",
            "64"
        ],
        [
            "\u017Bebbu\u0121 G\u0127awde",
            "65"
        ],
        [
            "\u017Bebbu\u0121 Malta",
            "66"
        ],
        [
            "\u017Bejtun",
            "67"
        ],
        [
            "\u017Burrieq",
            "68"
        ]
    ]
];
const $c8f06188fc3ad916$export$61a81a4b59098e0c = [
    "Marshall Islands",
    "MH",
    [
        [
            "Ailinglaplap",
            "ALL"
        ],
        [
            "Ailuk",
            "ALK"
        ],
        [
            "Arno",
            "ARN"
        ],
        [
            "Aur",
            "AUR"
        ],
        [
            "Bikini and Kili",
            "KIL"
        ],
        [
            "Ebon",
            "EBO"
        ],
        [
            "Jabat",
            "JAB"
        ],
        [
            "Jaluit",
            "JAL"
        ],
        [
            "Kwajalein",
            "KWA"
        ],
        [
            "Lae",
            "LAE"
        ],
        [
            "Lib",
            "LIB"
        ],
        [
            "Likiep",
            "LIK"
        ],
        [
            "Majuro",
            "MAJ"
        ],
        [
            "Maloelap",
            "MAL"
        ],
        [
            "Mejit",
            "MEJ"
        ],
        [
            "Namdrik",
            "NMK"
        ],
        [
            "Namu",
            "NMU"
        ],
        [
            "Rongelap",
            "RON"
        ],
        [
            "Ujae",
            "UJA"
        ],
        [
            "Utrik",
            "UTI"
        ],
        [
            "Wotho",
            "WTH"
        ],
        [
            "Wotje",
            "WTJ"
        ]
    ]
];
const $c8f06188fc3ad916$export$451b471c9c9066b = [
    "Martinique",
    "MQ",
    [
        [
            "Martinique",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$c4e38e98e3fb5f60 = [
    "Mauritania",
    "MR",
    [
        [
            "Adrar",
            "07"
        ],
        [
            "Assaba",
            "03"
        ],
        [
            "Brakna",
            "05"
        ],
        [
            "Dakhlet Nouadhibou",
            "08"
        ],
        [
            "Gorgol",
            "04"
        ],
        [
            "Guidimaka",
            "10"
        ],
        [
            "Hodh Ech Chargui",
            "01"
        ],
        [
            "Hodh El Gharbi",
            "02"
        ],
        [
            "Inchiri",
            "12"
        ],
        [
            "Nouakchott Nord",
            "14"
        ],
        [
            "Nouakchott Ouest",
            "13"
        ],
        [
            "Nouakchott Sud",
            "15"
        ],
        [
            "Tagant",
            "09"
        ],
        [
            "Tiris Zemmour",
            "11"
        ],
        [
            "Trarza",
            "06"
        ]
    ]
];
const $c8f06188fc3ad916$export$c5764e4399dad848 = [
    "Mauritius",
    "MU",
    [
        [
            "Agalega Islands",
            "AG"
        ],
        [
            "Beau Bassin-Rose Hill",
            "BR"
        ],
        [
            "Black River",
            "BL"
        ],
        [
            "Cargados Carajos Shoals",
            "CC"
        ],
        [
            "Curepipe",
            "CU"
        ],
        [
            "Flacq",
            "FL"
        ],
        [
            "Grand Port",
            "GP"
        ],
        [
            "Moka",
            "MO"
        ],
        [
            "Pamplemousses",
            "PA"
        ],
        [
            "Plaines Wilhems",
            "PW"
        ],
        [
            "Port Louis (City)",
            "PU"
        ],
        [
            "Port Louis",
            "PL"
        ],
        [
            "Riviere du Rempart",
            "RR"
        ],
        [
            "Rodrigues Island",
            "RO"
        ],
        [
            "Savanne",
            "SA"
        ],
        [
            "Vacoas-Phoenix",
            "CP"
        ]
    ]
];
const $c8f06188fc3ad916$export$8c2e794969bbe829 = [
    "Mayotte",
    "YT",
    [
        [
            "Dzaoudzi",
            "01"
        ],
        [
            "Pamandzi",
            "02"
        ],
        [
            "Mamoudzou",
            "03"
        ],
        [
            "Dembeni",
            "04"
        ],
        [
            "Bandr\xe9l\xe9",
            "05"
        ],
        [
            "Kani-K\xe9li",
            "06"
        ],
        [
            "Bou\xe9ni",
            "07"
        ],
        [
            "Chirongui",
            "08"
        ],
        [
            "Sada",
            "09"
        ],
        [
            "Ouangani",
            "10"
        ],
        [
            "Chiconi",
            "11"
        ],
        [
            "Tsingoni",
            "12"
        ],
        [
            "M'Tsangamouji",
            "13"
        ],
        [
            "Acoua",
            "14"
        ],
        [
            "Mtsamboro",
            "15"
        ],
        [
            "Bandraboua",
            "16"
        ],
        [
            "Koungou",
            "17"
        ]
    ]
];
const $c8f06188fc3ad916$export$80b36494c451f15f = [
    "Mexico",
    "MX",
    [
        [
            "Aguascalientes",
            "AGU"
        ],
        [
            "Baja California",
            "BCN"
        ],
        [
            "Baja California Sur",
            "BCS"
        ],
        [
            "Campeche",
            "CAM"
        ],
        [
            "Ciudad de M\xe9xico",
            "CMX"
        ],
        [
            "Chiapas",
            "CHP"
        ],
        [
            "Chihuahua",
            "CHH"
        ],
        [
            "Coahuila de Zaragoza",
            "COA"
        ],
        [
            "Colima",
            "COL"
        ],
        [
            "Durango",
            "DUR"
        ],
        [
            "Estado de M\xe9xico",
            "MEX"
        ],
        [
            "Guanajuato",
            "GUA"
        ],
        [
            "Guerrero",
            "GRO"
        ],
        [
            "Hidalgo",
            "HID"
        ],
        [
            "Jalisco",
            "JAL"
        ],
        [
            "Michoac\xe1n de Ocampo",
            "MIC"
        ],
        [
            "Morelos",
            "MOR"
        ],
        [
            "Nayarit",
            "NAY"
        ],
        [
            "Nuevo Le\xf3n",
            "NLE"
        ],
        [
            "Oaxaca",
            "OAX"
        ],
        [
            "Puebla",
            "PUE"
        ],
        [
            "Quer\xe9taro de Arteaga",
            "QUE"
        ],
        [
            "Quintana Roo",
            "ROO"
        ],
        [
            "San Luis Potos\xed",
            "SLP"
        ],
        [
            "Sinaloa",
            "SIN"
        ],
        [
            "Sonora",
            "SON"
        ],
        [
            "Tabasco",
            "TAB"
        ],
        [
            "Tamaulipas",
            "TAM"
        ],
        [
            "Tlaxcala",
            "TLA"
        ],
        [
            "Veracruz",
            "VER"
        ],
        [
            "Yucat\xe1n",
            "YUC"
        ],
        [
            "Zacatecas",
            "ZAC"
        ]
    ]
];
const $c8f06188fc3ad916$export$ae39d226e90e08ef = [
    "Micronesia, Federated States of",
    "FM",
    [
        [
            "Chuuk (Truk)",
            "TRK"
        ],
        [
            "Kosrae",
            "KSA"
        ],
        [
            "Pohnpei",
            "PNI"
        ],
        [
            "Yap",
            "YAP"
        ]
    ]
];
const $c8f06188fc3ad916$export$3c37c3bdb860ae1e = [
    "Moldova",
    "MD",
    [
        [
            "Anenii Noi",
            "AN"
        ],
        [
            "Basarabeasca",
            "BS"
        ],
        [
            "B\u0103l\u021Bi",
            "BA"
        ],
        [
            "Bender",
            "BD"
        ],
        [
            "Briceni",
            "BR"
        ],
        [
            "Cahul",
            "CA"
        ],
        [
            "Cantemir",
            "CT"
        ],
        [
            "C\u0103l\u0103ra\u0219i",
            "CL"
        ],
        [
            "C\u0103u\u0219eni",
            "CS"
        ],
        [
            "Chi\u0219in\u0103u",
            "CU"
        ],
        [
            "Cimi\u0219lia",
            "CM"
        ],
        [
            "Criuleni",
            "CR"
        ],
        [
            "Dondu\u0219eni",
            "DO"
        ],
        [
            "Drochia",
            "DR"
        ],
        [
            "Dub\u0103sari",
            "DU"
        ],
        [
            "Edine\u021B",
            "ED"
        ],
        [
            "F\u0103le\u0219ti",
            "FA"
        ],
        [
            "Flore\u0219ti",
            "FL"
        ],
        [
            "G\u0103g\u0103uzia",
            "GA"
        ],
        [
            "Glodeni",
            "GL"
        ],
        [
            "H\xeence\u0219ti",
            "HI"
        ],
        [
            "Ialoveni",
            "IA"
        ],
        [
            "Leova",
            "LE"
        ],
        [
            "Nisporeni",
            "NI"
        ],
        [
            "Ocni\u021Ba",
            "OC"
        ],
        [
            "Orhei",
            "OR"
        ],
        [
            "Rezina",
            "RE"
        ],
        [
            "R\xee\u0219cani",
            "RI"
        ],
        [
            "S\xeengerei",
            "SI"
        ],
        [
            "Soroca",
            "SO"
        ],
        [
            "St\xe2nga Nistrului",
            "SN"
        ],
        [
            "Str\u0103\u0219eni",
            "ST"
        ],
        [
            "\u0218old\u0103ne\u0219ti",
            "SD"
        ],
        [
            "\u0218tefan Vod\u0103",
            "SV"
        ],
        [
            "Taraclia",
            "TA"
        ],
        [
            "Telene\u0219ti",
            "TE"
        ],
        [
            "Ungheni",
            "UN"
        ]
    ]
];
const $c8f06188fc3ad916$export$cd68417dc2ec295d = [
    "Monaco",
    "MC",
    [
        [
            "Colle",
            "CL"
        ],
        [
            "Condamine",
            "CO"
        ],
        [
            "Fontvieille",
            "FO"
        ],
        [
            "Gare",
            "GA"
        ],
        [
            "Jardin Exotique",
            "JE"
        ],
        [
            "Larvotto",
            "LA"
        ],
        [
            "Malbousquet",
            "MA"
        ],
        [
            "Monaco-Ville",
            "MO"
        ],
        [
            "Moneghetti",
            "MG"
        ],
        [
            "Monte-Carlo",
            "MC"
        ],
        [
            "Moulins",
            "MU"
        ],
        [
            "Port-Hercule",
            "PH"
        ],
        [
            "Saint-Roman",
            "SR"
        ],
        [
            "Sainte-D\xe9vote",
            "SD"
        ],
        [
            "Source",
            "SO"
        ],
        [
            "Sp\xe9lugues",
            "SP"
        ],
        [
            "Vallon de la Rousse",
            "VR"
        ]
    ]
];
const $c8f06188fc3ad916$export$30e7c6589c527eef = [
    "Mongolia",
    "MN",
    [
        [
            "Arhangay",
            "073"
        ],
        [
            "Bayan-Olgiy",
            "071"
        ],
        [
            "Bayanhongor",
            "069"
        ],
        [
            "Bulgan",
            "067"
        ],
        [
            "Darhan",
            "037"
        ],
        [
            "Dornod",
            "061"
        ],
        [
            "Dornogovi",
            "063"
        ],
        [
            "Dundgovi",
            "059"
        ],
        [
            "Dzavhan",
            "057"
        ],
        [
            "Govi-Altay",
            "065"
        ],
        [
            "Govi-Sumber",
            "064"
        ],
        [
            "Hovd",
            "043"
        ],
        [
            "Hovsgol",
            "041"
        ],
        [
            "Omnogovi",
            "053"
        ],
        [
            "Ovorhangay",
            "055"
        ],
        [
            "Selenge",
            "049"
        ],
        [
            "Suhbaatar",
            "051"
        ],
        [
            "Tov",
            "047"
        ],
        [
            "Ulaanbaatar",
            "1"
        ],
        [
            "Uvs",
            "046"
        ],
        [
            "Erdenet",
            "074"
        ]
    ]
];
const $c8f06188fc3ad916$export$4898541b722d275d = [
    "Montenegro",
    "ME",
    [
        [
            "Andrijevica",
            "01"
        ],
        [
            "Bar",
            "02"
        ],
        [
            "Berane",
            "03"
        ],
        [
            "Bijelo Polje",
            "04"
        ],
        [
            "Budva",
            "05"
        ],
        [
            "Cetinje",
            "06"
        ],
        [
            "Danilovgrad",
            "07"
        ],
        [
            "Gusinje",
            "22"
        ],
        [
            "Herceg Novi",
            "08"
        ],
        [
            "Kola\u0161in",
            "09"
        ],
        [
            "Kotor",
            "10"
        ],
        [
            "Mojkovac",
            "11"
        ],
        [
            "Nik\u0161i\u0107",
            "12"
        ],
        [
            "Petnica",
            "23"
        ],
        [
            "Plav",
            "13"
        ],
        [
            "Plu\u017Eine",
            "14"
        ],
        [
            "Pljevlja",
            "15"
        ],
        [
            "Podgorica",
            "16"
        ],
        [
            "Ro\u017Eaje",
            "17"
        ],
        [
            "\u0160avnik",
            "18"
        ],
        [
            "Tivat",
            "19"
        ],
        [
            "Ulcinj",
            "20"
        ],
        [
            "\u017Dabljak",
            "21"
        ]
    ]
];
const $c8f06188fc3ad916$export$71ad59f2e432cfe8 = [
    "Montserrat",
    "MS",
    [
        [
            "Saint Anthony",
            "undefined"
        ],
        [
            "Saint Georges",
            "undefined"
        ],
        [
            "Saint Peter's",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$d88940c21edc1e8e = [
    "Morocco",
    "MA",
    [
        [
            "Tanger-T\xe9touan-Al Hoce\xefma",
            "MA-01"
        ],
        [
            "L'Oriental",
            "MA-02"
        ],
        [
            "F\xe8s-Mekn\xe8s",
            "MA-03"
        ],
        [
            "Rabat-Sal\xe9-K\xe9nitra",
            "MA-04"
        ],
        [
            "B\xe9ni Mellal-Kh\xe9nifra",
            "MA-05"
        ],
        [
            "Casablanca-Settat",
            "MA-06"
        ],
        [
            "Marrakech-Safi",
            "MA-07"
        ],
        [
            "Dr\xe2a-Tafilalet",
            "MA-08"
        ],
        [
            "Souss-Massa",
            "MA-09"
        ],
        [
            "Guelmim-Oued Noun",
            "MA-10"
        ],
        [
            "La\xe2youne-Sakia El Hamra",
            "MA-11"
        ],
        [
            "Dakhla-Oued Ed-Dahab",
            "MA-12"
        ]
    ]
];
const $c8f06188fc3ad916$export$b5030f3cedb7f384 = [
    "Mozambique",
    "MZ",
    [
        [
            "Cabo Delgado",
            "P"
        ],
        [
            "Gaza",
            "G"
        ],
        [
            "Inhambane",
            "I"
        ],
        [
            "Manica",
            "B"
        ],
        [
            "Maputo",
            "L"
        ],
        [
            "Maputo (City)",
            "MPM"
        ],
        [
            "Nampula",
            "N"
        ],
        [
            "Niassa",
            "A"
        ],
        [
            "Sofala",
            "S"
        ],
        [
            "Tete",
            "T"
        ],
        [
            "Zambezia",
            "Q"
        ]
    ]
];
const $c8f06188fc3ad916$export$eefdfd8a735ff143 = [
    "Myanmar",
    "MM",
    [
        [
            "Ayeyarwady",
            "07"
        ],
        [
            "Bago",
            "02"
        ],
        [
            "Chin",
            "14"
        ],
        [
            "Kachin",
            "11"
        ],
        [
            "Kayah",
            "12"
        ],
        [
            "Kayin",
            "13"
        ],
        [
            "Magway",
            "03"
        ],
        [
            "Mandalay",
            "04"
        ],
        [
            "Mon",
            "15"
        ],
        [
            "Nay Pyi Taw",
            "18"
        ],
        [
            "Rakhine",
            "16"
        ],
        [
            "Sagaing",
            "01"
        ],
        [
            "Shan",
            "17"
        ],
        [
            "Tanintharyi",
            "05"
        ],
        [
            "Yangon",
            "06"
        ]
    ]
];
const $c8f06188fc3ad916$export$dbd1925f4fe9ec65 = [
    "Namibia",
    "NA",
    [
        [
            "Erongo",
            "ER"
        ],
        [
            "Hardap",
            "HA"
        ],
        [
            "Kavango East",
            "KE"
        ],
        [
            "Kavango West",
            "KW"
        ],
        [
            "Karas",
            "KA"
        ],
        [
            "Khomas",
            "KH"
        ],
        [
            "Kunene",
            "KU"
        ],
        [
            "Ohangwena",
            "OW"
        ],
        [
            "Omaheke",
            "OH"
        ],
        [
            "Omusati",
            "OS"
        ],
        [
            "Oshana",
            "ON"
        ],
        [
            "Oshikoto",
            "OT"
        ],
        [
            "Otjozondjupa",
            "OD"
        ],
        [
            "Zambezi",
            "CA"
        ]
    ]
];
const $c8f06188fc3ad916$export$8885480fb36cb8cc = [
    "Nauru",
    "NR",
    [
        [
            "Aiwo",
            "01"
        ],
        [
            "Anabar",
            "02"
        ],
        [
            "Anetan",
            "03"
        ],
        [
            "Anibare",
            "04"
        ],
        [
            "Baiti",
            "05"
        ],
        [
            "Boe",
            "06"
        ],
        [
            "Buada",
            "07"
        ],
        [
            "Denigomodu",
            "08"
        ],
        [
            "Ewa",
            "09"
        ],
        [
            "Ijuw",
            "10"
        ],
        [
            "Meneng",
            "11"
        ],
        [
            "Nibok",
            "12"
        ],
        [
            "Uaboe",
            "13"
        ],
        [
            "Yaren",
            "14"
        ]
    ]
];
const $c8f06188fc3ad916$export$575bf2af220888ee = [
    "Nepal",
    "NP",
    [
        [
            "Province No. 1",
            "1"
        ],
        [
            "Madhesh Province",
            "2"
        ],
        [
            "Bagmati Province",
            "3"
        ],
        [
            "Gandaki Province",
            "4"
        ],
        [
            "Lumbini Province",
            "5"
        ],
        [
            "Karnali Province",
            "6"
        ],
        [
            "Sudurpashchim Province",
            "7"
        ]
    ]
];
const $c8f06188fc3ad916$export$e51d3c675bb0140d = [
    "Netherlands",
    "NL",
    [
        [
            "Drenthe",
            "DR"
        ],
        [
            "Flevoland",
            "FL"
        ],
        [
            "Friesland",
            "FR"
        ],
        [
            "Gelderland",
            "GE"
        ],
        [
            "Groningen",
            "GR"
        ],
        [
            "Limburg",
            "LI"
        ],
        [
            "Noord-Brabant",
            "NB"
        ],
        [
            "Noord-Holland",
            "NH"
        ],
        [
            "Overijssel",
            "OV"
        ],
        [
            "Utrecht",
            "UT"
        ],
        [
            "Zeeland",
            "ZE"
        ],
        [
            "Zuid-Holland",
            "ZH"
        ]
    ]
];
const $c8f06188fc3ad916$export$fbcebdb931d67ac9 = [
    "New Caledonia",
    "NC",
    [
        [
            "Iles Loyaute",
            "undefined"
        ],
        [
            "Nord",
            "undefined"
        ],
        [
            "Sud",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$b6db8d689596ccb0 = [
    "New Zealand",
    "NZ",
    [
        [
            "Auckland",
            "AUK"
        ],
        [
            "Bay of Plenty",
            "BOP"
        ],
        [
            "Canterbury",
            "CAN"
        ],
        [
            "Gisborne",
            "GIS"
        ],
        [
            "Hawke's Bay",
            "HKB"
        ],
        [
            "Marlborough",
            "MBH"
        ],
        [
            "Manawatu-Wanganui",
            "MWT"
        ],
        [
            "Northland",
            "NTL"
        ],
        [
            "Nelson",
            "NSN"
        ],
        [
            "Otago",
            "OTA"
        ],
        [
            "Southland",
            "STL"
        ],
        [
            "Taranaki",
            "TKI"
        ],
        [
            "Tasman",
            "TAS"
        ],
        [
            "Waikato",
            "WKO"
        ],
        [
            "Wellington",
            "WGN"
        ],
        [
            "West Coast",
            "WTC"
        ],
        [
            "Chatham Islands Territory",
            "CIT"
        ]
    ]
];
const $c8f06188fc3ad916$export$2128ddd8b6e5cc05 = [
    "Nicaragua",
    "NI",
    [
        [
            "Boaco",
            "BO"
        ],
        [
            "Carazo",
            "CA"
        ],
        [
            "Chinandega",
            "CI"
        ],
        [
            "Chontales",
            "CO"
        ],
        [
            "Estel\xed",
            "ES"
        ],
        [
            "Granada",
            "GR"
        ],
        [
            "Jinotega",
            "JI"
        ],
        [
            "Le\xf3n",
            "LE"
        ],
        [
            "Madriz",
            "MD"
        ],
        [
            "Managua",
            "MN"
        ],
        [
            "Masaya",
            "MS"
        ],
        [
            "Matagalpa",
            "MT"
        ],
        [
            "Nueva Segovia",
            "NS"
        ],
        [
            "R\xedo San Juan",
            "SJ"
        ],
        [
            "Rivas",
            "RI"
        ],
        [
            "Atl\xe1ntico Norte",
            "AN"
        ],
        [
            "Atl\xe1ntico Sur",
            "AS"
        ]
    ]
];
const $c8f06188fc3ad916$export$8719acbfb72c829 = [
    "Niger",
    "NE",
    [
        [
            "Agadez",
            "1"
        ],
        [
            "Diffa",
            "2"
        ],
        [
            "Dosso",
            "3"
        ],
        [
            "Maradi",
            "4"
        ],
        [
            "Niamey",
            "8"
        ],
        [
            "Tahoua",
            "5"
        ],
        [
            "Tillab\xe9ri",
            "6"
        ],
        [
            "Zinder",
            "7"
        ]
    ]
];
const $c8f06188fc3ad916$export$d9501190a8cd7a46 = [
    "Nigeria",
    "NG",
    [
        [
            "Abia",
            "AB"
        ],
        [
            "Abuja Federal Capital Territory",
            "FC"
        ],
        [
            "Adamawa",
            "AD"
        ],
        [
            "Akwa Ibom",
            "AK"
        ],
        [
            "Anambra",
            "AN"
        ],
        [
            "Bauchi",
            "BA"
        ],
        [
            "Bayelsa",
            "BY"
        ],
        [
            "Benue",
            "BE"
        ],
        [
            "Borno",
            "BO"
        ],
        [
            "Cross River",
            "CR"
        ],
        [
            "Delta",
            "DE"
        ],
        [
            "Ebonyi",
            "EB"
        ],
        [
            "Edo",
            "ED"
        ],
        [
            "Ekiti",
            "EK"
        ],
        [
            "Enugu",
            "EN"
        ],
        [
            "Gombe",
            "GO"
        ],
        [
            "Imo",
            "IM"
        ],
        [
            "Jigawa",
            "JI"
        ],
        [
            "Kaduna",
            "KD"
        ],
        [
            "Kano",
            "KN"
        ],
        [
            "Katsina",
            "KT"
        ],
        [
            "Kebbi",
            "KE"
        ],
        [
            "Kogi",
            "KO"
        ],
        [
            "Kwara",
            "KW"
        ],
        [
            "Lagos",
            "LA"
        ],
        [
            "Nasarawa",
            "NA"
        ],
        [
            "Niger",
            "NI"
        ],
        [
            "Ogun",
            "OG"
        ],
        [
            "Ondo",
            "ON"
        ],
        [
            "Osun",
            "OS"
        ],
        [
            "Oyo",
            "OY"
        ],
        [
            "Plateau",
            "PL"
        ],
        [
            "Rivers",
            "RI"
        ],
        [
            "Sokoto",
            "SO"
        ],
        [
            "Taraba",
            "TA"
        ],
        [
            "Yobe",
            "YO"
        ],
        [
            "Zamfara",
            "ZA"
        ]
    ]
];
const $c8f06188fc3ad916$export$8227ca023eb0daaa = [
    "Niue",
    "NU",
    [
        [
            "Niue",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$ebe65a9e9fde641f = [
    "Norfolk Island",
    "NF",
    [
        [
            "Norfolk Island",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$15b7d6cdd29b06a0 = [
    "Northern Mariana Islands",
    "MP",
    [
        [
            "Northern Islands",
            "undefined"
        ],
        [
            "Rota",
            "undefined"
        ],
        [
            "Saipan",
            "undefined"
        ],
        [
            "Tinian",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$c01351c0af048e39 = [
    "Norway",
    "NO",
    [
        [
            "Agder",
            "09"
        ],
        [
            "Innlandet",
            "34"
        ],
        [
            "Jan Mayen",
            "22"
        ],
        [
            "M\xf8re og Romsdal",
            "15"
        ],
        [
            "Nordland",
            "18"
        ],
        [
            "Oslo",
            "03"
        ],
        [
            "Rogaland",
            "11"
        ],
        [
            "Svalbard",
            "21"
        ],
        [
            "Troms og Finnmark",
            "54"
        ],
        [
            "Tr\xf8ndelag",
            "50"
        ],
        [
            "Vestfold og Telemark",
            "38"
        ],
        [
            "Vestland",
            "46"
        ],
        [
            "Viken",
            "30"
        ]
    ]
];
const $c8f06188fc3ad916$export$1ed389bd9cb529 = [
    "Oman",
    "OM",
    [
        [
            "Ad Dakhiliyah",
            "DA"
        ],
        [
            "Al Buraymi",
            "BU"
        ],
        [
            "Al Wusta",
            "WU"
        ],
        [
            "Az Zahirah",
            "ZA"
        ],
        [
            "Janub al Batinah",
            "BS"
        ],
        [
            "Janub ash Sharqiyah",
            "SS"
        ],
        [
            "Masqat",
            "MA"
        ],
        [
            "Musandam",
            "MU"
        ],
        [
            "Shamal al Batinah",
            "BJ"
        ],
        [
            "Shamal ash Sharqiyah",
            "SJ"
        ],
        [
            "Zufar",
            "ZU"
        ]
    ]
];
const $c8f06188fc3ad916$export$73910688e185534c = [
    "Pakistan",
    "PK",
    [
        [
            "Azad Kashmir",
            "JK"
        ],
        [
            "Balochistan",
            "BA"
        ],
        [
            "Gilgit-Baltistan",
            "GB"
        ],
        [
            "Islamabad",
            "IS"
        ],
        [
            "Khaibar Pakhtunkhwa",
            "KP"
        ],
        [
            "Punjab",
            "PB"
        ],
        [
            "Sindh",
            "SD"
        ],
        [
            "Federally Administered Tribal Areas",
            "TA"
        ]
    ]
];
const $c8f06188fc3ad916$export$5f5211c171c1b47a = [
    "Palau",
    "PW",
    [
        [
            "Aimeliik",
            "002"
        ],
        [
            "Airai",
            "004"
        ],
        [
            "Angaur",
            "010"
        ],
        [
            "Hatobohei",
            "050"
        ],
        [
            "Kayangel",
            "100"
        ],
        [
            "Koror",
            "150"
        ],
        [
            "Melekeok",
            "212"
        ],
        [
            "Ngaraard",
            "214"
        ],
        [
            "Ngarchelong",
            "218"
        ],
        [
            "Ngardmau",
            "222"
        ],
        [
            "Ngatpang",
            "224"
        ],
        [
            "Ngchesar",
            "226"
        ],
        [
            "Ngeremlengui",
            "227"
        ],
        [
            "Ngiwal",
            "228"
        ],
        [
            "Peleliu",
            "350"
        ],
        [
            "Sonsoral",
            "370"
        ]
    ]
];
const $c8f06188fc3ad916$export$5adddb0645f34b2 = [
    "Palestine",
    "PS",
    [
        [
            "Ak Khal\u012Bl",
            "HBN"
        ],
        [
            "Al Quds",
            "JEM"
        ],
        [
            "Ar\u012B\u1E29\u0101 wal Aghw\u0101r",
            "JRH"
        ],
        [
            "Bayt La\u1E29m",
            "BTH"
        ],
        [
            "Dayr al Bala\u1E29",
            "DEB"
        ],
        [
            "Ghazzah",
            "GZA"
        ],
        [
            "Jan\u012Bn",
            "JEN"
        ],
        [
            "Kh\u0101n Y\u016Bnis",
            "KYS"
        ],
        [
            "N\u0101blus",
            "NBS"
        ],
        [
            "Qalq\u012Byah",
            "QQA"
        ],
        [
            "Rafa\u1E29",
            "RFH"
        ],
        [
            "R\u0101m All\u0101h wal B\u012Brah",
            "RBH"
        ],
        [
            "Salf\u012Bt",
            "SLT"
        ],
        [
            "Sham\u0101l Ghazzah",
            "NGZ"
        ],
        [
            "\u0162\u016Bb\u0101s",
            "TBS"
        ],
        [
            "\u0162\u016Blkarm",
            "TKM"
        ]
    ]
];
const $c8f06188fc3ad916$export$ff7e3d480d313da2 = [
    "Panama",
    "PA",
    [
        [
            "Bocas del Toro",
            "1"
        ],
        [
            "Chiriqu\xed",
            "4"
        ],
        [
            "Cocl\xe9",
            "2"
        ],
        [
            "Col\xf3n",
            "3"
        ],
        [
            "Dari\xe9n",
            "5"
        ],
        [
            "Ember\xe1",
            "EM"
        ],
        [
            "Herrera",
            "6"
        ],
        [
            "Kuna Yala",
            "KY"
        ],
        [
            "Los Santos",
            "7"
        ],
        [
            "Ng\xe4be-Bugl\xe9",
            "NB"
        ],
        [
            "Panam\xe1",
            "8"
        ],
        [
            "Panam\xe1 Oeste",
            "10"
        ],
        [
            "Veraguas",
            "9"
        ]
    ]
];
const $c8f06188fc3ad916$export$c56943b7b8ffea21 = [
    "Papua New Guinea",
    "PG",
    [
        [
            "Bougainville",
            "NSB"
        ],
        [
            "Central",
            "CPM"
        ],
        [
            "Chimbu",
            "CPK"
        ],
        [
            "East New Britain",
            "EBR"
        ],
        [
            "East Sepik",
            "ESW"
        ],
        [
            "Eastern Highlands",
            "EHG"
        ],
        [
            "Enga",
            "EPW"
        ],
        [
            "Gulf",
            "GPK"
        ],
        [
            "Hela",
            "HLA"
        ],
        [
            "Jiwaka",
            "JWK"
        ],
        [
            "Madang",
            "MOM"
        ],
        [
            "Manus",
            "MRL"
        ],
        [
            "Milne Bay",
            "MBA"
        ],
        [
            "Morobe",
            "MPL"
        ],
        [
            "Port Moresby",
            "NCD"
        ],
        [
            "New Ireland",
            "NIK"
        ],
        [
            "Northern",
            "NPP"
        ],
        [
            "Southern Highlands",
            "SHM"
        ],
        [
            "West New Britain",
            "WBK"
        ],
        [
            "West Sepik",
            "SAN"
        ],
        [
            "Western",
            "WPD"
        ],
        [
            "Western Highlands",
            "WHM"
        ]
    ]
];
const $c8f06188fc3ad916$export$21b6e0fb60b525ae = [
    "Paraguay",
    "PY",
    [
        [
            "Alto Paraguay",
            "16"
        ],
        [
            "Alto Parana",
            "10"
        ],
        [
            "Amambay",
            "13"
        ],
        [
            "Asuncion",
            "ASU"
        ],
        [
            "Caaguazu",
            "5"
        ],
        [
            "Caazapa",
            "6"
        ],
        [
            "Canindeyu",
            "14"
        ],
        [
            "Central",
            "11"
        ],
        [
            "Concepcion",
            "1"
        ],
        [
            "Cordillera",
            "3"
        ],
        [
            "Boqueron",
            "17"
        ],
        [
            "Guaira",
            "4"
        ],
        [
            "Itapua",
            "7"
        ],
        [
            "Misiones",
            "8"
        ],
        [
            "Neembucu",
            "12"
        ],
        [
            "Paraguari",
            "9"
        ],
        [
            "Presidente Hayes",
            "15"
        ],
        [
            "San Pedro",
            "2"
        ]
    ]
];
const $c8f06188fc3ad916$export$d5e55eb9565ea8d5 = [
    "Peru",
    "PE",
    [
        [
            "Amazonas",
            "AMA"
        ],
        [
            "Ancash",
            "ANC"
        ],
        [
            "Apurimac",
            "APU"
        ],
        [
            "Arequipa",
            "ARE"
        ],
        [
            "Ayacucho",
            "AYA"
        ],
        [
            "Cajamarca",
            "CAJ"
        ],
        [
            "Callao",
            "CAL"
        ],
        [
            "Cusco",
            "CUS"
        ],
        [
            "Huancavelica",
            "HUV"
        ],
        [
            "Huanuco",
            "HUC"
        ],
        [
            "Ica",
            "ICA"
        ],
        [
            "Junin",
            "JUN"
        ],
        [
            "La Libertad",
            "LAL"
        ],
        [
            "Lambayeque",
            "LAM"
        ],
        [
            "Lima",
            "LIM"
        ],
        [
            "Loreto",
            "LOR"
        ],
        [
            "Madre de Dios",
            "MDD"
        ],
        [
            "Moquegua",
            "MOQ"
        ],
        [
            "Municipalidad Metropolitana de Lima",
            "LMA"
        ],
        [
            "Pasco",
            "PAS"
        ],
        [
            "Piura",
            "PIU"
        ],
        [
            "Puno",
            "PUN"
        ],
        [
            "San Martin",
            "SAM"
        ],
        [
            "Tacna",
            "TAC"
        ],
        [
            "Tumbes",
            "TUM"
        ],
        [
            "Ucayali",
            "UCA"
        ]
    ]
];
const $c8f06188fc3ad916$export$38ea63fabb2c685f = [
    "Philippines",
    "PH",
    [
        [
            "Autonomous Region in Muslim Mindanao",
            "PH-14"
        ],
        [
            "Bicol",
            "PH-05"
        ],
        [
            "Cagayan Valley",
            "PH-02"
        ],
        [
            "Calabarzon",
            "PH-40"
        ],
        [
            "Caraga",
            "PH-13"
        ],
        [
            "Central Luzon",
            "PH-03"
        ],
        [
            "Central Visayas",
            "PH-07"
        ],
        [
            "Cordillera Administrative Region",
            "PH-15"
        ],
        [
            "Davao",
            "PH-11"
        ],
        [
            "Eastern Visayas",
            "PH-08"
        ],
        [
            "Ilocos",
            "PH-01"
        ],
        [
            "Mimaropa",
            "PH-41"
        ],
        [
            "National Capital Region",
            "PH-00"
        ],
        [
            "Northern Mindanao",
            "PH-10"
        ],
        [
            "Soccsksargen",
            "PH-12"
        ],
        [
            "Western Visayas",
            "PH-06"
        ],
        [
            "Zamboanga Peninsula",
            "PH-09"
        ]
    ]
];
const $c8f06188fc3ad916$export$6bc8c38c416ebf89 = [
    "Pitcairn",
    "PN",
    [
        [
            "Pitcairn Islands",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$9e95f02561f2d9f9 = [
    "Poland",
    "PL",
    [
        [
            "Dolno\u015Bl\u0105skie",
            "02"
        ],
        [
            "Kujawsko-pomorskie",
            "04"
        ],
        [
            "\u0141\xf3dzkie",
            "10"
        ],
        [
            "Lubelskie",
            "06"
        ],
        [
            "Lubuskie",
            "08"
        ],
        [
            "Ma\u0142opolskie",
            "12"
        ],
        [
            "Mazowieckie",
            "14"
        ],
        [
            "Opolskie",
            "16"
        ],
        [
            "Podkarpackie",
            "18"
        ],
        [
            "Podlaskie",
            "20"
        ],
        [
            "Pomorskie",
            "22"
        ],
        [
            "\u015Al\u0105skie",
            "24"
        ],
        [
            "\u015Awi\u0119tokrzyskie",
            "26"
        ],
        [
            "Warmi\u0144sko-mazurskie",
            "28"
        ],
        [
            "Wielkopolskie",
            "30"
        ],
        [
            "Zachodniopomorskie",
            "32"
        ]
    ]
];
const $c8f06188fc3ad916$export$3961bdb9130b90e7 = [
    "Portugal",
    "PT",
    [
        [
            "A\xe7ores",
            "20"
        ],
        [
            "Aveiro",
            "01"
        ],
        [
            "Beja",
            "02"
        ],
        [
            "Braga",
            "03"
        ],
        [
            "Bragan\xe7a",
            "04"
        ],
        [
            "Castelo Branco",
            "05"
        ],
        [
            "Coimbra",
            "06"
        ],
        [
            "\xc9vora",
            "07"
        ],
        [
            "Faro",
            "08"
        ],
        [
            "Guarda",
            "09"
        ],
        [
            "Leiria",
            "10"
        ],
        [
            "Lisboa",
            "11"
        ],
        [
            "Madeira",
            "30"
        ],
        [
            "Portalegre",
            "12"
        ],
        [
            "Porto",
            "13"
        ],
        [
            "Santar\xe9m",
            "14"
        ],
        [
            "Set\xfabal",
            "15"
        ],
        [
            "Viana do Castelo",
            "16"
        ],
        [
            "Vila Real",
            "17"
        ],
        [
            "Viseu",
            "18"
        ]
    ]
];
const $c8f06188fc3ad916$export$af5f8d68aad3cd3a = [
    "Puerto Rico",
    "PR",
    [
        [
            "Adjuntas",
            "undefined"
        ],
        [
            "Aguada",
            "undefined"
        ],
        [
            "Aguadilla",
            "undefined"
        ],
        [
            "Aguas Buenas",
            "undefined"
        ],
        [
            "Aibonito",
            "undefined"
        ],
        [
            "Anasco",
            "undefined"
        ],
        [
            "Arecibo",
            "undefined"
        ],
        [
            "Arroyo",
            "undefined"
        ],
        [
            "Barceloneta",
            "undefined"
        ],
        [
            "Barranquitas",
            "undefined"
        ],
        [
            "Bayamon",
            "undefined"
        ],
        [
            "Cabo Rojo",
            "undefined"
        ],
        [
            "Caguas",
            "undefined"
        ],
        [
            "Camuy",
            "undefined"
        ],
        [
            "Canovanas",
            "undefined"
        ],
        [
            "Carolina",
            "undefined"
        ],
        [
            "Cat",
            "undefined"
        ],
        [
            "Ceiba",
            "undefined"
        ],
        [
            "Ciales",
            "undefined"
        ],
        [
            "Cidra",
            "undefined"
        ],
        [
            "Coamo",
            "undefined"
        ],
        [
            "Comerio",
            "undefined"
        ],
        [
            "Corozal",
            "undefined"
        ],
        [
            "Culebra",
            "undefined"
        ],
        [
            "Dorado",
            "undefined"
        ],
        [
            "Fajardo",
            "undefined"
        ],
        [
            "Florida",
            "undefined"
        ],
        [
            "Guanica",
            "undefined"
        ],
        [
            "Guayama",
            "undefined"
        ],
        [
            "Guayanilla",
            "undefined"
        ],
        [
            "Guaynabo",
            "undefined"
        ],
        [
            "Gurabo",
            "undefined"
        ],
        [
            "Hatillo",
            "undefined"
        ],
        [
            "Hormigueros",
            "undefined"
        ],
        [
            "Humacao",
            "undefined"
        ],
        [
            "Isabe",
            "undefined"
        ],
        [
            "Juana Diaz",
            "undefined"
        ],
        [
            "Juncos",
            "undefined"
        ],
        [
            "Lajas",
            "undefined"
        ],
        [
            "Lares",
            "undefined"
        ],
        [
            "Las Marias",
            "undefined"
        ],
        [
            "Las oiza",
            "undefined"
        ],
        [
            "Luquillo",
            "undefined"
        ],
        [
            "Manati",
            "undefined"
        ],
        [
            "Maricao",
            "undefined"
        ],
        [
            "Maunabo",
            "undefined"
        ],
        [
            "Mayaguez",
            "undefined"
        ],
        [
            "Moca",
            "undefined"
        ],
        [
            "Morovis",
            "undefined"
        ],
        [
            "Naguabo",
            "undefined"
        ],
        [
            "Naranjito",
            "undefined"
        ],
        [
            "Orocovis",
            "undefined"
        ],
        [
            "Patillas",
            "undefined"
        ],
        [
            "Penuelas",
            "undefined"
        ],
        [
            "Ponce",
            "undefined"
        ],
        [
            "Quebradillas",
            "undefined"
        ],
        [
            "Rincon",
            "undefined"
        ],
        [
            "Rio Grande",
            "undefined"
        ],
        [
            "Sabana linas",
            "undefined"
        ],
        [
            "San German",
            "undefined"
        ],
        [
            "San Juan",
            "undefined"
        ],
        [
            "San Lorenzo",
            "undefined"
        ],
        [
            "San Sebastian",
            "undefined"
        ],
        [
            "Santa Isabel",
            "undefined"
        ],
        [
            "Toa Alta",
            "undefined"
        ],
        [
            "Toa Baja",
            "undefined"
        ],
        [
            "Trujillo Alto",
            "undefined"
        ],
        [
            "Utuado",
            "undefined"
        ],
        [
            "Vega Alta",
            "undefined"
        ],
        [
            "Vega ues",
            "undefined"
        ],
        [
            "Villalba",
            "undefined"
        ],
        [
            "Yabucoa",
            "undefined"
        ],
        [
            "Yauco",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$a7078eadaecd4b6f = [
    "Qatar",
    "QA",
    [
        [
            "Ad Daw\u1E29ah",
            "DA"
        ],
        [
            "Al Khawr wa adh Dhakh\u012Brah",
            "KH"
        ],
        [
            "Al Wakrah",
            "WA"
        ],
        [
            "Ar Rayy\u0101n",
            "RA"
        ],
        [
            "Ash Sham\u0101l",
            "MS"
        ],
        [
            "Az\u0327 Za\u0327`\u0101yin",
            "ZA"
        ],
        [
            "Umm \u015Eal\u0101l",
            "US"
        ]
    ]
];
const $c8f06188fc3ad916$export$ded96516917cab2a = [
    "R\xe9union",
    "RE",
    [
        [
            "R\xe9union",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$993ec495e78d530d = [
    "Romania",
    "RO",
    [
        [
            "Alba",
            "RO-AB"
        ],
        [
            "Arad",
            "RO-AR"
        ],
        [
            "Arges",
            "RO-AG"
        ],
        [
            "Bacau",
            "RO-BC"
        ],
        [
            "Bihor",
            "RO-BH"
        ],
        [
            "Bistrita-Nasaud",
            "RO-BN"
        ],
        [
            "Botosani",
            "RO-BT"
        ],
        [
            "Braila",
            "RO-BR"
        ],
        [
            "Brasov",
            "RO-BV"
        ],
        [
            "Bucharest",
            "RO-B"
        ],
        [
            "Buzau",
            "RO-BZ"
        ],
        [
            "Calarasi",
            "RO-CL"
        ],
        [
            "Caras-Severin",
            "RO-CS"
        ],
        [
            "Cluj",
            "RO-CJ"
        ],
        [
            "Constanta",
            "RO-CT"
        ],
        [
            "Covasna",
            "RO-CV"
        ],
        [
            "Dambovita",
            "RO-DB"
        ],
        [
            "Dolj",
            "RO-DJ"
        ],
        [
            "Galati",
            "RO-GL"
        ],
        [
            "Giurgiu",
            "RO-GR"
        ],
        [
            "Gorj",
            "RO-GJ"
        ],
        [
            "Harghita",
            "RO-HR"
        ],
        [
            "Hunedoara",
            "RO-HD"
        ],
        [
            "Ialomita",
            "RO-IL"
        ],
        [
            "Iasi",
            "RO-IS"
        ],
        [
            "Ilfov",
            "RO-IF"
        ],
        [
            "Maramures",
            "RO-MM"
        ],
        [
            "Mehedinti",
            "RO-MH"
        ],
        [
            "Mures",
            "RO-MS"
        ],
        [
            "Neamt",
            "RO-NT"
        ],
        [
            "Olt",
            "RO-OT"
        ],
        [
            "Prahova",
            "RO-PH"
        ],
        [
            "Salaj",
            "RO-SJ"
        ],
        [
            "Satu Mare",
            "RO-SM"
        ],
        [
            "Sibiu",
            "RO-SB"
        ],
        [
            "Suceava",
            "RO-SV"
        ],
        [
            "Teleorman",
            "RO-TR"
        ],
        [
            "Timis",
            "RO-TM"
        ],
        [
            "Tulcea",
            "RO-TL"
        ],
        [
            "Valcea",
            "RO-VL"
        ],
        [
            "Vaslui",
            "RO-VS"
        ],
        [
            "Vrancea",
            "RO-VN"
        ]
    ]
];
const $c8f06188fc3ad916$export$6c2517b5e52f01cc = [
    "Russian Federation",
    "RU",
    [
        [
            "Republic of Adygea",
            "AD"
        ],
        [
            "Republic of Altai (Gorno-Altaysk)",
            "AL"
        ],
        [
            "Altai Krai",
            "ALT"
        ],
        [
            "Amur Oblast",
            "AMU"
        ],
        [
            "Arkhangelsk Oblast",
            "ARK"
        ],
        [
            "Astrakhan Oblast",
            "AST"
        ],
        [
            "Republic of Bashkortostan",
            "BA"
        ],
        [
            "Belgorod Oblast",
            "BEL"
        ],
        [
            "Bryansk Oblast",
            "BRY"
        ],
        [
            "Republic of Buryatia",
            "BU"
        ],
        [
            "Chechen Republic",
            "CE"
        ],
        [
            "Chelyabinsk Oblast",
            "CHE"
        ],
        [
            "Chukotka Autonomous Okrug",
            "CHU"
        ],
        [
            "Chuvash Republic",
            "CU"
        ],
        [
            "Republic of Dagestan",
            "DA"
        ],
        [
            "Republic of Ingushetia",
            "IN"
        ],
        [
            "Irkutsk Oblast",
            "IRK"
        ],
        [
            "Ivanovo Oblast",
            "IVA"
        ],
        [
            "Jewish Autonomous Oblast",
            "JEW"
        ],
        [
            "Kabardino-Balkar Republic",
            "KB"
        ],
        [
            "Kaliningrad Oblast",
            "KLN"
        ],
        [
            "Republic of Kalmykia",
            "KL"
        ],
        [
            "Kaluga Oblast",
            "KLU"
        ],
        [
            "Kamchatka Krai",
            "KAM"
        ],
        [
            "Karachay-Cherkess Republic",
            "KC"
        ],
        [
            "Republic of Karelia",
            "KR"
        ],
        [
            "Khabarovsk Krai",
            "KHA"
        ],
        [
            "Republic of Khakassia",
            "KK"
        ],
        [
            "Khanty-Mansi Autonomous Okrug - Yugra",
            "KHM"
        ],
        [
            "Kemerovo Oblast",
            "KEM"
        ],
        [
            "Kirov Oblast",
            "KIR"
        ],
        [
            "Komi Republic",
            "KO"
        ],
        [
            "Kostroma Oblast",
            "KOS"
        ],
        [
            "Krasnodar Krai",
            "KDA"
        ],
        [
            "Krasnoyarsk Krai",
            "KYA"
        ],
        [
            "Kurgan Oblast",
            "KGN"
        ],
        [
            "Kursk Oblast",
            "KRS"
        ],
        [
            "Leningrad Oblast",
            "LEN"
        ],
        [
            "Lipetsk Oblast",
            "LIP"
        ],
        [
            "Magadan Oblast",
            "MAG"
        ],
        [
            "Mari El Republic",
            "ME"
        ],
        [
            "Republic of Mordovia",
            "MO"
        ],
        [
            "Moscow Oblast",
            "MOS"
        ],
        [
            "Moscow",
            "MOW"
        ],
        [
            "Murmansk Oblast",
            "MU"
        ],
        [
            "Nenets Autonomous Okrug",
            "NEN"
        ],
        [
            "Nizhny Novgorod Oblast",
            "NIZ"
        ],
        [
            "Novgorod Oblast",
            "NGR"
        ],
        [
            "Novosibirsk Oblast",
            "NVS"
        ],
        [
            "Omsk Oblast",
            "OMS"
        ],
        [
            "Orenburg Oblast",
            "ORE"
        ],
        [
            "Oryol Oblast",
            "ORL"
        ],
        [
            "Penza Oblast",
            "PNZ"
        ],
        [
            "Perm Krai",
            "PER"
        ],
        [
            "Primorsky Krai",
            "PRI"
        ],
        [
            "Pskov Oblast",
            "PSK"
        ],
        [
            "Rostov Oblast",
            "ROS"
        ],
        [
            "Ryazan Oblast",
            "RYA"
        ],
        [
            "Saint Petersburg",
            "SPE"
        ],
        [
            "Sakha (Yakutia) Republic",
            "SA"
        ],
        [
            "Sakhalin Oblast",
            "SAK"
        ],
        [
            "Samara Oblast",
            "SAM"
        ],
        [
            "Saratov Oblast",
            "SAR"
        ],
        [
            "Republic of North Ossetia-Alania",
            "NOA"
        ],
        [
            "Smolensk Oblast",
            "SMO"
        ],
        [
            "Stavropol Krai",
            "STA"
        ],
        [
            "Sverdlovsk Oblast",
            "SVE"
        ],
        [
            "Tambov Oblast",
            "TAM"
        ],
        [
            "Republic of Tatarstan",
            "TA"
        ],
        [
            "Tomsk Oblast",
            "TOM"
        ],
        [
            "Tuva Republic",
            "TU"
        ],
        [
            "Tula Oblast",
            "TUL"
        ],
        [
            "Tver Oblast",
            "TVE"
        ],
        [
            "Tyumen Oblast",
            "TYU"
        ],
        [
            "Udmurt Republic",
            "UD"
        ],
        [
            "Ulyanovsk Oblast",
            "ULY"
        ],
        [
            "Vladimir Oblast",
            "VLA"
        ],
        [
            "Volgograd Oblast",
            "VGG"
        ],
        [
            "Vologda Oblast",
            "VLG"
        ],
        [
            "Voronezh Oblast",
            "VOR"
        ],
        [
            "Yamalo-Nenets Autonomous Okrug",
            "YAN"
        ],
        [
            "Yaroslavl Oblast",
            "YAR"
        ],
        [
            "Zabaykalsky Krai",
            "ZAB"
        ]
    ]
];
const $c8f06188fc3ad916$export$ef5ca6a08aac8ca5 = [
    "Rwanda",
    "RW",
    [
        [
            "Kigali",
            "01"
        ],
        [
            "Eastern",
            "02"
        ],
        [
            "Northern",
            "03"
        ],
        [
            "Western",
            "04"
        ],
        [
            "Southern",
            "05"
        ]
    ]
];
const $c8f06188fc3ad916$export$b54e584898971a5 = [
    "Saint Barth\xe9lemy",
    "BL",
    [
        [
            "Au Vent",
            "02"
        ],
        [
            "Sous le Vent",
            "01"
        ]
    ]
];
const $c8f06188fc3ad916$export$c713cf928ffb5e8e = [
    "Saint Helena, Ascension and Tristan da Cunha",
    "SH",
    [
        [
            "Ascension",
            "AC"
        ],
        [
            "Saint Helena",
            "HL"
        ],
        [
            "Tristan da Cunha",
            "TA"
        ]
    ]
];
const $c8f06188fc3ad916$export$fd8f06eb7ce62883 = [
    "Saint Kitts and Nevis",
    "KN",
    [
        [
            "Saint Kitts",
            "K"
        ],
        [
            "Nevis",
            "N"
        ]
    ]
];
const $c8f06188fc3ad916$export$3cb73e0e841fe17f = [
    "Saint Lucia",
    "LC",
    [
        [
            "Anse-la-Raye",
            "01"
        ],
        [
            "Canaries",
            "12"
        ],
        [
            "Castries",
            "02"
        ],
        [
            "Choiseul",
            "03"
        ],
        [
            "Dennery",
            "05"
        ],
        [
            "Gros Islet",
            "06"
        ],
        [
            "Laborie",
            "07"
        ],
        [
            "Micoud",
            "08"
        ],
        [
            "Soufriere",
            "10"
        ],
        [
            "Vieux Fort",
            "11"
        ]
    ]
];
const $c8f06188fc3ad916$export$33916af50bbab5f5 = [
    "Saint Martin",
    "MF",
    [
        [
            "Saint Martin",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$164607a37e7daeba = [
    "Saint Pierre and Miquelon",
    "PM",
    [
        [
            "Miquelon",
            "undefined"
        ],
        [
            "Saint Pierre",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$c3ea4fdfa4d8ecb7 = [
    "Saint Vincent and the Grenadines",
    "VC",
    [
        [
            "Charlotte",
            "01"
        ],
        [
            "Grenadines",
            "06"
        ],
        [
            "Saint Andrew",
            "02"
        ],
        [
            "Saint David",
            "03"
        ],
        [
            "Saint George",
            "04"
        ],
        [
            "Saint Patrick",
            "05"
        ]
    ]
];
const $c8f06188fc3ad916$export$911baa0677ac404c = [
    "Samoa",
    "WS",
    [
        [
            "A'ana",
            "AA"
        ],
        [
            "Aiga-i-le-Tai",
            "AL"
        ],
        [
            "Atua",
            "AT"
        ],
        [
            "Fa'asaleleaga",
            "FA"
        ],
        [
            "Gaga'emauga",
            "GE"
        ],
        [
            "Gagaifomauga",
            "GI"
        ],
        [
            "Palauli",
            "PA"
        ],
        [
            "Satupa'itea",
            "SA"
        ],
        [
            "Tuamasaga",
            "TU"
        ],
        [
            "Va'a-o-Fonoti",
            "VF"
        ],
        [
            "Vaisigano",
            "VS"
        ]
    ]
];
const $c8f06188fc3ad916$export$59096964bd9627ef = [
    "San Marino",
    "SM",
    [
        [
            "Acquaviva",
            "01"
        ],
        [
            "Borgo Maggiore",
            "06"
        ],
        [
            "Chiesanuova",
            "02"
        ],
        [
            "Domagnano",
            "03"
        ],
        [
            "Faetano",
            "04"
        ],
        [
            "Fiorentino",
            "05"
        ],
        [
            "Montegiardino",
            "08"
        ],
        [
            "San Marino",
            "07"
        ],
        [
            "Serravalle",
            "09"
        ]
    ]
];
const $c8f06188fc3ad916$export$80980ed6b6f31397 = [
    "Sao Tome and Principe",
    "ST",
    [
        [
            "Principe",
            "P"
        ],
        [
            "Sao Tome",
            "S"
        ]
    ]
];
const $c8f06188fc3ad916$export$da51c6332ad11d7b = [
    "Saudi Arabia",
    "SA",
    [
        [
            "'Asir",
            "14"
        ],
        [
            "Al Bahah",
            "11"
        ],
        [
            "Al Hudud ash Shamaliyah",
            "08"
        ],
        [
            "Al Jawf",
            "12"
        ],
        [
            "Al Madinah al Munawwarah",
            "03"
        ],
        [
            "Al Qasim",
            "05"
        ],
        [
            "Ar Riyad",
            "01"
        ],
        [
            "Ash Sharqiyah",
            "04"
        ],
        [
            "Ha'il",
            "06"
        ],
        [
            "Jazan",
            "09"
        ],
        [
            "Makkah al Mukarramah",
            "02"
        ],
        [
            "Najran",
            "10"
        ],
        [
            "Tabuk",
            "07"
        ]
    ]
];
const $c8f06188fc3ad916$export$b70f9dd36a734be4 = [
    "Senegal",
    "SN",
    [
        [
            "Dakar",
            "DK"
        ],
        [
            "Diourbel",
            "DB"
        ],
        [
            "Fatick",
            "FK"
        ],
        [
            "Kaffrine",
            "KA"
        ],
        [
            "Kaolack",
            "KL"
        ],
        [
            "Kedougou",
            "KE"
        ],
        [
            "Kolda",
            "KD"
        ],
        [
            "Louga",
            "LG"
        ],
        [
            "Matam",
            "MT"
        ],
        [
            "Saint-Louis",
            "SL"
        ],
        [
            "Sedhiou",
            "SE"
        ],
        [
            "Tambacounda",
            "TC"
        ],
        [
            "Thies",
            "TH"
        ],
        [
            "Ziguinchor",
            "ZG"
        ]
    ]
];
const $c8f06188fc3ad916$export$e9d8d46fbf5f29f6 = [
    "Serbia",
    "RS",
    [
        [
            "Beograd (Belgrade)",
            "00"
        ],
        [
            "Borski",
            "14"
        ],
        [
            "Brani\u010Devski",
            "11"
        ],
        [
            "Jablani\u010Dki",
            "23"
        ],
        [
            "Ju\u017Enoba\u010Dki",
            "06"
        ],
        [
            "Ju\u017Enobanatski",
            "04"
        ],
        [
            "Kolubarski",
            "09"
        ],
        [
            "Kosovski",
            "25"
        ],
        [
            "Kosovsko-Mitrova\u010Dki",
            "28"
        ],
        [
            "Kosovsko-Pomoravski",
            "29"
        ],
        [
            "Ma\u010Dvanski",
            "08"
        ],
        [
            "Moravi\u010Dki",
            "17"
        ],
        [
            "Ni\u0161avski",
            "20"
        ],
        [
            "P\u010Dinjski",
            "24"
        ],
        [
            "Pe\u0107ki",
            "26"
        ],
        [
            "Pirotski",
            "22"
        ],
        [
            "Podunavski",
            "10"
        ],
        [
            "Pomoravski",
            "13"
        ],
        [
            "Prizrenski",
            "27"
        ],
        [
            "Rasinski",
            "19"
        ],
        [
            "Ra\u0161ki",
            "18"
        ],
        [
            "Severnoba\u010Dki",
            "01"
        ],
        [
            "Severnobanatski",
            "03"
        ],
        [
            "Srednjebanatski",
            "02"
        ],
        [
            "Sremski",
            "07"
        ],
        [
            "\u0160umadijski",
            "12"
        ],
        [
            "Topli\u010Dki",
            "21"
        ],
        [
            "Zaje\u010Darski",
            "15"
        ],
        [
            "Zapadnoba\u010Dki",
            "05"
        ],
        [
            "Zlatiborski",
            "16"
        ]
    ]
];
const $c8f06188fc3ad916$export$f49cccbff6374af4 = [
    "Seychelles",
    "SC",
    [
        [
            "Anse aux Pins",
            "01"
        ],
        [
            "Anse Boileau",
            "02"
        ],
        [
            "Anse Etoile",
            "03"
        ],
        [
            "Anse Royale",
            "05"
        ],
        [
            "Anu Cap",
            "04"
        ],
        [
            "Baie Lazare",
            "06"
        ],
        [
            "Baie Sainte Anne",
            "07"
        ],
        [
            "Beau Vallon",
            "08"
        ],
        [
            "Bel Air",
            "09"
        ],
        [
            "Bel Ombre",
            "10"
        ],
        [
            "Cascade",
            "11"
        ],
        [
            "Glacis",
            "12"
        ],
        [
            "Grand'Anse Mahe",
            "13"
        ],
        [
            "Grand'Anse Praslin",
            "14"
        ],
        [
            "La Digue",
            "15"
        ],
        [
            "La Riviere Anglaise",
            "16"
        ],
        [
            "Les Mamelles",
            "24"
        ],
        [
            "Mont Buxton",
            "17"
        ],
        [
            "Mont Fleuri",
            "18"
        ],
        [
            "Plaisance",
            "19"
        ],
        [
            "Pointe La Rue",
            "20"
        ],
        [
            "Port Glaud",
            "21"
        ],
        [
            "Roche Caiman",
            "25"
        ],
        [
            "Saint Louis",
            "22"
        ],
        [
            "Takamaka",
            "23"
        ]
    ]
];
const $c8f06188fc3ad916$export$b49d6918df199090 = [
    "Sierra Leone",
    "SL",
    [
        [
            "Eastern",
            "E"
        ],
        [
            "Northern",
            "N"
        ],
        [
            "Southern",
            "S"
        ],
        [
            "Western",
            "W"
        ]
    ]
];
const $c8f06188fc3ad916$export$bea437c40441867d = [
    "Singapore",
    "SG",
    [
        [
            "Central Singapore",
            "01"
        ],
        [
            "North East",
            "02"
        ],
        [
            "North West",
            "03"
        ],
        [
            "South East",
            "04"
        ],
        [
            "South West",
            "05"
        ]
    ]
];
const $c8f06188fc3ad916$export$b4f896bb97547f66 = [
    "Sint Maarten (Dutch part)",
    "SX",
    [
        [
            "Sint Maarten",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$5f584391ee0d99b4 = [
    "Slovakia",
    "SK",
    [
        [
            "Banskobystricky",
            "BC"
        ],
        [
            "Bratislavsky",
            "BL"
        ],
        [
            "Kosicky",
            "KI"
        ],
        [
            "Nitriansky",
            "NI"
        ],
        [
            "Presovsky",
            "PV"
        ],
        [
            "Trenciansky",
            "TC"
        ],
        [
            "Trnavsky",
            "TA"
        ],
        [
            "Zilinsky",
            "ZI"
        ]
    ]
];
const $c8f06188fc3ad916$export$e6702cab675b095 = [
    "Slovenia",
    "SI",
    [
        [
            "Ajdovscina",
            "001"
        ],
        [
            "Apace",
            "195"
        ],
        [
            "Beltinci",
            "002"
        ],
        [
            "Benedikt",
            "148"
        ],
        [
            "Bistrica ob Sotli",
            "149"
        ],
        [
            "Bled",
            "003"
        ],
        [
            "Bloke",
            "150"
        ],
        [
            "Bohinj",
            "004"
        ],
        [
            "Borovnica",
            "005"
        ],
        [
            "Bovec",
            "006"
        ],
        [
            "Braslovce",
            "151"
        ],
        [
            "Brda",
            "007"
        ],
        [
            "Brezice",
            "009"
        ],
        [
            "Brezovica",
            "008"
        ],
        [
            "Cankova",
            "152"
        ],
        [
            "Celje",
            "011"
        ],
        [
            "Cerklje na Gorenjskem",
            "012"
        ],
        [
            "Cerknica",
            "013"
        ],
        [
            "Cerkno",
            "014"
        ],
        [
            "Cerkvenjak",
            "153"
        ],
        [
            "Cirkulane",
            "196"
        ],
        [
            "Crensovci",
            "015"
        ],
        [
            "Crna na Koroskem",
            "016"
        ],
        [
            "Crnomelj",
            "017"
        ],
        [
            "Destrnik",
            "018"
        ],
        [
            "Divaca",
            "019"
        ],
        [
            "Dobje",
            "154"
        ],
        [
            "Dobrepolje",
            "020"
        ],
        [
            "Dobrna",
            "155"
        ],
        [
            "Dobrova-Polhov Gradec",
            "021"
        ],
        [
            "Dobrovnik",
            "156"
        ],
        [
            "Dol pri Ljubljani",
            "022"
        ],
        [
            "Dolenjske Toplice",
            "157"
        ],
        [
            "Domzale",
            "023"
        ],
        [
            "Dornava",
            "024"
        ],
        [
            "Dravograd",
            "025"
        ],
        [
            "Duplek",
            "026"
        ],
        [
            "Gorenja Vas-Poljane",
            "027"
        ],
        [
            "Gorisnica",
            "028"
        ],
        [
            "Gorje",
            "207"
        ],
        [
            "Gornja Radgona",
            "029"
        ],
        [
            "Gornji Grad",
            "030"
        ],
        [
            "Gornji Petrovci",
            "031"
        ],
        [
            "Grad",
            "158"
        ],
        [
            "Grosuplje",
            "032"
        ],
        [
            "Hajdina",
            "159"
        ],
        [
            "Hoce-Slivnica",
            "160"
        ],
        [
            "Hodos",
            "161"
        ],
        [
            "Horjul",
            "162"
        ],
        [
            "Hrastnik",
            "034"
        ],
        [
            "Hrpelje-Kozina",
            "035"
        ],
        [
            "Idrija",
            "036"
        ],
        [
            "Ig",
            "037"
        ],
        [
            "Ilirska Bistrica",
            "038"
        ],
        [
            "Ivancna Gorica",
            "039"
        ],
        [
            "Izola",
            "040"
        ],
        [
            "Jesenice",
            "041"
        ],
        [
            "Jursinci",
            "042"
        ],
        [
            "Kamnik",
            "043"
        ],
        [
            "Kanal",
            "044"
        ],
        [
            "Kidricevo",
            "045"
        ],
        [
            "Kobarid",
            "046"
        ],
        [
            "Kobilje",
            "047"
        ],
        [
            "Kocevje",
            "048"
        ],
        [
            "Komen",
            "049"
        ],
        [
            "Komenda",
            "164"
        ],
        [
            "Koper",
            "050"
        ],
        [
            "Kodanjevica na Krki",
            "197"
        ],
        [
            "Kostel",
            "165"
        ],
        [
            "Kozje",
            "051"
        ],
        [
            "Kranj",
            "052"
        ],
        [
            "Kranjska Gora",
            "053"
        ],
        [
            "Krizevci",
            "166"
        ],
        [
            "Krsko",
            "054"
        ],
        [
            "Kungota",
            "055"
        ],
        [
            "Kuzma",
            "056"
        ],
        [
            "Lasko",
            "057"
        ],
        [
            "Lenart",
            "058"
        ],
        [
            "Lendava",
            "059"
        ],
        [
            "Litija",
            "060"
        ],
        [
            "Ljubljana",
            "061"
        ],
        [
            "Ljubno",
            "062"
        ],
        [
            "Ljutomer",
            "063"
        ],
        [
            "Log-Dragomer",
            "208"
        ],
        [
            "Logatec",
            "064"
        ],
        [
            "Loska Dolina",
            "065"
        ],
        [
            "Loski Potok",
            "066"
        ],
        [
            "Lovrenc na Pohorju",
            "167"
        ],
        [
            "Lukovica",
            "068"
        ],
        [
            "Luce",
            "067"
        ],
        [
            "Majsperk",
            "069"
        ],
        [
            "Makole",
            "198"
        ],
        [
            "Maribor",
            "070"
        ],
        [
            "Markovci",
            "168"
        ],
        [
            "Medvode",
            "071"
        ],
        [
            "Menges",
            "072"
        ],
        [
            "Metlika",
            "073"
        ],
        [
            "Mezica",
            "074"
        ],
        [
            "Miklavz na Dravskem Polju",
            "169"
        ],
        [
            "Miren-Kostanjevica",
            "075"
        ],
        [
            "Mirna",
            "212"
        ],
        [
            "Mirna Pec",
            "170"
        ],
        [
            "Mislinja",
            "076"
        ],
        [
            "Mokronog-Trebelno",
            "199"
        ],
        [
            "Moravce",
            "077"
        ],
        [
            "Moravske Toplice",
            "078"
        ],
        [
            "Mozirje",
            "079"
        ],
        [
            "Murska Sobota",
            "080"
        ],
        [
            "Naklo",
            "082"
        ],
        [
            "Nazarje",
            "083"
        ],
        [
            "Nova Gorica",
            "084"
        ],
        [
            "Novo Mesto",
            "085"
        ],
        [
            "Odranci",
            "086"
        ],
        [
            "Ormoz",
            "087"
        ],
        [
            "Osilnica",
            "088"
        ],
        [
            "Pesnica",
            "089"
        ],
        [
            "Piran",
            "090"
        ],
        [
            "Pivka",
            "091"
        ],
        [
            "Podcetrtek",
            "092"
        ],
        [
            "Podlehnik",
            "172"
        ],
        [
            "Podvelka",
            "093"
        ],
        [
            "Poljcane",
            "200"
        ],
        [
            "Postojna",
            "094"
        ],
        [
            "Prebold",
            "174"
        ],
        [
            "Preddvor",
            "095"
        ],
        [
            "Prevalje",
            "175"
        ],
        [
            "Ptuj",
            "096"
        ],
        [
            "Race-Fram",
            "098"
        ],
        [
            "Radece",
            "099"
        ],
        [
            "Radenci",
            "100"
        ],
        [
            "Radlje ob Dravi",
            "101"
        ],
        [
            "Radovljica",
            "102"
        ],
        [
            "Ravne na Koroskem",
            "103"
        ],
        [
            "Razkrizje",
            "176"
        ],
        [
            "Recica ob Savinji",
            "209"
        ],
        [
            "Rence-Vogrsko",
            "201"
        ],
        [
            "Ribnica",
            "104"
        ],
        [
            "Ribnica na Poboriu",
            "177"
        ],
        [
            "Rogaska Slatina",
            "106"
        ],
        [
            "Rogasovci",
            "105"
        ],
        [
            "Rogatec",
            "107"
        ],
        [
            "Ruse",
            "108"
        ],
        [
            "Salovci",
            "033"
        ],
        [
            "Selnica ob Dravi",
            "178"
        ],
        [
            "Semic",
            "109"
        ],
        [
            "Sempeter-Vrtojba",
            "183"
        ],
        [
            "Sencur",
            "117"
        ],
        [
            "Sentilj",
            "118"
        ],
        [
            "Sentjernej",
            "119"
        ],
        [
            "Sentjur",
            "120"
        ],
        [
            "Sentrupert",
            "211"
        ],
        [
            "Sevnica",
            "110"
        ],
        [
            "Sezana",
            "111"
        ],
        [
            "Skocjan",
            "121"
        ],
        [
            "Skofja Loka",
            "122"
        ],
        [
            "Skofljica",
            "123"
        ],
        [
            "Slovenj Gradec",
            "112"
        ],
        [
            "Slovenska Bistrica",
            "113"
        ],
        [
            "Slovenske Konjice",
            "114"
        ],
        [
            "Smarje pri elsah",
            "124"
        ],
        [
            "Smarjeske Toplice",
            "206"
        ],
        [
            "Smartno ob Paki",
            "125"
        ],
        [
            "Smartno pri Litiji",
            "194"
        ],
        [
            "Sodrazica",
            "179"
        ],
        [
            "Solcava",
            "180"
        ],
        [
            "Sostanj",
            "126"
        ],
        [
            "Sredisce ob Dravi",
            "202"
        ],
        [
            "Starse",
            "115"
        ],
        [
            "Store",
            "127"
        ],
        [
            "Straza",
            "203"
        ],
        [
            "Sveta Ana",
            "181"
        ],
        [
            "Sveta Trojica v Slovenskih Goricah",
            "204"
        ],
        [
            "Sveta Andraz v Slovenskih Goricah",
            "182"
        ],
        [
            "Sveti Jurij",
            "116"
        ],
        [
            "Sveti Jurij v Slovenskih Goricah",
            "210"
        ],
        [
            "Sveti Tomaz",
            "205"
        ],
        [
            "Tabor",
            "184"
        ],
        [
            "Tisina",
            "010"
        ],
        [
            "Tolmin",
            "128"
        ],
        [
            "Trbovlje",
            "129"
        ],
        [
            "Trebnje",
            "130"
        ],
        [
            "Trnovska Vas",
            "185"
        ],
        [
            "Trzin",
            "186"
        ],
        [
            "Trzic",
            "131"
        ],
        [
            "Turnisce",
            "132"
        ],
        [
            "Velenje",
            "133"
        ],
        [
            "Velika Polana",
            "187"
        ],
        [
            "Velike Lasce",
            "134"
        ],
        [
            "Verzej",
            "188"
        ],
        [
            "Videm",
            "135"
        ],
        [
            "Vipava",
            "136"
        ],
        [
            "Vitanje",
            "137"
        ],
        [
            "Vodice",
            "138"
        ],
        [
            "Vojnik",
            "139"
        ],
        [
            "Vransko",
            "189"
        ],
        [
            "Vrhnika",
            "140"
        ],
        [
            "Vuzenica",
            "141"
        ],
        [
            "Zagorje ob Savi",
            "142"
        ],
        [
            "Zavrc",
            "143"
        ],
        [
            "Zrece",
            "144"
        ],
        [
            "Zalec",
            "190"
        ],
        [
            "Zelezniki",
            "146"
        ],
        [
            "Zetale",
            "191"
        ],
        [
            "Ziri",
            "147"
        ],
        [
            "Zirovnica",
            "192"
        ],
        [
            "Zuzemberk",
            "193"
        ]
    ]
];
const $c8f06188fc3ad916$export$279f8048cbf05e80 = [
    "Solomon Islands",
    "SB",
    [
        [
            "Central",
            "CE"
        ],
        [
            "Choiseul",
            "CH"
        ],
        [
            "Guadalcanal",
            "GU"
        ],
        [
            "Honiara",
            "CT"
        ],
        [
            "Isabel",
            "IS"
        ],
        [
            "Makira-Ulawa",
            "MK"
        ],
        [
            "Malaita",
            "ML"
        ],
        [
            "Rennell and Bellona",
            "RB"
        ],
        [
            "Temotu",
            "TE"
        ],
        [
            "Western",
            "WE"
        ]
    ]
];
const $c8f06188fc3ad916$export$f6311706676f39f2 = [
    "Somalia",
    "SO",
    [
        [
            "Awdal",
            "AW"
        ],
        [
            "Bakool",
            "BK"
        ],
        [
            "Banaadir",
            "BN"
        ],
        [
            "Bari",
            "BR"
        ],
        [
            "Bay",
            "BY"
        ],
        [
            "Galguduud",
            "GA"
        ],
        [
            "Gedo",
            "GE"
        ],
        [
            "Hiiraan",
            "HI"
        ],
        [
            "Jubbada Dhexe",
            "JD"
        ],
        [
            "Jubbada Hoose",
            "JH"
        ],
        [
            "Mudug",
            "MU"
        ],
        [
            "Nugaal",
            "NU"
        ],
        [
            "Sanaag",
            "SA"
        ],
        [
            "Shabeellaha Dhexe",
            "SD"
        ],
        [
            "Shabeellaha Hoose",
            "SH"
        ],
        [
            "Sool",
            "SO"
        ],
        [
            "Togdheer",
            "TO"
        ],
        [
            "Woqooyi Galbeed",
            "WO"
        ]
    ]
];
const $c8f06188fc3ad916$export$b2eccbdcd109dde0 = [
    "South Africa",
    "ZA",
    [
        [
            "Eastern Cape",
            "EC"
        ],
        [
            "Free State",
            "FS"
        ],
        [
            "Gauteng",
            "GT"
        ],
        [
            "KwaZulu-Natal",
            "NL"
        ],
        [
            "Limpopo",
            "LP"
        ],
        [
            "Mpumalanga",
            "MP"
        ],
        [
            "Northern Cape",
            "NC"
        ],
        [
            "North West",
            "NW"
        ],
        [
            "Western Cape",
            "WC"
        ]
    ]
];
const $c8f06188fc3ad916$export$f7fbe7cb90eabcb4 = [
    "South Georgia and South Sandwich Islands",
    "GS",
    [
        [
            "Bird Island",
            "undefined"
        ],
        [
            "Bristol Island",
            "undefined"
        ],
        [
            "Clerke Rocks",
            "undefined"
        ],
        [
            "Montagu Island",
            "undefined"
        ],
        [
            "Saunders Island",
            "undefined"
        ],
        [
            "South Georgia",
            "undefined"
        ],
        [
            "Southern Thule",
            "undefined"
        ],
        [
            "Traversay Islands",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$8cda4cf3f4deb8c2 = [
    "South Sudan",
    "SS",
    [
        [
            "Central Equatoria",
            "CE"
        ],
        [
            "Eastern Equatoria",
            "EE"
        ],
        [
            "Jonglei",
            "JG"
        ],
        [
            "Lakes",
            "LK"
        ],
        [
            "Northern Bahr el Ghazal",
            "BN"
        ],
        [
            "Unity",
            "UY"
        ],
        [
            "Upper Nile",
            "NU"
        ],
        [
            "Warrap",
            "WR"
        ],
        [
            "Western Bahr el Ghazal",
            "BW"
        ],
        [
            "Western Equatoria",
            "EW"
        ]
    ]
];
const $c8f06188fc3ad916$export$a723e6e41cced9bd = [
    "Spain",
    "ES",
    [
        [
            "Andaluc\xeca",
            "AN"
        ],
        [
            "Albacete",
            "AB"
        ],
        [
            "Alicante",
            "A"
        ],
        [
            "Almer\xeda",
            "AL"
        ],
        [
            "Araba/\xc1lava",
            "VI"
        ],
        [
            "Asturias",
            "O"
        ],
        [
            "\xc1vila",
            "AV"
        ],
        [
            "Arag\xf2n",
            "AR"
        ],
        [
            "Badajoz",
            "BA"
        ],
        [
            "Barcelona",
            "B"
        ],
        [
            "Bizkaia",
            "BI"
        ],
        [
            "Burgos",
            "BU"
        ],
        [
            "C\xe1ceres",
            "CC"
        ],
        [
            "C\xe1diz",
            "CA"
        ],
        [
            "Canarias",
            "CN"
        ],
        [
            "Cantabria",
            "S"
        ],
        [
            "Castell\xf3n/Castell\xf3",
            "CS"
        ],
        [
            "Ceuta",
            "CE"
        ],
        [
            "Ciudad Real",
            "CR"
        ],
        [
            "C\xf3rdoba",
            "CO"
        ],
        [
            "A Coru\xf1a",
            "C"
        ],
        [
            "Cuenca",
            "CU"
        ],
        [
            "Gipuzkoa",
            "SS"
        ],
        [
            "Girona",
            "GI"
        ],
        [
            "Granada",
            "GR"
        ],
        [
            "Guadalajara",
            "GU"
        ],
        [
            "Huelva",
            "H"
        ],
        [
            "Huesca",
            "HU"
        ],
        [
            "Illes Balears",
            "PM"
        ],
        [
            "Ja\xe9n",
            "J"
        ],
        [
            "Le\xf3n",
            "LE"
        ],
        [
            "Lleida",
            "L"
        ],
        [
            "Lugo",
            "LU"
        ],
        [
            "Madrid",
            "M"
        ],
        [
            "M\xe1laga",
            "MA"
        ],
        [
            "Melilla",
            "ML"
        ],
        [
            "Murcia",
            "MU"
        ],
        [
            "Navarra/Nafarroa",
            "NA"
        ],
        [
            "Ourense",
            "OR"
        ],
        [
            "Palencia",
            "P"
        ],
        [
            "Las Palmas",
            "GC"
        ],
        [
            "Pontevedra",
            "PO"
        ],
        [
            "La Rioja",
            "LO"
        ],
        [
            "Salamanca",
            "SA"
        ],
        [
            "Santa Cruz de Tenerife",
            "TF"
        ],
        [
            "Segovia",
            "SG"
        ],
        [
            "Sevilla",
            "SE"
        ],
        [
            "Soria",
            "SO"
        ],
        [
            "Tarragona",
            "T"
        ],
        [
            "Teruel",
            "TE"
        ],
        [
            "Toledo",
            "TO"
        ],
        [
            "Valencia/Val\xe8ncia",
            "V"
        ],
        [
            "Valladolid",
            "VA"
        ],
        [
            "Zamora",
            "ZA"
        ],
        [
            "Zaragoza",
            "Z"
        ]
    ]
];
const $c8f06188fc3ad916$export$782aca1f2c103f6b = [
    "Sri Lanka",
    "LK",
    [
        [
            "Basnahira",
            "1"
        ],
        [
            "Dakunu",
            "3"
        ],
        [
            "Madhyama",
            "2"
        ],
        [
            "Naegenahira",
            "5"
        ],
        [
            "Sabaragamuwa",
            "9"
        ],
        [
            "Uturu",
            "4"
        ],
        [
            "Uturumaeda",
            "7"
        ],
        [
            "Vayamba",
            "6"
        ],
        [
            "Uva",
            "8"
        ]
    ]
];
const $c8f06188fc3ad916$export$5b088def975a652b = [
    "Sudan",
    "SD",
    [
        [
            "Al Bahr al Ahmar",
            "RS"
        ],
        [
            "Al Jazirah",
            "GZ"
        ],
        [
            "Al Khartum",
            "KH"
        ],
        [
            "Al Qadarif",
            "GD"
        ],
        [
            "An Nil al Abyad",
            "NW"
        ],
        [
            "An Nil al Azraq",
            "NB"
        ],
        [
            "Ash Shamaliyah",
            "NO"
        ],
        [
            "Gharb Darfur",
            "DW"
        ],
        [
            "Gharb Kurdufan",
            "GK"
        ],
        [
            "Janub Darfur",
            "DS"
        ],
        [
            "Janub Kurdufan",
            "KS"
        ],
        [
            "Kassala",
            "KA"
        ],
        [
            "Nahr an Nil",
            "NR"
        ],
        [
            "Shamal Darfur",
            "DN"
        ],
        [
            "Sharq Darfur",
            "DE"
        ],
        [
            "Shiamal Kurdufan",
            "KN"
        ],
        [
            "Sinnar",
            "SI"
        ],
        [
            "Wasat Darfur Zalinjay",
            "DC"
        ]
    ]
];
const $c8f06188fc3ad916$export$13acf42283a26926 = [
    "Suriname",
    "SR",
    [
        [
            "Brokopondo",
            "BR"
        ],
        [
            "Commewijne",
            "CM"
        ],
        [
            "Coronie",
            "CR"
        ],
        [
            "Marowijne",
            "MA"
        ],
        [
            "Nickerie",
            "NI"
        ],
        [
            "Para",
            "PR"
        ],
        [
            "Paramaribo",
            "PM"
        ],
        [
            "Saramacca",
            "SA"
        ],
        [
            "Sipaliwini",
            "SI"
        ],
        [
            "Wanica",
            "WA"
        ]
    ]
];
const $c8f06188fc3ad916$export$988c8b3cfeed3531 = [
    "Eswatini",
    "SZ",
    [
        [
            "Hhohho",
            "HH"
        ],
        [
            "Lubombo",
            "LU"
        ],
        [
            "Manzini",
            "MA"
        ],
        [
            "Shiselweni",
            "SH"
        ]
    ]
];
const $c8f06188fc3ad916$export$88d2e60d4be28663 = [
    "Sweden",
    "SE",
    [
        [
            "Blekinge",
            "K"
        ],
        [
            "Dalarna",
            "W"
        ],
        [
            "G\xe4vleborg",
            "X"
        ],
        [
            "Gotland",
            "I"
        ],
        [
            "Halland",
            "N"
        ],
        [
            "J\xe4mtland",
            "Z"
        ],
        [
            "J\xf6nk\xf6ping",
            "F"
        ],
        [
            "Kalmar",
            "H"
        ],
        [
            "Kronoberg",
            "G"
        ],
        [
            "Norrbotten",
            "BD"
        ],
        [
            "\xd6rebro",
            "T"
        ],
        [
            "\xd6sterg\xf6tland",
            "E"
        ],
        [
            "Sk\xe5ne",
            "M"
        ],
        [
            "S\xf6dermanland",
            "D"
        ],
        [
            "Stockholm",
            "AB"
        ],
        [
            "Uppsala",
            "C"
        ],
        [
            "V\xe4rmland",
            "S"
        ],
        [
            "V\xe4sterbotten",
            "AC"
        ],
        [
            "V\xe4sternorrland",
            "Y"
        ],
        [
            "V\xe4stmanland",
            "U"
        ],
        [
            "V\xe4stra G\xf6taland",
            "O"
        ]
    ]
];
const $c8f06188fc3ad916$export$31ff2235b44019b8 = [
    "Switzerland",
    "CH",
    [
        [
            "Aargau",
            "AG"
        ],
        [
            "Appenzell Ausserrhoden",
            "AR"
        ],
        [
            "Appenzell Innerhoden",
            "AI"
        ],
        [
            "Basel-Landschaft",
            "BL"
        ],
        [
            "Basel-Stadt",
            "BS"
        ],
        [
            "Bern",
            "BE"
        ],
        [
            "Fribourg",
            "FR"
        ],
        [
            "Gen\xe8ve",
            "GE"
        ],
        [
            "Glarus",
            "GL"
        ],
        [
            "Graub\xfcnden",
            "GR"
        ],
        [
            "Jura",
            "JU"
        ],
        [
            "Luzern",
            "LU"
        ],
        [
            "Neuch\xe2tel",
            "NE"
        ],
        [
            "Nidwalden",
            "NW"
        ],
        [
            "Obwalden",
            "OW"
        ],
        [
            "Sankt Gallen",
            "SG"
        ],
        [
            "Schaffhausen",
            "SH"
        ],
        [
            "Schwyz",
            "SZ"
        ],
        [
            "Solothurn",
            "SO"
        ],
        [
            "Thurgau",
            "TG"
        ],
        [
            "Ticino",
            "TI"
        ],
        [
            "Uri",
            "UR"
        ],
        [
            "Valais",
            "VS"
        ],
        [
            "Vaud",
            "VD"
        ],
        [
            "Zug",
            "ZG"
        ],
        [
            "Z\xfcrich",
            "ZH"
        ]
    ]
];
const $c8f06188fc3ad916$export$2e8caadc521d7cbb = [
    "Syrian Arab Republic",
    "SY",
    [
        [
            "Al Hasakah",
            "HA"
        ],
        [
            "Al Ladhiqiyah",
            "LA"
        ],
        [
            "Al Qunaytirah",
            "QU"
        ],
        [
            "Ar Raqqah",
            "RA"
        ],
        [
            "As Suwayda'",
            "SU"
        ],
        [
            "Dar'a",
            "DR"
        ],
        [
            "Dayr az Zawr",
            "DY"
        ],
        [
            "Dimashq",
            "DI"
        ],
        [
            "Halab",
            "HL"
        ],
        [
            "Hamah",
            "HM"
        ],
        [
            "Hims",
            "HI"
        ],
        [
            "Idlib",
            "ID"
        ],
        [
            "Rif Dimashq",
            "RD"
        ],
        [
            "Tartus",
            "TA"
        ]
    ]
];
const $c8f06188fc3ad916$export$1d1fd77441e66de6 = [
    "Taiwan",
    "TW",
    [
        [
            "Changhua",
            "CHA"
        ],
        [
            "Chiayi",
            "CYQ"
        ],
        [
            "Hsinchu",
            "HSQ"
        ],
        [
            "Hualien",
            "HUA"
        ],
        [
            "Kaohsiung",
            "KHH"
        ],
        [
            "Keelung",
            "KEE"
        ],
        [
            "Kinmen",
            "KIN"
        ],
        [
            "Lienchiang",
            "LIE"
        ],
        [
            "Miaoli",
            "MIA"
        ],
        [
            "Nantou",
            "NAN"
        ],
        [
            "Penghu",
            "PEN"
        ],
        [
            "New Taipei",
            "NWT"
        ],
        [
            "Pingtung",
            "PIF"
        ],
        [
            "Taichung",
            "TXG"
        ],
        [
            "Tainan",
            "TNN"
        ],
        [
            "Taipei",
            "TPE"
        ],
        [
            "Taitung",
            "TTT"
        ],
        [
            "Taoyuan",
            "TAO"
        ],
        [
            "Yilan",
            "ILA"
        ],
        [
            "Yunlin",
            "YUN"
        ]
    ]
];
const $c8f06188fc3ad916$export$f5448d52a2727e70 = [
    "Tajikistan",
    "TJ",
    [
        [
            "Dushanbe",
            "DU"
        ],
        [
            "K\u016Dhistoni Badakhshon",
            "GB"
        ],
        [
            "Khatlon",
            "KT"
        ],
        [
            "Sughd",
            "SU"
        ]
    ]
];
const $c8f06188fc3ad916$export$786aa6dc686c7fa2 = [
    "Tanzania, United Republic of",
    "TZ",
    [
        [
            "Arusha",
            "01"
        ],
        [
            "Coast",
            "19"
        ],
        [
            "Dar es Salaam",
            "02"
        ],
        [
            "Dodoma",
            "03"
        ],
        [
            "Iringa",
            "04"
        ],
        [
            "Kagera",
            "05"
        ],
        [
            "Kigoma",
            "08"
        ],
        [
            "Kilimanjaro",
            "09"
        ],
        [
            "Lindi",
            "12"
        ],
        [
            "Manyara",
            "26"
        ],
        [
            "Mara",
            "13"
        ],
        [
            "Mbeya",
            "14"
        ],
        [
            "Morogoro",
            "16"
        ],
        [
            "Mtwara",
            "17"
        ],
        [
            "Mwanza",
            "18"
        ],
        [
            "Pemba North",
            "06"
        ],
        [
            "Pemba South",
            "10"
        ],
        [
            "Rukwa",
            "20"
        ],
        [
            "Ruvuma",
            "21"
        ],
        [
            "Shinyanga",
            "22"
        ],
        [
            "Singida",
            "23"
        ],
        [
            "Tabora",
            "24"
        ],
        [
            "Tanga",
            "25"
        ],
        [
            "Zanzibar North",
            "07"
        ],
        [
            "Zanzibar Central/South",
            "11"
        ],
        [
            "Zanzibar Urban/West",
            "15"
        ]
    ]
];
const $c8f06188fc3ad916$export$2b39a3648955dd09 = [
    "Thailand",
    "TH",
    [
        [
            "Amnat Charoen",
            "37"
        ],
        [
            "Ang Thong",
            "15"
        ],
        [
            "Bueng Kan",
            "38"
        ],
        [
            "Buri Ram",
            "31"
        ],
        [
            "Chachoengsao",
            "24"
        ],
        [
            "Chai Nat",
            "18"
        ],
        [
            "Chaiyaphum",
            "36"
        ],
        [
            "Chanthaburi",
            "22"
        ],
        [
            "Chiang Mai",
            "50"
        ],
        [
            "Chiang Rai",
            "57"
        ],
        [
            "Chon Buri",
            "20"
        ],
        [
            "Chumphon",
            "86"
        ],
        [
            "Kalasin",
            "46"
        ],
        [
            "Kamphaeng Phet",
            "62"
        ],
        [
            "Kanchanaburi",
            "71"
        ],
        [
            "Khon Kaen",
            "40"
        ],
        [
            "Krabi",
            "81"
        ],
        [
            "Krung Thep Mahanakhon (Bangkok)",
            "10"
        ],
        [
            "Lampang",
            "52"
        ],
        [
            "Lamphun",
            "51"
        ],
        [
            "Loei",
            "42"
        ],
        [
            "Lop Buri",
            "16"
        ],
        [
            "Mae Hong Son",
            "58"
        ],
        [
            "Maha Sarakham",
            "44"
        ],
        [
            "Mukdahan",
            "49"
        ],
        [
            "Nakhon Nayok",
            "26"
        ],
        [
            "Nakhon Phathom",
            "73"
        ],
        [
            "Nakhon Phanom",
            "48"
        ],
        [
            "Nakhon Ratchasima",
            "30"
        ],
        [
            "Nakhon Sawan",
            "60"
        ],
        [
            "Nakhon Si Thammarat",
            "80"
        ],
        [
            "Nan",
            "55"
        ],
        [
            "Narathiwat",
            "96"
        ],
        [
            "Nong Bua Lam Phu",
            "39"
        ],
        [
            "Nong Khai",
            "43"
        ],
        [
            "Nonthaburi",
            "12"
        ],
        [
            "Pathum Thani",
            "13"
        ],
        [
            "Pattani",
            "94"
        ],
        [
            "Phangnga",
            "82"
        ],
        [
            "Phatthalung",
            "93"
        ],
        [
            "Phayao",
            "56"
        ],
        [
            "Phetchabun",
            "67"
        ],
        [
            "Phetchaburi",
            "76"
        ],
        [
            "Phichit",
            "66"
        ],
        [
            "Phitsanulok",
            "65"
        ],
        [
            "Phra Nakhon Si Ayutthaya",
            "14"
        ],
        [
            "Phrae",
            "54"
        ],
        [
            "Phuket",
            "83"
        ],
        [
            "Prachin Buri",
            "25"
        ],
        [
            "Prachuap Khiri Khan",
            "77"
        ],
        [
            "Ranong",
            "85"
        ],
        [
            "Ratchaburi",
            "70"
        ],
        [
            "Rayong",
            "21"
        ],
        [
            "Roi Et",
            "45"
        ],
        [
            "Sa Kaeo",
            "27"
        ],
        [
            "Sakon Nakhon",
            "47"
        ],
        [
            "Samut Prakan",
            "11"
        ],
        [
            "Samut Sakhon",
            "74"
        ],
        [
            "Samut Songkhram",
            "75"
        ],
        [
            "Saraburi",
            "19"
        ],
        [
            "Satun",
            "91"
        ],
        [
            "Sing Buri",
            "17"
        ],
        [
            "Si Sa ket",
            "33"
        ],
        [
            "Songkhla",
            "90"
        ],
        [
            "Sukhothai",
            "64"
        ],
        [
            "Suphan Buri",
            "72"
        ],
        [
            "Surat Thani",
            "84"
        ],
        [
            "Surin",
            "32"
        ],
        [
            "Tak",
            "63"
        ],
        [
            "Trang",
            "92"
        ],
        [
            "Trat",
            "23"
        ],
        [
            "Ubon Ratchathani",
            "34"
        ],
        [
            "Udon Thani",
            "41"
        ],
        [
            "Uthai Thani",
            "61"
        ],
        [
            "Uttaradit",
            "53"
        ],
        [
            "Yala",
            "95"
        ],
        [
            "Yasothon",
            "35"
        ]
    ]
];
const $c8f06188fc3ad916$export$28666a74ae2b9cff = [
    "Timor-Leste",
    "TL",
    [
        [
            "Aileu",
            "AL"
        ],
        [
            "Ainaro",
            "AN"
        ],
        [
            "Baucau",
            "BA"
        ],
        [
            "Bobonaro",
            "BO"
        ],
        [
            "Cova Lima",
            "CO"
        ],
        [
            "Dili",
            "DI"
        ],
        [
            "Ermera",
            "ER"
        ],
        [
            "Lautem",
            "LA"
        ],
        [
            "Liquica",
            "LI"
        ],
        [
            "Manatuto",
            "MT"
        ],
        [
            "Manufahi",
            "MF"
        ],
        [
            "Oecussi",
            "OE"
        ],
        [
            "Viqueque",
            "VI"
        ]
    ]
];
const $c8f06188fc3ad916$export$3909ee2d70cce411 = [
    "Togo",
    "TG",
    [
        [
            "Centre",
            "C"
        ],
        [
            "Kara",
            "K"
        ],
        [
            "Maritime",
            "M"
        ],
        [
            "Plateaux",
            "P"
        ],
        [
            "Savannes",
            "S"
        ]
    ]
];
const $c8f06188fc3ad916$export$73184284939cbbe8 = [
    "Tokelau",
    "TK",
    [
        [
            "Atafu",
            "undefined"
        ],
        [
            "Fakaofo",
            "undefined"
        ],
        [
            "Nukunonu",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$ee525e60afffec7b = [
    "Tonga",
    "TO",
    [
        [
            "'Eua",
            "01"
        ],
        [
            "Ha'apai",
            "02"
        ],
        [
            "Niuas",
            "03"
        ],
        [
            "Tongatapu",
            "04"
        ],
        [
            "Vava'u",
            "05"
        ]
    ]
];
const $c8f06188fc3ad916$export$c506431d6b27243b = [
    "Trinidad and Tobago",
    "TT",
    [
        [
            "Arima",
            "ARI"
        ],
        [
            "Chaguanas",
            "CHA"
        ],
        [
            "Couva-Tabaquite-Talparo",
            "CTT"
        ],
        [
            "Diefo Martin",
            "DMN"
        ],
        [
            "Mayaro-Rio Claro",
            "MRC"
        ],
        [
            "Penal-Debe",
            "PED"
        ],
        [
            "Point Fortin",
            "PTF"
        ],
        [
            "Port-of-Spain",
            "POS"
        ],
        [
            "Princes Town",
            "PRT"
        ],
        [
            "San Fernando",
            "SFO"
        ],
        [
            "San Juan-Laventille",
            "SJL"
        ],
        [
            "Sangre Grande",
            "SGE"
        ],
        [
            "Siparia",
            "SIP"
        ],
        [
            "Tobago",
            "TOB"
        ],
        [
            "Tunapuna-Piarco",
            "TUP"
        ]
    ]
];
const $c8f06188fc3ad916$export$82039c5ab5b44a72 = [
    "Tunisia",
    "TN",
    [
        [
            "Ariana",
            "12"
        ],
        [
            "Beja",
            "31"
        ],
        [
            "Ben Arous",
            "13"
        ],
        [
            "Bizerte",
            "23"
        ],
        [
            "Gabes",
            "81"
        ],
        [
            "Gafsa",
            "71"
        ],
        [
            "Jendouba",
            "32"
        ],
        [
            "Kairouan",
            "41"
        ],
        [
            "Kasserine",
            "42"
        ],
        [
            "Kebili",
            "73"
        ],
        [
            "Kef",
            "33"
        ],
        [
            "Mahdia",
            "53"
        ],
        [
            "Medenine",
            "82"
        ],
        [
            "Monastir",
            "52"
        ],
        [
            "Nabeul",
            "21"
        ],
        [
            "Sfax",
            "61"
        ],
        [
            "Sidi Bouzid",
            "43"
        ],
        [
            "Siliana",
            "34"
        ],
        [
            "Sousse",
            "51"
        ],
        [
            "Tataouine",
            "83"
        ],
        [
            "Tozeur",
            "72"
        ],
        [
            "Tunis",
            "11"
        ],
        [
            "Zaghouan",
            "22"
        ]
    ]
];
const $c8f06188fc3ad916$export$5582bd7183a5e873 = [
    "Turkey",
    "TR",
    [
        [
            "Adana",
            "01"
        ],
        [
            "Adiyaman",
            "02"
        ],
        [
            "Afyonkarahisar",
            "03"
        ],
        [
            "Agri",
            "04"
        ],
        [
            "Aksaray",
            "68"
        ],
        [
            "Amasya",
            "05"
        ],
        [
            "Ankara",
            "06"
        ],
        [
            "Antalya",
            "07"
        ],
        [
            "Ardahan",
            "75"
        ],
        [
            "Artvin",
            "08"
        ],
        [
            "Aydin",
            "09"
        ],
        [
            "Balikesir",
            "10"
        ],
        [
            "Bartin",
            "74"
        ],
        [
            "Batman",
            "72"
        ],
        [
            "Bayburt",
            "69"
        ],
        [
            "Bilecik",
            "11"
        ],
        [
            "Bingol",
            "12"
        ],
        [
            "Bitlis",
            "13"
        ],
        [
            "Bolu",
            "14"
        ],
        [
            "Burdur",
            "15"
        ],
        [
            "Bursa",
            "16"
        ],
        [
            "Canakkale",
            "17"
        ],
        [
            "Cankiri",
            "18"
        ],
        [
            "Corum",
            "19"
        ],
        [
            "Denizli",
            "20"
        ],
        [
            "Diyarbakir",
            "21"
        ],
        [
            "Duzce",
            "81"
        ],
        [
            "Edirne",
            "22"
        ],
        [
            "Elazig",
            "23"
        ],
        [
            "Erzincan",
            "24"
        ],
        [
            "Erzurum",
            "25"
        ],
        [
            "Eskisehir",
            "26"
        ],
        [
            "Gaziantep",
            "27"
        ],
        [
            "Giresun",
            "28"
        ],
        [
            "Gumushane",
            "29"
        ],
        [
            "Hakkari",
            "30"
        ],
        [
            "Hatay",
            "31"
        ],
        [
            "Igdir",
            "76"
        ],
        [
            "Isparta",
            "32"
        ],
        [
            "Istanbul",
            "34"
        ],
        [
            "Izmir",
            "35"
        ],
        [
            "Kahramanmaras",
            "46"
        ],
        [
            "Karabuk",
            "78"
        ],
        [
            "Karaman",
            "70"
        ],
        [
            "Kars",
            "36"
        ],
        [
            "Kastamonu",
            "37"
        ],
        [
            "Kayseri",
            "38"
        ],
        [
            "Kilis",
            "79"
        ],
        [
            "Kirikkale",
            "71"
        ],
        [
            "Kirklareli",
            "39"
        ],
        [
            "Kirsehir",
            "40"
        ],
        [
            "Kocaeli",
            "41"
        ],
        [
            "Konya",
            "42"
        ],
        [
            "Kutahya",
            "43"
        ],
        [
            "Malatya",
            "44"
        ],
        [
            "Manisa",
            "45"
        ],
        [
            "Mardin",
            "47"
        ],
        [
            "Mersin",
            "33"
        ],
        [
            "Mugla",
            "48"
        ],
        [
            "Mus",
            "49"
        ],
        [
            "Nevsehir",
            "50"
        ],
        [
            "Nigde",
            "51"
        ],
        [
            "Ordu",
            "52"
        ],
        [
            "Osmaniye",
            "80"
        ],
        [
            "Rize",
            "53"
        ],
        [
            "Sakarya",
            "54"
        ],
        [
            "Samsun",
            "55"
        ],
        [
            "Sanliurfa",
            "63"
        ],
        [
            "Siirt",
            "56"
        ],
        [
            "Sinop",
            "57"
        ],
        [
            "Sirnak",
            "73"
        ],
        [
            "Sivas",
            "58"
        ],
        [
            "Tekirdag",
            "59"
        ],
        [
            "Tokat",
            "60"
        ],
        [
            "Trabzon",
            "61"
        ],
        [
            "Tunceli",
            "62"
        ],
        [
            "Usak",
            "64"
        ],
        [
            "Van",
            "65"
        ],
        [
            "Yalova",
            "77"
        ],
        [
            "Yozgat",
            "66"
        ],
        [
            "Zonguldak",
            "67"
        ]
    ]
];
const $c8f06188fc3ad916$export$e3227e6e5fca8775 = [
    "Turkmenistan",
    "TM",
    [
        [
            "Ahal",
            "A"
        ],
        [
            "Asgabat",
            "S"
        ],
        [
            "Balkan",
            "B"
        ],
        [
            "Dashoguz",
            "D"
        ],
        [
            "Lebap",
            "L"
        ],
        [
            "Mary",
            "M"
        ]
    ]
];
const $c8f06188fc3ad916$export$bf91931db7b40921 = [
    "Turks and Caicos Islands",
    "TC",
    [
        [
            "Turks and Caicos Islands",
            "undefined"
        ]
    ]
];
const $c8f06188fc3ad916$export$9e799ed47e538f9d = [
    "Tuvalu",
    "TV",
    [
        [
            "Funafuti",
            "FUN"
        ],
        [
            "Nanumanga",
            "NMG"
        ],
        [
            "Nanumea",
            "NMA"
        ],
        [
            "Niutao",
            "NIT"
        ],
        [
            "Nui",
            "NUI"
        ],
        [
            "Nukufetau",
            "NKF"
        ],
        [
            "Nukulaelae",
            "NKL"
        ],
        [
            "Vaitupu",
            "VAU"
        ]
    ]
];
const $c8f06188fc3ad916$export$c5b3cc9fdc52ea1d = [
    "Uganda",
    "UG",
    [
        [
            "Abim",
            "317"
        ],
        [
            "Adjumani",
            "301"
        ],
        [
            "Amolatar",
            "314"
        ],
        [
            "Amuria",
            "216"
        ],
        [
            "Amuru",
            "319"
        ],
        [
            "Apac",
            "302"
        ],
        [
            "Arua",
            "303"
        ],
        [
            "Budaka",
            "217"
        ],
        [
            "Bududa",
            "223"
        ],
        [
            "Bugiri",
            "201"
        ],
        [
            "Bukedea",
            "224"
        ],
        [
            "Bukwa",
            "218"
        ],
        [
            "Buliisa",
            "419"
        ],
        [
            "Bundibugyo",
            "401"
        ],
        [
            "Bushenyi",
            "402"
        ],
        [
            "Busia",
            "202"
        ],
        [
            "Butaleja",
            "219"
        ],
        [
            "Dokolo",
            "318"
        ],
        [
            "Gulu",
            "304"
        ],
        [
            "Hoima",
            "403"
        ],
        [
            "Ibanda",
            "416"
        ],
        [
            "Iganga",
            "203"
        ],
        [
            "Isingiro",
            "417"
        ],
        [
            "Jinja",
            "204"
        ],
        [
            "Kaabong",
            "315"
        ],
        [
            "Kabale",
            "404"
        ],
        [
            "Kabarole",
            "405"
        ],
        [
            "Kaberamaido",
            "213"
        ],
        [
            "Kalangala",
            "101"
        ],
        [
            "Kaliro",
            "220"
        ],
        [
            "Kampala",
            "102"
        ],
        [
            "Kamuli",
            "205"
        ],
        [
            "Kamwenge",
            "413"
        ],
        [
            "Kanungu",
            "414"
        ],
        [
            "Kapchorwa",
            "206"
        ],
        [
            "Kasese",
            "406"
        ],
        [
            "Katakwi",
            "207"
        ],
        [
            "Kayunga",
            "112"
        ],
        [
            "Kibaale",
            "407"
        ],
        [
            "Kiboga",
            "103"
        ],
        [
            "Kiruhura",
            "418"
        ],
        [
            "Kisoro",
            "408"
        ],
        [
            "Kitgum",
            "305"
        ],
        [
            "Koboko",
            "316"
        ],
        [
            "Kotido",
            "306"
        ],
        [
            "Kumi",
            "208"
        ],
        [
            "Kyenjojo",
            "415"
        ],
        [
            "Lira",
            "307"
        ],
        [
            "Luwero",
            "104"
        ],
        [
            "Lyantonde",
            "116"
        ],
        [
            "Manafwa",
            "221"
        ],
        [
            "Maracha",
            "320"
        ],
        [
            "Masaka",
            "105"
        ],
        [
            "Masindi",
            "409"
        ],
        [
            "Mayuge",
            "214"
        ],
        [
            "Mbale",
            "209"
        ],
        [
            "Mbarara",
            "410"
        ],
        [
            "Mityana",
            "114"
        ],
        [
            "Moroto",
            "308"
        ],
        [
            "Moyo",
            "309"
        ],
        [
            "Mpigi",
            "106"
        ],
        [
            "Mubende",
            "107"
        ],
        [
            "Mukono",
            "108"
        ],
        [
            "Nakapiripirit",
            "311"
        ],
        [
            "Nakaseke",
            "115"
        ],
        [
            "Nakasongola",
            "109"
        ],
        [
            "Namutumba",
            "222"
        ],
        [
            "Nebbi",
            "310"
        ],
        [
            "Ntungamo",
            "411"
        ],
        [
            "Oyam",
            "321"
        ],
        [
            "Pader",
            "312"
        ],
        [
            "Pallisa",
            "210"
        ],
        [
            "Rakai",
            "110"
        ],
        [
            "Rukungiri",
            "412"
        ],
        [
            "Sembabule",
            "111"
        ],
        [
            "Sironko",
            "215"
        ],
        [
            "Soroti",
            "211"
        ],
        [
            "Tororo",
            "212"
        ],
        [
            "Wakiso",
            "113"
        ],
        [
            "Yumbe",
            "313"
        ]
    ]
];
const $c8f06188fc3ad916$export$4b88e746e0f81154 = [
    "Ukraine",
    "UA",
    [
        [
            "Cherkaska oblast",
            "71"
        ],
        [
            "Chernihivska oblast",
            "74"
        ],
        [
            "Chernivetska oblast",
            "77"
        ],
        [
            "Dnipropetrovska oblast",
            "12"
        ],
        [
            "Donetska oblast",
            "14"
        ],
        [
            "Ivano-Frankivska oblast",
            "26"
        ],
        [
            "Kharkivska oblast",
            "63"
        ],
        [
            "Khersonska oblast",
            "65"
        ],
        [
            "Khmelnytska oblast",
            "68"
        ],
        [
            "Kyivska oblast",
            "32"
        ],
        [
            "Kirovohradska oblast",
            "35"
        ],
        [
            "Luhanska oblast",
            "09"
        ],
        [
            "Lvivska oblast",
            "46"
        ],
        [
            "Mykolaivska oblast",
            "48"
        ],
        [
            "Odeska oblast",
            "51"
        ],
        [
            "Poltavska oblast",
            "53"
        ],
        [
            "Rivnenska oblast",
            "56"
        ],
        [
            "Sumska oblast",
            "59"
        ],
        [
            "Ternopilska oblast",
            "61"
        ],
        [
            "Vinnytska oblast",
            "05"
        ],
        [
            "Volynska oblast",
            "07"
        ],
        [
            "Zakarpatska oblast",
            "21"
        ],
        [
            "Zaporizka oblast",
            "23"
        ],
        [
            "Zhytomyrska oblast",
            "18"
        ],
        [
            "Avtonomna Respublika Krym",
            "43"
        ],
        [
            "Kyiv",
            "30"
        ],
        [
            "Sevastopol",
            "40"
        ]
    ]
];
const $c8f06188fc3ad916$export$2b2c8e343c91a153 = [
    "United Arab Emirates",
    "AE",
    [
        [
            "Abu Dhabi",
            "AZ"
        ],
        [
            "Ajman",
            "AJ"
        ],
        [
            "Dubai",
            "DU"
        ],
        [
            "Fujairah",
            "FU"
        ],
        [
            "Ras al Khaimah",
            "RK"
        ],
        [
            "Sharjah",
            "SH"
        ],
        [
            "Umm Al Quwain",
            "UQ"
        ]
    ]
];
const $c8f06188fc3ad916$export$5c1daad85ece4f0d = [
    "United Kingdom",
    "GB",
    [
        [
            "Aberdeen City",
            "ABE"
        ],
        [
            "Aberdeenshire",
            "ABD"
        ],
        [
            "Angus",
            "ANS"
        ],
        [
            "Antrim and Newtownabbey",
            "ANN"
        ],
        [
            "Ards and North Down",
            "AND"
        ],
        [
            "Argyll and Bute",
            "AGB"
        ],
        [
            "Armagh City, Banbridge and Craigavon",
            "ABC"
        ],
        [
            "Barking and Dagenham",
            "BDG"
        ],
        [
            "Barnet",
            "BNE"
        ],
        [
            "Barnsley",
            "BNS"
        ],
        [
            "Bath and North East Somerset",
            "BAS"
        ],
        [
            "Bedford",
            "BDF"
        ],
        [
            "Belfast City",
            "BFS"
        ],
        [
            "Berkshire",
            "BRK"
        ],
        [
            "Bexley",
            "BEX"
        ],
        [
            "Birmingham",
            "BIR"
        ],
        [
            "Blackburn with Darwen",
            "BBD"
        ],
        [
            "Blackpool",
            "BPL"
        ],
        [
            "Blaenau Gwent",
            "BGW"
        ],
        [
            "Bolton",
            "BOL"
        ],
        [
            "Bournemouth, Christchurch and Poole",
            "BCP"
        ],
        [
            "Bracknell Forest",
            "BRC"
        ],
        [
            "Bradford",
            "BRD"
        ],
        [
            "Brent",
            "BEN"
        ],
        [
            "Bridgend",
            "BGE"
        ],
        [
            "Brighton and Hove",
            "BNH"
        ],
        [
            "Bristol, City of",
            "BST"
        ],
        [
            "Bromley",
            "BRY"
        ],
        [
            "Buckinghamshire",
            "BKM"
        ],
        [
            "Bury",
            "BUR"
        ],
        [
            "Caerphilly",
            "CAY"
        ],
        [
            "Calderdale",
            "CLD"
        ],
        [
            "Cambridgeshire",
            "CAM"
        ],
        [
            "Camden",
            "CMD"
        ],
        [
            "Cardiff",
            "CRF"
        ],
        [
            "Carmarthenshire",
            "CMN"
        ],
        [
            "Causeway Coast and Glens",
            "CCG"
        ],
        [
            "Central Bedfordshire",
            "CBF"
        ],
        [
            "Ceredigion",
            "CGN"
        ],
        [
            "Cheshire East",
            "CHE"
        ],
        [
            "Cheshire West and Chester",
            "CHW"
        ],
        [
            "Clackmannanshire",
            "CLK"
        ],
        [
            "Conwy",
            "CWY"
        ],
        [
            "Cornwall",
            "CON"
        ],
        [
            "Coventry",
            "COV"
        ],
        [
            "Croydon",
            "CRY"
        ],
        [
            "Cumbria",
            "CMA"
        ],
        [
            "Darlington",
            "DAL"
        ],
        [
            "Denbighshire",
            "DEN"
        ],
        [
            "Derby",
            "DER"
        ],
        [
            "Derbyshire",
            "DBY"
        ],
        [
            "Derry and Strabane",
            "DRS"
        ],
        [
            "Devon",
            "DEV"
        ],
        [
            "Doncaster",
            "DNC"
        ],
        [
            "Dorset",
            "DOR"
        ],
        [
            "Dudley",
            "DUD"
        ],
        [
            "Dumfries and Galloway",
            "DGY"
        ],
        [
            "Dundee City",
            "DND"
        ],
        [
            "Durham, County",
            "DUR"
        ],
        [
            "Ealing",
            "EAL"
        ],
        [
            "East Ayrshire",
            "EAY"
        ],
        [
            "East Dunbartonshire",
            "EDU"
        ],
        [
            "East Lothian",
            "ELN"
        ],
        [
            "East Renfrewshire",
            "ERW"
        ],
        [
            "East Riding of Yorkshire",
            "ERY"
        ],
        [
            "East Sussex",
            "ESX"
        ],
        [
            "Edinburgh, City of",
            "EDH"
        ],
        [
            "Eilean Siar",
            "ELS"
        ],
        [
            "Enfield",
            "ENF"
        ],
        [
            "Essex",
            "ESS"
        ],
        [
            "Falkirk",
            "FAL"
        ],
        [
            "Fermanagh and Omagh",
            "FMO"
        ],
        [
            "Fife",
            "FIF"
        ],
        [
            "Flintshire",
            "FLN"
        ],
        [
            "Gateshead",
            "GAT"
        ],
        [
            "Glasgow City",
            "GLG"
        ],
        [
            "Gloucestershire",
            "GLS"
        ],
        [
            "Greenwich",
            "GRE"
        ],
        [
            "Gwynedd",
            "GWN"
        ],
        [
            "Hackney",
            "HCK"
        ],
        [
            "Halton",
            "HAL"
        ],
        [
            "Hammersmith and Fulham",
            "HMF"
        ],
        [
            "Hampshire",
            "HAM"
        ],
        [
            "Haringey",
            "HRY"
        ],
        [
            "Harrow",
            "HRW"
        ],
        [
            "Hartlepool",
            "HPL"
        ],
        [
            "Havering",
            "HAV"
        ],
        [
            "Herefordshire",
            "HEF"
        ],
        [
            "Hertfordshire",
            "HRT"
        ],
        [
            "Highland",
            "HLD"
        ],
        [
            "Hillingdon",
            "HIL"
        ],
        [
            "Hounslow",
            "HNS"
        ],
        [
            "Inverclyde",
            "IVC"
        ],
        [
            "Isle of Anglesey",
            "AGY"
        ],
        [
            "Isle of Wight",
            "IOW"
        ],
        [
            "Isles of Scilly",
            "IOS"
        ],
        [
            "Islington",
            "ISL"
        ],
        [
            "Kensington and Chelsea",
            "KEC"
        ],
        [
            "Kent",
            "KEN"
        ],
        [
            "Kingston upon Hull",
            "KHL"
        ],
        [
            "Kingston upon Thames",
            "KTT"
        ],
        [
            "Kirklees",
            "KIR"
        ],
        [
            "Knowsley",
            "KWL"
        ],
        [
            "Lambeth",
            "LBH"
        ],
        [
            "Lancashire",
            "LAN"
        ],
        [
            "Leeds",
            "LDS"
        ],
        [
            "Leicester",
            "LCE"
        ],
        [
            "Leicestershire",
            "LEC"
        ],
        [
            "Lewisham",
            "LEW"
        ],
        [
            "Lincolnshire",
            "LIN"
        ],
        [
            "Lisburn and Castlereagh",
            "LBC"
        ],
        [
            "Liverpool",
            "LIV"
        ],
        [
            "London",
            "LND"
        ],
        [
            "Luton",
            "LUT"
        ],
        [
            "Manchester",
            "MAN"
        ],
        [
            "Medway",
            "MDW"
        ],
        [
            "Merthyr Tydfil",
            "MTY"
        ],
        [
            "Merton",
            "MRT"
        ],
        [
            "Mid and East Antrim",
            "MEA"
        ],
        [
            "Mid-Ulster",
            "MUL"
        ],
        [
            "Middlesbrough",
            "MDB"
        ],
        [
            "Midlothian",
            "MLN"
        ],
        [
            "Milton Keynes",
            "MIK"
        ],
        [
            "Monmouthshire",
            "MON"
        ],
        [
            "Moray",
            "MRY"
        ],
        [
            "Neath Port Talbot",
            "NTL"
        ],
        [
            "Newcastle upon Tyne",
            "NET"
        ],
        [
            "Newham",
            "NWM"
        ],
        [
            "Newport",
            "NWP"
        ],
        [
            "Newry, Mourne and Down",
            "NMD"
        ],
        [
            "Norfolk",
            "NFK"
        ],
        [
            "North Ayrshire",
            "NAY"
        ],
        [
            "North East Lincolnshire",
            "NEL"
        ],
        [
            "North Lanarkshire",
            "NLK"
        ],
        [
            "North Lincolnshire",
            "NLN"
        ],
        [
            "North Somerset",
            "NSM"
        ],
        [
            "North Tyneside",
            "NTY"
        ],
        [
            "North Yorkshire",
            "NYK"
        ],
        [
            "Northamptonshire",
            "NTH"
        ],
        [
            "Northumberland",
            "NBL"
        ],
        [
            "Nottingham",
            "NGM"
        ],
        [
            "Nottinghamshire",
            "NTT"
        ],
        [
            "Oldham",
            "OLD"
        ],
        [
            "Orkney Islands",
            "ORK"
        ],
        [
            "Oxfordshire",
            "OXF"
        ],
        [
            "Pembrokeshire",
            "PEM"
        ],
        [
            "Perth and Kinross",
            "PKN"
        ],
        [
            "Peterborough",
            "PTE"
        ],
        [
            "Plymouth",
            "PLY"
        ],
        [
            "Portsmouth",
            "POR"
        ],
        [
            "Powys",
            "POW"
        ],
        [
            "Reading",
            "RDG"
        ],
        [
            "Redbridge",
            "RDB"
        ],
        [
            "Redcar and Cleveland",
            "RCC"
        ],
        [
            "Renfrewshire",
            "RFW"
        ],
        [
            "Rhondda Cynon Taff",
            "RCT"
        ],
        [
            "Richmond upon Thames",
            "RIC"
        ],
        [
            "Rochdale",
            "RCH"
        ],
        [
            "Rotherham",
            "ROT"
        ],
        [
            "Rutland",
            "RUT"
        ],
        [
            "Salford",
            "SLF"
        ],
        [
            "Sandwell",
            "SAW"
        ],
        [
            "Scottish Borders",
            "SCB"
        ],
        [
            "Sefton",
            "SFT"
        ],
        [
            "Sheffield",
            "SHF"
        ],
        [
            "Shetland Islands",
            "ZET"
        ],
        [
            "Shropshire",
            "SHR"
        ],
        [
            "Slough",
            "SLG"
        ],
        [
            "Solihull",
            "SOL"
        ],
        [
            "Somerset",
            "SOM"
        ],
        [
            "South Ayrshire",
            "SAY"
        ],
        [
            "South Gloucestershire",
            "SGC"
        ],
        [
            "South Lanarkshire",
            "SLK"
        ],
        [
            "South Tyneside",
            "STY"
        ],
        [
            "Southampton",
            "STH"
        ],
        [
            "Southend-on-Sea",
            "SOS"
        ],
        [
            "Southwark",
            "SWK"
        ],
        [
            "St. Helens",
            "SHN"
        ],
        [
            "Staffordshire",
            "STS"
        ],
        [
            "Stirling",
            "STG"
        ],
        [
            "Stockport",
            "SKP"
        ],
        [
            "Stockton-on-Tees",
            "STT"
        ],
        [
            "Stoke-on-Trent",
            "STE"
        ],
        [
            "Suffolk",
            "SFK"
        ],
        [
            "Sunderland",
            "SND"
        ],
        [
            "Surrey",
            "SRY"
        ],
        [
            "Sutton",
            "STN"
        ],
        [
            "Swansea",
            "SWA"
        ],
        [
            "Swindon",
            "SWD"
        ],
        [
            "Tameside",
            "TAM"
        ],
        [
            "Telford and Wrekin",
            "TFW"
        ],
        [
            "Thurrock",
            "THR"
        ],
        [
            "Torbay",
            "TOB"
        ],
        [
            "Torfaen",
            "TOF"
        ],
        [
            "Tower Hamlets",
            "TWH"
        ],
        [
            "Trafford",
            "TRF"
        ],
        [
            "Vale of Glamorgan, The",
            "VGL"
        ],
        [
            "Wakefield",
            "WKF"
        ],
        [
            "Walsall",
            "WLL"
        ],
        [
            "Waltham Forest",
            "WFT"
        ],
        [
            "Wandsworth",
            "WND"
        ],
        [
            "Warrington",
            "WRT"
        ],
        [
            "Warwickshire",
            "WAR"
        ],
        [
            "West Berkshire",
            "WBK"
        ],
        [
            "West Dunbartonshire",
            "WDU"
        ],
        [
            "West Lothian",
            "WLN"
        ],
        [
            "West Sussex",
            "WSX"
        ],
        [
            "Westminster",
            "WSM"
        ],
        [
            "Wigan",
            "WGN"
        ],
        [
            "Wiltshire",
            "WIL"
        ],
        [
            "Windsor and Maidenhead",
            "WNM"
        ],
        [
            "Wirral",
            "WRL"
        ],
        [
            "Wokingham",
            "WOK"
        ],
        [
            "Wolverhampton",
            "WLV"
        ],
        [
            "Worcestershire",
            "WOR"
        ],
        [
            "Wrexham",
            "WRX"
        ],
        [
            "York",
            "YOR"
        ]
    ]
];
const $c8f06188fc3ad916$export$6137fb82cd5996e9 = [
    "United States",
    "US",
    [
        [
            "Alabama",
            "AL"
        ],
        [
            "Alaska",
            "AK"
        ],
        [
            "American Samoa",
            "AS"
        ],
        [
            "Arizona",
            "AZ"
        ],
        [
            "Arkansas",
            "AR"
        ],
        [
            "California",
            "CA"
        ],
        [
            "Colorado",
            "CO"
        ],
        [
            "Connecticut",
            "CT"
        ],
        [
            "Delaware",
            "DE"
        ],
        [
            "District of Columbia",
            "DC"
        ],
        [
            "Micronesia",
            "FM"
        ],
        [
            "Florida",
            "FL"
        ],
        [
            "Georgia",
            "GA"
        ],
        [
            "Guam",
            "GU"
        ],
        [
            "Hawaii",
            "HI"
        ],
        [
            "Idaho",
            "ID"
        ],
        [
            "Illinois",
            "IL"
        ],
        [
            "Indiana",
            "IN"
        ],
        [
            "Iowa",
            "IA"
        ],
        [
            "Kansas",
            "KS"
        ],
        [
            "Kentucky",
            "KY"
        ],
        [
            "Louisiana",
            "LA"
        ],
        [
            "Maine",
            "ME"
        ],
        [
            "Marshall Islands",
            "MH"
        ],
        [
            "Maryland",
            "MD"
        ],
        [
            "Massachusetts",
            "MA"
        ],
        [
            "Michigan",
            "MI"
        ],
        [
            "Minnesota",
            "MN"
        ],
        [
            "Mississippi",
            "MS"
        ],
        [
            "Missouri",
            "MO"
        ],
        [
            "Montana",
            "MT"
        ],
        [
            "Nebraska",
            "NE"
        ],
        [
            "Nevada",
            "NV"
        ],
        [
            "New Hampshire",
            "NH"
        ],
        [
            "New Jersey",
            "NJ"
        ],
        [
            "New Mexico",
            "NM"
        ],
        [
            "New York",
            "NY"
        ],
        [
            "North Carolina",
            "NC"
        ],
        [
            "North Dakota",
            "ND"
        ],
        [
            "Northern Mariana Islands",
            "MP"
        ],
        [
            "Ohio",
            "OH"
        ],
        [
            "Oklahoma",
            "OK"
        ],
        [
            "Oregon",
            "OR"
        ],
        [
            "Palau",
            "PW"
        ],
        [
            "Pennsylvania",
            "PA"
        ],
        [
            "Puerto Rico",
            "PR"
        ],
        [
            "Rhode Island",
            "RI"
        ],
        [
            "South Carolina",
            "SC"
        ],
        [
            "South Dakota",
            "SD"
        ],
        [
            "Tennessee",
            "TN"
        ],
        [
            "Texas",
            "TX"
        ],
        [
            "Utah",
            "UT"
        ],
        [
            "Vermont",
            "VT"
        ],
        [
            "Virgin Islands",
            "VI"
        ],
        [
            "Virginia",
            "VA"
        ],
        [
            "Washington",
            "WA"
        ],
        [
            "West Virginia",
            "WV"
        ],
        [
            "Wisconsin",
            "WI"
        ],
        [
            "Wyoming",
            "WY"
        ],
        [
            "Armed Forces Americas",
            "AA"
        ],
        [
            "Armed Forces Europe, Canada, Africa and Middle East",
            "AE"
        ],
        [
            "Armed Forces Pacific",
            "AP"
        ]
    ]
];
const $c8f06188fc3ad916$export$a0e1852ae1fae17b = [
    "United States Minor Outlying Islands",
    "UM",
    [
        [
            "Baker Island",
            "81"
        ],
        [
            "Howland Island",
            "84"
        ],
        [
            "Jarvis Island",
            "86"
        ],
        [
            "Johnston Atoll",
            "67"
        ],
        [
            "Kingman Reef",
            "89"
        ],
        [
            "Midway Islands",
            "71"
        ],
        [
            "Navassa Island",
            "76"
        ],
        [
            "Palmyra Atoll",
            "95"
        ],
        [
            "Wake Island",
            "79"
        ],
        [
            "Bajo Nuevo Bank",
            "BN"
        ],
        [
            "Serranilla Bank",
            "SB"
        ]
    ]
];
const $c8f06188fc3ad916$export$3f448fbd9cc8b25f = [
    "Uruguay",
    "UY",
    [
        [
            "Artigas",
            "AR"
        ],
        [
            "Canelones",
            "CA"
        ],
        [
            "Cerro Largo",
            "CL"
        ],
        [
            "Colonia",
            "CO"
        ],
        [
            "Durazno",
            "DU"
        ],
        [
            "Flores",
            "FS"
        ],
        [
            "Florida",
            "FD"
        ],
        [
            "Lavalleja",
            "LA"
        ],
        [
            "Maldonado",
            "MA"
        ],
        [
            "Montevideo",
            "MO"
        ],
        [
            "Paysand\xfa",
            "PA"
        ],
        [
            "R\xedo Negro",
            "RN"
        ],
        [
            "Rivera",
            "RV"
        ],
        [
            "Rocha",
            "RO"
        ],
        [
            "Salto",
            "SA"
        ],
        [
            "San Jos\xe9",
            "SJ"
        ],
        [
            "Soriano",
            "SO"
        ],
        [
            "Tacuaremb\xf3",
            "TA"
        ],
        [
            "Treinta y Tres",
            "TT"
        ]
    ]
];
const $c8f06188fc3ad916$export$6553e0f362fae356 = [
    "Uzbekistan",
    "UZ",
    [
        [
            "Toshkent shahri",
            "TK"
        ],
        [
            "Andijon",
            "AN"
        ],
        [
            "Buxoro",
            "BU"
        ],
        [
            "Farg\u2018ona",
            "FA"
        ],
        [
            "Jizzax",
            "JI"
        ],
        [
            "Namangan",
            "NG"
        ],
        [
            "Navoiy",
            "NW"
        ],
        [
            "Qashqadaryo (Qarshi)",
            "QA"
        ],
        [
            "Samarqand",
            "SA"
        ],
        [
            "Sirdaryo (Guliston)",
            "SI"
        ],
        [
            "Surxondaryo (Termiz)",
            "SU"
        ],
        [
            "Toshkent wiloyati",
            "TO"
        ],
        [
            "Xorazm (Urganch)",
            "XO"
        ],
        [
            "Qoraqalpog\u2018iston Respublikasi (Nukus)",
            "QR"
        ]
    ]
];
const $c8f06188fc3ad916$export$e4fcd53a919210fd = [
    "Vanuatu",
    "VU",
    [
        [
            "Malampa",
            "MAP"
        ],
        [
            "P\xe9nama",
            "PAM"
        ],
        [
            "Sanma",
            "SAM"
        ],
        [
            "Sh\xe9fa",
            "SEE"
        ],
        [
            "Taf\xe9a",
            "TAE"
        ],
        [
            "Torba",
            "TOB"
        ]
    ]
];
const $c8f06188fc3ad916$export$d7d2699f2b01bb80 = [
    "Venezuela, Bolivarian Republic of",
    "VE",
    [
        [
            "Dependencias Federales",
            "W"
        ],
        [
            "Distrito Federal",
            "A"
        ],
        [
            "Amazonas",
            "Z"
        ],
        [
            "Anzo\xe1tegui",
            "B"
        ],
        [
            "Apure",
            "C"
        ],
        [
            "Aragua",
            "D"
        ],
        [
            "Barinas",
            "E"
        ],
        [
            "Bol\xedvar",
            "F"
        ],
        [
            "Carabobo",
            "G"
        ],
        [
            "Cojedes",
            "H"
        ],
        [
            "Delta Amacuro",
            "Y"
        ],
        [
            "Falc\xf3n",
            "I"
        ],
        [
            "Gu\xe1rico",
            "J"
        ],
        [
            "Lara",
            "K"
        ],
        [
            "M\xe9rida",
            "L"
        ],
        [
            "Miranda",
            "M"
        ],
        [
            "Monagas",
            "N"
        ],
        [
            "Nueva Esparta",
            "O"
        ],
        [
            "Portuguesa",
            "P"
        ],
        [
            "Sucre",
            "R"
        ],
        [
            "T\xe1chira",
            "S"
        ],
        [
            "Trujillo",
            "T"
        ],
        [
            "Vargas",
            "X"
        ],
        [
            "Yaracuy",
            "U"
        ],
        [
            "Zulia",
            "V"
        ]
    ]
];
const $c8f06188fc3ad916$export$4ef9166b5b9f8bef = [
    "Vietnam",
    "VN",
    [
        [
            "An Giang",
            "44"
        ],
        [
            "B\xe0 R\u1ECBa - V\u0169ng T\xe0u",
            "43"
        ],
        [
            "B\xecnh D\u01B0\u01A1ng",
            "57"
        ],
        [
            "B\xecnh Ph\u01B0\u1EDBc",
            "58"
        ],
        [
            "B\xecnh \u0110\u1ECBnh",
            "31"
        ],
        [
            "B\xecnh Thu\u1EADn",
            "40"
        ],
        [
            "B\u1EA1c Li\xeau",
            "55"
        ],
        [
            "B\u1EAFc Giang",
            "54"
        ],
        [
            "B\u1EAFc K\u1EA1n",
            "53"
        ],
        [
            "B\u1EAFc Ninh",
            "56"
        ],
        [
            "B\u1EBFn Tre",
            "50"
        ],
        [
            "Cao B\u1EB1ng",
            "04"
        ],
        [
            "C\xe0 Mau",
            "59"
        ],
        [
            "\u0110\u1EAFk L\u1EAFk",
            "33"
        ],
        [
            "\u0110\u1EAFk N\xf4ng",
            "72"
        ],
        [
            "\u0110i\u1EC7n Bi\xean",
            "71"
        ],
        [
            "\u0110\u1ED3ng Nai",
            "39"
        ],
        [
            "\u0110\u1ED3ng Th\xe1p",
            "45"
        ],
        [
            "Gia Lai",
            "30"
        ],
        [
            "H\xe0 Giang",
            "03"
        ],
        [
            "H\xe0 Nam",
            "63"
        ],
        [
            "H\xe0 T\xe2y",
            "15"
        ],
        [
            "H\xe0 T\u0129nh",
            "23"
        ],
        [
            "H\u1EA3i D\u01B0\u01A1ng",
            "61"
        ],
        [
            "H\u1EADu Giang",
            "73"
        ],
        [
            "H\xf2a B\xecnh",
            "14"
        ],
        [
            "H\u01B0ng Y\xean",
            "66"
        ],
        [
            "Kh\xe1nh H\xf2a",
            "34"
        ],
        [
            "Ki\xean Giang",
            "47"
        ],
        [
            "Kon Tum",
            "28"
        ],
        [
            "Lai Ch\xe2u",
            "01"
        ],
        [
            "L\xe2m \u0110\u1ED3ng",
            "35"
        ],
        [
            "L\u1EA1ng S\u01A1n",
            "09"
        ],
        [
            "L\xe0o Cai",
            "02"
        ],
        [
            "Long An",
            "41"
        ],
        [
            "Nam \u0110\u1ECBnh",
            "67"
        ],
        [
            "Ngh\u1EC7 An",
            "22"
        ],
        [
            "Ninh B\xecnh",
            "18"
        ],
        [
            "Ninh Thu\u1EADn",
            "36"
        ],
        [
            "Ph\xfa Th\u1ECD",
            "68"
        ],
        [
            "Ph\xfa Y\xean",
            "32"
        ],
        [
            "Qu\u1EA3ng B\xecnh",
            "24"
        ],
        [
            "Qu\u1EA3ng Nam",
            "27"
        ],
        [
            "Qu\u1EA3ng Ng\xe3i",
            "29"
        ],
        [
            "Qu\u1EA3ng Ninh",
            "13"
        ],
        [
            "Qu\u1EA3ng Tr\u1ECB",
            "25"
        ],
        [
            "S\xf3c Tr\u0103ng",
            "52"
        ],
        [
            "S\u01A1n La",
            "05"
        ],
        [
            "T\xe2y Ninh",
            "37"
        ],
        [
            "Th\xe1i B\xecnh",
            "20"
        ],
        [
            "Th\xe1i Nguy\xean",
            "69"
        ],
        [
            "Thanh H\xf3a",
            "21"
        ],
        [
            "Th\u1EEBa Thi\xean\u2013Hu\u1EBF",
            "26"
        ],
        [
            "Ti\u1EC1n Giang",
            "46"
        ],
        [
            "Tr\xe0 Vinh",
            "51"
        ],
        [
            "Tuy\xean Quang",
            "07"
        ],
        [
            "V\u0129nh Long",
            "49"
        ],
        [
            "V\u0129nh Ph\xfac",
            "70"
        ],
        [
            "Y\xean B\xe1i",
            "06"
        ],
        [
            "C\u1EA7n Th\u01A1",
            "CT"
        ],
        [
            "\u0110\xe0 N\u1EB5ng",
            "DN"
        ],
        [
            "H\xe0 N\u1ED9i",
            "HN"
        ],
        [
            "H\u1EA3i Ph\xf2ng",
            "HP"
        ],
        [
            "H\u1ED3 Ch\xed Minh (S\xe0i G\xf2n)",
            "SG"
        ]
    ]
];
const $c8f06188fc3ad916$export$42769a1039364fc6 = [
    "Virgin Islands, British",
    "VG",
    [
        [
            "Anegada",
            "ANG"
        ],
        [
            "Jost Van Dyke",
            "JVD"
        ],
        [
            "Tortola",
            "TTA"
        ],
        [
            "Virgin Gorda",
            "VGD"
        ]
    ]
];
const $c8f06188fc3ad916$export$ae144c30ed7463e6 = [
    "Virgin Islands, U.S.",
    "VI",
    [
        [
            "St. Thomas",
            "STH"
        ],
        [
            "St. John",
            "SJO"
        ],
        [
            "St. Croix",
            "SCR"
        ]
    ]
];
const $c8f06188fc3ad916$export$2791da67db7afdb6 = [
    "Wallis and Futuna",
    "WF",
    [
        [
            "Alo",
            "ALO"
        ],
        [
            "Sigave",
            "SIG"
        ],
        [
            "Wallis",
            "WAL"
        ]
    ]
];
const $c8f06188fc3ad916$export$8e048a19e03780a2 = [
    "Western Sahara",
    "EH",
    [
        [
            "Es Smara",
            "ESM"
        ],
        [
            "Boujdour",
            "BOD"
        ],
        [
            "La\xe2youne",
            "LAA"
        ],
        [
            "Aousserd",
            "AOU"
        ],
        [
            "Oued ed Dahab",
            "OUD"
        ]
    ]
];
const $c8f06188fc3ad916$export$5c4a0ca5352789e5 = [
    "Yemen",
    "YE",
    [
        [
            "Aby\u0101n",
            "AB"
        ],
        [
            "'Adan",
            "AD"
        ],
        [
            "A\u1E11 \u1E10\u0101li'",
            "DA"
        ],
        [
            "Al Bay\u1E11\u0101'",
            "BA"
        ],
        [
            "Al \u1E28udaydah",
            "HU"
        ],
        [
            "Al Jawf",
            "JA"
        ],
        [
            "Al Mahrah",
            "MR"
        ],
        [
            "Al Ma\u1E29w\u012Bt",
            "MW"
        ],
        [
            "'Amr\u0101n",
            "AM"
        ],
        [
            "Dham\u0101r",
            "DH"
        ],
        [
            "\u1E28a\u1E11ramawt",
            "HD"
        ],
        [
            "\u1E28ajjah",
            "HJ"
        ],
        [
            "Ibb",
            "IB"
        ],
        [
            "La\u1E29ij",
            "LA"
        ],
        [
            "Ma'rib",
            "MA"
        ],
        [
            "Raymah",
            "RA"
        ],
        [
            "\u015E\u0101\u2018dah",
            "SD"
        ],
        [
            "\u015Ean\u2018\u0101'",
            "SN"
        ],
        [
            "Shabwah",
            "SH"
        ],
        [
            "T\u0101\u2018izz",
            "TA"
        ]
    ]
];
const $c8f06188fc3ad916$export$8b0f08115411339f = [
    "Zambia",
    "ZM",
    [
        [
            "Central",
            "02"
        ],
        [
            "Copperbelt",
            "08"
        ],
        [
            "Eastern",
            "03"
        ],
        [
            "Luapula",
            "04"
        ],
        [
            "Lusaka",
            "09"
        ],
        [
            "Muchinga",
            "10"
        ],
        [
            "Northern",
            "05"
        ],
        [
            "North-Western",
            "06"
        ],
        [
            "Southern",
            "07"
        ],
        [
            "Western",
            "01"
        ]
    ]
];
const $c8f06188fc3ad916$export$b2fd9c01d360241f = [
    "Zimbabwe",
    "ZW",
    [
        [
            "Bulawayo",
            "BU"
        ],
        [
            "Harare",
            "HA"
        ],
        [
            "Manicaland",
            "MA"
        ],
        [
            "Mashonaland Central",
            "MC"
        ],
        [
            "Mashonaland East",
            "ME"
        ],
        [
            "Mashonaland West",
            "MW"
        ],
        [
            "Masvingo",
            "MV"
        ],
        [
            "Matabeleland North",
            "MN"
        ],
        [
            "Matabeleland South",
            "MS"
        ],
        [
            "Midlands",
            "MI"
        ]
    ]
];
const $c8f06188fc3ad916$export$234e4f7526f79ef2 = [
    $c8f06188fc3ad916$export$515692adc069839f,
    $c8f06188fc3ad916$export$f5cd1d288a5591fb,
    $c8f06188fc3ad916$export$1bb1140fe1358b00,
    $c8f06188fc3ad916$export$d2309a4fc782a0d1,
    $c8f06188fc3ad916$export$33f07343a4b8be1f,
    $c8f06188fc3ad916$export$132ea4ffd82bf2b2,
    $c8f06188fc3ad916$export$98cc8105f49bb278,
    $c8f06188fc3ad916$export$d710c5f50fc7496a,
    $c8f06188fc3ad916$export$123513653fa883e4,
    $c8f06188fc3ad916$export$9b1a14e161c718eb,
    $c8f06188fc3ad916$export$1cd25c0dace0921a,
    $c8f06188fc3ad916$export$1507e1869e034170,
    $c8f06188fc3ad916$export$d170d5872abbd45,
    $c8f06188fc3ad916$export$24f205cbfb89b8fc,
    $c8f06188fc3ad916$export$537de78b98ba1ef0,
    $c8f06188fc3ad916$export$16cde7da05f651a,
    $c8f06188fc3ad916$export$66ea4a98fa009686,
    $c8f06188fc3ad916$export$873be2d0c4c0f90f,
    $c8f06188fc3ad916$export$2672079d1ac1dedf,
    $c8f06188fc3ad916$export$921068d8846a1559,
    $c8f06188fc3ad916$export$558af6901b7fc79a,
    $c8f06188fc3ad916$export$69784246352913ed,
    $c8f06188fc3ad916$export$8af59566cb38fe85,
    $c8f06188fc3ad916$export$289e628e47fc68d4,
    $c8f06188fc3ad916$export$f063c90a7fd94f53,
    $c8f06188fc3ad916$export$433b53d451a98e6d,
    $c8f06188fc3ad916$export$cd6527c992e4b6fe,
    $c8f06188fc3ad916$export$2ca204c58a1fc922,
    $c8f06188fc3ad916$export$a73c4d14459b698d,
    $c8f06188fc3ad916$export$cd7b90d76addb66a,
    $c8f06188fc3ad916$export$8ba1594c72a88684,
    $c8f06188fc3ad916$export$b3e0c086157e0a90,
    $c8f06188fc3ad916$export$8f8422ac5947a789,
    $c8f06188fc3ad916$export$ed16643e9b9e3dfe,
    $c8f06188fc3ad916$export$7ecc97c3ec9172d0,
    $c8f06188fc3ad916$export$5d7d56d6166de861,
    $c8f06188fc3ad916$export$2601bd2ab73f6dbe,
    $c8f06188fc3ad916$export$96381358fb12b492,
    $c8f06188fc3ad916$export$dcd191669c0a595f,
    $c8f06188fc3ad916$export$8de6180416dff1fc,
    $c8f06188fc3ad916$export$9c7a4b602f1ee953,
    $c8f06188fc3ad916$export$ea257f329676e0aa,
    $c8f06188fc3ad916$export$ba26f2d80491fb47,
    $c8f06188fc3ad916$export$9cf5b401f969f5e3,
    $c8f06188fc3ad916$export$9bf3043cb7503aa1,
    $c8f06188fc3ad916$export$f175668af5171efd,
    $c8f06188fc3ad916$export$ef748afa94c5c5f9,
    $c8f06188fc3ad916$export$183b2a0874e6e919,
    $c8f06188fc3ad916$export$423e5ab65bdedcb8,
    $c8f06188fc3ad916$export$7ca86d88f982585b,
    $c8f06188fc3ad916$export$9e8da9070f3c2e68,
    $c8f06188fc3ad916$export$6ede307faf7aaec4,
    $c8f06188fc3ad916$export$2779adff9720d9c9,
    $c8f06188fc3ad916$export$de92be486109a1df,
    $c8f06188fc3ad916$export$ddcf9efc80efb978,
    $c8f06188fc3ad916$export$41dbabafe943a3bc,
    $c8f06188fc3ad916$export$6f478fc577ffffe3,
    $c8f06188fc3ad916$export$640171019d58eb6d,
    $c8f06188fc3ad916$export$e5e7583d5d9c5f7b,
    $c8f06188fc3ad916$export$3aa7db55ae20a642,
    $c8f06188fc3ad916$export$861a3271cad515fc,
    $c8f06188fc3ad916$export$b116121769fff50f,
    $c8f06188fc3ad916$export$c63caaa7a05b64da,
    $c8f06188fc3ad916$export$fe81c0b6cf107daf,
    $c8f06188fc3ad916$export$129fe12d32abc311,
    $c8f06188fc3ad916$export$e107e11ec3489258,
    $c8f06188fc3ad916$export$8fc936c6ebd916b3,
    $c8f06188fc3ad916$export$64532cc081f88b3a,
    $c8f06188fc3ad916$export$20e28a5cfb7c13df,
    $c8f06188fc3ad916$export$3f443bcc5237c742,
    $c8f06188fc3ad916$export$404386694049c788,
    $c8f06188fc3ad916$export$58f4e3559034e3ed,
    $c8f06188fc3ad916$export$3117889032a11ab0,
    $c8f06188fc3ad916$export$4cd493ed69e3bc18,
    $c8f06188fc3ad916$export$b742dc37108d5cac,
    $c8f06188fc3ad916$export$b0bfe88d8be86eef,
    $c8f06188fc3ad916$export$a1c692af90f0ad93,
    $c8f06188fc3ad916$export$7d19ebf018caa9aa,
    $c8f06188fc3ad916$export$4014e91f2965d3df,
    $c8f06188fc3ad916$export$2c816677949efbbf,
    $c8f06188fc3ad916$export$af02b8e3ecf08df4,
    $c8f06188fc3ad916$export$64f1adb8dced2c27,
    $c8f06188fc3ad916$export$b2bfc53cef5629f5,
    $c8f06188fc3ad916$export$2063236980199869,
    $c8f06188fc3ad916$export$b3b059666b470a4,
    $c8f06188fc3ad916$export$be3bb2d6fb94aa6,
    $c8f06188fc3ad916$export$bad2a840ccda93b6,
    $c8f06188fc3ad916$export$44132903afebf574,
    $c8f06188fc3ad916$export$a1e9daa76fd80d91,
    $c8f06188fc3ad916$export$875a05f1afdc3a63,
    $c8f06188fc3ad916$export$b023c82b48e70453,
    $c8f06188fc3ad916$export$ffd553dab4f92f72,
    $c8f06188fc3ad916$export$49b768d2cda4fc68,
    $c8f06188fc3ad916$export$4f7b2a18b14c6e6,
    $c8f06188fc3ad916$export$f433acc20da515b9,
    $c8f06188fc3ad916$export$3927bce5ead7457e,
    $c8f06188fc3ad916$export$e8ae668e70e7a813,
    $c8f06188fc3ad916$export$8f976c058e984810,
    $c8f06188fc3ad916$export$d654914ee99e1b51,
    $c8f06188fc3ad916$export$7bf8e436292b0d9,
    $c8f06188fc3ad916$export$2cba20fb7b4c6fda,
    $c8f06188fc3ad916$export$bfe27467c1de9413,
    $c8f06188fc3ad916$export$70824c8942178d60,
    $c8f06188fc3ad916$export$8be180ec26319f9f,
    $c8f06188fc3ad916$export$35f3e3f7e3ce71e0,
    $c8f06188fc3ad916$export$776a9becd139230f,
    $c8f06188fc3ad916$export$5056f4df3c1a040a,
    $c8f06188fc3ad916$export$5e0fd3f816252990,
    $c8f06188fc3ad916$export$747f5b589ac90db,
    $c8f06188fc3ad916$export$c8c4756768edc1be,
    $c8f06188fc3ad916$export$62925b2b1d8826f,
    $c8f06188fc3ad916$export$4165087edc6149ea,
    $c8f06188fc3ad916$export$7300d7e65520d9c0,
    $c8f06188fc3ad916$export$4ff8ba3b6e78910e,
    $c8f06188fc3ad916$export$45edc2c6b51c02b3,
    $c8f06188fc3ad916$export$ebf06250eda1662e,
    $c8f06188fc3ad916$export$8aa7bcd4299a59b9,
    $c8f06188fc3ad916$export$171643e72dc5e91,
    $c8f06188fc3ad916$export$ced591d2396bbc3f,
    $c8f06188fc3ad916$export$ba5d28d969e41cd5,
    $c8f06188fc3ad916$export$867391011d376267,
    $c8f06188fc3ad916$export$32f37961c13d8178,
    $c8f06188fc3ad916$export$64f943d6c6d62030,
    $c8f06188fc3ad916$export$feea9fafc15a0118,
    $c8f06188fc3ad916$export$1dd3e96947fb44fc,
    $c8f06188fc3ad916$export$c6944423ed371873,
    $c8f06188fc3ad916$export$9e0d336de5ae0eb3,
    $c8f06188fc3ad916$export$4eb7334fca20385f,
    $c8f06188fc3ad916$export$2e3013aac067a692,
    $c8f06188fc3ad916$export$7158f0ceb70f54c7,
    $c8f06188fc3ad916$export$b6a2dd8a7c2d6cd5,
    $c8f06188fc3ad916$export$511fbc18fa6ca984,
    $c8f06188fc3ad916$export$9391ff7d7f7d79ce,
    $c8f06188fc3ad916$export$d7c1ae0cf4ef5274,
    $c8f06188fc3ad916$export$a3772f6eb527275b,
    $c8f06188fc3ad916$export$655dc88003efaac0,
    $c8f06188fc3ad916$export$20138591ba7d4d60,
    $c8f06188fc3ad916$export$670dad092b145ea,
    $c8f06188fc3ad916$export$b900a375df2ae552,
    $c8f06188fc3ad916$export$61a81a4b59098e0c,
    $c8f06188fc3ad916$export$451b471c9c9066b,
    $c8f06188fc3ad916$export$c4e38e98e3fb5f60,
    $c8f06188fc3ad916$export$c5764e4399dad848,
    $c8f06188fc3ad916$export$8c2e794969bbe829,
    $c8f06188fc3ad916$export$80b36494c451f15f,
    $c8f06188fc3ad916$export$ae39d226e90e08ef,
    $c8f06188fc3ad916$export$3c37c3bdb860ae1e,
    $c8f06188fc3ad916$export$cd68417dc2ec295d,
    $c8f06188fc3ad916$export$30e7c6589c527eef,
    $c8f06188fc3ad916$export$4898541b722d275d,
    $c8f06188fc3ad916$export$71ad59f2e432cfe8,
    $c8f06188fc3ad916$export$d88940c21edc1e8e,
    $c8f06188fc3ad916$export$b5030f3cedb7f384,
    $c8f06188fc3ad916$export$eefdfd8a735ff143,
    $c8f06188fc3ad916$export$dbd1925f4fe9ec65,
    $c8f06188fc3ad916$export$8885480fb36cb8cc,
    $c8f06188fc3ad916$export$575bf2af220888ee,
    $c8f06188fc3ad916$export$e51d3c675bb0140d,
    $c8f06188fc3ad916$export$fbcebdb931d67ac9,
    $c8f06188fc3ad916$export$b6db8d689596ccb0,
    $c8f06188fc3ad916$export$2128ddd8b6e5cc05,
    $c8f06188fc3ad916$export$8719acbfb72c829,
    $c8f06188fc3ad916$export$d9501190a8cd7a46,
    $c8f06188fc3ad916$export$8227ca023eb0daaa,
    $c8f06188fc3ad916$export$ebe65a9e9fde641f,
    $c8f06188fc3ad916$export$15b7d6cdd29b06a0,
    $c8f06188fc3ad916$export$c01351c0af048e39,
    $c8f06188fc3ad916$export$1ed389bd9cb529,
    $c8f06188fc3ad916$export$73910688e185534c,
    $c8f06188fc3ad916$export$5f5211c171c1b47a,
    $c8f06188fc3ad916$export$5adddb0645f34b2,
    $c8f06188fc3ad916$export$ff7e3d480d313da2,
    $c8f06188fc3ad916$export$c56943b7b8ffea21,
    $c8f06188fc3ad916$export$21b6e0fb60b525ae,
    $c8f06188fc3ad916$export$d5e55eb9565ea8d5,
    $c8f06188fc3ad916$export$38ea63fabb2c685f,
    $c8f06188fc3ad916$export$6bc8c38c416ebf89,
    $c8f06188fc3ad916$export$9e95f02561f2d9f9,
    $c8f06188fc3ad916$export$3961bdb9130b90e7,
    $c8f06188fc3ad916$export$af5f8d68aad3cd3a,
    $c8f06188fc3ad916$export$a7078eadaecd4b6f,
    $c8f06188fc3ad916$export$ded96516917cab2a,
    $c8f06188fc3ad916$export$993ec495e78d530d,
    $c8f06188fc3ad916$export$6c2517b5e52f01cc,
    $c8f06188fc3ad916$export$ef5ca6a08aac8ca5,
    $c8f06188fc3ad916$export$b54e584898971a5,
    $c8f06188fc3ad916$export$c713cf928ffb5e8e,
    $c8f06188fc3ad916$export$fd8f06eb7ce62883,
    $c8f06188fc3ad916$export$3cb73e0e841fe17f,
    $c8f06188fc3ad916$export$33916af50bbab5f5,
    $c8f06188fc3ad916$export$164607a37e7daeba,
    $c8f06188fc3ad916$export$c3ea4fdfa4d8ecb7,
    $c8f06188fc3ad916$export$911baa0677ac404c,
    $c8f06188fc3ad916$export$59096964bd9627ef,
    $c8f06188fc3ad916$export$80980ed6b6f31397,
    $c8f06188fc3ad916$export$da51c6332ad11d7b,
    $c8f06188fc3ad916$export$b70f9dd36a734be4,
    $c8f06188fc3ad916$export$e9d8d46fbf5f29f6,
    $c8f06188fc3ad916$export$f49cccbff6374af4,
    $c8f06188fc3ad916$export$b49d6918df199090,
    $c8f06188fc3ad916$export$bea437c40441867d,
    $c8f06188fc3ad916$export$b4f896bb97547f66,
    $c8f06188fc3ad916$export$5f584391ee0d99b4,
    $c8f06188fc3ad916$export$e6702cab675b095,
    $c8f06188fc3ad916$export$279f8048cbf05e80,
    $c8f06188fc3ad916$export$f6311706676f39f2,
    $c8f06188fc3ad916$export$b2eccbdcd109dde0,
    $c8f06188fc3ad916$export$f7fbe7cb90eabcb4,
    $c8f06188fc3ad916$export$8cda4cf3f4deb8c2,
    $c8f06188fc3ad916$export$a723e6e41cced9bd,
    $c8f06188fc3ad916$export$782aca1f2c103f6b,
    $c8f06188fc3ad916$export$5b088def975a652b,
    $c8f06188fc3ad916$export$13acf42283a26926,
    $c8f06188fc3ad916$export$988c8b3cfeed3531,
    $c8f06188fc3ad916$export$88d2e60d4be28663,
    $c8f06188fc3ad916$export$31ff2235b44019b8,
    $c8f06188fc3ad916$export$2e8caadc521d7cbb,
    $c8f06188fc3ad916$export$1d1fd77441e66de6,
    $c8f06188fc3ad916$export$f5448d52a2727e70,
    $c8f06188fc3ad916$export$786aa6dc686c7fa2,
    $c8f06188fc3ad916$export$2b39a3648955dd09,
    $c8f06188fc3ad916$export$28666a74ae2b9cff,
    $c8f06188fc3ad916$export$3909ee2d70cce411,
    $c8f06188fc3ad916$export$73184284939cbbe8,
    $c8f06188fc3ad916$export$ee525e60afffec7b,
    $c8f06188fc3ad916$export$c506431d6b27243b,
    $c8f06188fc3ad916$export$82039c5ab5b44a72,
    $c8f06188fc3ad916$export$5582bd7183a5e873,
    $c8f06188fc3ad916$export$e3227e6e5fca8775,
    $c8f06188fc3ad916$export$bf91931db7b40921,
    $c8f06188fc3ad916$export$9e799ed47e538f9d,
    $c8f06188fc3ad916$export$c5b3cc9fdc52ea1d,
    $c8f06188fc3ad916$export$4b88e746e0f81154,
    $c8f06188fc3ad916$export$2b2c8e343c91a153,
    $c8f06188fc3ad916$export$5c1daad85ece4f0d,
    $c8f06188fc3ad916$export$6137fb82cd5996e9,
    $c8f06188fc3ad916$export$a0e1852ae1fae17b,
    $c8f06188fc3ad916$export$3f448fbd9cc8b25f,
    $c8f06188fc3ad916$export$6553e0f362fae356,
    $c8f06188fc3ad916$export$e4fcd53a919210fd,
    $c8f06188fc3ad916$export$d7d2699f2b01bb80,
    $c8f06188fc3ad916$export$4ef9166b5b9f8bef,
    $c8f06188fc3ad916$export$42769a1039364fc6,
    $c8f06188fc3ad916$export$ae144c30ed7463e6,
    $c8f06188fc3ad916$export$2791da67db7afdb6,
    $c8f06188fc3ad916$export$8e048a19e03780a2,
    $c8f06188fc3ad916$export$5c4a0ca5352789e5,
    $c8f06188fc3ad916$export$8b0f08115411339f,
    $c8f06188fc3ad916$export$b2fd9c01d360241f
];
const $c8f06188fc3ad916$export$7a8c3fa4a24a2370 = [
    [
        "Afghanistan",
        "AF"
    ],
    [
        "\xc5land Islands",
        "AX"
    ],
    [
        "Albania",
        "AL"
    ],
    [
        "Algeria",
        "DZ"
    ],
    [
        "American Samoa",
        "AS"
    ],
    [
        "Andorra",
        "AD"
    ],
    [
        "Angola",
        "AO"
    ],
    [
        "Anguilla",
        "AI"
    ],
    [
        "Antarctica",
        "AQ"
    ],
    [
        "Antigua and Barbuda",
        "AG"
    ],
    [
        "Argentina",
        "AR"
    ],
    [
        "Armenia",
        "AM"
    ],
    [
        "Aruba",
        "AW"
    ],
    [
        "Australia",
        "AU"
    ],
    [
        "Austria",
        "AT"
    ],
    [
        "Azerbaijan",
        "AZ"
    ],
    [
        "Bahamas",
        "BS"
    ],
    [
        "Bahrain",
        "BH"
    ],
    [
        "Bangladesh",
        "BD"
    ],
    [
        "Barbados",
        "BB"
    ],
    [
        "Belarus",
        "BY"
    ],
    [
        "Belgium",
        "BE"
    ],
    [
        "Belize",
        "BZ"
    ],
    [
        "Benin",
        "BJ"
    ],
    [
        "Bermuda",
        "BM"
    ],
    [
        "Bhutan",
        "BT"
    ],
    [
        "Bolivia",
        "BO"
    ],
    [
        "Bonaire, Sint Eustatius and Saba",
        "BQ"
    ],
    [
        "Bosnia and Herzegovina",
        "BA"
    ],
    [
        "Botswana",
        "BW"
    ],
    [
        "Bouvet Island",
        "BV"
    ],
    [
        "Brazil",
        "BR"
    ],
    [
        "British Indian Ocean Territory",
        "IO"
    ],
    [
        "Brunei Darussalam",
        "BN"
    ],
    [
        "Bulgaria",
        "BG"
    ],
    [
        "Burkina Faso",
        "BF"
    ],
    [
        "Burundi",
        "BI"
    ],
    [
        "Cambodia",
        "KH"
    ],
    [
        "Cameroon",
        "CM"
    ],
    [
        "Canada",
        "CA"
    ],
    [
        "Cape Verde",
        "CV"
    ],
    [
        "Cayman Islands",
        "KY"
    ],
    [
        "Central African Republic",
        "CF"
    ],
    [
        "Chad",
        "TD"
    ],
    [
        "Chile",
        "CL"
    ],
    [
        "China",
        "CN"
    ],
    [
        "Christmas Island",
        "CX"
    ],
    [
        "Cocos (Keeling) Islands",
        "CC"
    ],
    [
        "Colombia",
        "CO"
    ],
    [
        "Comoros",
        "KM"
    ],
    [
        "Congo, Republic of the (Brazzaville)",
        "CG"
    ],
    [
        "Congo, the Democratic Republic of the (Kinshasa)",
        "CD"
    ],
    [
        "Cook Islands",
        "CK"
    ],
    [
        "Costa Rica",
        "CR"
    ],
    [
        "C\xf4te d'Ivoire, Republic of",
        "CI"
    ],
    [
        "Croatia",
        "HR"
    ],
    [
        "Cuba",
        "CU"
    ],
    [
        "Cura\xe7ao",
        "CW"
    ],
    [
        "Cyprus",
        "CY"
    ],
    [
        "Czech Republic",
        "CZ"
    ],
    [
        "Denmark",
        "DK"
    ],
    [
        "Djibouti",
        "DJ"
    ],
    [
        "Dominica",
        "DM"
    ],
    [
        "Dominican Republic",
        "DO"
    ],
    [
        "Ecuador",
        "EC"
    ],
    [
        "Egypt",
        "EG"
    ],
    [
        "El Salvador",
        "SV"
    ],
    [
        "Equatorial Guinea",
        "GQ"
    ],
    [
        "Eritrea",
        "ER"
    ],
    [
        "Estonia",
        "EE"
    ],
    [
        "Ethiopia",
        "ET"
    ],
    [
        "Falkland Islands (Islas Malvinas)",
        "FK"
    ],
    [
        "Faroe Islands",
        "FO"
    ],
    [
        "Fiji",
        "FJ"
    ],
    [
        "Finland",
        "FI"
    ],
    [
        "France",
        "FR"
    ],
    [
        "French Guiana",
        "GF"
    ],
    [
        "French Polynesia",
        "PF"
    ],
    [
        "French Southern and Antarctic Lands",
        "TF"
    ],
    [
        "Gabon",
        "GA"
    ],
    [
        "Gambia, The",
        "GM"
    ],
    [
        "Georgia",
        "GE"
    ],
    [
        "Germany",
        "DE"
    ],
    [
        "Ghana",
        "GH"
    ],
    [
        "Gibraltar",
        "GI"
    ],
    [
        "Greece",
        "GR"
    ],
    [
        "Greenland",
        "GL"
    ],
    [
        "Grenada",
        "GD"
    ],
    [
        "Guadeloupe",
        "GP"
    ],
    [
        "Guam",
        "GU"
    ],
    [
        "Guatemala",
        "GT"
    ],
    [
        "Guernsey",
        "GG"
    ],
    [
        "Guinea",
        "GN"
    ],
    [
        "Guinea-Bissau",
        "GW"
    ],
    [
        "Guyana",
        "GY"
    ],
    [
        "Haiti",
        "HT"
    ],
    [
        "Heard Island and McDonald Islands",
        "HM"
    ],
    [
        "Holy See (Vatican City)",
        "VA"
    ],
    [
        "Honduras",
        "HN"
    ],
    [
        "Hong Kong",
        "HK"
    ],
    [
        "Hungary",
        "HU"
    ],
    [
        "Iceland",
        "IS"
    ],
    [
        "India",
        "IN"
    ],
    [
        "Indonesia",
        "ID"
    ],
    [
        "Iran, Islamic Republic of",
        "IR"
    ],
    [
        "Iraq",
        "IQ"
    ],
    [
        "Ireland",
        "IE"
    ],
    [
        "Isle of Man",
        "IM"
    ],
    [
        "Israel",
        "IL"
    ],
    [
        "Italy",
        "IT"
    ],
    [
        "Jamaica",
        "JM"
    ],
    [
        "Japan",
        "JP"
    ],
    [
        "Jersey",
        "JE"
    ],
    [
        "Jordan",
        "JO"
    ],
    [
        "Kazakhstan",
        "KZ"
    ],
    [
        "Kenya",
        "KE"
    ],
    [
        "Kiribati",
        "KI"
    ],
    [
        "Korea, Democratic People's Republic of",
        "KP"
    ],
    [
        "Korea, Republic of",
        "KR"
    ],
    [
        "Kosovo",
        "XK"
    ],
    [
        "Kuwait",
        "KW"
    ],
    [
        "Kyrgyzstan",
        "KG"
    ],
    [
        "Laos",
        "LA"
    ],
    [
        "Latvia",
        "LV"
    ],
    [
        "Lebanon",
        "LB"
    ],
    [
        "Lesotho",
        "LS"
    ],
    [
        "Liberia",
        "LR"
    ],
    [
        "Libya",
        "LY"
    ],
    [
        "Liechtenstein",
        "LI"
    ],
    [
        "Lithuania",
        "LT"
    ],
    [
        "Luxembourg",
        "LU"
    ],
    [
        "Macao",
        "MO"
    ],
    [
        "Macedonia, Republic of",
        "MK"
    ],
    [
        "Madagascar",
        "MG"
    ],
    [
        "Malawi",
        "MW"
    ],
    [
        "Malaysia",
        "MY"
    ],
    [
        "Maldives",
        "MV"
    ],
    [
        "Mali",
        "ML"
    ],
    [
        "Malta",
        "MT"
    ],
    [
        "Marshall Islands",
        "MH"
    ],
    [
        "Martinique",
        "MQ"
    ],
    [
        "Mauritania",
        "MR"
    ],
    [
        "Mauritius",
        "MU"
    ],
    [
        "Mayotte",
        "YT"
    ],
    [
        "Mexico",
        "MX"
    ],
    [
        "Micronesia, Federated States of",
        "FM"
    ],
    [
        "Moldova",
        "MD"
    ],
    [
        "Monaco",
        "MC"
    ],
    [
        "Mongolia",
        "MN"
    ],
    [
        "Montenegro",
        "ME"
    ],
    [
        "Montserrat",
        "MS"
    ],
    [
        "Morocco",
        "MA"
    ],
    [
        "Mozambique",
        "MZ"
    ],
    [
        "Myanmar",
        "MM"
    ],
    [
        "Namibia",
        "NA"
    ],
    [
        "Nauru",
        "NR"
    ],
    [
        "Nepal",
        "NP"
    ],
    [
        "Netherlands",
        "NL"
    ],
    [
        "New Caledonia",
        "NC"
    ],
    [
        "New Zealand",
        "NZ"
    ],
    [
        "Nicaragua",
        "NI"
    ],
    [
        "Niger",
        "NE"
    ],
    [
        "Nigeria",
        "NG"
    ],
    [
        "Niue",
        "NU"
    ],
    [
        "Norfolk Island",
        "NF"
    ],
    [
        "Northern Mariana Islands",
        "MP"
    ],
    [
        "Norway",
        "NO"
    ],
    [
        "Oman",
        "OM"
    ],
    [
        "Pakistan",
        "PK"
    ],
    [
        "Palau",
        "PW"
    ],
    [
        "Palestine",
        "PS"
    ],
    [
        "Panama",
        "PA"
    ],
    [
        "Papua New Guinea",
        "PG"
    ],
    [
        "Paraguay",
        "PY"
    ],
    [
        "Peru",
        "PE"
    ],
    [
        "Philippines",
        "PH"
    ],
    [
        "Pitcairn",
        "PN"
    ],
    [
        "Poland",
        "PL"
    ],
    [
        "Portugal",
        "PT"
    ],
    [
        "Puerto Rico",
        "PR"
    ],
    [
        "Qatar",
        "QA"
    ],
    [
        "R\xe9union",
        "RE"
    ],
    [
        "Romania",
        "RO"
    ],
    [
        "Russian Federation",
        "RU"
    ],
    [
        "Rwanda",
        "RW"
    ],
    [
        "Saint Barth\xe9lemy",
        "BL"
    ],
    [
        "Saint Helena, Ascension and Tristan da Cunha",
        "SH"
    ],
    [
        "Saint Kitts and Nevis",
        "KN"
    ],
    [
        "Saint Lucia",
        "LC"
    ],
    [
        "Saint Martin",
        "MF"
    ],
    [
        "Saint Pierre and Miquelon",
        "PM"
    ],
    [
        "Saint Vincent and the Grenadines",
        "VC"
    ],
    [
        "Samoa",
        "WS"
    ],
    [
        "San Marino",
        "SM"
    ],
    [
        "Sao Tome and Principe",
        "ST"
    ],
    [
        "Saudi Arabia",
        "SA"
    ],
    [
        "Senegal",
        "SN"
    ],
    [
        "Serbia",
        "RS"
    ],
    [
        "Seychelles",
        "SC"
    ],
    [
        "Sierra Leone",
        "SL"
    ],
    [
        "Singapore",
        "SG"
    ],
    [
        "Sint Maarten (Dutch part)",
        "SX"
    ],
    [
        "Slovakia",
        "SK"
    ],
    [
        "Slovenia",
        "SI"
    ],
    [
        "Solomon Islands",
        "SB"
    ],
    [
        "Somalia",
        "SO"
    ],
    [
        "South Africa",
        "ZA"
    ],
    [
        "South Georgia and South Sandwich Islands",
        "GS"
    ],
    [
        "South Sudan",
        "SS"
    ],
    [
        "Spain",
        "ES"
    ],
    [
        "Sri Lanka",
        "LK"
    ],
    [
        "Sudan",
        "SD"
    ],
    [
        "Suriname",
        "SR"
    ],
    [
        "Eswatini",
        "SZ"
    ],
    [
        "Sweden",
        "SE"
    ],
    [
        "Switzerland",
        "CH"
    ],
    [
        "Syrian Arab Republic",
        "SY"
    ],
    [
        "Taiwan",
        "TW"
    ],
    [
        "Tajikistan",
        "TJ"
    ],
    [
        "Tanzania, United Republic of",
        "TZ"
    ],
    [
        "Thailand",
        "TH"
    ],
    [
        "Timor-Leste",
        "TL"
    ],
    [
        "Togo",
        "TG"
    ],
    [
        "Tokelau",
        "TK"
    ],
    [
        "Tonga",
        "TO"
    ],
    [
        "Trinidad and Tobago",
        "TT"
    ],
    [
        "Tunisia",
        "TN"
    ],
    [
        "Turkey",
        "TR"
    ],
    [
        "Turkmenistan",
        "TM"
    ],
    [
        "Turks and Caicos Islands",
        "TC"
    ],
    [
        "Tuvalu",
        "TV"
    ],
    [
        "Uganda",
        "UG"
    ],
    [
        "Ukraine",
        "UA"
    ],
    [
        "United Arab Emirates",
        "AE"
    ],
    [
        "United Kingdom",
        "GB"
    ],
    [
        "United States",
        "US"
    ],
    [
        "United States Minor Outlying Islands",
        "UM"
    ],
    [
        "Uruguay",
        "UY"
    ],
    [
        "Uzbekistan",
        "UZ"
    ],
    [
        "Vanuatu",
        "VU"
    ],
    [
        "Venezuela, Bolivarian Republic of",
        "VE"
    ],
    [
        "Vietnam",
        "VN"
    ],
    [
        "Virgin Islands, British",
        "VG"
    ],
    [
        "Virgin Islands, U.S.",
        "VI"
    ],
    [
        "Wallis and Futuna",
        "WF"
    ],
    [
        "Western Sahara",
        "EH"
    ],
    [
        "Yemen",
        "YE"
    ],
    [
        "Zambia",
        "ZM"
    ],
    [
        "Zimbabwe",
        "ZW"
    ]
];


const $dc10d5c326127160$export$1f7780cd779bf37c = [
    'US',
    'CA',
    'DE'
];
const $dc10d5c326127160$export$18b8b1bfabae50a3 = (env, hostnames = {})=>{
    const { hostname: hostname } = window?.location ?? {};
    const defaultHostnames = {
        local: [
            'localhost'
        ],
        dev: [
            'dev.tenable.com'
        ],
        staging: [
            'staging.tenable.com'
        ],
        production: [
            'www.tenable.com'
        ],
        ...hostnames
    };
    if (env) return {
        env: env
    };
    if (defaultHostnames?.local?.includes(hostname) ?? false) return {
        env: 'local'
    };
    if (defaultHostnames?.dev?.includes(hostname) ?? false) return {
        env: 'dev'
    };
    if (defaultHostnames?.staging?.includes(hostname) ?? false) return {
        env: 'staging'
    };
    if (defaultHostnames?.production?.includes(hostname) ?? false) return {
        env: 'production'
    };
    return {
        env: 'production'
    };
};
const $dc10d5c326127160$export$f45760bc25914a85 = (env = 'production')=>{
    let baseUrl = 'https://www.tenable.com';
    if (env === 'local') baseUrl = 'http://localhost:3000';
    if (env === 'dev') baseUrl = 'https://dev.tenable.com';
    if (env === 'staging') baseUrl = 'https://staging.tenable.com';
    if (env === 'preview') baseUrl = 'https://drupal9-preview.tenable.com';
    return {
        baseUrl: baseUrl,
        environment: env
    };
};
const $dc10d5c326127160$export$5dd27816c66fb702 = (html)=>{
    const escape = document.createElement('textarea');
    escape.textContent = html;
    return escape.innerHTML;
};
const $dc10d5c326127160$export$aa3f36fe5dd1f237 = (id)=>{
    const products = {
        vm: 'Tenable Vulnerability Management',
        consec: 'Tenable Vulnerability Management',
        was: 'Tenable Web App Scanning',
        nessus: 'Tenable Nessus Professional',
        tio: 'Tenable Vulnerability Management',
        lumin: 'Tenable Vulnerability Management',
        cns: 'Tenable Cloud Security',
        essentials: 'Tenable Nessus Essentials',
        expert: 'Tenable Nessus Expert',
        'nessus-extension': 'Nessus Extension',
        'nessus-extension-extended': 'Nessus Extension'
    };
    return products[id];
};
const $dc10d5c326127160$export$82d2f89c9ecf0a27 = (product)=>{
    if (product === 'nessus') return [
        'nessus'
    ];
    if (product === 'expert') return [
        'expert'
    ];
    if (product === 'essentials') return [
        'essentials'
    ];
    if ([
        'nessus-extension',
        'nessus-extension-extended',
        'nessus-pro-to-expert'
    ].includes(product)) return [
        product
    ];
    return [
        'vm',
        'was'
    ];
};
const $dc10d5c326127160$export$2e6793ceb30e87a7 = (options = {})=>{
    const targets = [];
    const { elementType: elementType } = options;
    const targetDivSelectors = options?.targetDivSelectors ?? [];
    targetDivSelectors.forEach((id)=>{
        const target = document.getElementById(id);
        if (target) targets.push(target);
    });
    if (targets.length < 1) return null;
    if (!elementType) {
        console.error('Element Type is not defined');
        return null;
    }
    const element = document.createElement(options?.elementType);
    targets[0].appendChild(element);
    return element;
};
const $dc10d5c326127160$export$9036647601a217a6 = (params)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const query = params.toString().length > 0 ? `?${params.toString()}` : '';
    const url = `${origin}${pathname}${query}`;
    window.history.replaceState(null, null, url);
};
const $dc10d5c326127160$export$adde79e3d4509f6a = [
    {
        label: 'Select Country',
        value: ''
    },
    ...$c8f06188fc3ad916$exports.countryNames.map((name, idx)=>({
            label: name,
            value: $c8f06188fc3ad916$exports.countryShortCodes[idx]
        }))
];
const $dc10d5c326127160$export$c1359df526b35f51 = (countryCode)=>{
    if (!$dc10d5c326127160$export$1f7780cd779bf37c.includes(countryCode)) return [];
    const countryArr = $c8f06188fc3ad916$exports[countryCode];
    if (!countryArr || !countryArr[2]) return [];
    return countryArr[2].map(([name, shortCode])=>({
            label: name,
            value: shortCode || name
        }));
};
const $dc10d5c326127160$export$6535eb414fa2c8b6 = (value)=>value && !/^https?:\/\//i.test(value) ? `https://${value}` : value;



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $038bd80682d88adb$export$850a745f54aa50d7 extends Event {
    constructor(s, t, e){
        super("context-request", {
            bubbles: !0,
            composed: !0
        }), this.context = s, this.callback = t, this.subscribe = e;
    }
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $373cb95b05cf8dbd$export$fd42f52fd3ae1109(n) {
    return n;
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $69dac3c6b02caeda$export$a7c73072b1a182ae {
    constructor(t, s, i, h){
        var e;
        if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = (t, s)=>{
            this.unsubscribe && (this.unsubscribe !== s && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = t, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = !0, this.callback && this.callback(t, s)), this.unsubscribe = s;
        }, this.host = t, void 0 !== s.context) {
            const t = s;
            this.context = t.context, this.callback = t.callback, this.subscribe = null !== (e = t.subscribe) && void 0 !== e && e;
        } else this.context = s, this.callback = i, this.subscribe = null != h && h;
        this.host.addController(this);
    }
    hostConnected() {
        this.dispatchRequest();
    }
    hostDisconnected() {
        this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
    }
    dispatchRequest() {
        this.host.dispatchEvent(new (0, $038bd80682d88adb$export$850a745f54aa50d7)(this.context, this.t, this.subscribe));
    }
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $8224fd61a6b65aef$export$b2bf9da44ce3a51c {
    constructor(t){
        this.disposers = new Map, this.updateObservers = ()=>{
            for (const [t, s] of this.disposers)t(this.o, s);
        }, void 0 !== t && (this.value = t);
    }
    get value() {
        return this.o;
    }
    set value(t) {
        this.setValue(t);
    }
    setValue(t, s = !1) {
        const i = s || !Object.is(t, this.o);
        this.o = t, i && this.updateObservers();
    }
    addCallback(t, s) {
        if (s) {
            this.disposers.has(t) || this.disposers.set(t, ()=>{
                this.disposers.delete(t);
            });
            const s = this.disposers.get(t);
            t(this.value, s);
        } else t(this.value);
    }
    clearCallbacks() {
        this.disposers.clear();
    }
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $20047d1f06125b00$export$78572d749d164a6c extends Event {
    constructor(t){
        super("context-provider", {
            bubbles: !0,
            composed: !0
        }), this.context = t;
    }
}
class $20047d1f06125b00$export$9f27bc3417b4524d extends (0, $8224fd61a6b65aef$export$b2bf9da44ce3a51c) {
    constructor(t, s, e){
        super(void 0 !== s.context ? s.initialValue : e), this.onContextRequest = (t)=>{
            t.context === this.context && t.composedPath()[0] !== this.host && (t.stopPropagation(), this.addCallback(t.callback, t.subscribe));
        }, this.host = t, void 0 !== s.context ? this.context = s.context : this.context = s, this.attachListeners(), this.host.addController(this);
    }
    attachListeners() {
        this.host.addEventListener("context-request", this.onContextRequest);
    }
    hostConnected() {
        this.host.dispatchEvent(new $20047d1f06125b00$export$78572d749d164a6c(this.context));
    }
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $d66e5ff627c307ea$export$a375903047a16407 {
    constructor(){
        this.pendingContextRequests = new Map, this.onContextProvider = (t)=>{
            const s = this.pendingContextRequests.get(t.context);
            if (void 0 === s) return;
            this.pendingContextRequests.delete(t.context);
            const { requests: o } = s;
            for (const { elementRef: s, callbackRef: n } of o){
                const o = s.deref(), c = n.deref();
                void 0 === o || void 0 === c || o.dispatchEvent(new (0, $038bd80682d88adb$export$850a745f54aa50d7)(t.context, c, !0));
            }
        }, this.onContextRequest = (e)=>{
            if (!0 !== e.subscribe) return;
            const t = e.composedPath()[0], s = e.callback;
            let o = this.pendingContextRequests.get(e.context);
            void 0 === o && this.pendingContextRequests.set(e.context, o = {
                callbacks: new WeakMap,
                requests: []
            });
            let n = o.callbacks.get(t);
            void 0 === n && o.callbacks.set(t, n = new WeakSet), n.has(s) || (n.add(s), o.requests.push({
                elementRef: new WeakRef(t),
                callbackRef: new WeakRef(s)
            }));
        };
    }
    attach(e) {
        e.addEventListener("context-request", this.onContextRequest), e.addEventListener("context-provider", this.onContextProvider);
    }
    detach(e) {
        e.removeEventListener("context-request", this.onContextRequest), e.removeEventListener("context-provider", this.onContextProvider);
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ba6019c4242af4aa$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $ba6019c4242af4aa$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $ba6019c4242af4aa$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ec589a0cf84a68a1$export$abe1e183e22e10ad({ context: o }) {
    return (0, $ba6019c4242af4aa$export$757d561a932dc1cb)({
        finisher: (t, n)=>{
            const r = new WeakMap;
            t.addInitializer((t)=>{
                r.set(t, new (0, $20047d1f06125b00$export$9f27bc3417b4524d)(t, {
                    context: o
                }));
            });
            const i = Object.getOwnPropertyDescriptor(t.prototype, n), c = null == i ? void 0 : i.set, s = {
                ...i,
                set: function(t) {
                    var e;
                    null === (e = r.get(this)) || void 0 === e || e.setValue(t), c && c.call(this, t);
                }
            };
            Object.defineProperty(t.prototype, n, s);
        }
    });
}




/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c6b0c5c50e38ba03$export$e11e6a155c5c4d9d({ context: t, subscribe: o }) {
    return (0, $ba6019c4242af4aa$export$757d561a932dc1cb)({
        finisher: (e, c)=>{
            e.addInitializer((e)=>{
                new (0, $69dac3c6b02caeda$export$a7c73072b1a182ae)(e, {
                    context: t,
                    callback: (r)=>{
                        e[c] = r;
                    },
                    subscribe: o
                });
            });
        }
    });
}


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $186c33842b6b7bba$export$99819ba07e0a18e5 = (0, $ec589a0cf84a68a1$export$abe1e183e22e10ad), $186c33842b6b7bba$export$5fb4c0ff1e1caf44 = (0, $c6b0c5c50e38ba03$export$e11e6a155c5c4d9d);



const $8bfb3448b5d39c28$var$appContext = (0, $373cb95b05cf8dbd$export$fd42f52fd3ae1109)(Symbol('tenable-app-context'));
var $8bfb3448b5d39c28$export$2e2bcd8739ae039 = $8bfb3448b5d39c28$var$appContext;


class $e6dddb5c49f01194$var$AppContextProvider extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static properties = {
        value: {
            type: Object
        }
    };
    constructor(){
        super();
        this.value = {};
    }
    provider = new (0, $20047d1f06125b00$export$9f27bc3417b4524d)(this, {
        context: (0, $8bfb3448b5d39c28$export$2e2bcd8739ae039),
        initialValue: this.value
    });
    connectedCallback() {
        super.connectedCallback();
        this.provider.setValue(this.value);
    }
    setContextValue(event) {
        const value = {
            ...this.value,
            ...event.detail
        };
        this.provider.setValue(value);
        this.value = value;
    }
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
    <div
      @set-app-context=${(e)=>this.setContextValue(e)}
    >
      <slot></slot>
    </div>
  `;
    }
}
customElements.define('tenable-app-provider', $e6dddb5c49f01194$var$AppContextProvider);





var $41291d7e812c5108$export$2e2bcd8739ae039 = [
    (0, $00b2a1180faf264c$export$2e2bcd8739ae039),
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
    .partners-page-container {
      font-family: system-ui,-apple-system,roboto,'segoe ui',sans-serif;
    }

    .partners-page-header {
      padding: 1rem;
      border-bottom: 2rem solid var(--tenable-partners-header-border-color, #1E2426);
      margin-bottom: 5rem;
    }

    .partners-page-header li.list-inline-item {
      position: relative;
      list-style-type: none;
      height: 2em;
      margin-left: 3rem;
    }

    .partners-page-header li span {
      margin-right: 3rem;
    }

    .logo {
      margin-left: 3rem;
      width: 155px;
    }

    footer {
      color: #FFFFFF;
      margin-top: 10rem;
      padding-top: 3rem;
      padding-bottom: 5rem;
      background-color: var(--tenable-partners-footer-background-color, #1E2426);
    }

    .footer-content {
      text-align: center;
    }

    .footer-links a {
      color: #FFFFFF;

      &:hover {
        color: #FFFFFF;
      }
    }

    .footer-social a {
      width: 34px;
      height: 34px;

      &:hover {
        text-decoration: none;
      }
    }

    .hidden-container svg{
      display: none;
    }

    div.hidden-container {
      display: none;
    }

    .menu-link {
      position: relative;
    }

    .menu-link a {
      color: #1E2426;

      &:hover {
        color: #555555;
      }
    }

    .hidden-container a {
      color: #5B6062;
    }

    .menu-icon {
      position: absolute;
      bottom: -2.5rem;
      left: 50%;
      transform: translate(-50%);
    }

    .footer-social {
      display: block;
      margin-bottom: 1em;
    }

    .footer-social a {
      margin-right: 1em;
    }
  `
];




const $f33e9a0a3fc07977$var$AppContextConsumer = (host, options = {})=>new (0, $69dac3c6b02caeda$export$a7c73072b1a182ae)(host, {
        context: (0, $8bfb3448b5d39c28$export$2e2bcd8739ae039),
        subscribe: true,
        ...options
    });
var $f33e9a0a3fc07977$export$2e2bcd8739ae039 = $f33e9a0a3fc07977$var$AppContextConsumer;



class $2c22977f80230f95$var$IconFacebook extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static properties = {
        height: {
            type: String
        },
        width: {
            type: String
        },
        fillColor: {
            type: String,
            attribute: 'fill-color'
        }
    };
    constructor(){
        super();
        this.height = '24';
        this.width = '24';
        this.fillColor = '#ffffff';
    }
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <svg xmlns="http://www.w3.org/2000/svg" fill="${this.fillColor}" width="${this.width}" height="${this.height}" viewBox="0 0 24 24" version="1.1">
        <path d="M12,2C6.477,2,2,6.477,2,12c0,5.013,3.693,9.153,8.505,9.876V14.65H8.031v-2.629h2.474v-1.749 c0-2.896,1.411-4.167,3.818-4.167c1.153,0,1.762,0.085,2.051,0.124v2.294h-1.642c-1.022,0-1.379,0.969-1.379,2.061v1.437h2.995 l-0.406,2.629h-2.588v7.247C18.235,21.236,22,17.062,22,12C22,6.477,17.523,2,12,2z"/>
      </svg>
    `;
    }
}
customElements.define('tenable-icon-facebook', $2c22977f80230f95$var$IconFacebook);



class $61026803f3dfe6d9$var$IconLinkedIn extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static properties = {
        height: {
            type: String
        },
        width: {
            type: String
        },
        fillColor: {
            type: String,
            attribute: 'fill-color'
        }
    };
    constructor(){
        super();
        this.height = '24';
        this.width = '24';
        this.fillColor = '#ffffff';
    }
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <svg xmlns="http://www.w3.org/2000/svg" fill="${this.fillColor}" width="${this.width}" height="${this.height}" viewBox="0 0 1024 1024" version="1.1">
        <path d="M76.43 361.726h185.949v597.36H76.429v-597.36zM169.46 64.76c59.45 0 107.652 48.27 107.652 107.624 0 59.416-48.202 107.679-107.651 107.679-59.662 0-107.772-48.263-107.772-107.679C61.688 113.03 109.798 64.76 169.461 64.76M378.943 361.726h178.074v81.644h2.526c24.76-47.003 85.404-96.498 175.787-96.498 187.963 0 222.73 123.667 222.73 284.553v327.66h-185.6V668.653c0-69.336-1.374-158.46-96.56-158.46-96.684 0-111.423 75.456-111.423 153.333v295.56H378.943v-597.36z" />
      </svg>
    `;
    }
}
customElements.define('tenable-icon-linkedin', $61026803f3dfe6d9$var$IconLinkedIn);



class $a7ae0c10ee43e547$var$IconTwitter extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static properties = {
        height: {
            type: String
        },
        width: {
            type: String
        },
        fillColor: {
            type: String,
            attribute: 'fill-color'
        }
    };
    constructor(){
        super();
        this.height = '24';
        this.width = '24';
        this.fillColor = '#ffffff';
    }
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <svg xmlns="http://www.w3.org/2000/svg" fill="${this.fillColor}" width="${this.width}" height="${this.height}" viewBox="0 0 24 24">
        <path d="M 2.3671875 3 L 9.4628906 13.140625 L 2.7402344 21 L 5.3808594 21 L 10.644531 14.830078 L 14.960938 21 L 21.871094 21 L 14.449219 10.375 L 20.740234 3 L 18.140625 3 L 13.271484 8.6875 L 9.2988281 3 L 2.3671875 3 z M 6.2070312 5 L 8.2558594 5 L 18.033203 19 L 16.001953 19 L 6.2070312 5 z"/>
      </svg>
    `;
    }
}
customElements.define('tenable-icon-twitter', $a7ae0c10ee43e547$var$IconTwitter);



class $a2771fcccc282af7$var$IconYoutube extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static properties = {
        height: {
            type: String
        },
        width: {
            type: String
        },
        fillColor: {
            type: String,
            attribute: 'fill-color'
        }
    };
    constructor(){
        super();
        this.height = '24';
        this.width = '24';
        this.fillColor = '#ffffff';
    }
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <svg xmlns="http://www.w3.org/2000/svg" fill="${this.fillColor}" width="${this.width}" height="${this.height}"  viewBox="0 0 24 24">
        <path d="M21.582,6.186c-0.23-0.86-0.908-1.538-1.768-1.768C18.254,4,12,4,12,4S5.746,4,4.186,4.418 c-0.86,0.23-1.538,0.908-1.768,1.768C2,7.746,2,12,2,12s0,4.254,0.418,5.814c0.23,0.86,0.908,1.538,1.768,1.768 C5.746,20,12,20,12,20s6.254,0,7.814-0.418c0.861-0.23,1.538-0.908,1.768-1.768C22,16.254,22,12,22,12S22,7.746,21.582,6.186z M10,15.464V8.536L16,12L10,15.464z"/>
      </svg>
    `;
    }
}
customElements.define('tenable-icon-youtube', $a2771fcccc282af7$var$IconYoutube);






var $9389f059f90be0a1$export$2e2bcd8739ae039 = [
    (0, $00b2a1180faf264c$export$2e2bcd8739ae039),
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
    .login-container {
      min-width: 30rem;
      max-width: 50rem;
      margin-left: auto;
      margin-right: auto;
    }

    .login-panel {
      text-align: center;
      border-radius: 3px;
      box-shadow: 0 .375em 1em rgba(0, 0, 0, .25);
      background: #ffffff;
    }

    .login-container .login-panel {
      padding: 4rem 3rem 4rem 3rem;
    }

    .login-container .login-panel img {
      width: 22rem;
      height: auto;
    }

    .login-container .login-panel .panel-heading {
      background: #ffffff;
      padding-top: 2rem;
      padding-bottom: 1rem
    }

    .login-container .login-panel .panel-heading h2 {
      margin: 0;
      font-weight: 700;
      line-height: 1.2;
      color: #5B6062;
    }

    .login-container .login-panel .panel-body h4  {
      margin-bottom: 2rem;
      color: #5B6062;
    }

    .login-container .login-panel .panel-body .login-btn  {
      margin: 0;
    }

    .login-btn {
      --tenable-btn-primary-background-color: #1E2426;
      --tenable-btn-primary-border-color: #1E2426;
      --tenable-btn-primary-hover-background-color: #e7ff00;
      --tenable-button-width: fit-content;
    }
  `
];




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $95d4e5daf5753923$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $95d4e5daf5753923$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $95d4e5daf5753923$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0a7731726e7f7d8c$var$i = "important", $0a7731726e7f7d8c$var$n = " !" + $0a7731726e7f7d8c$var$i, $0a7731726e7f7d8c$export$1e5b4ce2fa884e6a = (0, $95d4e5daf5753923$export$99b43ad1ed32e735)(class extends (0, $95d4e5daf5753923$export$befdefbdce210f91) {
    constructor(t){
        var e;
        if (super(t), t.type !== (0, $95d4e5daf5753923$export$9ba3b3f20a85bfa).ATTRIBUTE || "style" !== t.name || (null === (e = t.strings) || void 0 === e ? void 0 : e.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ht) {
            this.ht = new Set;
            for(const t in r)this.ht.add(t);
            return this.render(r);
        }
        this.ht.forEach((t)=>{
            null == r[t] && (this.ht.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = "");
        });
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ht.add(t);
                const r = "string" == typeof e && e.endsWith($0a7731726e7f7d8c$var$n);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $0a7731726e7f7d8c$var$i : "") : s[t] = e;
            }
        }
        return 0, $e0373a6519ee54ad$export$9c068ae9cc5db4e8;
    }
});





var $4341d1034513f52f$export$2e2bcd8739ae039 = [
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
    button {
      display: var(--tenable-button-display, inline-block);
      font-weight: var(--tenable-button-font-weight, 400);
      text-align: var(--tenable-button-text-align, center);
      white-space: var(--tenable-button-white-space, nowrap);
      vertical-align: var(--tenable-button-vertical-align, middle);
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border: var(--tenable-button-border, 1px solid transparent);
      padding: var(--tenable-button-padding, .5rem 1.5rem);
      font-family: var(--tenable-button-font-family, 1rem, 'aeonik pro',barlow,system-ui,-apple-system,roboto,segoe ui,sans-serif);
      font-size: var(--tenable-button-font-size, 1rem);
      line-height: var(--tenable-button-line-height, 1.5);
      border-radius: var(--tenable-button-border-radius, 0);
      transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
      width: var(--tenable-button-width, var(--tenable-button-width-default, auto));
    }

    button:not(:disabled):not(.disabled) {
      cursor: pointer;
    }

    button.disabled,
    button:disabled {
      opacity: var(--tenable-btn-primary-disabled-opacity, .65);
      pointer-events: none;
    }

    .btn-lg {
      font-size: var(--tenable-button-font-size, 1.2rem);
      padding: var(--tenable-button-padding, .3rem 1rem);
    }

    .btn-sm {
      font-size: var(--tenable-button-font-size, .875rem);
      padding: var(--tenable-button-padding, .25rem .5rem);
    }

    .btn-primary {
      color: var(--tenable-btn-primary-color, #fff);
      background-color: var(--tenable-btn-primary-background-color, #1e2426);
      border-color: var(--tenable-btn-primary-border-color, #1e2426);
    }

    .btn-primary:hover {
      color: var(--tenable-btn-primary-hover-color, #1e2426);
      background-color: var(--tenable-btn-primary-hover-background-color, #e7ff00);
      border-color: var(--tenable-btn-primary-hover-border-color, #1e2426);
    }

    .btn-primary.disabled,
    .btn-primary:disabled {
      color: var(--tenable-btn-primary-disabled-color, #fff);
      background-color: var(--tenable-btn-primary-disabled-background-color, #1E24264D);
      border-color: var(--tenable-btn-primary-disabled-border-color, #1E24264D);
    }

    .btn-secondary {
      color: var(--tenable-btn-secondary-color, #1e2426);
      background-color: var(--tenable-btn-secondary-background-color, #ffffff);
      border-color: var(--tenable-btn-secondary-border-color, #1e2426);
    }

    .btn-secondary:hover {
      color: var(--tenable-btn-secondary-hover-color, #1e2426);
      background-color: var(--tenable-btn-secondary-hover-background-color, #e7ff00);
      border-color: var(--tenable-btn-secondary-hover-border-color, #1e2426);
    }

    .btn-secondary.disabled,
    .btn-secondary:disabled {
      color: var(--tenable-btn-secondary-disabled-color, #1E24264D);
      background-color: var(--tenable-btn-secondary-disabled-background-color, #ffffff);
      border-color: var(--tenable-btn-secondary-disabled-border-color, #1E24264D);
    }

    .btn-success {
      color: var(--tenable-btn-success-color, #fff);
      background-color: var(--tenable-btn-success-background-color, #3fae49);
      border-color: var(--tenable-btn-success-border-color, #3fae49);
    }

    .btn-success:hover {
      color: var(--tenable-btn-success-hover-color, #fff);
      background-color: var(--tenable-btn-success-hover-background-color, #35923d);
      border-color: var(--tenable-btn-success-hover-border-color, #35923d);
    }

    .btn-success.disabled,
    .btn-success:disabled {
      color: var(--tenable-btn-success-disabled-color, #fff);
      background-color: var(--tenable-btn-success-disabled-background-color, #3fae49);
      border-color: var(--tenable-btn-success-disabled-border-color, #3fae49);
    }

    .btn-warning {
      color: var(--tenable-btn-warning-color, #fff);
      background-color: var(--tenable-btn-warning-background-color, #fd6219);
      border-color: var(--tenable-btn-warning-border-color, #fd6219);
    }

    .btn-warning:hover {
      color: var(--tenable-btn-warning-hover-color, #fff);
      background-color: var(--tenable-btn-warning-hover-background-color, #ee4e02);
      border-color: var(--tenable-btn-warning-hover-border-color, #ee4e02);
    }

    .btn-warning.disabled,
    .btn-warning:disabled {
      color: var(--tenable-btn-warning-disabled-color, #fff);
      background-color: var(--tenable-btn-warning-disabled-background-color, #fd6219);
      border-color: var(--tenable-btn-warning-disabled-border-color, #fd6219);
    }

    .btn-link {
      color: var(--tenable-btn-link-color, #1e2426);
      text-decoration: none;
      background: none;
      width: inherit;
      padding: 0;
    }

    .btn-link:hover {
      color: var(--tenable-btn-link-hover-color, #e7ff00);
      text-decoration: underline;
    }

    .btn-link.disabled,
    .btn-link:disabled {
      color: var(--tenable-btn-link-disabled-color, #6c757d);
    }
  `
];


class $2c7b00c41b87c69d$var$Button extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $4341d1034513f52f$export$2e2bcd8739ae039);
    static properties = {
        color: {
            type: String,
            converter: (value)=>[
                    'primary',
                    'secondary',
                    'success',
                    'warning',
                    'link'
                ].includes(value) ? `btn-${value}` : 'btn-primary'
        },
        type: {
            type: String,
            converter: (value)=>[
                    'button',
                    'submit',
                    'reset'
                ].includes(value) ? value : 'button'
        },
        disabled: {
            type: Boolean
        },
        size: {
            type: String,
            converter: (value)=>[
                    'sm',
                    'lg'
                ].includes(value) ? `btn-${value}` : ''
        },
        style: {
            type: Object
        }
    };
    constructor(){
        super();
        this.color = 'btn-primary';
        this.type = 'button';
        this.size = '';
        this.disabled = false;
        this.style = {};
    }
    handleClick(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        const eventType = this.type === 'submit' ? 'handle-submit' : 'button-click';
        this.dispatchEvent(new CustomEvent(eventType, {
            detail: {
                srcEvent: event
            },
            composed: true,
            bubbles: true
        }));
    }
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
    <button
      @click=${this.handleClick}
      type="${this.type}"
      class="${this.color} ${this.size}"
      ?disabled=${this.disabled}
      role="button"
      style="${(0, $0a7731726e7f7d8c$export$1e5b4ce2fa884e6a)(this.style)}"
    >
      <slot></slot>
    </button>
  `;
    }
}
customElements.define('tenable-button', $2c7b00c41b87c69d$var$Button);


class $73ac39420e34763e$var$PartnersLogin extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $9389f059f90be0a1$export$2e2bcd8739ae039);
    static properties = {
        loginBtnUrl: {
            type: String
        }
    };
    constructor(){
        super();
        this.logingBtnUrl = '';
    }
    context = (0, $f33e9a0a3fc07977$export$2e2bcd8739ae039)(this);
    #getPartnersUrl(env) {
        let partnersLoginUrl = 'https://login.tenable.com/samlp/acBiHkx5cwsrFedV2M8OsFYq1Zq4ng5f?connection=Username-Password-Authentication';
        if (env === 'dev' || env === 'local') partnersLoginUrl = 'https://login-staging.tenable.com/samlp/tVRa6nSV4WKXvsX1aIkzXucDwvSX1vMy?connection=Username-Password-Authentication';
        if (env === 'staging') partnersLoginUrl = 'https://dev-login.tenablesecurity.com/samlp/sfdfJ9QLaq7mna9RSKQM1g6EdIoJTzAG?connection=Username-Password-Authentication';
        return partnersLoginUrl;
    }
    connectedCallback() {
        super.connectedCallback();
        this.loginBtnUrl = this.#getPartnersUrl(this.context.value?.env);
    }
    render() {
        const isOpenPartners = this.context.value?.type === 'openPartners';
        const logo = isOpenPartners ? 'https://static.tenable.com/partners/tenable_open_black.png' : 'https://static.tenable.com/partners/tenable-assure-logo.png';
        const heading = isOpenPartners ? 'Tenable Open Partner Portal' : 'Tenable Partner Portal';
        const description = isOpenPartners ? 'Access the Tenable OPEN partner portal for a one-stop view of joint marketing benefits, developer guides, product access and technical documentation.' : 'Access the Tenable Partner Portal for a one-stop view of sales and technical enablement, demand generation marketing, pipeline management, and analytics.';
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <div class="login-container w-50">
        <div class="panel panel-default login-panel">
          <img src="${logo}" alt="Tenable">
          <div class="panel-heading">
            <h2>${heading}</h2>
          </div>
          <div class="panel-body">
            <h4>${description}</h4>
          </div>
          <a href="${this.loginBtnUrl}">
            <tenable-button class="login-btn" size="lg">Login</tenable-button>
          </a>
        </div>
      </div>
    `;
    }
}
customElements.define('tenable-partners-login', $73ac39420e34763e$var$PartnersLogin);





var $7b158124d7893a46$export$2e2bcd8739ae039 = [
    (0, $00b2a1180faf264c$export$2e2bcd8739ae039),
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
    .partners-registration-container {
      min-width: 25rem;
      max-width: 40rem;
      margin-left: auto;
      margin-right: auto;
    }


    .partners-registration-container .registration-panel {
      padding: 4rem 3rem 4rem 3rem;
      text-align: center;
      border-radius: 3px;
      box-shadow: 0 .375em 1em rgba(0, 0, 0, .25);
      background: #ffffff;
    }

    .partners-registration-container .registration-panel img {
      width: 22rem;
      height: auto;
    }

    .partners-registration-container .registration-panel .panel-heading {
      background: #ffffff;
      padding-top: 2rem;
      padding-bottom: 1rem;
      margin-bottom: 1rem;
    }

    .partners-registration-container .registration-panel .panel-heading h2 {
      margin: 0;
      font-weight: 700;
      line-height: 1.2;
      color: #5B6062;
    }
  `
];





class $ae5b58ea8631ae4b$var$BaseApi {
    constructor(config){
        const { baseUrl: baseUrl, environment: environment } = (0, $dc10d5c326127160$export$f45760bc25914a85)(config?.env);
        this.baseUrl = baseUrl;
        this.environment = environment;
    }
    async parseResponse(response) {
        let data = {};
        try {
            data = await response.json();
        } catch (error) {
            console.error('Error parsing response', {
                error: error
            });
        }
        if (!response.ok) {
            const message = data?.message ?? response?.statusText ?? response;
            const cause = {
                status: response?.status,
                statusText: response?.statusText,
                data: data
            };
            throw new Error(message, {
                cause: cause
            });
        }
        return {
            data: data
        };
    }
}
var $ae5b58ea8631ae4b$export$2e2bcd8739ae039 = $ae5b58ea8631ae4b$var$BaseApi;


class $9aa856a3e1664cb7$var$PartnersRegistrationApi extends (0, $ae5b58ea8631ae4b$export$2e2bcd8739ae039) {
    constructor(config){
        super(config);
        this.endpoint = config?.endpoint ?? '/evaluations/api/v1/partners/accounts';
    }
    async create(body) {
        const url = `${this.baseUrl}${this.endpoint}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
        return this.parseResponse(response);
    }
}
var $9aa856a3e1664cb7$export$2e2bcd8739ae039 = $9aa856a3e1664cb7$var$PartnersRegistrationApi;



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * Tag that allows expressions to be used in localized non-HTML template
 * strings.
 *
 * Example: msg(str`Hello ${this.user}!`);
 *
 * The Lit html tag can also be used for this purpose, but HTML will need to be
 * escaped, and there is a small overhead for HTML parsing.
 *
 * Untagged template strings with expressions aren't supported by lit-localize
 * because they don't allow for values to be captured at runtime.
 */ const $4855ce3ada043cb7$var$_str = (strings, ...values)=>({
        strTag: true,
        strings: strings,
        values: values
    });
const $4855ce3ada043cb7$export$42d51816ce590c93 = $4855ce3ada043cb7$var$_str;
const $4855ce3ada043cb7$export$d837b01947f59adf = (val)=>typeof val !== 'string' && 'strTag' in val;
const $4855ce3ada043cb7$export$54d1368c2e63ae35 = (strings, values, valueOrder)=>{
    let concat = strings[0];
    for(let i = 1; i < strings.length; i++){
        concat += values[valueOrder ? valueOrder[i - 1] : i - 1];
        concat += strings[i];
    }
    return concat;
};


const $30dc421a99632c8b$export$627842c9718b61c7 = (template)=>(0, $4855ce3ada043cb7$export$d837b01947f59adf)(template) ? (0, $4855ce3ada043cb7$export$54d1368c2e63ae35)(template.strings, template.values) : template;


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * Name of the event dispatched to `window` whenever a locale change starts,
 * finishes successfully, or fails. Only relevant to runtime mode.
 *
 * The `detail` of this event is an object with a `status` string that can be:
 * "loading", "ready", or "error", along with the relevant locale code, and
 * error message if applicable.
 *
 * You can listen for this event to know when your application should be
 * re-rendered following a locale change. See also the Localized mixin, which
 * automatically re-renders LitElement classes using this event.
 */ const $62f1633a3e29349e$export$22ecc5ec4a7dfb64 = 'lit-localize-status';



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
class $4dfc32bf1589eb12$var$LocalizeController {
    constructor(host){
        this.__litLocalizeEventHandler = (event)=>{
            if (event.detail.status === 'ready') this.host.requestUpdate();
        };
        this.host = host;
    }
    hostConnected() {
        window.addEventListener((0, $62f1633a3e29349e$export$22ecc5ec4a7dfb64), this.__litLocalizeEventHandler);
    }
    hostDisconnected() {
        window.removeEventListener((0, $62f1633a3e29349e$export$22ecc5ec4a7dfb64), this.__litLocalizeEventHandler);
    }
}
/**
 * Re-render the given LitElement whenever a new active locale has loaded.
 *
 * See also {@link localized} for the same functionality as a decorator.
 *
 * When using lit-localize in transform mode, calls to this function are
 * replaced with undefined.
 *
 * Usage:
 *
 *   import {LitElement, html} from 'lit';
 *   import {msg, updateWhenLocaleChanges} from '@lit/localize';
 *
 *   class MyElement extends LitElement {
 *     constructor() {
 *       super();
 *       updateWhenLocaleChanges(this);
 *     }
 *
 *     render() {
 *       return html`<b>${msg('Hello World')}</b>`;
 *     }
 *   }
 */ const $4dfc32bf1589eb12$var$_updateWhenLocaleChanges = (host)=>host.addController(new $4dfc32bf1589eb12$var$LocalizeController(host));
const $4dfc32bf1589eb12$export$19147fd8eb2795e4 = $4dfc32bf1589eb12$var$_updateWhenLocaleChanges;


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
/**
 * Class decorator to enable re-rendering the given LitElement whenever a new
 * active locale has loaded.
 *
 * See also {@link updateWhenLocaleChanges} for the same functionality without
 * the use of decorators.
 *
 * When using lit-localize in transform mode, applications of this decorator are
 * removed.
 *
 * Usage:
 *
 *   import {LitElement, html} from 'lit';
 *   import {customElement} from 'lit/decorators.js';
 *   import {msg, localized} from '@lit/localize';
 *
 *   @localized()
 *   @customElement('my-element')
 *   class MyElement extends LitElement {
 *     render() {
 *       return html`<b>${msg('Hello World')}</b>`;
 *     }
 *   }
 */ const $22c3ce0da677ba80$var$_localized = ()=>(classOrDescriptor)=>typeof classOrDescriptor === 'function' ? $22c3ce0da677ba80$var$legacyLocalized(classOrDescriptor) : $22c3ce0da677ba80$var$standardLocalized(classOrDescriptor);
const $22c3ce0da677ba80$export$85ef745e96563a4b = $22c3ce0da677ba80$var$_localized;
const $22c3ce0da677ba80$var$standardLocalized = ({ kind: kind, elements: elements })=>{
    return {
        kind: kind,
        elements: elements,
        finisher (clazz) {
            clazz.addInitializer((0, $4dfc32bf1589eb12$export$19147fd8eb2795e4));
        }
    };
};
const $22c3ce0da677ba80$var$legacyLocalized = (clazz)=>{
    clazz.addInitializer((0, $4dfc32bf1589eb12$export$19147fd8eb2795e4));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return clazz;
};


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $0443af683f44f5ee$export$85f6557964517f1a {
    constructor(){
        this.settled = false;
        this.promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    resolve(value) {
        this.settled = true;
        this._resolve(value);
    }
    reject(error) {
        this.settled = true;
        this._reject(error);
    }
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ /**
 * @license
 * Copyright 2014 Travis Webb
 * SPDX-License-Identifier: MIT
 */ // This module is derived from the file:
// https://github.com/tjwebb/fnv-plus/blob/1e2ce68a07cb7dd4c3c85364f3d8d96c95919474/index.js#L309
//
// Changes:
// - Only the _hash64_1a_fast function is included.
// - Removed loop unrolling.
// - Converted to TypeScript ES module.
// - var -> let/const
//
// TODO(aomarks) Upstream improvements to https://github.com/tjwebb/fnv-plus/.
const $09a0dda63db15b92$var$hl = [];
for(let i = 0; i < 256; i++)$09a0dda63db15b92$var$hl[i] = (i >> 4 & 15).toString(16) + (i & 15).toString(16);
function $09a0dda63db15b92$export$318d539d57e27224(str) {
    let t0 = 0, v0 = 0x2325, t1 = 0, v1 = 0x8422, t2 = 0, v2 = 0x9ce4, t3 = 0, v3 = 0xcbf2;
    for(let i = 0; i < str.length; i++){
        v0 ^= str.charCodeAt(i);
        t0 = v0 * 435;
        t1 = v1 * 435;
        t2 = v2 * 435;
        t3 = v3 * 435;
        t2 += v0 << 8;
        t3 += v1 << 8;
        t1 += t0 >>> 16;
        v0 = t0 & 65535;
        t2 += t1 >>> 16;
        v1 = t1 & 65535;
        v3 = t3 + (t2 >>> 16) & 65535;
        v2 = t2 & 65535;
    }
    return $09a0dda63db15b92$var$hl[v3 >> 8] + $09a0dda63db15b92$var$hl[v3 & 255] + $09a0dda63db15b92$var$hl[v2 >> 8] + $09a0dda63db15b92$var$hl[v2 & 255] + $09a0dda63db15b92$var$hl[v1 >> 8] + $09a0dda63db15b92$var$hl[v1 & 255] + $09a0dda63db15b92$var$hl[v0 >> 8] + $09a0dda63db15b92$var$hl[v0 & 255];
}


const $c05ab4410fcfb4e2$export$bab7f2b996bc5244 = '\x1e';
/**
 * Id prefix on html-tagged templates to distinguish e.g. `<b>x</b>` from
 * html`<b>x</b>`.
 */ const $c05ab4410fcfb4e2$var$HTML_PREFIX = 'h';
/**
 * Id prefix on plain string templates to distinguish e.g. `<b>x</b>` from
 * html`<b>x</b>`.
 */ const $c05ab4410fcfb4e2$var$STRING_PREFIX = 's';
function $c05ab4410fcfb4e2$export$bb8801913caa27b4(strings, isHtmlTagged) {
    return (isHtmlTagged ? $c05ab4410fcfb4e2$var$HTML_PREFIX : $c05ab4410fcfb4e2$var$STRING_PREFIX) + (0, $09a0dda63db15b92$export$318d539d57e27224)(typeof strings === 'string' ? strings : strings.join($c05ab4410fcfb4e2$export$bab7f2b996bc5244));
}


const $1b917dd7e00f6b34$var$expressionOrders = new WeakMap();
const $1b917dd7e00f6b34$var$hashCache = new Map();
function $1b917dd7e00f6b34$export$9a3f0ce3906e68f(templates, template, options) {
    var _a;
    if (templates) {
        const id = (_a = options === null || options === void 0 ? void 0 : options.id) !== null && _a !== void 0 ? _a : $1b917dd7e00f6b34$var$generateId(template);
        const localized = templates[id];
        if (localized) {
            if (typeof localized === 'string') // E.g. "Hello World!"
            return localized;
            else if ('strTag' in localized) // E.g. str`Hello ${name}!`
            //
            // Localized templates have ${number} in place of real template
            // expressions. They can't have real template values, because the
            // variable scope would be wrong. The number tells us the index of the
            // source value to substitute in its place, because expressions can be
            // moved to a different position during translation.
            return (0, $4855ce3ada043cb7$export$54d1368c2e63ae35)(localized.strings, // Cast `template` because its type wasn't automatically narrowed (but
            // we know it must be the same type as `localized`).
            template.values, localized.values);
            else {
                // E.g. html`Hello <b>${name}</b>!`
                //
                // We have to keep our own mapping of expression ordering because we do
                // an in-place update of `values`, and otherwise we'd lose ordering for
                // subsequent renders.
                let order = $1b917dd7e00f6b34$var$expressionOrders.get(localized);
                if (order === undefined) {
                    order = localized.values;
                    $1b917dd7e00f6b34$var$expressionOrders.set(localized, order);
                }
                return {
                    ...localized,
                    values: order.map((i)=>template.values[i])
                };
            }
        }
    }
    return (0, $30dc421a99632c8b$export$627842c9718b61c7)(template);
}
function $1b917dd7e00f6b34$var$generateId(template) {
    const strings = typeof template === 'string' ? template : template.strings;
    let id = $1b917dd7e00f6b34$var$hashCache.get(strings);
    if (id === undefined) {
        id = (0, $c05ab4410fcfb4e2$export$bb8801913caa27b4)(strings, typeof template !== 'string' && !('strTag' in template));
        $1b917dd7e00f6b34$var$hashCache.set(strings, id);
    }
    return id;
}


/**
 * Dispatch a "lit-localize-status" event to `window` with the given detail.
 */ function $64696e8d83e85192$var$dispatchStatusEvent(detail) {
    window.dispatchEvent(new CustomEvent((0, $62f1633a3e29349e$export$22ecc5ec4a7dfb64), {
        detail: detail
    }));
}
let $64696e8d83e85192$var$activeLocale = '';
let $64696e8d83e85192$var$loadingLocale;
let $64696e8d83e85192$var$sourceLocale;
let $64696e8d83e85192$var$validLocales;
let $64696e8d83e85192$var$loadLocale;
let $64696e8d83e85192$var$templates;
let $64696e8d83e85192$var$loading = new (0, $0443af683f44f5ee$export$85f6557964517f1a)();
// The loading promise must be initially resolved, because that's what we should
// return if the user immediately calls setLocale(sourceLocale).
$64696e8d83e85192$var$loading.resolve();
let $64696e8d83e85192$var$requestId = 0;
const $64696e8d83e85192$export$2f3903bcf09d572a = (config)=>{
    (0, $5c496e1a5b2fd7d3$export$293be9dc57421d1c)((template, options)=>(0, $1b917dd7e00f6b34$export$9a3f0ce3906e68f)($64696e8d83e85192$var$templates, template, options));
    $64696e8d83e85192$var$activeLocale = $64696e8d83e85192$var$sourceLocale = config.sourceLocale;
    $64696e8d83e85192$var$validLocales = new Set(config.targetLocales);
    $64696e8d83e85192$var$validLocales.add(config.sourceLocale);
    $64696e8d83e85192$var$loadLocale = config.loadLocale;
    return {
        getLocale: $64696e8d83e85192$var$getLocale,
        setLocale: $64696e8d83e85192$var$setLocale
    };
};
/**
 * Return the active locale code.
 */ const $64696e8d83e85192$var$getLocale = ()=>{
    return $64696e8d83e85192$var$activeLocale;
};
/**
 * Set the active locale code, and begin loading templates for that locale using
 * the `loadLocale` function that was passed to `configureLocalization`. Returns
 * a promise that resolves when the next locale is ready to be rendered.
 *
 * Note that if a second call to `setLocale` is made while the first requested
 * locale is still loading, then the second call takes precedence, and the
 * promise returned from the first call will resolve when second locale is
 * ready. If you need to know whether a particular locale was loaded, check
 * `getLocale` after the promise resolves.
 *
 * Throws if the given locale is not contained by the configured `sourceLocale`
 * or `targetLocales`.
 */ const $64696e8d83e85192$var$setLocale = (newLocale)=>{
    if (newLocale === ($64696e8d83e85192$var$loadingLocale !== null && $64696e8d83e85192$var$loadingLocale !== void 0 ? $64696e8d83e85192$var$loadingLocale : $64696e8d83e85192$var$activeLocale)) return $64696e8d83e85192$var$loading.promise;
    if (!$64696e8d83e85192$var$validLocales || !$64696e8d83e85192$var$loadLocale) throw new Error('Internal error');
    if (!$64696e8d83e85192$var$validLocales.has(newLocale)) throw new Error('Invalid locale code');
    $64696e8d83e85192$var$requestId++;
    const thisRequestId = $64696e8d83e85192$var$requestId;
    $64696e8d83e85192$var$loadingLocale = newLocale;
    if ($64696e8d83e85192$var$loading.settled) $64696e8d83e85192$var$loading = new (0, $0443af683f44f5ee$export$85f6557964517f1a)();
    $64696e8d83e85192$var$dispatchStatusEvent({
        status: 'loading',
        loadingLocale: newLocale
    });
    const localePromise = newLocale === $64696e8d83e85192$var$sourceLocale ? // queue it on a microtask so that switching locales is consistently
    // asynchronous.
    Promise.resolve({
        templates: undefined
    }) : $64696e8d83e85192$var$loadLocale(newLocale);
    localePromise.then((mod)=>{
        if ($64696e8d83e85192$var$requestId === thisRequestId) {
            $64696e8d83e85192$var$activeLocale = newLocale;
            $64696e8d83e85192$var$loadingLocale = undefined;
            $64696e8d83e85192$var$templates = mod.templates;
            $64696e8d83e85192$var$dispatchStatusEvent({
                status: 'ready',
                readyLocale: newLocale
            });
            $64696e8d83e85192$var$loading.resolve();
        }
    // Else another locale was requested in the meantime. Don't resolve or
    // reject, because the newer load call is going to use the same promise.
    // Note the user can call getLocale() after the promise resolves if they
    // need to check if the locale is still the one they expected to load.
    }, (err)=>{
        if ($64696e8d83e85192$var$requestId === thisRequestId) {
            $64696e8d83e85192$var$dispatchStatusEvent({
                status: 'error',
                errorLocale: newLocale,
                errorMessage: err.toString()
            });
            $64696e8d83e85192$var$loading.reject(err);
        }
    });
    return $64696e8d83e85192$var$loading.promise;
};


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ 

const $8d7557d23cc50568$export$96b14ce1c501d224 = (config)=>{
    (0, $5c496e1a5b2fd7d3$export$293be9dc57421d1c)((0, $30dc421a99632c8b$export$627842c9718b61c7));
    const sourceLocale = config.sourceLocale;
    return {
        getLocale: ()=>sourceLocale
    };
};


let $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf = (0, $30dc421a99632c8b$export$627842c9718b61c7);
let $5c496e1a5b2fd7d3$var$installed = false;
function $5c496e1a5b2fd7d3$export$293be9dc57421d1c(impl) {
    if ($5c496e1a5b2fd7d3$var$installed) throw new Error('lit-localize can only be configured once');
    $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf = impl;
    $5c496e1a5b2fd7d3$var$installed = true;
}


class $421753a939d8b79e$var$FormController {
    constructor(host, { schema: schema, onSubmit: onSubmit }){
        this.host = host;
        this.onSubmit = onSubmit;
        this.#schema = schema || {};
        host.addController(this);
    }
    #schema = {};
    #errors = {};
    #values = {};
    #isSubmitting = false;
    #formErrors = [];
    get schema() {
        return this.#schema;
    }
    set schema(schema) {
        this.#schema = schema;
        this.host.requestUpdate();
    }
    get errors() {
        return this.#errors;
    }
    set errors(errors) {
        this.#errors = errors;
        this.host.requestUpdate();
    }
    get values() {
        return this.#values;
    }
    set values(values) {
        this.#values = values;
        this.host.requestUpdate();
    }
    get isSubmitting() {
        return this.#isSubmitting;
    }
    set isSubmitting(isSubmitting) {
        this.#isSubmitting = isSubmitting;
        this.host.requestUpdate();
    }
    get formErrors() {
        return this.#formErrors;
    }
    set formErrors(formErrors) {
        this.#formErrors = formErrors;
        this.host.requestUpdate();
    }
    inputHandler(event) {
        const value = event?.detail?.value;
        const values = {};
        values[event.detail.name] = value;
        this.values = {
            ...this.values,
            ...values
        };
    }
    async validateField(event) {
        const { errors: errors } = this;
        this?.schema?.validateAt;
        try {
            await this.schema.validateAt(event.detail.name, this.values);
            delete errors[event.detail.name];
        } catch (err) {
            errors[event.detail.name] = err.message;
        }
        this.errors = {
            ...this.errors,
            ...errors
        };
    }
    async validate() {
        if (typeof this?.schema?.validate !== 'function') return true;
        try {
            await this.schema.validate(this.values, {
                abortEarly: false
            });
        } catch (err) {
            console.error('Validation Error', {
                err: err
            });
            err.inner.forEach((error)=>{
                this.errors = {
                    ...this.errors,
                    [error.path]: error.message
                };
            });
            return false;
        }
        return true;
    }
    async submitHandler(event) {
        event.preventDefault();
        this.isSubmitting = true;
        this.formErrors = [];
        const isValid = await this.validate();
        if (!isValid) {
            this.isSubmitting = false;
            return;
        }
        try {
            await this.onSubmit({
                values: this.values,
                errors: this.errors
            });
        } catch (err) {
            console.error('Form Submission Error', {
                err: err
            });
            this.formErrors = [
                err?.message ?? (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Submission failed')
            ];
        }
        this.isSubmitting = false;
    }
}
var $421753a939d8b79e$export$2e2bcd8739ae039 = $421753a939d8b79e$var$FormController;




var $7521568146c72f54$export$2e2bcd8739ae039 = [
    (0, $00b2a1180faf264c$export$2e2bcd8739ae039),
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
    #partners-registration-form-submit-msg.alert {
      padding: 15px;
      margin-bottom: 20px;
      border: 1px solid transparent;
      border-radius: 4px;
    }

    #partners-registration-form-submit-msg.alert-info {
      background-color: #d9edf7;
      border-color: #bce8f1;
      color: #31708f;
    }

    .partners-registration-form-container .error-msg,
    .partners-registration-form-container .submit-msg  {
      text-align: left;
      margin-bottom: 1rem;
    }

    .partners-registration-form-container tenable-form-group,
    #partners-registration-form-desc,
    #partners-registration-form-error-msg {
      text-align: left;
    }

    .partners-registration-form-container tenable-form-group label small {
      font-weight: normal;
    }

    .partners-registration-form-container .registration-btn {
      --tenable-btn-primary-background-color:  #1E2426;
      --tenable-btn-primary-border-color: #1E2426;
      --tenable-btn-primary-disabled-background-color: var(--tenable-btn-primary-background-color, #1E2426);
      --tenable-btn-primary-disabled-border-color: var(--tenable-btn-primary-background-color, #1E2426);
      --tenable-button-width: fit-content;
      text-align: center;
    }

    .partners-registration-form-container #partners-registration-form {
      --tenable-input-placeholder-color: #ccc;
    }
  `
];





/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d139314b822a60f6$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $e0373a6519ee54ad$export$45b790e32b2810ee);





var $c9aec6098b180f88$export$2e2bcd8739ae039 = [
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  `
];


class $0654bdf0689bc81e$var$Form extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $c9aec6098b180f88$export$2e2bcd8739ae039);
    static properties = {
        rel: {
            type: String
        },
        name: {
            type: String
        },
        label: {
            type: String
        },
        noValidate: {
            type: Boolean,
            reflect: true,
            attribute: 'no-validate'
        },
        autoComplete: {
            type: Boolean,
            reflect: true,
            attribute: 'auto-complete'
        },
        errors: {
            type: Object
        },
        values: {
            type: Object
        }
    };
    constructor(){
        super();
        this.rel = '';
        this.name = '';
        this.label = '';
        this.noValidate = false;
        this.autoComplete = true;
        this.errors = {};
        this.values = {};
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.submitButton) this.submitButton.addEventListener('click', this.handleSubmit);
    }
    get submitButton() {
        return this.querySelector("button[type='submit']") || this.querySelector("input[type='submit']");
    }
    handleSubmit = (event)=>{
        event.preventDefault();
        this.dispatchEvent(new CustomEvent('form-submitted', {
            detail: {
                srcEvent: event,
                errors: this.errors,
                values: this.values
            },
            composed: true,
            bubbles: true
        }));
    };
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <form
        @submit=${this.handleSubmit}
        role="form"
        name=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.name || undefined)}
        rel=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.rel || undefined)}
        label=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.label || undefined)}
        autocomplete=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.autoComplete ? 'on' : 'off')}
        ?novalidate=${this.novalidate}
        @handle-submit=${this.handleSubmit}
      >
        <slot></slot>
      </form>
    `;
    }
}
customElements.define('tenable-form', $0654bdf0689bc81e$var$Form);




var $025c96f8783503f0$export$2e2bcd8739ae039 = [
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  .form-group {
    margin: 0 0 1em;
  }

  .form-group ::slotted(label) {
    margin: 0 0 .25rem;
    display: block;
    font-weight: var(--tenable-label-font-weight, 600);
    color: var(--tenable-label-color, #5B6062);
  }
  `
];


class $e6966c51d3f1061b$var$FormGroup extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $025c96f8783503f0$export$2e2bcd8739ae039);
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <div class="form-group">
        <slot></slot>
      </div>
    `;
    }
}
customElements.define('tenable-form-group', $e6966c51d3f1061b$var$FormGroup);




var $e450632068650c9f$export$2e2bcd8739ae039 = [
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  :host {
    color: var(--tenable-form-error-color, #9C2121);
    font-size: var(--tenable-form-error-font-size, 100%);
  }`
];


class $4e83f4e8cdd08cde$var$FormFeedback extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $e450632068650c9f$export$2e2bcd8739ae039);
    static properties = {
        message: {
            type: String
        },
        hidden: {
            type: Boolean
        }
    };
    constructor(){
        super();
        this.message = '';
        this.hidden = false;
    }
    render() {
        return this.message && !this.hidden && (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<div>${this.message}</div>`;
    }
}
customElements.define('tenable-form-feedback', $4e83f4e8cdd08cde$var$FormFeedback);




var $e3e41ad6c31f228c$export$2e2bcd8739ae039 = [
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  ul {
    color: var(--tenable-form-error-text-color, #ffffff);
    background: var(--tenable-form-error-background, var(--tenable-form-error-color, #9C2121));
    border: 1px solid var(--tenable-form-error-border-color, transparent);
    border-radius: 3px;
    padding: .5rem;
    margin-bottom: 1rem;
    list-style: none;
  }

  li {
    color: var(--tenable-form-error-text-color, #ffffff);
    line-height: 1.2;
  }
  `
];


class $0d0124388a53b412$var$FormError extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $e3e41ad6c31f228c$export$2e2bcd8739ae039);
    static properties = {
        errors: {
            type: Array
        }
    };
    constructor(){
        super();
        this.errors = [];
    }
    render() {
        if (!this.errors?.length) return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)``;
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
    <ul>
      ${this.errors.map((error)=>(0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<li>${error}</li>`)}
    </ul>
  `;
    }
}
customElements.define('tenable-form-error', $0d0124388a53b412$var$FormError);





/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $dfdf7a5ae1edfed3$export$56cc687933817664 = (0, $95d4e5daf5753923$export$99b43ad1ed32e735)(class extends (0, $95d4e5daf5753923$export$befdefbdce210f91) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $95d4e5daf5753923$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $e0373a6519ee54ad$export$9c068ae9cc5db4e8;
    }
});






var $e17685f55d791d93$export$2e2bcd8739ae039 = [
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  /* Input */
  input[type="text"],
  input[type="email"],
  input[type="password"],
  input[type="tel"],
  input[type="url"],
  input[type="number"],
  input[type="datetime-local"] {
    width: var(--tenable-input-width, 100%);
    border: var(--tenable-input-border, 1px solid #ccc);
    border-radius: var(--tenable-input-border-radius, 0);
    padding: var(--tenable-input-padding, .5rem);
    display: var(--tenable-input-display, block);
    box-shadow: inset 0 1px 2px #0000000d;
    font: var(--tenable-input-font, inherit);
    line-height: var(--tenable-input-line-height, normal);
    box-sizing:  var(--tenable-input-box-sizing, border-box);
    font-size: var(--tenable-input-font-size, 1rem);
    background-color: var(--tenable-input-background, #ffffff);
    color: var(--tenable-input-color, #5B6062);
  }

  input[type="checkbox"],
  input[type="radio"] {
    accent-color: var(--tenable-input-accent-color, #1E2426);
  }

  input:focus {
    border-color: var(--tenable-input-focus-border-color, #1E2426);
    box-shadow: var(--tenable-input-focus-box-shadow, 0 0 0 .15rem rgba(13,110,253,.25));
    outline: 0;
  }

  input.invalid {
    border-color: var(--tenable-input-invalid-border-color, #9C2121);
  }

  input[type="hidden"] {
    display: none;
  }

  input::placeholder {
    color: var(--tenable-input-placeholder-color, #5B6062);
    font-weight: var(--tenable-input-placeholder-font-weight, 400);
  }

  /* Input Hides Default Browser Styling */
  input.hide-spinner::-webkit-outer-spin-button,
  input.hide-spinner::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input.hide-spinner[type=number] {
    -moz-appearance: textfield;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-text-fill-color: var(--tenable-input-color, #5B6062);
    -webkit-box-shadow: 0 0 0px 1000px var(--tenable-input-autofill-background, #e9f5ff) inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  /* Label */
  label {
    margin: var(--tenable-label-margin, 0 0 .25rem);
    display: block;
    font-weight: var(--tenable-label-font-weight, 600);
    color: var(--tenable-label-color, #5B6062);
  }

  /* Floating Label */
  .form-floating {
    position: relative;
  }

  .form-floating label {
    display: inline-block;
    position: absolute;
    top: var(--tenable-input-padding, .75rem);
    left: var(--tenable-input-padding, .75rem);
    pointer-events: none;
    transition: all .1s ease-in-out;
    color: var(--tenable-input-placeholder-color, var(--tenable-text-color, #5B6062));
    font-weight: var(--tenable-input-placeholder-font-weight, 400);
  }

  .form-floating input {
    padding: .75rem;
    font-size: 1rem;
  }

  .form-floating input:focus,
  .form-floating input:not(:placeholder-shown) {
    padding: 1.15rem 0.75rem 0.35rem;
  }

  .form-floating input:not(:placeholder-shown) + label,
  .form-floating input:focus + label {
    font-size: .75rem;
    transform: translate(0, -.50rem);
    color: var(--tenable-label-floating-color, #5B6062);
  }
  `
];


class $42efdfd9e51eecd0$var$Input extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $e17685f55d791d93$export$2e2bcd8739ae039);
    static properties = {
        type: {
            type: String,
            converter: (value)=>[
                    'text',
                    'email',
                    'password',
                    'number',
                    'tel',
                    'url',
                    'hidden',
                    'checkbox',
                    'radio',
                    'datetime-local',
                    'file'
                ].includes(value) ? value : 'text'
        },
        name: {
            type: String
        },
        id: {
            type: String
        },
        placeholder: {
            type: String
        },
        min: {
            type: String
        },
        max: {
            type: String
        },
        maxLength: {
            type: String,
            attribute: 'max-length'
        },
        invalid: {
            type: Boolean,
            reflect: true
        },
        required: {
            type: Boolean,
            reflect: true
        },
        autofocus: {
            type: Boolean,
            reflect: true
        },
        disabled: {
            type: Boolean,
            reflect: true
        },
        readonly: {
            type: Boolean,
            reflect: true
        },
        ariaDescribedBy: {
            type: String,
            attribute: 'aria-describedby'
        },
        ariaLabel: {
            type: String,
            attribute: 'aria-label'
        },
        ariaInvalid: {
            type: String,
            attribute: 'aria-invalid'
        },
        value: {
            type: String,
            reflect: true
        },
        checked: {
            type: Boolean,
            reflect: true
        },
        label: {
            type: String
        },
        hideLabel: {
            type: Boolean
        },
        labelType: {
            type: String,
            attribute: 'label-type',
            converter: (value)=>[
                    'before',
                    'after',
                    'around',
                    'float'
                ].includes(value) ? value : 'before'
        },
        accept: {
            type: String
        },
        multiple: {
            type: Boolean,
            reflect: true
        },
        inputmode: {
            type: String,
            reflect: true
        },
        hideSpinner: {
            type: Boolean,
            attribute: 'hide-spinner'
        }
    };
    constructor(){
        super();
        this.type = 'text';
        this.name = '';
        this.id = undefined;
        this.placeholder = '';
        this.min = undefined;
        this.max = undefined;
        this.maxLength = undefined;
        this.invalid = false;
        this.required = false;
        this.autofocus = false;
        this.disabled = false;
        this.readonly = false;
        this.ariaDescribedBy = '';
        this.ariaLabel = '';
        this.value = '';
        this.checked = false;
        this.label = '';
        this.hideLabel = false;
        this.labelType = 'before';
        this.accept = '';
        this.multiple = false;
        this.inputmode = undefined;
        this.hideSpinner = false;
    }
    #handleChange(event) {
        let { value: value } = event.target;
        if (this.type === 'checkbox') value = event.target.checked;
        if (this.type === 'file') value = Array.from(event.target.files);
        this.value = value;
        this.dispatchEvent(new CustomEvent('input-change', {
            bubbles: true,
            composed: true,
            detail: {
                srcEvent: event,
                name: this.name,
                value: value
            }
        }));
    }
    #handleBlur(event) {
        this.dispatchEvent(new CustomEvent('input-blur', {
            bubbles: true,
            composed: true,
            detail: {
                srcEvent: event,
                name: this.name
            }
        }));
    }
    #handleKeyDown(event) {
        this.dispatchEvent(new CustomEvent('input-keydown', {
            bubbles: true,
            composed: true,
            detail: {
                srcEvent: event
            }
        }));
    }
    #handleFocus(event) {
        if (!this.disabled) this.dispatchEvent(new CustomEvent('input-focus', {
            bubbles: true,
            composed: true,
            detail: {
                srcEvent: event
            }
        }));
    }
    #handleMouseDown(event) {
        if (!this.disabled) this.dispatchEvent(new CustomEvent('input-mousedown', {
            bubbles: true,
            composed: true,
            detail: {
                srcEvent: event
            }
        }));
    }
    #handleValueChange() {
        this.dispatchEvent(new CustomEvent('input-change', {
            bubbles: true,
            composed: true,
            detail: {
                name: this.name,
                value: this.value
            }
        }));
    }
    render() {
        this.#handleValueChange();
        const classes = (0, $dfdf7a5ae1edfed3$export$56cc687933817664)({
            invalid: this.invalid,
            'hide-spinner': this.hideSpinner
        });
        // Helper to render label content: prefer slotted content, fallback to this.label
        const labelContent = (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<slot name="label">${this.label}</slot>`;
        const input = (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<input
      @blur=${this.#handleBlur}
      @input=${this.#handleChange}
      @focus=${this.#handleFocus}
      @keydown=${this.#handleKeyDown}
      @mousedown=${this.#handleMouseDown}
      class=${classes}
      type=${this.type}
      name=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.name || undefined)}
      id=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.id)}
      data-testid=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.id ?? this.name)}
      ?invalid=${this.invalid}
      ?required=${this.required}
      ?autofocus=${this.autofocus}
      ?disabled=${this.disabled}
      ?readonly=${this.readonly}
      aria-describedby=${this.ariaDescribedBy}
      aria-label=${this.ariaLabel}
      placeholder=${this.hideLabel ? this.label : this.placeholder}
      min=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.min)}
      max=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.max)}
      maxlength=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.maxLength)}
      .value=${this.value}
      .checked=${this.checked}
      accept=${this.accept}
      .multiple=${this.multiple}
      inputmode=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.inputmode)}
    >`;
        // If label is hidden, render only the input. Otherwise, allow slotted label or text label.
        if (this.hideLabel) return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`${input}`;
        if (this.labelType === 'float') return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
        <div class="form-floating">
          ${input}
          <label for=${this.id || this.name}>${labelContent}</label>
        </div>
      `;
        if (this.labelType === 'before') return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<label for=${this.id || this.name}>${labelContent}</label>${input}`;
        if (this.labelType === 'around') return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<label for=${this.id || this.name}>${labelContent}${input}</label>`;
        if (this.labelType === 'after') return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<label for=${this.id || this.name}>${input}${labelContent}</label>`;
        return '';
    }
}
customElements.define('tenable-input', $42efdfd9e51eecd0$var$Input);






var $891d9573f8a3dcaa$export$2e2bcd8739ae039 = [
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  select {
    background: var(--tenable-input-background, #ffffff);
    width: var(--tenable-input-width, 100%);
    border: var(--tenable-input-border, 1px solid #ccc);
    border-radius: var(--tenable-input-border-radius, 0);
    padding: var(--tenable-input-padding, .5rem);
    height: var(--tenable-input-height, 2.5rem);
    display: var(--tenable-input-display, block !important);
    box-shadow: var(--tenable-input-box-shadow, inset 0 1px 2px #0000000d);
    font: var(--tenable-input-font, inherit);
    line-height: var(--tenable-input-line-height, normal);
    box-sizing:  var(--tenable-input-box-sizing, border-box);
  }

  select[multiple] {
    height: auto;
  }

  select:focus {
    border-color: var(--tenable-input-focus-border-color, #1E2426);
    box-shadow: var(--tenable-input-focus-box-shadow, 0 0 0 .15rem rgba(13,110,253,.25));
    outline: 0;
  }

  select.invalid {
    border-color: var(--tenable-input-invalid-border-color, #9C2121);
  }

  select.placeholder {
    color: var(--tenable-input-placeholder-color, #5B6062);
  }

  label {
    margin: var(--tenable-label-margin, 0 0 .25rem);
    display: block;
    font-weight: var(--tenable-label-font-weight, 600);
    color: var(--tenable-label-color, #5B6062);
  }

  /* Floating Label */
  .form-floating {
    position: relative;
  }

  .form-floating label {
    display: inline-block;
    position: absolute;
    top: var(--tenable-input-padding, .5rem);
    left: var(--tenable-input-padding, .75rem);
    pointer-events: none;
    transition: all .1s ease-in-out;
    color: var(--tenable-input-placeholder-color, var(--tenable-text-color, #5B6062));
    font-weight: var(--tenable-input-placeholder-font-weight, 400);
  }

  .form-floating select {
    font-size: 1rem;
    padding: 0.85rem 0.75rem 0.35rem;
    color: var(--tenable-text-color, #5B6062);
  }

  .form-floating select + label:not(.blank-placeholder),
  .form-floating select:focus + label {
    font-size: .75rem;
    transform: translate(0, -.50rem);
    color: var(--tenable-label-floating-color, #5B6062);
  }
  `
];


class $39d875f8f5ca6a6d$var$Select extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $891d9573f8a3dcaa$export$2e2bcd8739ae039);
    static properties = {
        type: {
            type: String,
            converter: (value)=>[
                    'text',
                    'email',
                    'password',
                    'number',
                    'tel',
                    'url',
                    'hidden',
                    'checkbox'
                ].includes(value) ? value : 'text'
        },
        name: {
            type: String
        },
        id: {
            type: String
        },
        invalid: {
            type: Boolean,
            reflect: true
        },
        required: {
            type: Boolean,
            reflect: true
        },
        autofocus: {
            type: Boolean,
            reflect: true
        },
        disabled: {
            type: Boolean,
            reflect: true
        },
        ariaDescribedBy: {
            type: String,
            attribute: 'aria-describedby'
        },
        ariaLabel: {
            type: String,
            attribute: 'aria-label'
        },
        ariaInvalid: {
            type: String,
            attribute: 'aria-invalid'
        },
        value: {
            type: String,
            reflect: true
        },
        checked: {
            type: Boolean,
            reflect: true
        },
        label: {
            type: String
        },
        hideLabel: {
            type: Boolean
        },
        labelType: {
            type: String,
            attribute: 'label-type',
            converter: (value)=>[
                    'before',
                    'after',
                    'around',
                    'float'
                ].includes(value) ? value : 'before'
        },
        options: {
            type: Array
        },
        multiple: {
            type: Boolean,
            reflect: true
        },
        size: {
            type: Number
        },
        values: {
            reflect: true,
            converter: {
                fromAttribute: (value)=>value.split(','),
                toAttribute: (value)=>String(value.join())
            }
        }
    };
    constructor(){
        super();
        this.type = 'text';
        this.name = '';
        this.id = undefined;
        this.min = undefined;
        this.max = undefined;
        this.maxLength = undefined;
        this.invalid = false;
        this.required = false;
        this.autofocus = false;
        this.disabled = false;
        this.readonly = false;
        this.ariaDescribedBy = '';
        this.ariaLabel = '';
        this.value = '';
        this.checked = false;
        this.label = '';
        this.hideLabel = false;
        this.labelType = 'before';
        this.options = [];
        this.multiple = false;
        this.values = [];
        this.size = undefined;
    }
    #handleChange(event) {
        let { value: value } = event.target;
        let values = [];
        if (this.multiple) {
            values = Array.prototype.slice.call(event.target.querySelectorAll('option:checked'), 0).map((v)=>v.value);
            value = values.join();
        }
        this.value = value;
        this.values = values;
        this.dispatchEvent(new CustomEvent('input-change', {
            bubbles: true,
            composed: true,
            detail: {
                srcEvent: event,
                name: this.name,
                value: this.multiple ? this.values : this.value
            }
        }));
    }
    #handleBlur(event) {
        this.dispatchEvent(new CustomEvent('input-blur', {
            bubbles: true,
            composed: true,
            detail: {
                srcEvent: event,
                name: this.name
            }
        }));
    }
    #handleKeyDown(event) {
        this.dispatchEvent(new CustomEvent('input-keydown', {
            bubbles: true,
            composed: true,
            detail: {
                srcEvent: event
            }
        }));
    }
    #handleFocus(event) {
        if (!this.disabled) this.dispatchEvent(new CustomEvent('input-focus', {
            bubbles: true,
            composed: true,
            detail: {
                srcEvent: event
            }
        }));
    }
    #handleMouseDown(event) {
        if (!this.disabled) this.dispatchEvent(new CustomEvent('input-mousedown', {
            bubbles: true,
            composed: true,
            detail: {
                srcEvent: event
            }
        }));
    }
    #handleValueChange() {
        this.dispatchEvent(new CustomEvent('input-change', {
            bubbles: true,
            composed: true,
            detail: {
                name: this.name,
                value: this.multiple ? this.values : this.value
            }
        }));
    }
    render() {
        this.#handleValueChange();
        const selectedOption = this.options.find((option)=>option.value === this.value);
        const input = (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <select
        @blur=${this.#handleBlur}
        @input=${this.#handleChange}
        @focus=${this.#handleFocus}
        @keydown=${this.#handleKeyDown}
        @mousedown=${this.#handleMouseDown}
        class=${(0, $dfdf7a5ae1edfed3$export$56cc687933817664)({
            invalid: this.invalid,
            placeholder: selectedOption?.placeholder === true
        })}
        name=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.name || undefined)}
        id=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.id)}
        data-testid=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.id ?? this.name)}
        ?invalid=${this.invalid}
        ?required=${this.required}
        ?autofocus=${this.autofocus}
        ?disabled=${this.disabled}
        ?multiple=${this.multiple}
        size=${(0, $d139314b822a60f6$export$f68dd208b5df064d)(this.size)}
        aria-describedby=${this.ariaDescribedBy}
        aria-label=${this.ariaLabel}
      >
        ${this.options.map((option)=>(0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
          <option value=${option.value} ?selected=${this.multiple ? this.values.includes(option.value) : option.value === this.value} ?disabled=${option.disabled}>
            ${this.hideLabel ? `${this.label}: ${option.label}` : option.label}
          </option>
        `)}
      </select>
  `;
        if (!this.label || this.hideLabel) return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`${input}`;
        if (this.labelType === 'float') return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
        <div class="form-floating">
          ${input}
          <label for=${this.name} class=${(0, $dfdf7a5ae1edfed3$export$56cc687933817664)({
            'blank-placeholder': selectedOption?.placeholder === true && selectedOption?.label === ''
        })}>${this.label}</label>
        </div>
      `;
        if (this.labelType === 'before') return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<label for=${this.name}>${this.label}</label>${input}`;
        if (this.labelType === 'around') return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<label for=${this.name}>${this.label}${input}</label>`;
        if (this.labelType === 'after') return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<label for=${this.name}>${input}${this.label}</label>`;
        return '';
    }
}
customElements.define('tenable-select', $39d875f8f5ca6a6d$var$Select);
var $39d875f8f5ca6a6d$export$2e2bcd8739ae039 = $39d875f8f5ca6a6d$var$Select;


var $6bf48344a7d4c6c4$exports = {};
var $b23d02e8cb93f570$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $b23d02e8cb93f570$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$b23d02e8cb93f570$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$b23d02e8cb93f570$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$b23d02e8cb93f570$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $b23d02e8cb93f570$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $b23d02e8cb93f570$var$DIGIT_REGEX = /^\d+$/, $b23d02e8cb93f570$var$LEAD_DIGIT_REGEX = /^\d/, $b23d02e8cb93f570$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $b23d02e8cb93f570$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $b23d02e8cb93f570$var$MAX_CACHE_SIZE = 512;
var $b23d02e8cb93f570$var$pathCache = new $b23d02e8cb93f570$var$Cache($b23d02e8cb93f570$var$MAX_CACHE_SIZE), $b23d02e8cb93f570$var$setCache = new $b23d02e8cb93f570$var$Cache($b23d02e8cb93f570$var$MAX_CACHE_SIZE), $b23d02e8cb93f570$var$getCache = new $b23d02e8cb93f570$var$Cache($b23d02e8cb93f570$var$MAX_CACHE_SIZE);
var $b23d02e8cb93f570$var$config;
$b23d02e8cb93f570$exports = {
    Cache: $b23d02e8cb93f570$var$Cache,
    split: $b23d02e8cb93f570$var$split,
    normalizePath: $b23d02e8cb93f570$var$normalizePath,
    setter: function(path) {
        var parts = $b23d02e8cb93f570$var$normalizePath(path);
        return $b23d02e8cb93f570$var$setCache.get(path) || $b23d02e8cb93f570$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $b23d02e8cb93f570$var$normalizePath(path);
        return $b23d02e8cb93f570$var$getCache.get(path) || $b23d02e8cb93f570$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($b23d02e8cb93f570$var$isQuoted(part) || $b23d02e8cb93f570$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $b23d02e8cb93f570$var$forEach(Array.isArray(path) ? path : $b23d02e8cb93f570$var$split(path), cb, thisArg);
    }
};
function $b23d02e8cb93f570$var$normalizePath(path) {
    return $b23d02e8cb93f570$var$pathCache.get(path) || $b23d02e8cb93f570$var$pathCache.set(path, $b23d02e8cb93f570$var$split(path).map(function(part) {
        return part.replace($b23d02e8cb93f570$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $b23d02e8cb93f570$var$split(path) {
    return path.match($b23d02e8cb93f570$var$SPLIT_REGEX) || [
        ''
    ];
}
function $b23d02e8cb93f570$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($b23d02e8cb93f570$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $b23d02e8cb93f570$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $b23d02e8cb93f570$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $b23d02e8cb93f570$var$hasLeadingNumber(part) {
    return part.match($b23d02e8cb93f570$var$LEAD_DIGIT_REGEX) && !part.match($b23d02e8cb93f570$var$DIGIT_REGEX);
}
function $b23d02e8cb93f570$var$hasSpecialChars(part) {
    return $b23d02e8cb93f570$var$SPEC_CHAR_REGEX.test(part);
}
function $b23d02e8cb93f570$var$shouldBeQuoted(part) {
    return !$b23d02e8cb93f570$var$isQuoted(part) && ($b23d02e8cb93f570$var$hasLeadingNumber(part) || $b23d02e8cb93f570$var$hasSpecialChars(part));
}


var $791c2d08d57990b5$exports = {};
const $791c2d08d57990b5$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $791c2d08d57990b5$var$words = (str)=>str.match($791c2d08d57990b5$var$reWords) || [];
const $791c2d08d57990b5$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $791c2d08d57990b5$var$join = (str, d)=>$791c2d08d57990b5$var$words(str).join(d).toLowerCase();
const $791c2d08d57990b5$var$camelCase = (str)=>$791c2d08d57990b5$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const $791c2d08d57990b5$var$pascalCase = (str)=>$791c2d08d57990b5$var$upperFirst($791c2d08d57990b5$var$camelCase(str));
const $791c2d08d57990b5$var$snakeCase = (str)=>$791c2d08d57990b5$var$join(str, '_');
const $791c2d08d57990b5$var$kebabCase = (str)=>$791c2d08d57990b5$var$join(str, '-');
const $791c2d08d57990b5$var$sentenceCase = (str)=>$791c2d08d57990b5$var$upperFirst($791c2d08d57990b5$var$join(str, ' '));
const $791c2d08d57990b5$var$titleCase = (str)=>$791c2d08d57990b5$var$words(str).map($791c2d08d57990b5$var$upperFirst).join(' ');
$791c2d08d57990b5$exports = {
    words: $791c2d08d57990b5$var$words,
    upperFirst: $791c2d08d57990b5$var$upperFirst,
    camelCase: $791c2d08d57990b5$var$camelCase,
    pascalCase: $791c2d08d57990b5$var$pascalCase,
    snakeCase: $791c2d08d57990b5$var$snakeCase,
    kebabCase: $791c2d08d57990b5$var$kebabCase,
    sentenceCase: $791c2d08d57990b5$var$sentenceCase,
    titleCase: $791c2d08d57990b5$var$titleCase
};


var $43bed39701948fae$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $43bed39701948fae$exports = function(edges) {
    return $43bed39701948fae$var$toposort($43bed39701948fae$var$uniqueNodes(edges), edges);
};
$43bed39701948fae$exports.array = $43bed39701948fae$var$toposort;
function $43bed39701948fae$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $43bed39701948fae$var$makeOutgoingEdges(edges), nodesHash = $43bed39701948fae$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $43bed39701948fae$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $43bed39701948fae$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $43bed39701948fae$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $5489e3723f5efb95$var$toString = Object.prototype.toString;
const $5489e3723f5efb95$var$errorToString = Error.prototype.toString;
const $5489e3723f5efb95$var$regExpToString = RegExp.prototype.toString;
const $5489e3723f5efb95$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $5489e3723f5efb95$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $5489e3723f5efb95$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $5489e3723f5efb95$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $5489e3723f5efb95$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $5489e3723f5efb95$var$symbolToString.call(val).replace($5489e3723f5efb95$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $5489e3723f5efb95$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $5489e3723f5efb95$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $5489e3723f5efb95$var$regExpToString.call(val);
    return null;
}
function $5489e3723f5efb95$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $5489e3723f5efb95$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $5489e3723f5efb95$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $5489e3723f5efb95$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $5489e3723f5efb95$var$_Symbol$toStringTag, $5489e3723f5efb95$var$_Symbol$hasInstance, $5489e3723f5efb95$var$_Symbol$toStringTag2;
let $5489e3723f5efb95$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$5489e3723f5efb95$var$_Symbol$toStringTag = Symbol.toStringTag;
class $5489e3723f5efb95$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$5489e3723f5efb95$var$_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $5489e3723f5efb95$var$toArray(errorOrErrors).forEach((err)=>{
            if ($5489e3723f5efb95$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$5489e3723f5efb95$var$_Symbol$hasInstance = Symbol.hasInstance;
$5489e3723f5efb95$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $5489e3723f5efb95$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || 'this';
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === 'string') return message.replace($5489e3723f5efb95$var$strReg, (_, key)=>$5489e3723f5efb95$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $5489e3723f5efb95$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$5489e3723f5efb95$var$_Symbol$toStringTag2] = 'Error';
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $5489e3723f5efb95$export$2191b9da168c6cf0);
    }
    static [$5489e3723f5efb95$var$_Symbol$hasInstance](inst) {
        return $5489e3723f5efb95$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $5489e3723f5efb95$var$mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    defined: '${path} must be defined',
    notNull: '${path} cannot be null',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$5489e3723f5efb95$export$5790025c6e6c2ba6(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$5489e3723f5efb95$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$5489e3723f5efb95$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $5489e3723f5efb95$var$string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    datetime: '${path} must be a valid ISO date-time',
    datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $5489e3723f5efb95$var$number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $5489e3723f5efb95$var$date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $5489e3723f5efb95$var$boolean = {
    isValue: '${path} field must be ${value}'
};
let $5489e3723f5efb95$var$object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}',
    exact: '${path} object contains unknown properties: ${properties}'
};
let $5489e3723f5efb95$var$array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
let $5489e3723f5efb95$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$5489e3723f5efb95$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$5489e3723f5efb95$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $5489e3723f5efb95$export$2191b9da168c6cf0.formatError($5489e3723f5efb95$var$mixed.notType, params);
    }
};
var $5489e3723f5efb95$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $5489e3723f5efb95$var$mixed,
    string: $5489e3723f5efb95$var$string,
    number: $5489e3723f5efb95$var$number,
    date: $5489e3723f5efb95$var$date,
    object: $5489e3723f5efb95$var$object,
    array: $5489e3723f5efb95$var$array,
    boolean: $5489e3723f5efb95$var$boolean,
    tuple: $5489e3723f5efb95$var$tuple
});
const $5489e3723f5efb95$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $5489e3723f5efb95$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        return new $5489e3723f5efb95$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$5489e3723f5efb95$export$213e2a3e7c4f326e(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
const $5489e3723f5efb95$var$prefixes = {
    context: '$',
    value: '.'
};
function $5489e3723f5efb95$export$eff4d24c3ff7876e(key, options) {
    return new $5489e3723f5efb95$var$Reference(key, options);
}
class $5489e3723f5efb95$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $5489e3723f5efb95$var$prefixes.context;
        this.isValue = this.key[0] === $5489e3723f5efb95$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $5489e3723f5efb95$var$prefixes.context : this.isValue ? $5489e3723f5efb95$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $b23d02e8cb93f570$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$5489e3723f5efb95$var$Reference.prototype.__isYupRef = true;
const $5489e3723f5efb95$var$isAbsent = (value)=>value == null;
function $5489e3723f5efb95$var$createValidation(config) {
    function validate({ value: value, path: path = '', options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        const resolveOptions = {
            value: value,
            parent: parent,
            context: context
        };
        function createError(overrides = {}) {
            const nextParams = $5489e3723f5efb95$var$resolveParams(Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params), resolveOptions);
            const error = new $5489e3723f5efb95$export$2191b9da168c6cf0($5489e3723f5efb95$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve (item) {
                return $5489e3723f5efb95$var$resolveMaybeRef(item, resolveOptions);
            },
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($5489e3723f5efb95$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($5489e3723f5efb95$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $5489e3723f5efb95$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
// Warning: mutates the input
function $5489e3723f5efb95$var$resolveParams(params, options) {
    if (!params) return params;
    for (const key of Object.keys(params))params[key] = $5489e3723f5efb95$var$resolveMaybeRef(params[key], options);
    return params;
}
function $5489e3723f5efb95$var$resolveMaybeRef(item, options) {
    return $5489e3723f5efb95$var$Reference.isRef(item) ? item.getValue(options.value, options.parent, options.context) : item;
}
function $5489e3723f5efb95$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $b23d02e8cb93f570$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $5489e3723f5efb95$export$cfedb76369cc7782(obj, path, value, context) {
    return $5489e3723f5efb95$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $5489e3723f5efb95$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($5489e3723f5efb95$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $5489e3723f5efb95$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $5489e3723f5efb95$var$clone(src, seen = new Map()) {
    if ($5489e3723f5efb95$export$213e2a3e7c4f326e(src) || !src || typeof src !== 'object') return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $5489e3723f5efb95$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $5489e3723f5efb95$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($5489e3723f5efb95$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $5489e3723f5efb95$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
/**
 * Copied from @standard-schema/spec to avoid having a dependency on it.
 * https://github.com/standard-schema/standard-schema/blob/main/packages/spec/src/index.ts
 */ function $5489e3723f5efb95$var$createStandardPath(path) {
    if (!(path != null && path.length)) return undefined;
    // Array to store the final path segments
    const segments = [];
    // Buffer for building the current segment
    let currentSegment = '';
    // Track if we're inside square brackets (array/property access)
    let inBrackets = false;
    // Track if we're inside quotes (for property names with special chars)
    let inQuotes = false;
    for(let i = 0; i < path.length; i++){
        const char = path[i];
        if (char === '[' && !inQuotes) {
            // When entering brackets, push any accumulated segment after splitting on dots
            if (currentSegment) {
                segments.push(...currentSegment.split('.').filter(Boolean));
                currentSegment = '';
            }
            inBrackets = true;
            continue;
        }
        if (char === ']' && !inQuotes) {
            if (currentSegment) {
                // Handle numeric indices (e.g. arr[0])
                if (/^\d+$/.test(currentSegment)) segments.push(currentSegment);
                else // Handle quoted property names (e.g. obj["foo.bar"])
                segments.push(currentSegment.replace(/^"|"$/g, ''));
                currentSegment = '';
            }
            inBrackets = false;
            continue;
        }
        if (char === '"') {
            // Toggle quote state for handling quoted property names
            inQuotes = !inQuotes;
            continue;
        }
        if (char === '.' && !inBrackets && !inQuotes) {
            // On dots outside brackets/quotes, push current segment
            if (currentSegment) {
                segments.push(currentSegment);
                currentSegment = '';
            }
            continue;
        }
        currentSegment += char;
    }
    // Push any remaining segment after splitting on dots
    if (currentSegment) segments.push(...currentSegment.split('.').filter(Boolean));
    return segments;
}
function $5489e3723f5efb95$var$createStandardIssues(error, parentPath) {
    const path = parentPath ? `${parentPath}.${error.path}` : error.path;
    return error.errors.map((err)=>({
            message: err,
            path: $5489e3723f5efb95$var$createStandardPath(path)
        }));
}
function $5489e3723f5efb95$var$issuesFromValidationError(error, parentPath) {
    var _error$inner;
    if (!((_error$inner = error.inner) != null && _error$inner.length) && error.errors.length) return $5489e3723f5efb95$var$createStandardIssues(error, parentPath);
    const path = parentPath ? `${parentPath}.${error.path}` : error.path;
    return error.inner.flatMap((err)=>$5489e3723f5efb95$var$issuesFromValidationError(err, path));
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $5489e3723f5efb95$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $5489e3723f5efb95$var$ReferenceSet();
        this._blacklist = new $5489e3723f5efb95$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($5489e3723f5efb95$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $5489e3723f5efb95$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $5489e3723f5efb95$var$isAbsent(result)) return result;
            let formattedValue = $5489e3723f5efb95$export$5790025c6e6c2ba6(value);
            let formattedResult = $5489e3723f5efb95$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this, options), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError('Must include `key` or `index` for nested validations');
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? 'index' : 'key']: k,
            path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($5489e3723f5efb95$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $5489e3723f5efb95$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($5489e3723f5efb95$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $5489e3723f5efb95$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($5489e3723f5efb95$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($5489e3723f5efb95$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : $5489e3723f5efb95$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $5489e3723f5efb95$var$createValidation({
            message: message,
            name: 'nullable',
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $5489e3723f5efb95$var$createValidation({
            message: message,
            name: 'optionality',
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $5489e3723f5efb95$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $5489e3723f5efb95$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $5489e3723f5efb95$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $5489e3723f5efb95$var$mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = $5489e3723f5efb95$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = $5489e3723f5efb95$var$toArray(keys).map((key)=>new $5489e3723f5efb95$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new $5489e3723f5efb95$var$Condition(deps, options) : $5489e3723f5efb95$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $5489e3723f5efb95$var$createValidation({
            message: message,
            name: 'typeError',
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $5489e3723f5efb95$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $5489e3723f5efb95$var$createValidation({
            message: message,
            name: 'oneOf',
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $5489e3723f5efb95$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $5489e3723f5efb95$var$createValidation({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.filter((n, idx, list)=>list.findIndex((c)=>c.OPTIONS.name === n.OPTIONS.name) === idx).map((fn)=>{
                const params = fn.OPTIONS.params && options ? $5489e3723f5efb95$var$resolveParams(Object.assign({}, fn.OPTIONS.params), options) : fn.OPTIONS.params;
                return {
                    name: fn.OPTIONS.name,
                    params: params
                };
            })
        };
        return description;
    }
    get ['~standard']() {
        const schema = this;
        const standard = {
            version: 1,
            vendor: 'yup',
            async validate (value) {
                try {
                    const result = await schema.validate(value, {
                        abortEarly: false
                    });
                    return {
                        value: result
                    };
                } catch (err) {
                    if (err instanceof $5489e3723f5efb95$export$2191b9da168c6cf0) return {
                        issues: $5489e3723f5efb95$var$issuesFromValidationError(err)
                    };
                    throw err;
                }
            }
        };
        return standard;
    }
}
// @ts-expect-error
$5489e3723f5efb95$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$5489e3723f5efb95$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $5489e3723f5efb95$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$5489e3723f5efb95$export$19342e026b58ebb7.prototype[alias] = $5489e3723f5efb95$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$5489e3723f5efb95$export$19342e026b58ebb7.prototype[alias] = $5489e3723f5efb95$export$19342e026b58ebb7.prototype.notOneOf;
const $5489e3723f5efb95$var$returnsTrue = ()=>true;
function $5489e3723f5efb95$export$9b30b6294c1449a8(spec) {
    return new $5489e3723f5efb95$export$1e88358c94ddec71(spec);
}
class $5489e3723f5efb95$export$1e88358c94ddec71 extends $5489e3723f5efb95$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === 'function' ? {
            type: 'mixed',
            check: spec
        } : Object.assign({
            type: 'mixed',
            check: $5489e3723f5efb95$var$returnsTrue
        }, spec));
    }
}
$5489e3723f5efb95$export$9b30b6294c1449a8.prototype = $5489e3723f5efb95$export$1e88358c94ddec71.prototype;
function $5489e3723f5efb95$export$87b259aa03e3d267() {
    return new $5489e3723f5efb95$export$c7980688f11e1f49();
}
class $5489e3723f5efb95$export$c7980688f11e1f49 extends $5489e3723f5efb95$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'boolean',
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (this.spec.coerce && !this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $5489e3723f5efb95$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return $5489e3723f5efb95$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $5489e3723f5efb95$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return $5489e3723f5efb95$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$5489e3723f5efb95$export$87b259aa03e3d267.prototype = $5489e3723f5efb95$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $5489e3723f5efb95$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $5489e3723f5efb95$var$parseIsoDate(date) {
    const struct = $5489e3723f5efb95$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $5489e3723f5efb95$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $5489e3723f5efb95$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $5489e3723f5efb95$var$toNumber(regexResult[1]),
        month: $5489e3723f5efb95$var$toNumber(regexResult[2], 1) - 1,
        day: $5489e3723f5efb95$var$toNumber(regexResult[3], 1),
        hour: $5489e3723f5efb95$var$toNumber(regexResult[4]),
        minute: $5489e3723f5efb95$var$toNumber(regexResult[5]),
        second: $5489e3723f5efb95$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $5489e3723f5efb95$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $5489e3723f5efb95$var$toNumber(regexResult[10]),
        minuteOffset: $5489e3723f5efb95$var$toNumber(regexResult[11])
    };
}
function $5489e3723f5efb95$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $5489e3723f5efb95$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $5489e3723f5efb95$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $5489e3723f5efb95$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $5489e3723f5efb95$var$yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let $5489e3723f5efb95$var$hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let $5489e3723f5efb95$var$zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let $5489e3723f5efb95$var$rIsoDateTime = new RegExp(`${$5489e3723f5efb95$var$yearMonthDay}T${$5489e3723f5efb95$var$hourMinuteSecond}(\\.\\d+)?${$5489e3723f5efb95$var$zOrOffset}$`);
let $5489e3723f5efb95$var$isTrimmed = (value)=>$5489e3723f5efb95$var$isAbsent(value) || value === value.trim();
let $5489e3723f5efb95$var$objStringTag = ({}).toString();
function $5489e3723f5efb95$export$22b082955e083ec3() {
    return new $5489e3723f5efb95$export$49bf8b2ede5138eb();
}
class $5489e3723f5efb95$export$49bf8b2ede5138eb extends $5489e3723f5efb95$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'string',
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === 'string';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (!this.spec.coerce || this.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $5489e3723f5efb95$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $5489e3723f5efb95$var$mixed.required,
                name: 'required',
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== 'required');
            return schema;
        });
    }
    length(length, message = $5489e3723f5efb95$var$string.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $5489e3723f5efb95$var$string.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $5489e3723f5efb95$var$string.max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || $5489e3723f5efb95$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $5489e3723f5efb95$var$string.email) {
        return this.matches($5489e3723f5efb95$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $5489e3723f5efb95$var$string.url) {
        return this.matches($5489e3723f5efb95$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $5489e3723f5efb95$var$string.uuid) {
        return this.matches($5489e3723f5efb95$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = '';
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === 'object') ({ message: message = '', allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($5489e3723f5efb95$var$rIsoDateTime, {
            name: 'datetime',
            message: message || $5489e3723f5efb95$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: 'datetime_offset',
            message: message || $5489e3723f5efb95$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $5489e3723f5efb95$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: 'datetime_precision',
            message: message || $5489e3723f5efb95$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $5489e3723f5efb95$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = $5489e3723f5efb95$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $5489e3723f5efb95$var$isTrimmed
        });
    }
    lowercase(message = $5489e3723f5efb95$var$string.lowercase) {
        return this.transform((value)=>!$5489e3723f5efb95$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$5489e3723f5efb95$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $5489e3723f5efb95$var$string.uppercase) {
        return this.transform((value)=>!$5489e3723f5efb95$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$5489e3723f5efb95$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$5489e3723f5efb95$export$22b082955e083ec3.prototype = $5489e3723f5efb95$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $5489e3723f5efb95$var$isNaN$1 = (value)=>value != +value;
function $5489e3723f5efb95$export$98e628dec113755e() {
    return new $5489e3723f5efb95$export$f192ec5e9228ab19();
}
class $5489e3723f5efb95$export$f192ec5e9228ab19 extends $5489e3723f5efb95$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'number',
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === 'number' && !$5489e3723f5efb95$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                if (!this.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (this.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $5489e3723f5efb95$var$number.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $5489e3723f5efb95$var$number.max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $5489e3723f5efb95$var$number.lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $5489e3723f5efb95$var$number.moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $5489e3723f5efb95$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $5489e3723f5efb95$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $5489e3723f5efb95$var$number.integer) {
        return this.test({
            name: 'integer',
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$5489e3723f5efb95$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';
        // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!$5489e3723f5efb95$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$5489e3723f5efb95$export$98e628dec113755e.prototype = $5489e3723f5efb95$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $5489e3723f5efb95$var$invalidDate = new Date('');
let $5489e3723f5efb95$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $5489e3723f5efb95$export$324d90190a8b822a() {
    return new $5489e3723f5efb95$export$18ec3cc5a157503f();
}
class $5489e3723f5efb95$export$18ec3cc5a157503f extends $5489e3723f5efb95$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'date',
            check (v) {
                return $5489e3723f5efb95$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!this.spec.coerce || this.isType(value) || value === null) return value;
                value = $5489e3723f5efb95$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $5489e3723f5efb95$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$5489e3723f5efb95$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $5489e3723f5efb95$var$date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $5489e3723f5efb95$var$date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$5489e3723f5efb95$export$18ec3cc5a157503f.INVALID_DATE = $5489e3723f5efb95$var$invalidDate;
$5489e3723f5efb95$export$324d90190a8b822a.prototype = $5489e3723f5efb95$export$18ec3cc5a157503f.prototype;
$5489e3723f5efb95$export$324d90190a8b822a.INVALID_DATE = $5489e3723f5efb95$var$invalidDate;
// @ts-expect-error
function $5489e3723f5efb95$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $b23d02e8cb93f570$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($5489e3723f5efb95$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($5489e3723f5efb95$export$213e2a3e7c4f326e(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($43bed39701948fae$exports))).array(Array.from(nodes), edges).reverse();
}
function $5489e3723f5efb95$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $5489e3723f5efb95$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $5489e3723f5efb95$var$findIndex(keys, a) - $5489e3723f5efb95$var$findIndex(keys, b);
    };
}
const $5489e3723f5efb95$var$parseJson = (value, _, schema)=>{
    if (typeof value !== 'string') return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return schema.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $5489e3723f5efb95$var$deepPartial(schema) {
    if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $5489e3723f5efb95$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $5489e3723f5efb95$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === 'tuple') return schema.optional().clone({
        types: schema.spec.types.map($5489e3723f5efb95$var$deepPartial)
    });
    if ('optional' in schema) return schema.optional();
    return schema;
}
const $5489e3723f5efb95$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $b23d02e8cb93f570$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $b23d02e8cb93f570$exports.getter)((0, $b23d02e8cb93f570$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $5489e3723f5efb95$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $5489e3723f5efb95$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $5489e3723f5efb95$var$defaultSort = $5489e3723f5efb95$var$sortByKeyOrder([]);
function $5489e3723f5efb95$export$be5493f9613cbbe(spec) {
    return new $5489e3723f5efb95$export$18b4fc70ec7eccf8(spec);
}
class $5489e3723f5efb95$export$18b4fc70ec7eccf8 extends $5489e3723f5efb95$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: 'object',
            check (value) {
                return $5489e3723f5efb95$var$isObject(value) || typeof value === 'function';
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $5489e3723f5efb95$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            let inputValue = value[prop];
            if (field) {
                let fieldValue;
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $5489e3723f5efb95$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(inputValue, innerOptions) : inputValue;
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = inputValue;
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== inputValue) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$5489e3723f5efb95$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $5489e3723f5efb95$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ('default' in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $5489e3723f5efb95$var$sortFields(shape, excludedEdges);
        next._sortErrors = $5489e3723f5efb95$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $5489e3723f5efb95$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $b23d02e8cb93f570$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($5489e3723f5efb95$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($5489e3723f5efb95$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: 'exact',
            exclusive: true,
            message: message || $5489e3723f5efb95$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $5489e3723f5efb95$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(', ')
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $5489e3723f5efb95$var$object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $5489e3723f5efb95$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $5489e3723f5efb95$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $791c2d08d57990b5$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $791c2d08d57990b5$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $791c2d08d57990b5$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$5489e3723f5efb95$export$be5493f9613cbbe.prototype = $5489e3723f5efb95$export$18b4fc70ec7eccf8.prototype;
function $5489e3723f5efb95$export$2f23118c22fb2630(type) {
    return new $5489e3723f5efb95$export$4347112b8447a7d(type);
}
class $5489e3723f5efb95$export$4347112b8447a7d extends $5489e3723f5efb95$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: 'array',
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`,
                parent: value,
                originalValue: v,
                value: v,
                index: idx
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($5489e3723f5efb95$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$5489e3723f5efb95$export$213e2a3e7c4f326e(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + $5489e3723f5efb95$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $5489e3723f5efb95$var$array.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $5489e3723f5efb95$var$array.min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $5489e3723f5efb95$var$array.max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$5489e3723f5efb95$export$2f23118c22fb2630.prototype = $5489e3723f5efb95$export$4347112b8447a7d.prototype;
// @ts-ignore
function $5489e3723f5efb95$export$65e3907585753458(schemas) {
    return new $5489e3723f5efb95$export$411c3b3687e8ecc8(schemas);
}
class $5489e3723f5efb95$export$411c3b3687e8ecc8 extends $5489e3723f5efb95$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: 'tuple',
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($5489e3723f5efb95$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ''}[${idx}]`,
                parent: value,
                originalValue: value[idx],
                value: value[idx],
                index: idx
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$5489e3723f5efb95$export$65e3907585753458.prototype = $5489e3723f5efb95$export$411c3b3687e8ecc8.prototype;
function $5489e3723f5efb95$export$488013bae63b21da(builder) {
    return new $5489e3723f5efb95$export$71117d144d3091c9(builder);
}
function $5489e3723f5efb95$var$catchValidationError(fn) {
    try {
        return fn();
    } catch (err) {
        if ($5489e3723f5efb95$export$2191b9da168c6cf0.isError(err)) return Promise.reject(err);
        throw err;
    }
}
class $5489e3723f5efb95$export$71117d144d3091c9 {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$5489e3723f5efb95$export$213e2a3e7c4f326e(schema)) throw new TypeError('lazy() functions must return a valid schema');
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $5489e3723f5efb95$export$71117d144d3091c9(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return $5489e3723f5efb95$var$catchValidationError(()=>this._resolve(value, options).validate(value, options));
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return $5489e3723f5efb95$var$catchValidationError(()=>this._resolve(value, options).validateAt(path, value, options));
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        try {
            return this._resolve(value, options).isValid(value, options);
        } catch (err) {
            if ($5489e3723f5efb95$export$2191b9da168c6cf0.isError(err)) return Promise.resolve(false);
            throw err;
        }
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: 'lazy',
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    get ['~standard']() {
        const schema = this;
        const standard = {
            version: 1,
            vendor: 'yup',
            async validate (value) {
                try {
                    const result = await schema.validate(value, {
                        abortEarly: false
                    });
                    return {
                        value: result
                    };
                } catch (err) {
                    if ($5489e3723f5efb95$export$2191b9da168c6cf0.isError(err)) return {
                        issues: $5489e3723f5efb95$var$issuesFromValidationError(err)
                    };
                    throw err;
                }
            }
        };
        return standard;
    }
}
function $5489e3723f5efb95$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $5489e3723f5efb95$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $5489e3723f5efb95$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$5489e3723f5efb95$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}


var $6bf48344a7d4c6c4$require$object = $5489e3723f5efb95$export$be5493f9613cbbe;
var $6bf48344a7d4c6c4$require$string = $5489e3723f5efb95$export$22b082955e083ec3;
var $6bf48344a7d4c6c4$require$number = $5489e3723f5efb95$export$98e628dec113755e;
var $6bf48344a7d4c6c4$require$array = $5489e3723f5efb95$export$2f23118c22fb2630;
var $6bf48344a7d4c6c4$require$addMethod = $5489e3723f5efb95$export$20be359f745f973c;
$6bf48344a7d4c6c4$require$addMethod($6bf48344a7d4c6c4$require$string, 'noInvalidChars', function() {
    return this.test('noInvalidChars', 'Contains invalid character', function(value) {
        const badChars = /[|%"<>@\\]/g;
        const badJS = /javascript:/i;
        if (badChars.test(value) || badJS.test(value)) return this.createError({
            message: 'Contains invalid character'
        });
        return true;
    });
});
const $6bf48344a7d4c6c4$var$schema = (messages = {})=>$6bf48344a7d4c6c4$require$object().shape({
        firstName: $6bf48344a7d4c6c4$require$string().noInvalidChars().required(messages?.firstName?.required ?? 'First Name cannot be blank'),
        lastName: $6bf48344a7d4c6c4$require$string().noInvalidChars().required(messages?.lastName?.required ?? 'Last Name cannot be blank'),
        email: $6bf48344a7d4c6c4$require$string().email(messages?.email?.email ?? 'Invalid email address').required(messages?.email?.required ?? 'Email address cannot be blank'),
        jobRole: $6bf48344a7d4c6c4$require$array().of($6bf48344a7d4c6c4$require$string().required(messages?.jobRole.required ?? 'Job Role cannot be blank')).min(1, messages?.jobRole?.required ?? 'Job Role cannot be blank'),
        partnerId: $6bf48344a7d4c6c4$require$number().transform((val, orig)=>orig === '' ? undefined : val).required(messages?.partnerId.required ?? 'Partner ID cannot be blank'),
        companyName: $6bf48344a7d4c6c4$require$string().noInvalidChars().required(messages?.company?.required ?? 'Company cannot be blank')
    });
$6bf48344a7d4c6c4$exports = $6bf48344a7d4c6c4$var$schema;



const $7770416d141ea2c7$var$messages = ()=>({
        firstName: {
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('First Name cannot be blank')
        },
        lastName: {
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Last Name cannot be blank')
        },
        email: {
            email: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Invalid email address'),
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Email address cannot be blank')
        },
        jobRole: {
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Job Role cannot be blank')
        },
        partnerId: {
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Partner ID cannot be blank')
        },
        companyName: {
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Company cannot be blank')
        }
    });
var $7770416d141ea2c7$export$2e2bcd8739ae039 = $7770416d141ea2c7$var$messages;


var $c6d6e75a850d8e09$exports = {};

var $c6d6e75a850d8e09$require$object = $5489e3723f5efb95$export$be5493f9613cbbe;
var $c6d6e75a850d8e09$require$string = $5489e3723f5efb95$export$22b082955e083ec3;
var $c6d6e75a850d8e09$require$number = $5489e3723f5efb95$export$98e628dec113755e;
var $c6d6e75a850d8e09$require$addMethod = $5489e3723f5efb95$export$20be359f745f973c;
$c6d6e75a850d8e09$require$addMethod($c6d6e75a850d8e09$require$string, 'noInvalidChars', function() {
    return this.test('noInvalidChars', 'Contains invalid character', function(value) {
        const badChars = /[|%"<>@\\]/g;
        const badJS = /javascript:/i;
        if (badChars.test(value) || badJS.test(value)) return this.createError({
            message: 'Contains invalid character'
        });
        return true;
    });
});
const $c6d6e75a850d8e09$var$schema = (messages = {})=>$c6d6e75a850d8e09$require$object().shape({
        title: $c6d6e75a850d8e09$require$string().noInvalidChars().required(messages?.title?.required ?? 'Title cannot be blank'),
        firstName: $c6d6e75a850d8e09$require$string().noInvalidChars().required(messages?.firstName?.required ?? 'First Name cannot be blank'),
        lastName: $c6d6e75a850d8e09$require$string().noInvalidChars().required(messages?.lastName?.required ?? 'Last Name cannot be blank'),
        email: $c6d6e75a850d8e09$require$string().email(messages?.email?.email ?? 'Invalid email address').required(messages?.email?.required ?? 'Email address cannot be blank'),
        jobRole: $c6d6e75a850d8e09$require$string().transform((value)=>value || undefined).required(messages?.jobRole?.required ?? 'Job Role cannot be blank').oneOf([
            'Marketing',
            'Business',
            'Technical'
        ], messages?.jobRole?.invalid ?? 'Invalid Job Role'),
        partnerId: $c6d6e75a850d8e09$require$number().transform((val, orig)=>orig === '' ? undefined : val).required(messages?.partnerId?.required ?? 'Customer ID cannot be blank'),
        companyName: $c6d6e75a850d8e09$require$string().noInvalidChars().required(messages?.companyName?.required ?? 'Company cannot be blank')
    });
$c6d6e75a850d8e09$exports = $c6d6e75a850d8e09$var$schema;



const $8b81040e659fd96b$var$messages = ()=>({
        title: {
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Title cannot be blank')
        },
        firstName: {
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('First Name cannot be blank')
        },
        lastName: {
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Last Name cannot be blank')
        },
        email: {
            email: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Invalid email address'),
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Email address cannot be blank')
        },
        jobRole: {
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Job Role cannot be blank')
        },
        partnerId: {
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Customer ID cannot be blank')
        },
        companyName: {
            required: (0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Company cannot be blank')
        }
    });
var $8b81040e659fd96b$export$2e2bcd8739ae039 = $8b81040e659fd96b$var$messages;


class $2b07c44d41714add$var$PartnersRegistrationForm extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $7521568146c72f54$export$2e2bcd8739ae039);
    static properties = {
        type: {
            type: String
        },
        options: {
            type: Array,
            state: true
        }
    };
    constructor(){
        super();
        this.type = 'partners';
        this.messages = (0, $7770416d141ea2c7$export$2e2bcd8739ae039)();
        this.openPartnersMessages = (0, $8b81040e659fd96b$export$2e2bcd8739ae039)();
        this.partnersOptions = [
            {
                value: 'Marketing',
                label: 'Marketing'
            },
            {
                value: 'Sales',
                label: 'Sales'
            },
            {
                value: 'Admin',
                label: 'Admin'
            },
            {
                value: 'Technical',
                label: 'Technical'
            },
            {
                value: 'MSSP Technical',
                label: 'MSSP Technical'
            },
            {
                value: 'MSSP Sales',
                label: 'MSSP Sales'
            }
        ];
        this.openPartnersOptions = [
            {
                value: '',
                label: 'Select a role',
                placeholder: true,
                disabled: true
            },
            {
                value: 'Marketing',
                label: 'Marketing'
            },
            {
                value: 'Business',
                label: 'Business'
            },
            {
                value: 'Technical',
                label: 'Technical'
            }
        ];
        this.options = this.partnersOptions;
    }
    context = (0, $f33e9a0a3fc07977$export$2e2bcd8739ae039)(this);
    form = new (0, $421753a939d8b79e$export$2e2bcd8739ae039)(this, {
        onSubmit: (params)=>this.onSubmit(params)
    });
    connectedCallback() {
        super.connectedCallback();
        const isOpenPartners = this.context.value?.type === 'openPartners';
        this.options = isOpenPartners ? this.openPartnersOptions : this.partnersOptions;
        this.form.schema = isOpenPartners ? (0, (/*@__PURE__*/$parcel$interopDefault($c6d6e75a850d8e09$exports)))(this.openPartnersMessages) : (0, (/*@__PURE__*/$parcel$interopDefault($6bf48344a7d4c6c4$exports)))(this.messages);
    }
    #escapeHTML(text) {
        const escape = document.createElement('textarea');
        escape.textContent = text;
        return escape.innerHTML;
    }
    #buildPayload(values) {
        const base = {
            FirstName: this.#escapeHTML(values.firstName),
            LastName: this.#escapeHTML(values.lastName),
            Email: this.#escapeHTML(values.email),
            JobRole: values.jobRole,
            CompanyName: this.#escapeHTML(values.companyName),
            SourceIdentifier: values.sourceIdentifier
        };
        return {
            ...base,
            ...this.type === 'openPartners' && {
                Title: this.#escapeHTML(values.title)
            },
            PartnerID: this.#escapeHTML(values.partnerId)
        };
    }
    async onSubmit({ values: values }) {
        const isOpenPartners = this.type === 'openPartners';
        const api = new (0, $9aa856a3e1664cb7$export$2e2bcd8739ae039)({
            env: this.context.value?.env,
            ...isOpenPartners && {
                endpoint: '/evaluations/api/v1/open-partners/accounts'
            }
        });
        const payload = this.#buildPayload(values);
        try {
            await api.create(payload);
        } catch (error) {
            const msg = `Oops! ${error.message || 'Server Error'}`;
            throw new Error(msg);
        }
        this.dispatchEvent(new CustomEvent('next-step', {
            composed: true,
            bubbles: true
        }));
    }
    render() {
        const isOpenPartners = this.context.value?.type === 'openPartners';
        const idFieldLabel = isOpenPartners ? 'Customer ID' : 'Partner ID';
        const sourceIdentifierValue = isOpenPartners ? 'openPartners' : 'partners';
        const description = isOpenPartners ? 'Register to access the Tenable OPEN partner portal for a one-stop view of joint marketing benefits, developer guides, product access and technical documentation.' : 'Register to access the Tenable Partner Portal for a one-stop view of sales and technical enablement, demand generation marketing, pipeline management, and analytics.';
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <div class="partners-registration-form-container">
        <div id="partners-registration-form-desc">
          <p>${description}</p>
        </div>

        ${this.form.isSubmitting ? (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
          <div id="partners-registration-form-submit-msg" class="alert alert-info submit-msg">
            <strong>Submitting:</strong><br>
            Please allow up to 2 minutes for request to process, do not refresh the page
          </div>` : ''}

        <tenable-form id="partners-registration-form" .errors=${this.form.errors} .values=${this.form.values} @form-submitted=${(e)=>this.form.submitHandler(e)}>
          <tenable-form-error id="partners-registration-form-error-msg" .errors=${this.form.formErrors}></tenable-form-error>

          <tenable-input type="hidden" id="partners-sourceIdentifier" name="sourceIdentifier" value="${sourceIdentifierValue}" @input-change=${(e)=>this.form.inputHandler(e)}></tenable-input>

          <tenable-form-group>
            <tenable-input type="text" id="partners-firstName" name="firstName" label="First Name" placeholder="First Name" ?invalid=${this.form.errors.firstName} @input-change=${(e)=>this.form.inputHandler(e)} @input-blur=${(e)=>this.form.validateField(e)} required></tenable-input>
            <tenable-form-feedback message=${this.form.errors.firstName}></tenable-form-feedback>
          </tenable-form-group>

          <tenable-form-group>
            <tenable-input type="text" id="partners-lastName" name="lastName" label="Last Name" placeholder="Last Name" ?invalid=${this.form.errors.lastName} @input-change=${(e)=>this.form.inputHandler(e)} @input-blur=${(e)=>this.form.validateField(e)} required></tenable-input>
            <tenable-form-feedback message=${this.form.errors.lastName}></tenable-form-feedback>
          </tenable-form-group>

          <tenable-form-group>
            <tenable-input type="email" id="partners-email" name="email" label="Email" placeholder="Email" ?invalid=${this.form.errors.email} @input-change=${(e)=>this.form.inputHandler(e)} @input-blur=${(e)=>this.form.validateField(e)} required></tenable-input>
            <tenable-form-feedback message=${this.form.errors.email}></tenable-form-feedback>
          </tenable-form-group>

          ${isOpenPartners ? (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
            <tenable-form-group>
              <tenable-input type="text" id="partners-title" name="title" label="Title" placeholder="Title" ?invalid=${this.form.errors.title} @input-change=${(e)=>this.form.inputHandler(e)} @input-blur=${(e)=>this.form.validateField(e)} required></tenable-input>
              <tenable-form-feedback message=${this.form.errors.title}></tenable-form-feedback>
            </tenable-form-group>
          ` : ''}

          <tenable-form-group>
            <label for="jobRole">Job Role ${isOpenPartners ? '' : (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<small>(To select multiple roles use ctrl or cmd)</small>`}</label>
            <tenable-select
              name="jobRole"
              id="partners-jobRole"
              ?invalid=${this.form.errors.jobRole}
              @input-change=${(e)=>this.form.inputHandler(e)}
              @input-blur=${(e)=>this.form.validateField(e)}
              .options=${this.options}
              size=${isOpenPartners ? undefined : this.options.length}
              ?multiple=${!isOpenPartners}
              required
            >
            </tenable-select>
            <tenable-form-feedback message=${this.form.errors.jobRole}></tenable-form-feedback>
          </tenable-form-group>

          <tenable-form-group>
            <label for="partnerId" style="margin-bottom: 0;">${idFieldLabel}</label>
            ${isOpenPartners ? (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<small>If you do not know your customer ID, please email <a href="mailto:techpartners@tenable.com">techpartners@tenable.com</a> to request it</small>` : (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<small>If you do not know your partner ID please ask your channel manager or email <a href="mailto:partners@tenable.com">partners@tenable.com</a></small>`}
            <tenable-input type="number" inputmode="numeric" id="partners-partnerId" name="partnerId" placeholder="${idFieldLabel}" ?invalid=${this.form.errors.partnerId} hide-spinner @input-change=${(e)=>this.form.inputHandler(e)} @input-blur=${(e)=>this.form.validateField(e)} required></tenable-input>
            <tenable-form-feedback message=${this.form.errors.partnerId}></tenable-form-feedback>
          </tenable-form-group>

          <tenable-form-group>
            <tenable-input type="text" id="partners-company" name="companyName" label="Company" placeholder="Company" ?invalid=${this.form.errors.company} @input-change=${(e)=>this.form.inputHandler(e)} @input-blur=${(e)=>this.form.validateField(e)} required></tenable-input>
            <tenable-form-feedback message=${this.form.errors.companyName}></tenable-form-feedback>
          </tenable-form-group>

          <tenable-button type="submit" class="registration-btn" size="lg" ?disabled=${this.form.isSubmitting}>
            ${this.form.isSubmitting ? 'Submitting...' : 'Submit'}
          </tenable-button>
        </tenable-form>
      </div>
    `;
    }
}
customElements.define('tenable-partners-registration-form', $2b07c44d41714add$var$PartnersRegistrationForm);





var $f041950d7b2da932$export$2e2bcd8739ae039 = [
    (0, $00b2a1180faf264c$export$2e2bcd8739ae039),
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
    .partners-registration-form-confirmation h2 {
      font-weight: 700;
      line-height: 1.2;
      color: #5B6062;
    }

    .partners-registration-form-container h4 {
      color: #777779;
    }
  `
];




class $f5868d7018fdcdd3$var$IconCheck extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static properties = {
        color: {
            type: String
        },
        width: {
            type: String
        }
    };
    constructor(){
        super();
        this.color = '#f87b1e';
        this.width = '6em';
        (0, $4dfc32bf1589eb12$export$19147fd8eb2795e4)(this);
    }
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" width="${this.width}" stroke="${this.color}" stroke-width="1.5" fill="transparent">
        <title>${(0, $5c496e1a5b2fd7d3$export$d8bbfaecd0f57bdf)('Check')}</title>
        <polygon points="58.99 18.24 32.49 44.74 21.01 33.26 12.5 41.77 32.49 61.76 67.5 26.75 58.99 18.24" stroke-miterlimit="10"/>
        <line x1="65.83" y1="25.08" x2="30.82" y2="60.09" stroke-miterlimit="10"/>
        <circle cx="40" cy="40" r="36.53" stroke-linecap="round" stroke-miterlimit="10"/>
      </svg>
    `;
    }
}
customElements.define('tenable-icon-check', $f5868d7018fdcdd3$var$IconCheck);


class $cabee02b4b06813d$var$PartnersRegistrationConfirmation extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $f041950d7b2da932$export$2e2bcd8739ae039);
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <div class="confirmation-box" id="partners-registration-form-confirmation">
        <tenable-icon-check width="8em" color="#3fae29"></tenable-icon-check>

        <h2>Success</h2>
        <h4>Please check your email for enrollment confirmation and password setup instructions.</h4>
      </div>
    `;
    }
}
customElements.define('tenable-partners-registration-confirmation', $cabee02b4b06813d$var$PartnersRegistrationConfirmation);






const $59adad0d25d54f82$var$stepWizardContext = (0, $373cb95b05cf8dbd$export$fd42f52fd3ae1109)(Symbol('tenable-step-wizard-context'));
var $59adad0d25d54f82$export$2e2bcd8739ae039 = $59adad0d25d54f82$var$stepWizardContext;


class $d8465c63b566effc$var$StepWizardContextProvider extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static properties = {
        value: {
            type: Object
        }
    };
    constructor(){
        super();
        this.value = {};
    }
    provider = new (0, $20047d1f06125b00$export$9f27bc3417b4524d)(this, {
        context: (0, $59adad0d25d54f82$export$2e2bcd8739ae039),
        initialValue: this.value
    });
    connectedCallback() {
        super.connectedCallback();
        this.provider.setValue(this.value);
    }
    setContextValue(event) {
        const value = {
            ...this.value,
            ...event.detail
        };
        this.provider.setValue(value);
        this.value = value;
    }
    render() {
        this.provider.setValue(this.value);
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
    <div
      @set-step-wizard-context=${(e)=>this.setContextValue(e)}
    >
      <slot></slot>
    </div>
  `;
    }
}
customElements.define('tenable-step-wizard-provider', $d8465c63b566effc$var$StepWizardContextProvider);




var $b226d39b2397c86f$export$2e2bcd8739ae039 = [
    (0, $d166a5a387251cdc$export$dbf350e5966cf602)`
  .step-wizard-progress {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      margin: .5rem 0 2rem 0;
      padding: 0;
      list-style: none;
    }
    .step-wizard-progress-item {
      flex: 1 1 0;
      position: relative;
      text-align: center;
      min-width: 80px;
    }
    .step-wizard-progress-line-before,
    .step-wizard-progress-line-after {
      position: absolute;
      top: 24px;
      height: 2px;
      background: #d3d3d3;
      z-index: 0;
      left: 0;
      right: 0;
    }
    .step-wizard-progress-line-before.complete,
    .step-wizard-progress-line-after.complete {
      background: var(--tenable-step-wiz-progress-color, #1e2426);
    }
    .step-wizard-progress-line-before {
      left: -50%;
      right: 50%;
    }
    .step-wizard-progress-line-after {
      left: 50%;
      right: -50%;
    }
    .step-wizard-progress-icon {
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .step-wizard-progress-btn {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 1px solid var(--tenable-step-wiz-progress-color, #1e2426);
      background: #fff;
      color: var(--tenable-step-wiz-progress-color, #1e2426);
      font-weight: bold;
      font-size: 0.91875rem;
      margin-bottom: 0.5rem;
      cursor: pointer;
      transition: background 0.2s, color 0.2s;
    }
    .step-wizard-progress-btn.done {
      background: var(--tenable-step-wiz-progress-color, #1e2426);
      color: #fff;
    }
    .step-wizard-progress-btn.incomplete {
      background: #fff;
      color: #5B6062;
      border-color: #5B6062;
    }
    .step-wizard-progress-btn.current {
      box-shadow: 0 0 0 .2rem var(--tenable-step-wiz-progress-shadow-color, #e7ff00);
      background-color: var(--tenable-step-wiz-progress-color, #1e2426);
      color: #fff;
    }
    .step-wizard-progress-btn.disabled {
      opacity: 1;
      cursor: not-allowed;
    }
    .step-wizard-progress-label {
      font-size: 0.95rem;
      margin-top: 0.2rem;
      color: var(--tenable-step-wiz-label-color, #1e2426);
      font-weight: 500;
    }
    .step-wizard-progress-label.done {
      color: var(--tenable-step-wiz-label-color, #1e2426);
    }
    .step-wizard-progress-label.incomplete {
      color: var(--tenable-step-wiz-label-incomplete-color, #5B6062);
    }
  `
];


class $82672ada1366d655$var$StepWizardProgress extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static properties = {
        steps: {
            type: Array
        },
        stepStyles: {
            type: Array
        },
        disableProgress: {
            type: Boolean
        },
        className: {
            type: String
        },
        activeStep: {
            type: Number
        }
    };
    constructor(){
        super();
        this.steps = [];
        this.stepStyles = [];
        this.showProgressBar = false;
        this.disableProgress = true;
        this.className = '';
        this.activeStep = 0;
    }
    static styles = (0, $b226d39b2397c86f$export$2e2bcd8739ae039);
    setActiveStep(index) {
        const event = new CustomEvent('set-active-step', {
            detail: {
                step: index
            },
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(event);
    }
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <nav class="step-wizard-progress ${this.className}">
        ${this.steps.map((step, index)=>{
            const style = this.stepStyles[index] || '';
            const disabled = this.disableProgress || step.disableProgress;
            return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
        <div class="step-wizard-progress-item">
          <div class="step-wizard-progress-line-before ${style}"
            style="${index === 0 ? 'display:none;' : ''}"></div>
          <div class="step-wizard-progress-line-after ${style}"
            style="${index === this.steps.length - 1 ? 'display:none;' : ''}"></div>
          <div class="step-wizard-progress-icon">
            <button
              class="step-wizard-progress-btn btn-sm ${style} ${disabled ? 'disabled' : ''}"
              ?disabled=${disabled}
              @click="${()=>!disabled && this.setActiveStep(index)}"
              type="button"
            >
              ${index + 1}
            </button>
            <div class="step-wizard-progress-label ${style}">
              ${step.stepName || `Step ${index + 1}`}
            </div>
          </div>
        </div>
      `;
        })}
      </nav>
    `;
    }
}
customElements.define('tenable-step-wizard-progress', $82672ada1366d655$var$StepWizardProgress);



class $7281bcc9f1c77167$var$StepWizard extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $b226d39b2397c86f$export$2e2bcd8739ae039);
    static properties = {
        activeStep: {
            type: Number,
            reflect: true,
            attribute: 'active-step'
        },
        totalSteps: {
            type: Number,
            reflect: true,
            attribute: 'total-steps'
        },
        showProgressBar: {
            type: Boolean
        },
        disableProgress: {
            type: Boolean,
            state: true
        },
        steps: {
            type: Array,
            state: true
        }
    };
    constructor(){
        super();
        this.activeStep = 0;
        this.totalSteps = 0;
        this.showProgressBar = false;
        this.disableProgress = true;
        this.steps = [];
    }
    getNavStyles = (activeIndex, steps = [])=>{
        const stepStyles = [];
        steps.forEach((step, i)=>{
            if (i < activeIndex) stepStyles.push('done');
            else if (i === activeIndex) stepStyles.push('current');
            else stepStyles.push('incomplete');
        });
        return stepStyles;
    };
    firstUpdated() {
        const slot = this.shadowRoot.querySelector('slot');
        if (slot) {
            const childNodes = slot.assignedElements({
                flatten: true
            });
            this.steps = Array.from(childNodes);
            this.updateSteps(this.steps);
        }
    }
    get slottedChildren() {
        const slot = this.shadowRoot.querySelector('slot');
        return slot ? slot.assignedElements({
            flatten: true
        }) : [];
    }
    handleSlotchange(e) {
        const childNodes = e.target.assignedElements({
            flatten: true
        });
        this.steps = Array.from(childNodes);
        this.updateSteps(this.steps);
    }
    next() {
        this.activeStep += 1;
        this.updateSteps(this.slottedChildren);
    }
    previous() {
        this.activeStep -= 1;
        this.updateSteps(this.slottedChildren);
    }
    setActiveStep(event) {
        this.activeStep = event?.detail?.step ?? this.activeStep;
        this.updateSteps(this.slottedChildren);
    }
    updateSteps(childNodes) {
        this.totalSteps = childNodes?.length ?? 0;
        childNodes.forEach((child, index)=>{
            if (index === this.activeStep) {
                child.style.display = 'block';
                child.setAttribute('is-active-step', true);
            } else {
                child.style.display = 'none';
                child.setAttribute('is-active-step', false);
            }
            child.setAttribute('step', index);
            child.setAttribute('active-step', this.activeStep);
            child.setAttribute('total-steps', this.totalSteps);
        });
    }
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <tenable-step-wizard-provider .value=${{
            totalSteps: this.totalSteps,
            activeStep: this.activeStep
        }}>
        ${this.showProgressBar ? (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
          <tenable-step-wizard-progress
            .steps=${this.steps}
            .disableProgress=${this.disableProgress}
            .stepStyles=${this.getNavStyles(this.activeStep, this.steps)}
          ></tenable-step-wizard-progress>
        ` : ''}
        <div
          class="step-wizard-steps"
          @next-step=${(e)=>this.next(e)}
          @previous-step=${(e)=>this.previous(e)}
          @set-active-step=${(e)=>this.setActiveStep(e)}
        >
          <slot @slotchange=${this.handleSlotchange}></slot>
        </div>
      </tenable-step-wizard-provider>
    `;
    }
}
customElements.define('tenable-step-wizard', $7281bcc9f1c77167$var$StepWizard);


class $5907e288603500d6$var$PartnersRegistration extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $7b158124d7893a46$export$2e2bcd8739ae039);
    static properties = {
        type: {
            type: String
        }
    };
    constructor(){
        super();
        this.type = 'partners';
    }
    context = (0, $f33e9a0a3fc07977$export$2e2bcd8739ae039)(this);
    render() {
        const isOpenPartners = this.context.value?.type === 'openPartners';
        const title = isOpenPartners ? 'Tenable Open Partner Portal Registration' : 'Tenable Partner Portal Registration';
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <div class="partners-registration-container w-50">
        <div class="panel panel-default registration-panel">
          <img src="${isOpenPartners ? 'https://static.tenable.com/partners/tenable_open_black.png' : 'https://static.tenable.com/partners/tenable-assure-logo.png'}" alt="Tenable">
          <div class="panel-heading">
            <h2>${title}</h2>
          </div>
          <tenable-step-wizard>
            <tenable-partners-registration-form type=${this.type}></tenable-partners-registration-form>
            <tenable-partners-registration-confirmation></tenable-partners-registration-confirmation>
          </tenable-step-wizard>
        </div>
      </div>
    `;
    }
}
customElements.define('tenable-partners-registration', $5907e288603500d6$var$PartnersRegistration);


class $724bbcecb17b0b52$var$PartnersPage extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $41291d7e812c5108$export$2e2bcd8739ae039);
    static properties = {
        activeContainer: {
            type: String,
            state: true
        },
        type: {
            type: String
        }
    };
    context = (0, $f33e9a0a3fc07977$export$2e2bcd8739ae039)(this);
    constructor(){
        super();
        this.activeContainer = this.#getActiveContainer();
        this.type = 'partners';
    }
    async #setActiveContainer(activeContainer) {
        this.activeContainer = activeContainer;
    }
    #getActiveContainer() {
        const locationHash = window.location.hash.substring(1);
        const activeContainer = locationHash === 'register' || locationHash === 'login' ? locationHash : 'register';
        return activeContainer;
    }
    connectedCallback() {
        super.connectedCallback();
        this.activeContainer = this.#getActiveContainer();
    }
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <div class="partners-page-container">
        <div class="partners-page-header">
          <li class="list-inline-item">
            <span id="partner-menu-register" class="menu-link ${this.activeContainer !== 'register' ? 'hidden-container' : ''}">
              <a id="partner-register-link" href="#register" @click="${()=>this.#setActiveContainer('register')}">Register</a>
              <svg class="menu-icon" width="36px" height="36px" fill="#1E2426" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 24 24" xml:space="preserve">
                <style type="text/css">
                  .st0{fill:none;}
                </style>
                <path d="M18.5,15.5l-6-7l-6,7H18.5z"/>
                <rect class="st0" width="24" height="24"/>
                <rect class="st0" width="24" height="24"/>
              </svg>
            </span>
            <span id="partner-menu-login" class="menu-link ${this.activeContainer !== 'login' ? 'hidden-container' : ''}">
              <a id="partner-login-link" href="#login" @click="${()=>this.#setActiveContainer('login')}">Partner Login</a>
              <svg class="menu-icon" width="36px" height="36px" fill="#1E2426" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 24 24" xml:space="preserve">
                <style type="text/css">
                  .st0{fill:none;}
                </style>
                <path d="M18.5,15.5l-6-7l-6,7H18.5z"/>
                <rect class="st0" width="24" height="24"/>
                <rect class="st0" width="24" height="24"/>
              </svg>
            </span>
          </li>
        </div>
        ${this.activeContainer === 'login' ? (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<tenable-partners-login></tenable-partners-login>` : ''}
        ${this.activeContainer === 'register' ? (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`<tenable-partners-registration type=${this.type}></tenable-partners-registration>` : ''}
      </div>
    `;
    }
}
customElements.define('tenable-partners-page', $724bbcecb17b0b52$var$PartnersPage);


class $ef3028a21e5556ba$var$TenablePartners extends (0, $70334511cd44bfe1$export$3f2f9f5909897157) {
    static styles = (0, $00b2a1180faf264c$export$2e2bcd8739ae039);
    static properties = {
        env: {
            type: String
        },
        type: {
            type: String
        }
    };
    constructor(){
        super();
        this.env = '';
        this.type = 'partners';
    }
    connectedCallback() {
        super.connectedCallback();
        const { env: env } = (0, $dc10d5c326127160$export$18b8b1bfabae50a3)(this.env);
        this.env = env;
    }
    render() {
        return (0, $79945edb0549afcc$export$c0bb0b647f701bb5)`
      <tenable-app-provider .value=${{
            env: this.env,
            type: this.type
        }}>
        <tenable-partners-page type=${this.type}></tenable-partners-page>
      </tenable-app-provider>
    `;
    }
}
customElements.define('tenable-partners', $ef3028a21e5556ba$var$TenablePartners);

})();
//# sourceMappingURL=index.js.map
